const stores = [
  {
    "name": "FARMACIA S.GORDIANO snc di A. Amalfitano e C.",
    "address": "L.go Giovanni XXIII, 5, CIVITAVECCHIA RM 00053, ITALIA",
    "lat": 42.07561,
    "lng": 11.81408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.07561,11.81408"
  },
  {
    "name": "Ottierre srl",
    "address": "Località S. Francesco, Simeri Crichi CZ 88050, Italia",
    "lat": 39.511275,
    "lng": 15.94831,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.511275,15.94831"
  },
  {
    "name": "Genesis Grigoriadis",
    "address": "2 Argous & 281 Thivon, Peristeri, Athens 12135, Grecia",
    "lat": 38.023735,
    "lng": 23.694789,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.023735,23.694789"
  },
  {
    "name": "ORTHOTECNICA DI DOTT AMATO LUCIANO",
    "address": "VIA CASTELVETRANO, 27//B, MAZARA DEL VALLO TP 91026, Italia",
    "lat": 37.6501484,
    "lng": 12.5970025,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6501484,12.5970025"
  },
  {
    "name": "FARMACIA COSTA VOLPINO S.R.L.",
    "address": "VIA NAZIONALE, 152, COSTA VOLPINO BG 24062, Italia",
    "lat": 45.8227809,
    "lng": 10.0840893,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8227809,10.0840893"
  },
  {
    "name": "ORTOPEDIA FORESTI",
    "address": "VIA PUSTERLA, 14, ISEO BS 25049, Italia",
    "lat": 45.6601637,
    "lng": 10.0534116,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6601637,10.0534116"
  },
  {
    "name": "HUMANTECH S.R.L.",
    "address": "Via G.Marconi, 9, TORRE DE' ROVERI BG 24060, Italia",
    "lat": 45.6988337,
    "lng": 9.7611617,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6988337,9.7611617"
  },
  {
    "name": "ORTOPEDIA LEONE SRL",
    "address": "VIA SISMONDI, 44, MILANO MI 20133, Italia",
    "lat": 45.4655665,
    "lng": 9.2253347,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4655665,9.2253347"
  },
  {
    "name": "ORTHO LAB SPORT SRL",
    "address": "CORSO SAN GOTTARDO, 3, MILANO MI 20136, Italia",
    "lat": 45.4516123,
    "lng": 9.1801808,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4516123,9.1801808"
  },
  {
    "name": "GI.GU.SAN DI GIORGIO GUCCIONE",
    "address": "VIA VITTORIO VENETO, 5, MODICA RG 97015, Italia",
    "lat": 36.8550043,
    "lng": 14.7562036,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=36.8550043,14.7562036"
  },
  {
    "name": "L'ORTHOPEDIA S.R.L.",
    "address": "Corso di Porta Romana, 52, MILANO MI 20122, Italia",
    "lat": 45.4579896,
    "lng": 9.1925197,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4579896,9.1925197"
  },
  {
    "name": "RICCI ROBERTA",
    "address": "VIA DEL BRENNERO, 27/29, FONTE NUOVA RM 00013, Italia",
    "lat": 41.9941791,
    "lng": 12.6210029,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9941791,12.6210029"
  },
  {
    "name": "OFFICINA E SANITARIA ORTOPEDICA GRASSO s.r.l.",
    "address": "Viale Riccardo da Lentini, 80, LENTINI SR 96016, Italia",
    "lat": 37.2920359,
    "lng": 14.9995254,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.2920359,14.9995254"
  },
  {
    "name": "SALUS MEDICAZIONI s.r.l.",
    "address": "VIA AQUILEIA, 35, BARANZATE MI 20021, Italia",
    "lat": 45.5264805,
    "lng": 9.1065488,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5264805,9.1065488"
  },
  {
    "name": "D.I.Massai Stefano",
    "address": "Via Provinciale di Procchio,55, MARCIANA LI 57030, Italia",
    "lat": 42.7851435,
    "lng": 10.2381317,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7851435,10.2381317"
  },
  {
    "name": "C.O.V.SRL CENTRO ORTOPEDICO VIGEVANESE",
    "address": "Viale L. da Vinci 20, VIGEVANO PV 27029, Italia",
    "lat": 45.3199258,
    "lng": 8.8648978,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3199258,8.8648978"
  },
  {
    "name": "Farmacia VIII Colle Di Antonella Dott.ssa Izzo",
    "address": "Via Paolo di Dono, 35/39, ROMA RM 00142, Italia",
    "lat": 41.8301442,
    "lng": 12.4941122,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8301442,12.4941122"
  },
  {
    "name": "Farmacia Spargoli Dr. Mario",
    "address": "Via Lanciano, 38, FRISA CH 66030, Italia",
    "lat": 42.2588144,
    "lng": 14.3659468,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2588144,14.3659468"
  },
  {
    "name": "Parafarmacia PARERE A.M. di Muscellara Maria Loreta & c sas",
    "address": "Viale Mazzini, 143 B, ALBA ADRIATICA TE 64011, Italia",
    "lat": 42.8330396,
    "lng": 13.9281007,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8330396,13.9281007"
  },
  {
    "name": "FARMACIA SANSONI DI SANSONI FRANCA E C. S.N.C.",
    "address": "Piazza del popolo 8, FAENZA RA 48018, Italia",
    "lat": 44.285355,
    "lng": 11.8832989,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.285355,11.8832989"
  },
  {
    "name": "FARMACIA DEGLI ANGELI DEL DOTT.SIMONE SANTINI E C. S.A.S.",
    "address": "Piazza Garibaldi, 35, ROCCA SAN CASCIANO FC 47017, Italia",
    "lat": 44.0601259,
    "lng": 11.8424674,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0601259,11.8424674"
  },
  {
    "name": "FARMACIA FABBRI SNC DELLE D.SSE VERONA,MORGAGNI,MORIGI E NIERO",
    "address": "Piazza garibaldi, 2, FORLIMPOPOLI FC 47034, Italia",
    "lat": 44.1876154,
    "lng": 12.125953,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1876154,12.125953"
  },
  {
    "name": "Parafarmacia Herba Salus sas",
    "address": "Via Gramsci, 211/b-b1, CASTEL MAGGIORE BO 40013, Italia",
    "lat": 39.253074,
    "lng": 16.697184,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.253074,16.697184"
  },
  {
    "name": "PARAPHARMA S.r.l.",
    "address": "Via Palladio, 53 - Z-I, TAVAGNACCO UD 33010, Italia",
    "lat": 46.11208,
    "lng": 13.2171771,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.11208,13.2171771"
  },
  {
    "name": "D.L.F. spa",
    "address": "Via Basilicata, 9, SAN GIULIANO MILANESE MI 20098, Italia",
    "lat": 45.3956617,
    "lng": 9.2515209,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3956617,9.2515209"
  },
  {
    "name": "SERVIZI IN COMUNE S.p.A.",
    "address": "Via Pontina km 31,400, POMEZIA RM 00071, Italia",
    "lat": 41.671181,
    "lng": 12.49943,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.671181,12.49943"
  },
  {
    "name": "Farmacia Bellariva di Bochini Giuliano e C snc",
    "address": "Via Settembrini, 17/i, RIMINI RN 47900, Italia",
    "lat": 44.0434215,
    "lng": 12.5904086,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0434215,12.5904086"
  },
  {
    "name": "Farmacia Calisese",
    "address": "via Malanotte, 92, CESENA FC 47023, Italia",
    "lat": 44.1002525,
    "lng": 12.3028089,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1002525,12.3028089"
  },
  {
    "name": "FARMACIA GOTTI S.R.L.",
    "address": "Via Tripoli, 76, RIMINI RN 47923, Italia",
    "lat": 44.054822,
    "lng": 12.57406,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.054822,12.57406"
  },
  {
    "name": "Parafarmacia Dott. CANCELLOTTI",
    "address": "Via Cesare Battisti, 95, GABICCE MARE PU 61011, Italia",
    "lat": 43.9664918,
    "lng": 12.7575134,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9664918,12.7575134"
  },
  {
    "name": "FARMACIA CAPPONI DR. ANGELO",
    "address": "Piazza delle Arti e dei Mestieri, 9/10, CAMERATA PICENA AN 60020, Italia",
    "lat": 43.5814812,
    "lng": 13.3424562,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5814812,13.3424562"
  },
  {
    "name": "Farmacia Marchegiani Dott.ssa Federica",
    "address": "Via Tambroni, 15 Loc. Sambucheto, MONTECASSIANO MC 62010, Italia",
    "lat": 43.355888,
    "lng": 13.477619,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.355888,13.477619"
  },
  {
    "name": "Farmacia San Giacomo snc",
    "address": "Via del Corso, 498, ROMA RM 00186, Italia",
    "lat": 41.90812,
    "lng": 12.4773433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.90812,12.4773433"
  },
  {
    "name": "LA SANITARIA COOPERATIVA SOCIALE",
    "address": "Viale Kennedy, 20, VIADANA MN 46019, Italia",
    "lat": 44.9303342,
    "lng": 10.50421,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9303342,10.50421"
  },
  {
    "name": "Farmacia Dott.ssa Loredana Lombardi Boccia",
    "address": "V.le F.T. Marinetti n. 211, ROMA RM 00143, Italia",
    "lat": 41.824259,
    "lng": 12.508448,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.824259,12.508448"
  },
  {
    "name": "OTTOBOCK soluzioni ortopediche srl",
    "address": "Via Turati 5/7, BUDRIO BO 40054, Italia",
    "lat": 44.5345134,
    "lng": 11.5243403,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5345134,11.5243403"
  },
  {
    "name": "Farmacia Dott.ssa Olivieri sas",
    "address": "Via Enrico Mattei 8, SAN BENEDETTO DEL TRONTO AP 63074, Italia",
    "lat": 42.9179558,
    "lng": 13.8909271,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9179558,13.8909271"
  },
  {
    "name": "SANITHOSPITAL sas di Annamaria Soddu & C.",
    "address": "Via 27 Gennaio, 16, SARZANA SP 19038, Italia",
    "lat": 44.1189472,
    "lng": 9.9497863,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1189472,9.9497863"
  },
  {
    "name": "LA SANITARIA DI LAURA FERMI",
    "address": "Via Garibaldi 82, SPOTORNO SV 17028, Italia",
    "lat": 44.2253242,
    "lng": 8.41645,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2253242,8.41645"
  },
  {
    "name": "CA.MED. DI REPETTO AURORA sas",
    "address": "C.so Dante 44-46, CHIAVARI GE 16043, Italia",
    "lat": 44.3144278,
    "lng": 9.3321733,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3144278,9.3321733"
  },
  {
    "name": "CODUTO DAMIANO ORTOPEDIA SANITARIA",
    "address": "Via Fumagalli, 12, INZAGO MI 20065, Italia",
    "lat": 45.5425221,
    "lng": 9.4831025,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5425221,9.4831025"
  },
  {
    "name": "Ortopedia Castagna Centro Tecnico Riabilitativo S.r.l.",
    "address": "Via Ghislanzoni 18 B, LECCO LC 23900, Italia",
    "lat": 45.8471041,
    "lng": 9.3997317,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8471041,9.3997317"
  },
  {
    "name": "Sanitaria Pieffe s.a.s. di Caselli Katia e Moscatelli Monia",
    "address": "Via V.Emanuele Orlando 2, CITTA' DI CASTELLO PG 06012, Italia",
    "lat": 43.4511199,
    "lng": 12.2460395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4511199,12.2460395"
  },
  {
    "name": "Maurizia Ortopedia Di Bondi Maurizia",
    "address": "Via Giardini, 171, PAVULLO NEL FRIGNANO MO 41026, Italia",
    "lat": 44.3186022,
    "lng": 10.8344585,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3186022,10.8344585"
  },
  {
    "name": "SA.FE ORTOPEDIA S.A.S. di Ferri Sebastiano",
    "address": "Via Marconi Guglielmo, 7, CARAVAGGIO BG 24043, Italia",
    "lat": 45.4970409,
    "lng": 9.6445748,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4970409,9.6445748"
  },
  {
    "name": "CENTRO ORTOPEDICO SANITARIA BRESCIANA",
    "address": "V.Piave 201, BRESCIA BS 25123, Italia",
    "lat": 45.5303261,
    "lng": 10.2468389,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5303261,10.2468389"
  },
  {
    "name": "RISANA S.R.L.S",
    "address": "Viale Po, 10, CREMONA CR 26100, Italia",
    "lat": 45.1321583,
    "lng": 10.0157014,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1321583,10.0157014"
  },
  {
    "name": "ORTOPEDIA SANITARIA SIGNORI CLOTILDE & C. SNC",
    "address": "Via Brunati, 19, SALO' BS 25087, Italia",
    "lat": 45.6075529,
    "lng": 10.5328721,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6075529,10.5328721"
  },
  {
    "name": "ORTOPEDIA PASSONI Srl",
    "address": "Via Lombroso 12, PAVIA PV 27100, Italia",
    "lat": 45.1953589,
    "lng": 9.1480951,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1953589,9.1480951"
  },
  {
    "name": "G.A.M. SRL",
    "address": "Via Cavour 11/15, CASALPUSTERLENGO LO 26841, Italia",
    "lat": 45.1813722,
    "lng": 9.6495266,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1813722,9.6495266"
  },
  {
    "name": "L'ORTOPEDIA DI LINDA POLTRONIERI",
    "address": "Corso XXVI Aprile, 20, STRADELLA PV 27049, Italia",
    "lat": 45.0760996,
    "lng": 9.3003561,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0760996,9.3003561"
  },
  {
    "name": "FARMACIA VARINELLI S.N.C. DI D.SSA SILVANA VARINELLI & C.",
    "address": "Via Nazionale 88, CASAZZA BG 24060, Italia",
    "lat": 45.7503354,
    "lng": 9.9085745,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7503354,9.9085745"
  },
  {
    "name": "SANITARIA FRANCIACORTA DI OMODEI GIOVANNA",
    "address": "Via I.Lama, TIMOLINE DI CORTE FRANCA BS 25050, Italia",
    "lat": 45.6373372,
    "lng": 10.0110224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6373372,10.0110224"
  },
  {
    "name": "FARMACIA RAMBELLI",
    "address": "Via Ravegnana 149, FORLI' FC 47100, Italia",
    "lat": 44.226356,
    "lng": 12.0473262,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.226356,12.0473262"
  },
  {
    "name": "SANITAS SRL",
    "address": "Piazza Cavour, 25, PINEROLO TO 10064, Italia",
    "lat": 44.8851208,
    "lng": 7.3314549,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8851208,7.3314549"
  },
  {
    "name": "FARMACIA PIAZZA QUADRATA - SOCIETA' A RESPONSABILITA' LIMITATA",
    "address": "Viale Regina Margherita, 61/63/65, ROMA RM 00198, Italia",
    "lat": 41.9138938,
    "lng": 12.5053775,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9138938,12.5053775"
  },
  {
    "name": "VAL BIO PARAFARMACIA sas",
    "address": "Via C. Battisti, 1, CHIERI TO 10023, Italia",
    "lat": 45.00807,
    "lng": 7.8234899,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.00807,7.8234899"
  },
  {
    "name": "FARMACIA DEL MOLINO di OK PHARMA s.n.c.",
    "address": "Via Molino 15, VOLVERA TO 10040, Italia",
    "lat": 44.9529509,
    "lng": 7.510071,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9529509,7.510071"
  },
  {
    "name": "FARMACIA MONTANARI",
    "address": "Via Mattei 30, RAVENNA RA 48100, Italia",
    "lat": 44.434905,
    "lng": 12.2070873,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.434905,12.2070873"
  },
  {
    "name": "FARMACIA SAN FRANCESCO",
    "address": "Corso Emaldi 27, FUSIGNANO RA 48010, Italia",
    "lat": 44.4673978,
    "lng": 11.961515,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4673978,11.961515"
  },
  {
    "name": "ORTOPEDIA CRISPI S.R.L.",
    "address": "Viale Mecenate 521, AREZZO AR 52100, Italia",
    "lat": 43.4548099,
    "lng": 11.8809695,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4548099,11.8809695"
  },
  {
    "name": "FARMACIA Dott. ROGGERO MARIANGELA",
    "address": "Piazza della Libertà, 7, BROSSASCO CN 12020, Italia",
    "lat": 44.5685998,
    "lng": 7.3601745,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5685998,7.3601745"
  },
  {
    "name": "NEW PHARMA PARAFARMACIA di ALLEGRINI Dr.ssa MARICLA",
    "address": "Via Novara 18, GHEMME NO 28074, Italia",
    "lat": 45.5952294,
    "lng": 8.4236788,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5952294,8.4236788"
  },
  {
    "name": "FARMACIA RICCI S.R.L.",
    "address": "Via Domenico Carbone, 38, VILLALVERNIA AL 15050, Italia",
    "lat": 46.2652364,
    "lng": 11.3390292,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.2652364,11.3390292"
  },
  {
    "name": "FARMACIA SANT'ANNA Dott.ssa Serratore Francesca",
    "address": "P.zza Vittorio Veneto 13, VINADIO CN 12010, Italia",
    "lat": 44.3066957,
    "lng": 7.1735774,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3066957,7.1735774"
  },
  {
    "name": "Chiera & Tessaro Di Francesco Chiera Ed Eleonora Tessaro Snc",
    "address": "Via Aosta, 10, IVREA TO 10015, Italia",
    "lat": 45.5116363,
    "lng": 7.856154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5116363,7.856154"
  },
  {
    "name": "PARAFARMACIA FOLETTO di Dott.ssa FOLETTO STEFANIA",
    "address": "Via Iside Viana, 29, CANDELO BI 13878, Italia",
    "lat": 45.5441163,
    "lng": 8.1050481,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5441163,8.1050481"
  },
  {
    "name": "FDA s.n.c. di Donolato Antonio & C.",
    "address": "Via Guido Martino , 8, CUNEO CN 12100, Italia",
    "lat": 44.4215142,
    "lng": 7.552589,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4215142,7.552589"
  },
  {
    "name": "I.T.O.S. CUNEO snc di Leto Patrizia e Luciano Massimo",
    "address": "Corso Duca degli Abruzzi, 4, TORINO TO 10128, Italia",
    "lat": 45.0668889,
    "lng": 7.6655682,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0668889,7.6655682"
  },
  {
    "name": "FARMACIA D.SSA TERESA SILVAGNI",
    "address": "Corso Alagon, CUGLIERI - Santa caterina OR 09073, Italia",
    "lat": 40.1051093,
    "lng": 8.4908899,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.1051093,8.4908899"
  },
  {
    "name": "FARMACIA FOCO DI FOCO GIORGIO",
    "address": "P.zz Risorgimento, 7, STAZZANO AL 15060, Italia",
    "lat": 44.7266795,
    "lng": 8.8678263,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7266795,8.8678263"
  },
  {
    "name": "PARAFARMACIA Dott. PAOLO CHIARI",
    "address": "C.so Nizza, 40, CUNEO CN 12100, Italia",
    "lat": 44.3855735,
    "lng": 7.5435524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3855735,7.5435524"
  },
  {
    "name": "PARAFARMACIA VALOBRA DI REPACI DONATELLA",
    "address": "Via Valobra F. , 27, Carmagnola TO 10022, Italia",
    "lat": 44.8466074,
    "lng": 7.7215221,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8466074,7.7215221"
  },
  {
    "name": "APPLICAZIONI ORTOPEDICHE POZZATO DI POZZATI GABRIELE & C. SAS",
    "address": "Via Matteotti, 1, COSSATO BI 13014, Italia",
    "lat": 45.5671111,
    "lng": 8.1748477,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5671111,8.1748477"
  },
  {
    "name": "P. & P. ORTHOSANITARI SNC",
    "address": "Via Sebastiano Caboto, 5, TORINO TO 10128, Italia",
    "lat": 45.0542892,
    "lng": 7.6637319,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0542892,7.6637319"
  },
  {
    "name": "CENTRO ORTOPEDICO DI BORGOMANERO",
    "address": "V.le Kennedy, 40, BORGOMANERO NO 28021, Italia",
    "lat": 45.710557,
    "lng": 8.4532964,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.710557,8.4532964"
  },
  {
    "name": "FARMACIA S.PAOLO DOTT.SSA MASCHIETTO GRAZIELLA",
    "address": "Via Ticino 4/A, RIVOLI TO 10098, Italia",
    "lat": 45.0694546,
    "lng": 7.5409259,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0694546,7.5409259"
  },
  {
    "name": "GRUPPO FARMACIE BENESSERE SNC",
    "address": "Via Roma, 48, CANALE CN 12043, Italia",
    "lat": 44.7966891,
    "lng": 7.991468,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7966891,7.991468"
  },
  {
    "name": "FARMACIA Dott.ssa MARIA LORENZA BORRETTA",
    "address": "Via Umberto I, 86, POLONGHERA CN 12030, Italia",
    "lat": 44.8051026,
    "lng": 7.5951442,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8051026,7.5951442"
  },
  {
    "name": "PARAFARMACIA LAL snc della Dott. Giovanna Bergaglio",
    "address": "Via Dante, 48, ALESSANDRIA AL 15121, Italia",
    "lat": 44.9130917,
    "lng": 8.619248,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9130917,8.619248"
  },
  {
    "name": "F.CIA SAN LORENZO DI MONDINO STEFANO",
    "address": "Via Silvio Pellico, 1, NONE TO 10060, Italia",
    "lat": 44.9338859,
    "lng": 7.5416946,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9338859,7.5416946"
  },
  {
    "name": "GENCHI FARMA di Guelfo Genchi",
    "address": "Strada Provinciale, Via S. Giorgio, TRIGGIANO BA 70019, Italia",
    "lat": 41.0736047,
    "lng": 16.9373269,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0736047,16.9373269"
  },
  {
    "name": "FARMACIA MARI di Paolini Samuele & C. s.a.s.",
    "address": "Via F.lli Rosselli, 42, PESARO PU 61121, Italia",
    "lat": 42.65607,
    "lng": 12.427455,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.65607,12.427455"
  },
  {
    "name": "PARAFARMACIA VITTORI SAS DI VITTORIO VITTORI & C.",
    "address": "Via Salaria, 34, SPINETOLI AP 63078, Italia",
    "lat": 42.8718266,
    "lng": 13.7619615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8718266,13.7619615"
  },
  {
    "name": "SANITARIA AMBROGIANI F. & C. s.n.c.",
    "address": "Galleria dei Fonditori, 30, PESARO PU 61122, Italia",
    "lat": 43.9009202,
    "lng": 12.902052,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9009202,12.902052"
  },
  {
    "name": "FARMACIA di BOSSOLASCO di Dr. CORTE sas",
    "address": "C.so Della Valle 20, BOSSOLASCO CN 12060, Italia",
    "lat": 44.5309443,
    "lng": 8.0485073,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5309443,8.0485073"
  },
  {
    "name": "FARMACIA FERMI S.N.C.",
    "address": "Corso Cervi Fratelli 17/5, COLLEGNO TO 10093, Italia",
    "lat": 45.077043,
    "lng": 7.587471,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.077043,7.587471"
  },
  {
    "name": "FARMACIA SANTA RITA snc di C. Alessio e S. Madaffari",
    "address": "Viale XXI Aprile, 2, ROMA RM 00161, Italia",
    "lat": 41.9207188,
    "lng": 12.518171,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9207188,12.518171"
  },
  {
    "name": "FARMACIA ALBA",
    "address": "Via Mazzini, 3, SOLAROLO RA 48027, Italia",
    "lat": 44.360137,
    "lng": 11.8441694,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.360137,11.8441694"
  },
  {
    "name": "FARMACIA DOTT. ARTUFFO GIUSEPPE",
    "address": "Via XX Settembre 30, SANTO STEFANO BELBO CN 12058, Italia",
    "lat": 44.707937,
    "lng": 8.2323043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.707937,8.2323043"
  },
  {
    "name": "ORTOPEDIA C.P.O. di Tanganelli Fabio",
    "address": "Via Carlo Rolando 12 R, GENOVA GE 16151, Italia",
    "lat": 44.4138841,
    "lng": 8.8882664,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4138841,8.8882664"
  },
  {
    "name": "ORTOFARM s.a.s. di Alessandro Ramognino e C.",
    "address": "Via Roma 110, LA SPEZIA SP 19122, Italia",
    "lat": 44.1074607,
    "lng": 9.8161743,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1074607,9.8161743"
  },
  {
    "name": "FARMACIE COMUNALI DI RICCIONE SPA",
    "address": "Via Veneto n.28, RICCIONE RN 47838, Italia",
    "lat": 40.270163,
    "lng": 18.335624,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.270163,18.335624"
  },
  {
    "name": "FARMACIA GRASSI di Pierluigi e Francesco snc",
    "address": "Via Gramsci 9, CESENATICO FC 47042, Italia",
    "lat": 44.1931641,
    "lng": 12.38371,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1931641,12.38371"
  },
  {
    "name": "AULLA SALUTESTORE di ILARIA BATTAGLIA",
    "address": "Via resistenza 17, AULLA MS 54011, Italia",
    "lat": 44.2149691,
    "lng": 9.9667838,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2149691,9.9667838"
  },
  {
    "name": "FARMACIA CIOCI ROMANO EMANUELE",
    "address": "Via Gramsci 65, OSTRA AN 60010, Italia",
    "lat": 43.6124243,
    "lng": 13.1570062,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6124243,13.1570062"
  },
  {
    "name": "Farmacia Roggia snc",
    "address": "Piazza Vermenagna, 1, VERNANTE CN 12019, Italia",
    "lat": 44.2430208,
    "lng": 7.5337807,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2430208,7.5337807"
  },
  {
    "name": "FARMACIA D'AURIZIO del Dr. Giovanni D'Aurizio & C. SNC",
    "address": "Via Marsala, 50, SAN BENEDETTO DEL TRONTO AP 63074, Italia",
    "lat": 42.957506,
    "lng": 13.879493,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.957506,13.879493"
  },
  {
    "name": "ORTOPEDIA BARANI VALERIA",
    "address": "Via P.Anfossi, 43, GENOVA GE 16164, Italia",
    "lat": 44.4987258,
    "lng": 8.9036793,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4987258,8.9036793"
  },
  {
    "name": "FARMACIA MONETA CAGLIO da RE' di Maria Isabella",
    "address": "P.zza Germania Bonomelli, 5, ROMA RM 00154, Italia",
    "lat": 41.8647297,
    "lng": 12.4919937,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8647297,12.4919937"
  },
  {
    "name": "Farmar S.a.s. Di Avoni Marco E C.",
    "address": "Via Fernando Santi, 36, DOZZA BO 40060, Italia",
    "lat": 44.3797986,
    "lng": 11.6482201,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3797986,11.6482201"
  },
  {
    "name": "C.O.S. CENTRO ORTOPEDICO SANITARIO di Silvia Guidi & C. snc",
    "address": "Via di Pratale ang. Ugo Foscolo 2/A, PISA PI 56127, Italia",
    "lat": 43.722327,
    "lng": 10.415108,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.722327,10.415108"
  },
  {
    "name": "Farmacia Golinelli Del Dott. Giovanni Golinelli & C. S.N.C.",
    "address": "Via San Matteo, 8, MEDOLLA MO 41036, Italia",
    "lat": 44.8474732,
    "lng": 11.0714737,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8474732,11.0714737"
  },
  {
    "name": "FARMACIA ZUCCARI snc di Pierluigi e Germana Zuccari",
    "address": "Via Bologna, 181/A, FORLI' FC 47100, Italia",
    "lat": 44.1644853,
    "lng": 12.175976,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1644853,12.175976"
  },
  {
    "name": "FARMACIA ARTEMISIA snc",
    "address": "Via Giardini Nord, 446/B, CASINALBO MO 41041, Italia",
    "lat": 44.5989398,
    "lng": 10.8635103,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5989398,10.8635103"
  },
  {
    "name": "RAVENNA FARMACIE",
    "address": "Via Fiume montone Abbandonato, 124, RAVENNA RA 48124, Italia",
    "lat": 44.4133467,
    "lng": 12.1855313,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4133467,12.1855313"
  },
  {
    "name": "SANITARIA ROTEGLIESE DI MONTERMINI LUCIA",
    "address": "Via Radici in Monte 126, CASTELLARANO RE 42014, Italia",
    "lat": 44.4907288,
    "lng": 10.6993441,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4907288,10.6993441"
  },
  {
    "name": "FARMACIA MATTIOLI di Mattioli Giuseppe & C. SNC",
    "address": "Via Idice 54, OZZANO DELL'EMILIA - Mercatale BO 40064, Italia",
    "lat": 44.391416,
    "lng": 11.4288739,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.391416,11.4288739"
  },
  {
    "name": "FARMACIA GUBERTINI Di Fumanelli Dr. Laura",
    "address": "Via Nazario Sauro, 53, MANZOLINO MO 41013, Italia",
    "lat": 44.5956824,
    "lng": 11.0993103,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5956824,11.0993103"
  },
  {
    "name": "FARMACIA STORI Dott.ssa Fiammetta Stori e C. SAS",
    "address": "Via Nazionale n. 141/B, ALTEDO BO 40051, Italia",
    "lat": 44.665857,
    "lng": 11.4879119,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.665857,11.4879119"
  },
  {
    "name": "FARMACIA MIRABELLA S.R.L.",
    "address": "S.S. 32 Ticinese, 17/19, VARALLO POMBIA NO 28040, Italia",
    "lat": 45.66246,
    "lng": 8.618638,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.66246,8.618638"
  },
  {
    "name": "FARMACIA SAN MATTEO di Evangelista Maria Cecilia",
    "address": "Via Pioppe, 1, SAN GIOVANNI IN PERSICETO - San matteo della decima BO 40017, Italia",
    "lat": 44.7055127,
    "lng": 11.2287877,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7055127,11.2287877"
  },
  {
    "name": "FARGEOT & Cie S.A.S. - Podowell",
    "address": "Route de Limoges, Thiviers 24800, Francia",
    "lat": 45.4706623,
    "lng": 0.9420717,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4706623,0.9420717"
  },
  {
    "name": "FARMACIA ALLE SCUOLE",
    "address": "Viale dei Martiri, 10B, CASTEL GUELFO DI BOLOGNA BO 40023, Italia",
    "lat": 44.4315528,
    "lng": 11.6752265,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4315528,11.6752265"
  },
  {
    "name": "PARAFARMACIA FIUME GIALLO S.A.S. Dott.ssa ELENA MOSCA",
    "address": "Via Fiume Giallo 399, ROMA RM 00144, Italia",
    "lat": 41.8141952,
    "lng": 12.4326589,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8141952,12.4326589"
  },
  {
    "name": "SANITY E....di Balaris Valeria",
    "address": "Via Pinerolo, 47, PIOSSASCO TO 10045, Italia",
    "lat": 44.9770835,
    "lng": 7.4494621,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9770835,7.4494621"
  },
  {
    "name": "ORTOPEDIA CLA.RO. DI CASAGRANDE MARIA LETIZIA & C. SAS",
    "address": "Viale Saffi, 28, NOVI LIGURE AL 15067, Italia",
    "lat": 44.7624746,
    "lng": 8.7862744,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7624746,8.7862744"
  },
  {
    "name": "FARMACIA SAN VITALE",
    "address": "Via Martiri della Libertà, 109, MASSA LOMBARDA RA 48024, Italia",
    "lat": 44.4507934,
    "lng": 11.8125677,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4507934,11.8125677"
  },
  {
    "name": "ORT. RONDONOTTI snc di Ballaratti e Maugeri",
    "address": "C.so Mazzini, 33, NOVARA NO 28100, Italia",
    "lat": 45.4426827,
    "lng": 8.623189,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4426827,8.623189"
  },
  {
    "name": "Farmacia Sarti Dei Dott.Ri Tosi Giuseppe E Ugo Maria Snc",
    "address": "Via Giacomo Matteotti, 28, CASTEL SAN PIETRO TERME BO 40024, Italia",
    "lat": 44.3986607,
    "lng": 11.590421,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3986607,11.590421"
  },
  {
    "name": "POSSETTI DI POSSETTI D. E C. SNC",
    "address": "C.so Torino, 86, PINEROLO TO 10064, Italia",
    "lat": 44.8896241,
    "lng": 7.3642844,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8896241,7.3642844"
  },
  {
    "name": "ORTOPEDIA PELLETTERIA CUGINI DI CUGINI P.M. & C. SNC",
    "address": "Via Mazzini, 47/49, ALBINO BG 24021, Italia",
    "lat": 45.7571611,
    "lng": 9.7916673,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7571611,9.7916673"
  },
  {
    "name": "MEDISAN sas di Paola Caterina",
    "address": "Largo Tirreno, 129, TORINO TO 10136, Italia",
    "lat": 45.0521582,
    "lng": 7.6502611,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0521582,7.6502611"
  },
  {
    "name": "MEDICAL SUPPORTI SRL",
    "address": "Via G. Fucà, 2/A, RAGUSA RG 97100, Italia",
    "lat": 36.924206,
    "lng": 14.728147,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=36.924206,14.728147"
  },
  {
    "name": "Bottega di Ortopedia Sanithospital srl",
    "address": "Via F.lli Parodi, 26/F, CASALE MONFERRATO AL 15033, Italia",
    "lat": 45.130629,
    "lng": 8.451483,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.130629,8.451483"
  },
  {
    "name": "S.F.E.R.A. s.r.l.",
    "address": "Via della Serenina 1/a, IMOLA BO 40026, Italia",
    "lat": 44.353405,
    "lng": 11.714131,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.353405,11.714131"
  },
  {
    "name": "FARMACIA DELL'APA s.n.c.",
    "address": "Piazza Giovanni Leccis, 15, DOMUSNOVAS CI 09015, Italia",
    "lat": 39.305106,
    "lng": 8.53334,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.305106,8.53334"
  },
  {
    "name": "Farmacia Dott. CIANA PIERINA",
    "address": "Via A. Di Dio, 33, ORNAVASSO VB 28877, Italia",
    "lat": 45.970886,
    "lng": 8.414438,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.970886,8.414438"
  },
  {
    "name": "ANTICA FARMACIA DEI SERVI",
    "address": "Strada Maggiore, 39, BOLOGNA BO 40125, Italia",
    "lat": 44.4922122,
    "lng": 11.3514849,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4922122,11.3514849"
  },
  {
    "name": "REHATTIVA S.R.L.",
    "address": "Via Cremasca, 50, AZZANO SAN PAOLO BG 24052, Italia",
    "lat": 45.6589648,
    "lng": 9.6807466,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6589648,9.6807466"
  },
  {
    "name": "AUDIOMED SRL",
    "address": "CORSO LAGHI 62/A, AVIGLIANA TO 10051, Italia",
    "lat": 45.082474,
    "lng": 7.401094,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.082474,7.401094"
  },
  {
    "name": "G.L.O. srl",
    "address": "Via Caracci, 19/A, CASALECCHIO DI RENO BO 40033, Italia",
    "lat": 44.487853,
    "lng": 11.289722,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.487853,11.289722"
  },
  {
    "name": "ORTHOSHOPS Srl",
    "address": "Via Nobel 88, REGGIO EMILIA RE 42121, Italia",
    "lat": 44.7296903,
    "lng": 10.6403787,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7296903,10.6403787"
  },
  {
    "name": "DRF s.r.l.",
    "address": "Via Tavernola, 16, CASANDRINO NA 80025, Italia",
    "lat": 40.916482,
    "lng": 14.253364,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.916482,14.253364"
  },
  {
    "name": "FARMACIA CICOGNANI del Dott. Lucio Gurioli e C. sas",
    "address": "Viale Fratelli Spazzoli, 83, FORLI' FC 47121, Italia",
    "lat": 44.2118601,
    "lng": 12.0520577,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2118601,12.0520577"
  },
  {
    "name": "FARMACIA DEDOLA DR.SSA TERESA",
    "address": "Via Curie Pietro E Maria, 35, CAGLIARI CA 09126, Italia",
    "lat": 39.208158,
    "lng": 9.136798,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.208158,9.136798"
  },
  {
    "name": "FARMACIA MGF di Pagella Danilo & C. SNC",
    "address": "Via Alessandria, 25, BASSIGNANA AL 15042, Italia",
    "lat": 45.0001765,
    "lng": 8.7311784,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0001765,8.7311784"
  },
  {
    "name": "FARMACIA DOTT. EMER DI EMER ROBERTO & C snc",
    "address": "C.so Garibaldi, 47, BAVENO VB 28831, Italia",
    "lat": 45.9102974,
    "lng": 8.5047818,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9102974,8.5047818"
  },
  {
    "name": "FARMACIA PIETRO PISANI dei Dott.ri MARIA GRAZIA & VITTORIO PISANI SNC",
    "address": "Via Gramsci, 63, GAGLIANICO BI 13894, Italia",
    "lat": 45.5409272,
    "lng": 8.0721249,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5409272,8.0721249"
  },
  {
    "name": "L'ORTOPEDIA FOSSANESE di Dalmasso Erika",
    "address": "Via Ospedale, 15, FOSSANO CN 12045, Italia",
    "lat": 44.547784,
    "lng": 7.7238949,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.547784,7.7238949"
  },
  {
    "name": "PARAFARMACIA Dott. De Angelis CATOPHARM S.A.S.",
    "address": "V.le Marconi, snc, SUTRI VT 01015, Italia",
    "lat": 42.2436847,
    "lng": 12.2200503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2436847,12.2200503"
  },
  {
    "name": "FARMACIA DELLE PALME Dr.ssa Cascianini Cosetta",
    "address": "Via delle Palme, 5/e, BRACCIANO RM 00062, Italia",
    "lat": 42.0996813,
    "lng": 12.1557813,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0996813,12.1557813"
  },
  {
    "name": "FARMACIA BORSO' Dr. FRANCO",
    "address": "Via dei Bonificatori, 10, BORGO VODICE LT 04010, Italia",
    "lat": 41.3386917,
    "lng": 13.1037379,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.3386917,13.1037379"
  },
  {
    "name": "FARMACIA TARQUINI SRL",
    "address": "Via Paolo Laziale, 12/16, Ladispoli RM 00055, Italia",
    "lat": 41.945666,
    "lng": 12.085609,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.945666,12.085609"
  },
  {
    "name": "DI.BA. SANITARIA S.r.l. di Barbara Di Giovanni",
    "address": "Viale Crispi, 103, TERAMO TE 64100, Italia",
    "lat": 42.6600061,
    "lng": 13.7141249,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6600061,13.7141249"
  },
  {
    "name": "FARMACIA TOTI S.R.L.",
    "address": "Via XXV Aprile n°15/23, CIVITAVECCHIA RM 00053, Italia",
    "lat": 42.096696,
    "lng": 11.799813,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.096696,11.799813"
  },
  {
    "name": "FARMACIA INFERNETTO SAS DOTT. GORETTI PIZZUTI A.",
    "address": "Via Umberto Giordano, 93, ROMA RM 00124, Italia",
    "lat": 41.7410699,
    "lng": 12.3608551,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7410699,12.3608551"
  },
  {
    "name": "Farmacia Forli Chiara di Chiara Forli &c snc",
    "address": "Via Casilina Km.62, 200, ANAGNI FR 03012, Italia",
    "lat": 41.721902,
    "lng": 13.186569,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.721902,13.186569"
  },
  {
    "name": "PHARMASITE di Dott.ssa Salehi Allameh Elham",
    "address": "P.za 1° Maggio 3, PONT SAINT MARTIN AO 11026, Italia",
    "lat": 45.6005762,
    "lng": 7.7965397,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6005762,7.7965397"
  },
  {
    "name": "FARMACIA BALESTRINI S.A.S.",
    "address": "Via Pietro Micca, 8, BIELLA BI 13900, Italia",
    "lat": 45.5620444,
    "lng": 8.0516663,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5620444,8.0516663"
  },
  {
    "name": "FARMACIE COMUNALI SRL",
    "address": "Via della Scafa, 145/D, FIUMICINO RM 00054, Italia",
    "lat": 41.7694199,
    "lng": 12.245888,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7694199,12.245888"
  },
  {
    "name": "ORTHOS s.r.l.",
    "address": "Viale Vibrata, 10, CORROPOLI TE 64013, Italia",
    "lat": 42.815728,
    "lng": 13.8534873,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.815728,13.8534873"
  },
  {
    "name": "INIZIATIVE FARMACIA CELADON S.N.C.",
    "address": "Via San Donato, 92, GRANAROLO DELL'EMILIA BO 40057, Italia",
    "lat": 44.551303,
    "lng": 11.4469139,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.551303,11.4469139"
  },
  {
    "name": "Farmacia Dottori Matteo e Marta Cecchi snc",
    "address": "Via Roma, 10, LORO PICENO MC 62020, Italia",
    "lat": 41.906389,
    "lng": 12.7356023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.906389,12.7356023"
  },
  {
    "name": "PARAFARMACIA GOCCE DI SALUTE della Dott.ssa Rosaria Laguardia",
    "address": "Via del Commercio 1, CASTELPLANIO AN 60031, Italia",
    "lat": 43.500429,
    "lng": 13.1112108,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.500429,13.1112108"
  },
  {
    "name": "FARMACIA SAN GIOVANNI DR VALLA LUIGI CAVALLINI ROBERTO & C SNC",
    "address": "Via Papa Giovanni XXII n° 27, CAMERANO  AN 60021, Italia",
    "lat": 43.5298577,
    "lng": 13.5486993,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5298577,13.5486993"
  },
  {
    "name": "LABORATORIO ORTOPEDICO SPECIALIZZATO PANICHELLI ARMANDO & C SNC",
    "address": "Via De Amicis, 24/26, CIVITANOVA MARCHE MC 62012, Italia",
    "lat": 43.3062549,
    "lng": 13.7221426,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3062549,13.7221426"
  },
  {
    "name": "FARMACIA CALCATERRA DOTTORESSE CARLA E PAOLA SNC",
    "address": "P.zza Magagnini, 3, SANTA MARIA NUOVA AN 60030, Italia",
    "lat": 43.4957587,
    "lng": 13.3091395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4957587,13.3091395"
  },
  {
    "name": "S.O.M. SRL OFFICINE ORTOPEDICHE",
    "address": "Via Roma, 301/A, AVEZZANO AQ 67051, Italia",
    "lat": 42.0324404,
    "lng": 13.4206878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0324404,13.4206878"
  },
  {
    "name": "FARMACIA VANNINI Dr.ssa Maria Lorena",
    "address": "Via Roma, 55, MORRO D'ALBA AN 60030, Italia",
    "lat": 43.599561,
    "lng": 13.212615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.599561,13.212615"
  },
  {
    "name": "Parafarmacia MediPharma s.n.c. di Dott.ssa Cannarsa e Dott.ssa Cavina",
    "address": "Via L.Fava, 421/19, MEDICINA BO 40059, Italia",
    "lat": 44.4796804,
    "lng": 11.6366763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4796804,11.6366763"
  },
  {
    "name": "FARMACIA FARINA S.A.S. D.ssa Conimi Federica & C",
    "address": "Via Stella, 34, BROCCOSTELLA FR 03030, Italia",
    "lat": 41.7020266,
    "lng": 13.6401463,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7020266,13.6401463"
  },
  {
    "name": "FARMACIA PIFERI del Dr. SERAFINI MARCO e C. SNC",
    "address": "Viale dei Navigatori 37, PUNTA MARINA RA 48122, Italia",
    "lat": 44.4412551,
    "lng": 12.2936547,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4412551,12.2936547"
  },
  {
    "name": "FARMACIA VIALE GIULIO CESARE SNC",
    "address": "Viale Giulio Cesare 201, NOVARA NO 28100, Italia",
    "lat": 45.4347136,
    "lng": 8.6175936,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4347136,8.6175936"
  },
  {
    "name": "FARMACIA BALDINELLI DEI DOTTORI BALDINELLI FABIO ED ALICE S.N.C.",
    "address": "Via Tiburtina, 349, TIVOLI - Tivoli terme RM 00011, Italia",
    "lat": 41.9523931,
    "lng": 12.7221091,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9523931,12.7221091"
  },
  {
    "name": "FARMACIA DR.SSA MANUELA SVEGLIATI",
    "address": "Piazza Umberto I°, 13, MONTE SAN PIETRANGELI FM 63815, Italia",
    "lat": 42.4389317,
    "lng": 11.1169447,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4389317,11.1169447"
  },
  {
    "name": "PARAFARMACIA SAN ROCCO di Dott.ssa CHIARA CANETTA",
    "address": "Corso Valsesia, 95, GATTINARA VC 13045, Italia",
    "lat": 45.6164313,
    "lng": 8.3709967,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6164313,8.3709967"
  },
  {
    "name": "FARMACIA MOSCIONI E CANTARINI della Dott.ssa Cantarini Rosa snc",
    "address": "Strada Nazionale Flaminia, 232, CUCCURANO PU 61031, Italia",
    "lat": 43.8038601,
    "lng": 12.9757629,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8038601,12.9757629"
  },
  {
    "name": "L'OFFICINA DI PANDORA DI SARA RICCIONI",
    "address": "Via Gorgonero, 22, SAN SEVERINO MARCHE MC 62027, Italia",
    "lat": 43.2315185,
    "lng": 13.1786113,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2315185,13.1786113"
  },
  {
    "name": "PARAFARMACIA L'AMAMELIDE D.ssa Coro Caterina",
    "address": "V.le Tommaso Tittoni, 58, SAN FELICE CIRCEO LT 04017, Italia",
    "lat": 41.2427214,
    "lng": 13.0938853,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2427214,13.0938853"
  },
  {
    "name": "FARMACIA CRISTALLINI di Quondamatteo Laura",
    "address": "Piazza Mercato, 16/A, MONTEFANO MC 62010, Italia",
    "lat": 43.411883,
    "lng": 13.4399754,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.411883,13.4399754"
  },
  {
    "name": "FARMACIA DI BORGO TOSSIGNANO della Dott.ssa Claudia Zannoni e C. s.a.s",
    "address": "Via Mazzini, 6, BORGO TOSSIGNANO BO 40021, Italia",
    "lat": 44.277029,
    "lng": 11.5880285,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.277029,11.5880285"
  },
  {
    "name": "A.S.M.",
    "address": "Viale Buridani, 33, VENARIA REALE TO 10078, Italia",
    "lat": 45.1288292,
    "lng": 7.6304878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1288292,7.6304878"
  },
  {
    "name": "FARMACIA DELL'ELCE DI BEVILACQUA CARLO MARIA",
    "address": "Via Tragliatella km. 4,600, ANGUILLARA SABAZIA RM 00061, Italia",
    "lat": 42.0175598,
    "lng": 12.2425499,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0175598,12.2425499"
  },
  {
    "name": "FARMACIA MORELLI DI Morelli Dott. Fabiano",
    "address": "Via Puglia, 15, VITERBO - Grotte santo stefano VT 01026, Italia",
    "lat": 42.5187105,
    "lng": 12.1681956,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5187105,12.1681956"
  },
  {
    "name": "ANTICA FARMACIA ROSSI s.n.c. Dott Gabriele Rossi & C.",
    "address": "Largo donatori del Sangue, 1, Montelabbate PU 61025, Italia",
    "lat": 43.7973087,
    "lng": 12.8651314,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7973087,12.8651314"
  },
  {
    "name": "FARMACIA SANTERNO s.a.s. del Dott. Ambrogio Intilisano",
    "address": "Via Della Repubblica, 1, RAVENNA - Santerno RA 48100, Italia",
    "lat": 44.4351669,
    "lng": 12.0591352,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4351669,12.0591352"
  },
  {
    "name": "Parafarmacia DARSENA",
    "address": "Via Trieste 107, RAVENNA RA 48122, Italia",
    "lat": 44.4201673,
    "lng": 12.219986,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4201673,12.219986"
  },
  {
    "name": "Farmacia Radici dei dottori Femia, Gozzi, Lindner snc",
    "address": "Via Radici Sud, 7, CASTELLARANO RE 42014, Italia",
    "lat": 44.5083084,
    "lng": 10.7295225,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5083084,10.7295225"
  },
  {
    "name": "FARMACIA VECCO s.n.c.",
    "address": "Via Giovanni Lupo, 65, GRUGLIASCO TO 10095, Italia",
    "lat": 45.0652085,
    "lng": 7.5788171,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0652085,7.5788171"
  },
  {
    "name": "FARMACIA SANTA FRANCESCA s.n.c. della Dott.ssa Manfredi Raffaella e C.",
    "address": "Via L. Camusso, 2, OSASCO TO 10060, Italia",
    "lat": 44.8474724,
    "lng": 7.3458129,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8474724,7.3458129"
  },
  {
    "name": "PARAFARMACIA ANGELICA della Dott.ssa Paini Raffaella",
    "address": "Via Emilia, 105, PONTECURONE AL 15055, Italia",
    "lat": 44.9604477,
    "lng": 8.9326826,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9604477,8.9326826"
  },
  {
    "name": "FARMACIA DEL CAMPO D.ssa Molina Beatrice",
    "address": "Via Pontina, km 50,850, APRILIA LT 04011, Italia",
    "lat": 41.5791515,
    "lng": 12.6548528,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.5791515,12.6548528"
  },
  {
    "name": "SANITARIA CASTELLO ORTOPEDIA s.a.s. di BOCCHIMPANI Dr.ssa ROBERTA & C.",
    "address": "Via degli Spadari, 19-23/B, FERRARA FE 44121, Italia",
    "lat": 44.8388692,
    "lng": 11.6172419,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8388692,11.6172419"
  },
  {
    "name": "Antica Farmacia Bidone S.n.c. Dei Dott. Gasio Danilo E Linfante Amalio",
    "address": "Piazza Allende, 3, TORTONA AL 15057, Italia",
    "lat": 44.8969445,
    "lng": 8.8607337,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8969445,8.8607337"
  },
  {
    "name": "FARMACIA DELLA PISTA S.R.L. Dott.ssa PIACENZA MARINA e C.",
    "address": "Corso IV Novembre, 38, ALESSANDRIA AL 15121, Italia",
    "lat": 44.9043165,
    "lng": 8.6182972,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9043165,8.6182972"
  },
  {
    "name": "FARMACIA AEROPORTO della Dr.ssa Federica Di Renzo",
    "address": "Via del Triumvirato, 84, BOLOGNA BO 40132, Italia",
    "lat": 44.5299532,
    "lng": 11.293749,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5299532,11.293749"
  },
  {
    "name": "FARMACIA MAGNI E BOCCASANTA snc",
    "address": "Viale Passardi, 116, SCORTCHINO DI BONDENO FE 44012, Italia",
    "lat": 44.8785553,
    "lng": 11.326616,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8785553,11.326616"
  },
  {
    "name": "FARMACIA AGUGLIANO di Pranzetti Riccardo Maria e Annalisa s.n.c.",
    "address": "Piazza Vittorio Emanuele II, 19, AGUGLIANO AN 60020, Italia",
    "lat": 43.5434361,
    "lng": 13.387087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5434361,13.387087"
  },
  {
    "name": "FARMACIA STROZZIERI DR. STEFANO",
    "address": "Viale Giacomo Leopardi, 126, ACQUAVIVA PICENA AP 63075, Italia",
    "lat": 42.9439745,
    "lng": 13.8122635,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9439745,13.8122635"
  },
  {
    "name": "MEDICAM DI PUTELLI SERGIO",
    "address": "Via del Lanico, 45, MALEGNO BS 25053, Italia",
    "lat": 45.9472867,
    "lng": 10.2768882,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9472867,10.2768882"
  },
  {
    "name": "FARMACIA CARRATURO ELENA",
    "address": "Salita dell'Arco, 8, ARPINO FR 03033, Italia",
    "lat": 41.6485025,
    "lng": 13.610412,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6485025,13.610412"
  },
  {
    "name": "FARMACIA CASTELLO S.R.L.",
    "address": "Piazza Pierfrancesco Lorusso 15/A, CASTEL MAGGIORE BO 40013, Italia",
    "lat": 44.57434,
    "lng": 11.36796,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.57434,11.36796"
  },
  {
    "name": "FARMACIA LUIGI MARCONI sas",
    "address": "Via Giacomo Leopardi, 19, PEDASO FM 63827, Italia",
    "lat": 43.09839,
    "lng": 13.841143,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.09839,13.841143"
  },
  {
    "name": "PHARMA G.D.M. SRL",
    "address": "VIA DELL'ABBAZIA, 34, FANO PU 61032, Italia",
    "lat": 43.8373975,
    "lng": 13.0113233,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8373975,13.0113233"
  },
  {
    "name": "SPAZIO SALUTE SAN DECENZIO SRL",
    "address": "Via San Decenzio, 6, PESARO PU 61121, Italia",
    "lat": 43.9064429,
    "lng": 12.9125096,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9064429,12.9125096"
  },
  {
    "name": "ANTICA FARMACIA S.S. TRINITA'",
    "address": "P.zza Cavour, 22/B, COCCONATO AT 14023, Italia",
    "lat": 45.0860076,
    "lng": 8.0400882,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0860076,8.0400882"
  },
  {
    "name": "Farmacia Valle Santa s.n.c.",
    "address": "Via di Boccea, 1056, ROMA RM 00166, Italia",
    "lat": 41.9136609,
    "lng": 12.3894586,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9136609,12.3894586"
  },
  {
    "name": "Farmacia Collemarino Dr.ssa Sordoni & c. sas",
    "address": "Via Matteo Ricci, 15, ANCONA AN 60126, Italia",
    "lat": 43.6122061,
    "lng": 13.4343264,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6122061,13.4343264"
  },
  {
    "name": "FARMACIA SANTA RITA S.N.C. DEI DOTTORI GIOVANNI E VALENTINA LODO",
    "address": "P.zza Libertà 17, CODIGORO FE 44021, Italia",
    "lat": 44.8303642,
    "lng": 12.1073646,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8303642,12.1073646"
  },
  {
    "name": "Farmacia Cingolani Dott Cingolani Dario",
    "address": "Via San Filippo, 10, MAGLIANO DI TENNA FM 63832, Italia",
    "lat": 43.135772,
    "lng": 13.5961443,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.135772,13.5961443"
  },
  {
    "name": "FARMACIA SIMIUS s.a.s. di Carta Vincenzo & C.",
    "address": "Via Nino Bixio, VILLASIMIUS CA 09049, Italia",
    "lat": 39.1400987,
    "lng": 9.5221836,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.1400987,9.5221836"
  },
  {
    "name": "FARMADELTA DELLA DOTT.SSA ROBERTA PASQUALINI E C. S.A.S.",
    "address": "Via Romea, 14/B, COMACCHIO - Vaccolino FE 44020, Italia",
    "lat": 44.8051269,
    "lng": 12.1782051,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8051269,12.1782051"
  },
  {
    "name": "OFFICINA ORTOPEDICA SANREMESE",
    "address": "Via Nino Bixio 25/27, SAN REMO IM 18038, Italia",
    "lat": 43.8147534,
    "lng": 7.7763989,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8147534,7.7763989"
  },
  {
    "name": "FARMACIA PIEVE S.N.C.",
    "address": "Via Verdi, 104, NOVI LIGURE AL 15067, Italia",
    "lat": 44.7635014,
    "lng": 8.7980745,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7635014,8.7980745"
  },
  {
    "name": "FARMACIA MONTE CAMINETTO s.a.s.",
    "address": "Via Sacrofano Cassia, 5280, SACROFANO RM 00060, Italia",
    "lat": 42.0998842,
    "lng": 12.4532324,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0998842,12.4532324"
  },
  {
    "name": "FARMACIA GENOVESE",
    "address": "Via Carlo Alberto, 5, SAN GIORGIO CANAVESE TO 10090, Italia",
    "lat": 45.3354394,
    "lng": 7.7952566,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3354394,7.7952566"
  },
  {
    "name": "OBIETTIVO SALUTE ORTOPEDIA SANITARIA SNC",
    "address": "Viale Duca degli Abruzzi, 121, BRESCIA BS 25124, Italia",
    "lat": 45.5203215,
    "lng": 10.229518,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5203215,10.229518"
  },
  {
    "name": "FARMACIA DEL POPOLO DI IMARISIO MARCO & C. S.N.C.",
    "address": "Via Antica Dogana, 2, ASTI - Quarto d'asti AT 14030, Italia",
    "lat": 44.9571563,
    "lng": 8.2577699,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9571563,8.2577699"
  },
  {
    "name": "FARMACIA CALCATELLI di Calcatelli & C. SNC",
    "address": "Viale Puccini, 5, JESI AN 60035, Italia",
    "lat": 43.528062,
    "lng": 13.236187,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.528062,13.236187"
  },
  {
    "name": "ASPES S.p.A.",
    "address": "Viale Goffredo Mameli, 15, PESARO PU 61121, Italia",
    "lat": 43.9120072,
    "lng": 12.9038268,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9120072,12.9038268"
  },
  {
    "name": "NOVAFARM S.A.S. della D.SSA GIOVANNA ROSO & C.",
    "address": "Corso Divisione Acqui, 56, ACQUI TERME AL 15011, Italia",
    "lat": 44.6764043,
    "lng": 8.4634173,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6764043,8.4634173"
  },
  {
    "name": "FARMACIA PANATA FRANCESCO",
    "address": "Via Gramsci, 16/A, TREIA - Passo di treia MC 62010, Italia",
    "lat": 43.2855716,
    "lng": 13.3312425,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2855716,13.3312425"
  },
  {
    "name": "GUALERZI di Gualerzi Stefano e C. snc",
    "address": "Piazza della Repubblica, 12, FIDENZA PR 43036, Italia",
    "lat": 44.8674371,
    "lng": 10.0633326,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8674371,10.0633326"
  },
  {
    "name": "LP snc di Bettelli Patrizia & C",
    "address": "C.so Canalchiaro,97, MODENA MO 41100, Italia",
    "lat": 44.6447135,
    "lng": 10.923057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6447135,10.923057"
  },
  {
    "name": "FARMACIA DI ZOLA DELLA DR.SSA FRANCESCA GANDOLFI",
    "address": "Via Risorgimento 163/1-A-B, ZOLA PREDOSA BO 40069, Italia",
    "lat": 44.4925676,
    "lng": 11.2136363,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4925676,11.2136363"
  },
  {
    "name": "SANAVIT SNC DI ROMAGNANI SANDRO & C.",
    "address": "Viale E. Bagnoli, 68/C, CASTELNOVO NE' MONTI RE 42035, Italia",
    "lat": 44.4313091,
    "lng": 10.3950435,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4313091,10.3950435"
  },
  {
    "name": "FARMACIA DEL BIVIO Dr. ALESSANDRO GARDINI",
    "address": "Via dei Tulipani, 2, BIVIO MONTEGELLI FC 47030, Italia",
    "lat": 44.0145169,
    "lng": 12.2058903,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0145169,12.2058903"
  },
  {
    "name": "FARMACIA SAN GIACOMO del Dottor Fabrizio Roncarolo",
    "address": "Viale A. De Gasperi, 19/A, MONTEPRANDONE AP 63033, Italia",
    "lat": 42.899071,
    "lng": 13.856394,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.899071,13.856394"
  },
  {
    "name": "SANITARIA delle PALOMBARE di GUIDI LUCIA",
    "address": "Via Barilatti, 19, ANCONA AN 60127, Italia",
    "lat": 43.5936247,
    "lng": 13.5028475,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5936247,13.5028475"
  },
  {
    "name": "Farmacia Comunale Di Tolfa",
    "address": "Piazza Vittorio Veneto, 7, TOLFA RM 00059, Italia",
    "lat": 42.1496876,
    "lng": 11.9380741,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.1496876,11.9380741"
  },
  {
    "name": "PARAFARMACIA DEL LAGO srl di A.Firriolo & L.Cresca",
    "address": "Via Anguillarese, 22, ANGUILLARA SABAZIA RM 00061, Italia",
    "lat": 42.0885023,
    "lng": 12.278357,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0885023,12.278357"
  },
  {
    "name": "CIGNO ORTOPEDIA di A. CASAPIETRA di MASSILI P. e C. snc",
    "address": "Via Luciano Zamperini, 9Ar, GENOVA GE 16162, Italia",
    "lat": 44.456497,
    "lng": 8.9015703,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.456497,8.9015703"
  },
  {
    "name": "S.O.S. SERVIZI ORTOPEDICI SANITARI di IACONO NICOLE",
    "address": "Via Olivete, 25, ARENZANO GE 16011, Italia",
    "lat": 44.4051695,
    "lng": 8.6859092,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4051695,8.6859092"
  },
  {
    "name": "BERTOLUCCI T.O.P. s.r.l.",
    "address": "Viale Frosini Attilio, 28/34, PISTOIA PT 51100, Italia",
    "lat": 43.9279183,
    "lng": 10.9182187,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9279183,10.9182187"
  },
  {
    "name": "OFFICINA ORTOPEDICA PAVESE SRL",
    "address": "Viale Brambilla 34, PAVIA PV 27100, Italia",
    "lat": 45.1987391,
    "lng": 9.1509243,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1987391,9.1509243"
  },
  {
    "name": "FARMACIA BONFILI del Dr. R. Mannucci",
    "address": "Via Pietro Mauri, 6, FALCONARA MARITTIMA - Castelferretti AN 60015, Italia",
    "lat": 43.60552,
    "lng": 13.365201,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.60552,13.365201"
  },
  {
    "name": "FARMACIA ROMANI DR ROMANO",
    "address": "Via Picena 74, RIPE SAN GINESIO MC 62020, Italia",
    "lat": 43.1431935,
    "lng": 13.3620279,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1431935,13.3620279"
  },
  {
    "name": "BECCIO snc",
    "address": "Piazza Carducci, 128, TORINO TO 10126, Italia",
    "lat": 45.0421264,
    "lng": 7.6704318,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0421264,7.6704318"
  },
  {
    "name": "BIOMEDICA SU MISURA SRL",
    "address": "Via Rieti, 8, BRESCIA BS 25125, Italia",
    "lat": 45.5300483,
    "lng": 10.180564,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5300483,10.180564"
  },
  {
    "name": "FARMACIA MAROCCINI DELLA DOTT.SSA MAROCCINI ELEONORA",
    "address": "Via Luciano Laurana, 18-22, URBINO PU 61029, Italia",
    "lat": 43.7220894,
    "lng": 12.6386968,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7220894,12.6386968"
  },
  {
    "name": "SA.GE. SANITARIA GENOVESE di BARALDI G. & C. s.r.l.",
    "address": "Via Alessandro Repetto, 2, GENOVA GE 16143, Italia",
    "lat": 44.4083683,
    "lng": 8.9587413,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4083683,8.9587413"
  },
  {
    "name": "ORTOPEDIA ZAMBELLI SRL",
    "address": "VIA TARAMELLI 21/23, BERGAMO BG 24121, Italia",
    "lat": 45.6771506,
    "lng": 9.5564084,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6771506,9.5564084"
  },
  {
    "name": "ORTOMED s.r.l.",
    "address": "Via Rosselli, 4, CATANIA CT 95123, Italia",
    "lat": 37.51689,
    "lng": 15.0795275,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.51689,15.0795275"
  },
  {
    "name": "FARMACIA PRAMOLLO",
    "address": "Via Pramollo, 6, TORINO TO 10135, Italia",
    "lat": 45.0213803,
    "lng": 7.6240904,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0213803,7.6240904"
  },
  {
    "name": "IGEAMEDICAL S.R.L.",
    "address": "Via Don Minzoni, 7/9, VOGHERA PV 27058, Italia",
    "lat": 44.9925462,
    "lng": 9.0035884,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9925462,9.0035884"
  },
  {
    "name": "BABY GREEN di GUALDO GIUSEPPE",
    "address": "Piazza Della Repubblica, SCORDIA CT 95048, Italia",
    "lat": 37.2939709,
    "lng": 14.8477488,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.2939709,14.8477488"
  },
  {
    "name": "SANITARIA SESTRESE SRL",
    "address": "Via Sestri, 79 R, GENOVA GE 16154, Italia",
    "lat": 44.4235841,
    "lng": 8.8538925,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4235841,8.8538925"
  },
  {
    "name": "FARMACIA SANT'ANTONIO SNC di Dr.sse Ottelli e Sechi Francesca",
    "address": "Via Emilia Pavese, 248, PIACENZA PC 29121, Italia",
    "lat": 45.054855,
    "lng": 9.6451373,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.054855,9.6451373"
  },
  {
    "name": "FARMACIA DI GRAVELLONA TOCE S.N.C. di Dott. Calderara Giancarlo",
    "address": "Via Marconi, 32, GRAVELLONA TOCE VB 28883, Italia",
    "lat": 45.9302038,
    "lng": 8.4375497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9302038,8.4375497"
  },
  {
    "name": "EMIFARM s.a.s. di Balascas & C.",
    "address": "Via R. Margherita, 133, GIARDINI NAXOS ME 98035, Italia",
    "lat": 37.8157138,
    "lng": 15.2636257,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.8157138,15.2636257"
  },
  {
    "name": "ORTOPEDIA ROSA SRL",
    "address": "viale Albertoni, 6, MANTOVA MN 46100, Italia",
    "lat": 45.1482244,
    "lng": 10.7746292,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1482244,10.7746292"
  },
  {
    "name": "FARMACIA LANDI MASCAGNA SNC di Giuseppe e Antonella Rossi",
    "address": "Via F. Nicolai 141, CAPRAROLA VT 01032, Italia",
    "lat": 42.3275083,
    "lng": 12.2384279,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3275083,12.2384279"
  },
  {
    "name": "HYDRIA sas di NUNZIO SIDOTI & C.",
    "address": "Via Largo dei Normanni n. 1-3, PATTI ME 98066, Italia",
    "lat": 38.1390345,
    "lng": 14.9670979,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1390345,14.9670979"
  },
  {
    "name": "F.A.P.O. di La Rocca Flavia & C. sas",
    "address": "Via Antonio Maria Jaci, 43, MESSINA ME 98123, Italia",
    "lat": 38.2028694,
    "lng": 15.5566262,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.2028694,15.5566262"
  },
  {
    "name": "SANITAM BABY S.R.L.",
    "address": "Via Cannizzaro Tommaso, 172, MESSINA ME 98122, Italia",
    "lat": 38.1904491,
    "lng": 15.5483152,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1904491,15.5483152"
  },
  {
    "name": "FARMACIA MACERAUDI e CORVINO SNC",
    "address": "Via Matteotti, 7 bis, PRATO SESIA NO 28077, Italia",
    "lat": 45.6485219,
    "lng": 8.3728928,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6485219,8.3728928"
  },
  {
    "name": "KINEO S.R.L. Centro Ortopedico di Ricerca e Progettazione",
    "address": "Via Etnea, 414, CATANIA CT 95128, Italia",
    "lat": 37.513675,
    "lng": 15.0847872,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.513675,15.0847872"
  },
  {
    "name": "RO.GA. S.p.A.",
    "address": "Strada Comunale 89 Siriano, 294, ENNA EN 94100, Italia",
    "lat": 37.5291931,
    "lng": 14.2988659,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.5291931,14.2988659"
  },
  {
    "name": "ORTOPEDIA SANITARIA MARY di Maria Luisa Ciccalè & C. snc",
    "address": "Viale Trieste, 41 c/o Centro Comm.le Santarelli, FERMO FM 63900, Italia",
    "lat": 43.156824,
    "lng": 13.724104,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.156824,13.724104"
  },
  {
    "name": "FARMACIA ROVANI Dott.ssa LORENA",
    "address": "Via De Gasperi, 1, QUATTRO CASTELLA RE 42020, Italia",
    "lat": 44.6363362,
    "lng": 10.4706458,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6363362,10.4706458"
  },
  {
    "name": "FARMACIA CASTIGLIONE D.SSA M.C. LAZZARINI E D.SSA F.NERI SNCV",
    "address": "Via Ragazzena, 2, CERVIA RA 48015, Italia",
    "lat": 44.2609031,
    "lng": 12.2625346,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2609031,12.2625346"
  },
  {
    "name": "CHIAFFI PIO s.a.s. di Chiaffi Andrea & C.",
    "address": "Via Roma, 12, LANGHIRANO PR 43013, Italia",
    "lat": 44.6118674,
    "lng": 10.2667763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6118674,10.2667763"
  },
  {
    "name": "C.O.M. di LONGONI GIORDANO & C. s.n.c.",
    "address": "Largo dei mille, 8/B, GUASTALLA RE 42016, Italia",
    "lat": 44.9191912,
    "lng": 10.6540388,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9191912,10.6540388"
  },
  {
    "name": "FARMACIA SAN LEOPOLDO",
    "address": "PIAZZA TRATTATI DI ROMA 1, SAVIGNANO SUL RUBICONE FC 47039, Italia",
    "lat": 44.1525002,
    "lng": 12.4292479,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1525002,12.4292479"
  },
  {
    "name": "PARAFARMACIA SOLE DI DOTT.SSA GRAZIANI SUSANNA",
    "address": "VIA GARIBALDI 18/A, RUSSI RA 48026, Italia",
    "lat": 44.3692892,
    "lng": 12.0272445,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3692892,12.0272445"
  },
  {
    "name": "FARMACIA DI LESA S.N.C.",
    "address": "Via Carcano, 21, LESA NO 28040, Italia",
    "lat": 45.8273406,
    "lng": 8.564897,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8273406,8.564897"
  },
  {
    "name": "PARAFARMACIA ORTOPEDIA DOTT. PALMERI S.R.L.",
    "address": "Via Roma, 129, ARQUATA SCRIVIA AL 15061, Italia",
    "lat": 44.6822328,
    "lng": 8.8931176,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6822328,8.8931176"
  },
  {
    "name": "FARMACIA BEATO ANTONIO di Gabrielli Bernardo e Trenta Renata snc",
    "address": "Via Cesare Battisti, 5-7, AMANDOLA FM 63857, Italia",
    "lat": 42.9782779,
    "lng": 13.3532696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9782779,13.3532696"
  },
  {
    "name": "GALENICA S.N.C. di Dottori Villata Federico e Galletto",
    "address": "V.le Martiri della Libertà 4, LA LOGGIA TO 10040, Italia",
    "lat": 44.1695629,
    "lng": 9.6139143,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1695629,9.6139143"
  },
  {
    "name": "PARAFARMACIA RICCI SAS di COMASTRI D.SSA ANNA LISA E C.",
    "address": "Viale Antonio Gramsci 62, RAVENNA RA 48121, Italia",
    "lat": 44.4041122,
    "lng": 12.2038107,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4041122,12.2038107"
  },
  {
    "name": "FARMACIA NUOVA Dott.Tavella Alberto S.A.S.",
    "address": "Via Giardini Sud 130/A, FORMIGINE MO 41043, Italia",
    "lat": 44.5665696,
    "lng": 10.850276,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5665696,10.850276"
  },
  {
    "name": "HOMEOFARMA SRL",
    "address": "Via Giuseppe Mazzini, 182, PORTO SANT'ELPIDIO FM 63821, Italia",
    "lat": 43.2358684,
    "lng": 13.7707896,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2358684,13.7707896"
  },
  {
    "name": "FARMACIA BRANNETTI",
    "address": "Via Roscio 6, PONT CANAVESE TO 10085, Italia",
    "lat": 45.4212901,
    "lng": 7.5941481,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4212901,7.5941481"
  },
  {
    "name": "FARMACIA DELL'ASSUNTA DI D.SSA GALLINA FEDERICA",
    "address": "Via Circonvallazione 34, CASELLE TORINESE TO 10072, Italia",
    "lat": 45.1758127,
    "lng": 7.6437924,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1758127,7.6437924"
  },
  {
    "name": "J. Mifsud Premiere Healthcare",
    "address": "No. 31, Fort Street, Mellieha 1519, Malta",
    "lat": 35.9565612,
    "lng": 14.3576953,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=35.9565612,14.3576953"
  },
  {
    "name": "Farmacia Pianini Dr Mazzucchetti",
    "address": "Piazza V. Emanuele, 18, NOVAFELTRIA RN 47863, Italia",
    "lat": 43.8952725,
    "lng": 12.2903629,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8952725,12.2903629"
  },
  {
    "name": "TECN.OR. S.r.l.",
    "address": "Via Libertà 686, VIGNOLA MO 41058, Italia",
    "lat": 44.481477,
    "lng": 10.9996934,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.481477,10.9996934"
  },
  {
    "name": "Centro Ortopedico Sanitario di Ferro G. & C. s.a.s.",
    "address": "Via Principe Amedeo, 32, PARTINICO PA 90047, Italia",
    "lat": 38.0478971,
    "lng": 13.1173129,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0478971,13.1173129"
  },
  {
    "name": "ORTOPEDIA MORISI di Volodina Marina",
    "address": "Corso Italia, 154, SAN GIOVANNI IN PERSICETO BO 40017, Italia",
    "lat": 44.6401445,
    "lng": 11.1887774,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6401445,11.1887774"
  },
  {
    "name": "Farmacia Dolce-Baudino dal 1887 Della D.ssa Laura Bracco",
    "address": "Via Re Umberto, 13, SAN BENIGNO CANAVESE TO 10080, Italia",
    "lat": 45.2230963,
    "lng": 7.783794,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2230963,7.783794"
  },
  {
    "name": "FARMACIA PALOMBO Dott. VINCENZO",
    "address": "Corso Centocelle, 24, CIVITAVECCHIA RM 00053, Italia",
    "lat": 42.0927978,
    "lng": 11.7962451,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0927978,11.7962451"
  },
  {
    "name": "Farmacia S.Martino n°114 della Dott.ssa Cavazza Federica & C. s.a.s.",
    "address": "Via Garibaldi, 2, CASALECCHIO DI RENO BO 40033, Italia",
    "lat": 44.4783888,
    "lng": 11.277703,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4783888,11.277703"
  },
  {
    "name": "FARMACIA Parconord della Dott.ssa Ferraro Maria Carolina & C. s.a.s.",
    "address": "Via Ferrarese, 158/3, BOLOGNA BO 40128, Italia",
    "lat": 44.528459,
    "lng": 11.365965,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.528459,11.365965"
  },
  {
    "name": "Farmacia S.Camillo De Lellis di Maffei L. e Martinelli V. Snc",
    "address": "P.zza Caduti della Libertà, 2, FINALE EMILIA - Massa finalese MO 41035, Italia",
    "lat": 46.45407,
    "lng": 13.03719,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.45407,13.03719"
  },
  {
    "name": "ANTICA FARMACIA PACCHIONI Del Dott. Balugani Giulio e C. s.a.s.",
    "address": "Via Battisti, 11, SASSUOLO MO 41049, Italia",
    "lat": 44.541406,
    "lng": 10.7824524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.541406,10.7824524"
  },
  {
    "name": "Farmacia Della Rocca s.n.c. della Dott.ssa Pia Trerè",
    "address": "Via A. Acquacalda, 2, LUGO RA 48022, Italia",
    "lat": 44.4212919,
    "lng": 11.9130484,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4212919,11.9130484"
  },
  {
    "name": "FARMACIA DOTT. MINELLI DAVID",
    "address": "Via Vittorio Emanuele, 45, MONTE ROMANO VT 01010, Italia",
    "lat": 42.2753223,
    "lng": 11.9108192,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2753223,11.9108192"
  },
  {
    "name": "Farmacia Picasso s.n.c. di Rita Simoncelli e Mirco Loglio",
    "address": "Via Picasso,6, PARMA PR 43123, Italia",
    "lat": 44.7825242,
    "lng": 10.3645417,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7825242,10.3645417"
  },
  {
    "name": "PHARMA MEDICAL di SUSINNO SABRINA",
    "address": "Via Giovanni XXIII°, 46, AGRIGENTO AG 92100, Italia",
    "lat": 37.4029343,
    "lng": 13.6190433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.4029343,13.6190433"
  },
  {
    "name": "Farmacia Margutti Dr. Alessandro",
    "address": "Via Flaminia, 568, FALCONARA MARITTIMA AN 60015, Italia",
    "lat": 43.6301964,
    "lng": 13.3969016,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6301964,13.3969016"
  },
  {
    "name": "TRIPHARMA s.n.c.",
    "address": "C.so Luigi Einaudi 98, ASTI AT 14100, Italia",
    "lat": 44.8979526,
    "lng": 8.2107353,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8979526,8.2107353"
  },
  {
    "name": "Ortopedia Mogar, S.A.",
    "address": "Gran Vía de Carles III, n. 98 4 3, Barcelona 08028, Spagna",
    "lat": 41.38601,
    "lng": 2.127657,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.38601,2.127657"
  },
  {
    "name": "Farmacia St. Cristophe D.ssa Brero Emilia",
    "address": "Loc. Grande Chemin, 28, SAINT CHRISTOPHE AO 11020, Italia",
    "lat": 45.739658,
    "lng": 7.348957,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.739658,7.348957"
  },
  {
    "name": "FARMACIA NUOVA Dott.ssa A. PAPALEO",
    "address": "Via XXI Aprile, 2/E, VEROLI FR 03029, Italia",
    "lat": 41.6917013,
    "lng": 13.4173365,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6917013,13.4173365"
  },
  {
    "name": "PARAFARMACIA PANACEA di Cesaretti Michela",
    "address": "Via Flaminia, 103/B, COLLI AL METAURO - Tavernelle PU 61036, Italia",
    "lat": 43.7368731,
    "lng": 12.8937356,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7368731,12.8937356"
  },
  {
    "name": "FARMACIA FALASCHI DOTT.SSA PATRIZIA",
    "address": "Via E. Medi, 5, CASTELBELLINO AN 60030, Italia",
    "lat": 43.5026582,
    "lng": 13.1458116,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5026582,13.1458116"
  },
  {
    "name": "Ortopedia Rusca Monica",
    "address": "Strada Torino, 34, BEINASCO TO 10092, Italia",
    "lat": 45.0240089,
    "lng": 7.5931598,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0240089,7.5931598"
  },
  {
    "name": "Farmacia Dei Mosaici snc Dott.P.Segurini e Dott.ssa L.Gaetta",
    "address": "Via Delle Industrie, 88, RAVENNA RA 48122, Italia",
    "lat": 44.4278125,
    "lng": 12.2166542,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4278125,12.2166542"
  },
  {
    "name": "FARMACIA SAN PROSPERO s.a.s.",
    "address": "Via B. Croce, 24, IMOLA BO 40026, Italia",
    "lat": 44.3568225,
    "lng": 11.6976615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3568225,11.6976615"
  },
  {
    "name": "ORTOPEDIA GRASSINI di Grassini Paolo",
    "address": "P.zza Frua, 3, LEGNANO MI 20025, Italia",
    "lat": 45.5956224,
    "lng": 8.913458,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5956224,8.913458"
  },
  {
    "name": "Farmacia Parere-Strobbe S.r.l.",
    "address": "Via Galileo Galilei, 379/A, GIULIANOVA TE 64021, Italia",
    "lat": 42.7643408,
    "lng": 13.9549655,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7643408,13.9549655"
  },
  {
    "name": "Farmacia Mancini di Mancini C. e Leonardi P. s.n.c.",
    "address": "Via dell'Arengo, 40, OFFAGNA AN 60020, Italia",
    "lat": 43.5270493,
    "lng": 13.4413467,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5270493,13.4413467"
  },
  {
    "name": "PARAFARMACIA ETRUSCA di Toti Maria Chiara",
    "address": "Via Alberata Dante Alighieri, 9, TARQUINIA VT 01016, Italia",
    "lat": 42.2544597,
    "lng": 11.7595183,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2544597,11.7595183"
  },
  {
    "name": "Ortopedia Sanitaria Sergiacomi di Sergiacomi Ubaldarturo",
    "address": "Via Calatafimi, 73, SAN BENEDETTO DEL TRONTO AP 63074, Italia",
    "lat": 42.9558015,
    "lng": 13.880585,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9558015,13.880585"
  },
  {
    "name": "FARMACIA SAN GIORGIO SNC",
    "address": "Via Statale, 92, CENTO - Corpo reno FE 44042, Italia",
    "lat": 44.7588654,
    "lng": 11.3136963,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7588654,11.3136963"
  },
  {
    "name": "OR.VE.CA. SRL",
    "address": "S.S. Paullese, Km 10 (Polo Comm.le Km 10), SETTALA - Caleppio MI 20090, Italia",
    "lat": 45.402339,
    "lng": 9.471517,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.402339,9.471517"
  },
  {
    "name": "PARAFARMACIA BENESSERE IN CORSO di Mazzocchi Serena",
    "address": "Corso Giacomo Matteotti, 37D, CASTEL SAN GIOVANNI PC 29015, Italia",
    "lat": 45.0588387,
    "lng": 9.4358023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0588387,9.4358023"
  },
  {
    "name": "Nuova Farma Sas di Grillo Elisabetta & C.",
    "address": "Via Cairoli, 56, OVADA AL 15076, Italia",
    "lat": 44.6394292,
    "lng": 8.6453222,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6394292,8.6453222"
  },
  {
    "name": "Parafarmacia Del Corso di LANATI Dr.ssa FEDERICA",
    "address": "C.so Vitt.Emanuele II, 112, PIACENZA PC 29121, Italia",
    "lat": 45.0470561,
    "lng": 9.6864063,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0470561,9.6864063"
  },
  {
    "name": "FARMACIA S.STEFANO Dott. Patrizia Bertozzi",
    "address": "P.le della Vittoria, 1, POVIGLIO RE 42028, Italia",
    "lat": 44.842391,
    "lng": 10.5415778,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.842391,10.5415778"
  },
  {
    "name": "LA CHIMICO SANITARIA S.R.L.",
    "address": "S.S. 17 Est Km, 42, L'AQUILA - Bazzano AQ 67100, Italia",
    "lat": 42.3353307,
    "lng": 13.4495584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3353307,13.4495584"
  },
  {
    "name": "FARMACIA OTTAVIA SNC della Dott.ssa Angela Tabarrini & C.",
    "address": "Via Trionfale 11.264-11.270, ROMA RM 00135, Italia",
    "lat": 41.9142696,
    "lng": 12.4409205,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9142696,12.4409205"
  },
  {
    "name": "GUALTIERI CENTER SRL",
    "address": "Via Taddeo Alderotti, 67, FIRENZE FI 50139, Italia",
    "lat": 43.7985272,
    "lng": 11.2455289,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7985272,11.2455289"
  },
  {
    "name": "SANITARIA S.ANTONINO SNC DI ZINI G. & C.",
    "address": "Via M.Libertà, 7/a, SCANDIANO RE 42019, Italia",
    "lat": 44.5990763,
    "lng": 10.6907294,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5990763,10.6907294"
  },
  {
    "name": "FARMACIA PINETA SACCHETTI di Avenia Antonio & C. snc",
    "address": "Via della Pineta Sacchetti, 464, ROMA RM 00168, Italia",
    "lat": 41.9255135,
    "lng": 12.4263673,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9255135,12.4263673"
  },
  {
    "name": "Venetosalute Srl",
    "address": "Via Fratelli Cavanis ,10 e 14, CHIRIGNAGO VE 30030, Italia",
    "lat": 45.4811664,
    "lng": 12.1990686,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4811664,12.1990686"
  },
  {
    "name": "FOR.ME.SA. S.R.L.",
    "address": "Via Fratelli Canvelli, 6, NOCETO PR 43015, Italia",
    "lat": 44.8081352,
    "lng": 10.1978197,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8081352,10.1978197"
  },
  {
    "name": "FARMASALUS S.R.L.",
    "address": "P.le S.Maria della Misericordia, 15 int.1 e 6, UDINE UD 33100, Italia",
    "lat": 46.076832,
    "lng": 13.230018,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.076832,13.230018"
  },
  {
    "name": "PARAFARMACIA Dott.ssa ELENA DUCE",
    "address": "Via Martiri della Liberta, 107, SAN MAURO TORINESE TO 10099, Italia",
    "lat": 45.1018021,
    "lng": 7.7649964,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1018021,7.7649964"
  },
  {
    "name": "FARMACIA OSTI SRL",
    "address": "Via Matteotti, 74, BAZZANO BO 40053, Italia",
    "lat": 44.5064371,
    "lng": 11.0822775,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5064371,11.0822775"
  },
  {
    "name": "SANITARIA DON MINZONI",
    "address": "Via Don Minzoni, 230, MODENA MO 41125, Italia",
    "lat": 44.7262657,
    "lng": 10.9968408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7262657,10.9968408"
  },
  {
    "name": "LORISANITAS di Lorenza Lertola",
    "address": "Via Dante, 31, TARCENTO UD 33017, Italia",
    "lat": 46.2137319,
    "lng": 13.2182944,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.2137319,13.2182944"
  },
  {
    "name": "ORTOPEDIA SANITARIA CADORE di Piazza Dante",
    "address": "Via F.Coletti, 38/I, PIEVE DI CADORE - Tai di cadore BL 32044, Italia",
    "lat": 46.422588,
    "lng": 12.35818,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.422588,12.35818"
  },
  {
    "name": "ORTOPEDIA MENGOLI S.r.l.",
    "address": "Via P. Mengoli, 30/BC, BOLOGNA BO 40138, Italia",
    "lat": 44.4896767,
    "lng": 11.3717078,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4896767,11.3717078"
  },
  {
    "name": "FARMACIA PARERE S.R.L.",
    "address": "Via Roma, 42, ALBA ADRIATICA TE 64011, Italia",
    "lat": 42.8335918,
    "lng": 13.9196349,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8335918,13.9196349"
  },
  {
    "name": "Parafarmacia Ge-Pharma Dott.ssa Daniela Buccino",
    "address": "Via Marinai d'Italia, PIACENZA PC 29100, Italia",
    "lat": 45.0379919,
    "lng": 9.713918,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0379919,9.713918"
  },
  {
    "name": "FARMACIA MARCHETTI DR STEFANO",
    "address": "Via R. Sanzio, 22/B, MONTERUBBIANO - Rubbianello FM 63825, Italia",
    "lat": 45.396201,
    "lng": 11.293836,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.396201,11.293836"
  },
  {
    "name": "Sanitaria Ospedale Dr. Ferrazzi",
    "address": "Piazzale Spedali Civili, 46/48, BRESCIA BS 25123, Italia",
    "lat": 45.5545615,
    "lng": 10.2323138,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5545615,10.2323138"
  },
  {
    "name": "LAB.OR. srl",
    "address": "Via Cavour, 4, ORBASSANO TO 10043, Italia",
    "lat": 45.0102278,
    "lng": 7.54115,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0102278,7.54115"
  },
  {
    "name": "Sanitaria Ortopedia Simonazzi di Paganelli Guido e Fenzi Maurizia",
    "address": "Via Predosa, 4, ZOLA PREDOSA BO 40069, Italia",
    "lat": 44.4908247,
    "lng": 11.2183482,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4908247,11.2183482"
  },
  {
    "name": "Farmacia Dott. Sparacino Mariano S.n.c.",
    "address": "Via Vittorio Emanuele, 176/178, LIPARI ME 98055, Italia",
    "lat": 38.102929,
    "lng": 15.1219521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.102929,15.1219521"
  },
  {
    "name": "FARMACIA MERLO di Carmelo, Antonio e Alberto snc",
    "address": "P.zza Santa Maria di Gesù, 4, CATANIA CT 95123, Italia",
    "lat": 37.5122894,
    "lng": 15.0785613,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.5122894,15.0785613"
  },
  {
    "name": "IL MONDO DI ARILO' di Peruggini Ariela",
    "address": "Viale R. Elena, 195, MESSINA ME 98121, Italia",
    "lat": 38.2078016,
    "lng": 15.5533325,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.2078016,15.5533325"
  },
  {
    "name": "FARMACIA PAUSULA S.R.L.",
    "address": "Viale Pausula, 17/H, CORRIDONIA MC 62014, Italia",
    "lat": 43.2623817,
    "lng": 13.4936254,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2623817,13.4936254"
  },
  {
    "name": "SANITARIA SAN LUCA s.r.l. unipersonale",
    "address": "Via Emilia Ponente n.114, BOLOGNA BO 40133, Italia",
    "lat": 44.510886,
    "lng": 11.2906541,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.510886,11.2906541"
  },
  {
    "name": "SANITARIA ORTOPEDIA BORGO ROMA S.r.l.",
    "address": "Piazzale L.A. Scuro, 7/9, VERONA VR 37134, Italia",
    "lat": 45.4059111,
    "lng": 10.9937023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4059111,10.9937023"
  },
  {
    "name": "REAMED srl",
    "address": "Via F. Hayez, 4/a, VENEZIA - Mestre VE 30174, Italia",
    "lat": 45.5031679,
    "lng": 12.2260303,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5031679,12.2260303"
  },
  {
    "name": "ERBORISTERIA SANITARIA VEPHARMA di CALZAVARA ANTONIO",
    "address": "Via Ospedale, 38, VENEZIA - Mestre VE 30174, Italia",
    "lat": 45.4937205,
    "lng": 12.2387256,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4937205,12.2387256"
  },
  {
    "name": "SANITARIA LE COCCOLE di Accetta Nuccia",
    "address": "Via Colonnello Berte, 6, MILAZZO ME 98057, Italia",
    "lat": 38.2194323,
    "lng": 15.2377459,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.2194323,15.2377459"
  },
  {
    "name": "FARMACIA SAN ZENONE S.N.C. di MAGNI D.SSA BETTINA & C.",
    "address": "Via Mazzini, 3, CISANO BERGAMASCO BG 24034, Italia",
    "lat": 45.7398216,
    "lng": 9.4757348,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7398216,9.4757348"
  },
  {
    "name": "FARMACIA DI MAGNI D.SSA BETTINA & C. S.A.S.",
    "address": "Via Marconi, 596, CALUSCO D'ADDA BG 24033, Italia",
    "lat": 45.6896035,
    "lng": 9.4720613,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6896035,9.4720613"
  },
  {
    "name": "MEDIGOLD ORTOPEDIA",
    "address": "Via L. Da Vinci, 3, CAROBBIO DEGLI ANGELI BG 24060, Italia",
    "lat": 45.6596067,
    "lng": 9.8254519,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6596067,9.8254519"
  },
  {
    "name": "SANITARIA di FINCO Mario",
    "address": "Via Euganea, 13, SELVAZZANO DENTRO PD 35030, Italia",
    "lat": 45.3842751,
    "lng": 11.782315,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3842751,11.782315"
  },
  {
    "name": "SANITAS ORTOPEDIA DI CAPPADONA ELISA SRL",
    "address": "Via Fratelli Cairoli, 21, VARAZZE SV 17019, Italia",
    "lat": 44.3588242,
    "lng": 8.5732932,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3588242,8.5732932"
  },
  {
    "name": "MATTIOLI PARAFARMACIA E SANITARIA S.R.L",
    "address": "Via Marconi, 8/10, PIOVE DI SACCO PD 35028, Italia",
    "lat": 45.2987681,
    "lng": 12.0338866,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2987681,12.0338866"
  },
  {
    "name": "ERBORISTERIA E SANITARIA \"LA SORGENTE\" Dr. Temporin Alberto",
    "address": "Via Bachelet, 19, VIGONZA PD 35010, Italia",
    "lat": 45.4283324,
    "lng": 11.9620521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4283324,11.9620521"
  },
  {
    "name": "ORTOPEDIA RAFFAELLI S.N.C. DI MASSIMO LEONARDI E C.",
    "address": "Via Migliara, 46, ALESSANDRIA AL 15100, Italia",
    "lat": 44.7525672,
    "lng": 8.5283066,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7525672,8.5283066"
  },
  {
    "name": "MONTALTO MULTISERVIZI SRL SOCIETA' UNIPERSONALE",
    "address": "Via del Palombaro, 11, MONTALTO DI CASTRO VT 01014, Italia",
    "lat": 42.3241638,
    "lng": 11.5843524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3241638,11.5843524"
  },
  {
    "name": "SANITARIA RONCAGLIA di Venzo Marta",
    "address": "Via G.Marconi, 152, PONTE SAN NICOLO' PD 35020, Italia",
    "lat": 45.3651591,
    "lng": 11.9327188,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3651591,11.9327188"
  },
  {
    "name": "ORTOPEDIA BORELLA spa",
    "address": "Via Ghirada, 71/B, TREVISO TV 31100, Italia",
    "lat": 45.6560362,
    "lng": 12.2363538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6560362,12.2363538"
  },
  {
    "name": "FARMACIA CENTRALE s.r.l. DOTT. BERGONZO G. & DOTT. TORCHIO",
    "address": "C.so Francia n.10, RIVOLI TO 10098, Italia",
    "lat": 45.0712558,
    "lng": 7.5428027,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0712558,7.5428027"
  },
  {
    "name": "FARMACIA DEL MUSSOTTO del Dr. Bergonzo & C. s.a.s.",
    "address": "Corso Canale, 18, ALBA CN 12051, Italia",
    "lat": 44.7119997,
    "lng": 8.0251035,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7119997,8.0251035"
  },
  {
    "name": "FARMACIA LEUMANN DI DR. TORCHIO GIANMARIO & C.",
    "address": "Corso Francia 255/1, COLLEGNO TO 10093, Italia",
    "lat": 45.0727686,
    "lng": 7.5784554,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0727686,7.5784554"
  },
  {
    "name": "ORTOPEDIA PODOLOGIA MALPIGHI srl",
    "address": "Via P. Palagi, 33/2 a-b-c, BOLOGNA BO 40138, Italia",
    "lat": 44.4922596,
    "lng": 11.3662988,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4922596,11.3662988"
  },
  {
    "name": "LA SANITARIA s.n.c. di Lazzarin Donatella & C.",
    "address": "Via Villa del Bosco, 470, PONTELONGO PD 35029, Italia",
    "lat": 45.2436785,
    "lng": 12.0234172,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2436785,12.0234172"
  },
  {
    "name": "SANITARIA SCOLARO di Scolaro Rosario e Co. SNC",
    "address": "Via L. Manara n.86, MESSINA ME 98123, Italia",
    "lat": 38.1842461,
    "lng": 15.5521638,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1842461,15.5521638"
  },
  {
    "name": "Centro Ortopedico San Carlo di Barbi Stefano",
    "address": "Via Gaspare Buffa, 19-23 R, GENOVA GE 16158, Italia",
    "lat": 44.4292652,
    "lng": 8.7566023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4292652,8.7566023"
  },
  {
    "name": "SANITARIA ORTOPEDIA TOSATTO SAS DI COSSALTER CRISTINA E C.",
    "address": "Viale Arnaldo Fusinato, 12, FELTRE BL 32032, Italia",
    "lat": 45.5399772,
    "lng": 11.5443868,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5399772,11.5443868"
  },
  {
    "name": "FARMACIA DR. FABRIZIO PIAZZA",
    "address": "Via Repubblica, 17, MEDESANO - Felegara PR 43014, Italia",
    "lat": 44.7256284,
    "lng": 10.1130382,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7256284,10.1130382"
  },
  {
    "name": "OTTICA E ORTOPEDICA S.R.L.",
    "address": "Via Bice Cremagnani, 15/O, VIMERCATE MB 20871, Italia",
    "lat": 45.6128018,
    "lng": 9.3596498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6128018,9.3596498"
  },
  {
    "name": "ANAHATA ORTHO SRL",
    "address": "Viale Filippo Turati, 103, LECCO LC 23900, Italia",
    "lat": 45.858556,
    "lng": 9.3913014,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.858556,9.3913014"
  },
  {
    "name": "SANITARIA ORTOPEDIA BIOSANA di Giuseppe Presicce",
    "address": "Via Trionfale, 9550, ROMA RM 00135, Italia",
    "lat": 41.9345267,
    "lng": 12.4391583,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9345267,12.4391583"
  },
  {
    "name": "SANITARIA VITALITÀ E BENESSERE di DRIGO ANNA",
    "address": "Viale Trieste, 144, PORTOGRUARO VE 30026, Italia",
    "lat": 45.7742052,
    "lng": 12.8423043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7742052,12.8423043"
  },
  {
    "name": "SANITARIA PARAFARMACIA SAN BIAGIO s.r.l.",
    "address": "Via del Commercio, 73/75, FOSSALTA DI PORTOGRUARO VE 30025, Italia",
    "lat": 45.7791424,
    "lng": 12.9022188,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7791424,12.9022188"
  },
  {
    "name": "ORTOPEDIA PASETTO di Giarola Giovanna",
    "address": "Via Principe Umberto, 6, ESTE PD 35042, Italia",
    "lat": 45.2267107,
    "lng": 11.6594238,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2267107,11.6594238"
  },
  {
    "name": "SANITARIA 3G VENETA s.n.c. di GALVANETTO LUCA & C.",
    "address": "Via Italia Unita, 119, TORRI DI QUARTESOLO VI 36040, Italia",
    "lat": 45.5192662,
    "lng": 11.6171199,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5192662,11.6171199"
  },
  {
    "name": "SANITARIA E ORTOPEDIA BRUN DI CALIBRI ROBERTA",
    "address": "Via Roma, 55, LONIGO VI 36045, Italia",
    "lat": 45.3850874,
    "lng": 11.3880022,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3850874,11.3880022"
  },
  {
    "name": "CENTRO ORTOPEDICO MECCANICO LONGONI di SCIFONI & C. s.n.c.",
    "address": "Piazza Manzoni, 21, VIADANA MN 46019, Italia",
    "lat": 44.926959,
    "lng": 10.520504,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.926959,10.520504"
  },
  {
    "name": "FARMACIA di MARZABOTTO",
    "address": "Via Porrettana Nord, 4, MARZABOTTO BO 40043, Italia",
    "lat": 44.342083,
    "lng": 11.2053583,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.342083,11.2053583"
  },
  {
    "name": "IGEA LA SANITARIA",
    "address": "Borgo Aquileia, 10/C, PALMANOVA UD 33057, Italia",
    "lat": 45.9040543,
    "lng": 13.3099106,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9040543,13.3099106"
  },
  {
    "name": "LA SANITARIA DI VIGONOVO di Longhi Renata",
    "address": "Via Padova, 6, VIGONOVO VE 30030, Italia",
    "lat": 45.3876437,
    "lng": 12.0059499,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3876437,12.0059499"
  },
  {
    "name": "SANITARIA DOTT.SSA ANNA DEL PUP & C. SRL",
    "address": "Via Molinari, 6A/6B, PORDENONE PN 33170, Italia",
    "lat": 45.961762,
    "lng": 12.6610521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.961762,12.6610521"
  },
  {
    "name": "FARMACIA PERSEGHINI S.R.L.",
    "address": "Via Roma, 71, POZZOLO FORMIGARO AL 15068, Italia",
    "lat": 44.7935113,
    "lng": 8.7839513,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7935113,8.7839513"
  },
  {
    "name": "FARMACIA SAN GIOVANNI SNC Dott.ssa DI MICELI ELVIRA Dott.ssa MIRANDOLA",
    "address": "Largo Don G. Dossetti, 8, CRESPELLANO BO 40056, Italia",
    "lat": 44.51351,
    "lng": 11.1293,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.51351,11.1293"
  },
  {
    "name": "BIOVITA FARMA S.R.L.",
    "address": "Via A. Baccarini, 9, SCHIO VI 36015, Italia",
    "lat": 45.7112115,
    "lng": 11.3559913,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7112115,11.3559913"
  },
  {
    "name": "ORTHOPED srl",
    "address": "V.le Volontari della Libertà, 20/c, UDINE UD 33100, Italia",
    "lat": 46.0715944,
    "lng": 13.234683,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0715944,13.234683"
  },
  {
    "name": "FARMACIA MOGGIO di Moggio Anna Maria & C. snc",
    "address": "Piazza Verdi, 14, SALE AL 15045, Italia",
    "lat": 44.9838435,
    "lng": 8.8089584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9838435,8.8089584"
  },
  {
    "name": "ORTOPEDIA TECNICA SICILIANA SRL",
    "address": "Corso Vittorio Emanuele, 763, FLORIDIA SR 96014, Italia",
    "lat": 37.079004,
    "lng": 15.162873,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.079004,15.162873"
  },
  {
    "name": "FARMACIA SANT'ANSELMO SRL",
    "address": "Via Marconi, 11, NONANTOLA MO 41015, Italia",
    "lat": 44.6773492,
    "lng": 11.0429701,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6773492,11.0429701"
  },
  {
    "name": "LAB-OR SAN s.n.c. di Luisetto Cinzia e Rusin Sonia",
    "address": "Via J. Facciolati, 48/1-2, PADOVA PD 35127, Italia",
    "lat": 45.3862272,
    "lng": 11.8969014,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3862272,11.8969014"
  },
  {
    "name": "PERRI s.a.s. di CENZINA PERRI",
    "address": "Via Camesena, 24-26, ROMA RM 00157, Italia",
    "lat": 41.9101163,
    "lng": 12.5345449,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9101163,12.5345449"
  },
  {
    "name": "PARAFARMACIA SANAMEDICAL DELLA DOTT.SSA TERESA PISANI",
    "address": "Via Dogali, 73, POZZALLO RG 97016, Italia",
    "lat": 36.7258515,
    "lng": 14.8409352,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=36.7258515,14.8409352"
  },
  {
    "name": "ORTOPEDIA VIMEDICAL s.r.l.",
    "address": "Via del Progresso, 23, MONTICELLO CONTE OTTO VI 36010, Italia",
    "lat": 45.6064847,
    "lng": 11.5691003,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6064847,11.5691003"
  },
  {
    "name": "FARMACIA S.ANTONIO snc di Alessandri M., Calderone M., Farina D.",
    "address": "Via Caselline, 627, VIGNOLA MO 41058, Italia",
    "lat": 44.4853671,
    "lng": 10.9985684,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4853671,10.9985684"
  },
  {
    "name": "FARMACIA DOTT. DI FEBBO FIRMINIO",
    "address": "Piazza Vittorio Emanuele, 38, BASCIANO TE 64030, Italia",
    "lat": 42.5939197,
    "lng": 13.7407185,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5939197,13.7407185"
  },
  {
    "name": "FARMACIA STUFFIONE SRL",
    "address": "Via Matteotti, 348, RAVARINO - Stuffione MO 41017, Italia",
    "lat": 44.7539273,
    "lng": 11.1204948,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7539273,11.1204948"
  },
  {
    "name": "SANIMARCHE SRL",
    "address": "Via Regina Margherita, 267, POTENZA PICENA - Porto potenza picena MC 62018, Italia",
    "lat": 43.35236,
    "lng": 13.7004125,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.35236,13.7004125"
  },
  {
    "name": "CENTRO SANITARIO 2000 di A.Magistris e S.Becco",
    "address": "Via Papa Giovanni XXIII, 33, SULMONA AQ 67039, Italia",
    "lat": 45.6966762,
    "lng": 11.3724078,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6966762,11.3724078"
  },
  {
    "name": "FARMACIA QUARNA DANIELA",
    "address": "Via Roma, 28, SIZZANO NO 28070, Italia",
    "lat": 45.5754458,
    "lng": 8.4384294,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5754458,8.4384294"
  },
  {
    "name": "SANITARIA FILIPPINI IVANA",
    "address": "Via Nazionale, 81/A, VALLEFOGLIA-Bottega PU 61022, Italia",
    "lat": 43.8424083,
    "lng": 12.7465696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8424083,12.7465696"
  },
  {
    "name": "ORTOPEDIA ARTE SANA di Tavianini Elisabetta",
    "address": "Via del Governatore, 25, PESARO PU 61100, Italia",
    "lat": 43.9084843,
    "lng": 12.9060432,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9084843,12.9060432"
  },
  {
    "name": "ORTOPEDIA O.T.A. s.r.l.s.",
    "address": "Via Aldo Moro, 6/8, ALCAMO TP 91011, Italia",
    "lat": 44.0014773,
    "lng": 11.2416854,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0014773,11.2416854"
  },
  {
    "name": "SANITARIA MARINA di Luciani Martina",
    "address": "Via Genova, 19, CARRARA MS 54033, Italia",
    "lat": 44.0390025,
    "lng": 10.0374515,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0390025,10.0374515"
  },
  {
    "name": "ORTHOSANIT DUE s.r.l.",
    "address": "Via Robassomero, 9, CIRIE' TO 10073, Italia",
    "lat": 45.2278448,
    "lng": 7.6029339,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2278448,7.6029339"
  },
  {
    "name": "FARMACIA ALLEGRI DOTT.SSA ELISABETTA",
    "address": "Via Gravellona, 2, CASALE CORTE CERRO VB 28881, Italia",
    "lat": 45.9168734,
    "lng": 8.4151018,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9168734,8.4151018"
  },
  {
    "name": "MEDICAL HOUSE di DI MARCO VENTURA",
    "address": "Strada Statale, 150,151, NOTARESCO - Pianura vomano TE 64024, Italia",
    "lat": 42.6327033,
    "lng": 13.9072588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6327033,13.9072588"
  },
  {
    "name": "SANITARIA NOVASAN di Terrin Mara",
    "address": "Via Nazionale, 236, MIRA VE 30034, Italia",
    "lat": 45.4435957,
    "lng": 12.150852,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4435957,12.150852"
  },
  {
    "name": "VAGNI ROBERTA",
    "address": "Via Don Minzoni, 42, FABRIANO AN 60044, Italia",
    "lat": 43.3383422,
    "lng": 12.916509,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3383422,12.916509"
  },
  {
    "name": "SANITARIA DEL CENTRO DI MANNA ROMINA e C. snc",
    "address": "Piazza Comune, 19, OSIMO AN 60027, Italia",
    "lat": 43.4859525,
    "lng": 13.4820833,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4859525,13.4820833"
  },
  {
    "name": "ORTOPEDIA DURANTI di BARBARA e MONICA DURANTI S.N.C.",
    "address": "Via XXIX Settembre, 2, ANCONA AN 60122, Italia",
    "lat": 43.6172891,
    "lng": 13.5082603,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6172891,13.5082603"
  },
  {
    "name": "IL LOTO DI DR.SSA SORAGNA ALESSANDRA",
    "address": "Via Roosevelt, 65/67, CARPI MO 41012, Italia",
    "lat": 44.7933938,
    "lng": 10.8943072,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7933938,10.8943072"
  },
  {
    "name": "SANITARIA ORTOPEDIA di Renata Gubian",
    "address": "V.le Trento Trieste, 25, SAN DANIELE DEL FRIULI UD 33038, Italia",
    "lat": 46.1548169,
    "lng": 13.010135,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1548169,13.010135"
  },
  {
    "name": "FARMACIA SAN ROCCO di Adele Spaziani e Antonella Franchi S.n.c.",
    "address": "Via Monsignor Licinio Refice, 9, PATRICA FR 03010, Italia",
    "lat": 41.591399,
    "lng": 13.241786,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.591399,13.241786"
  },
  {
    "name": "Centro Ortopedico Aliotta s.r.l.",
    "address": "Via Palazzi, 132, GELA CL 93012, Italia",
    "lat": 37.0740593,
    "lng": 14.2304384,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.0740593,14.2304384"
  },
  {
    "name": "LOLATO s.r.l.",
    "address": "Via Don Bruno Marcon, 9, CITTADELLA PD 35013, Italia",
    "lat": 45.6698127,
    "lng": 11.7972682,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6698127,11.7972682"
  },
  {
    "name": "NATURAL SANITARIA di Parise Chiara e Tibaldo Silvia",
    "address": "Via A.Volta, 26, CHIAMPO VI 36072, Italia",
    "lat": 45.5450662,
    "lng": 11.2807432,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5450662,11.2807432"
  },
  {
    "name": "FARMACIA ARGENTIERI dei Dott. ARGENTIERI Salvatore e Giuseppe snc",
    "address": "Piazza Nanni Levera, 13, CASTEL D'AIANO BO 40034, Italia",
    "lat": 44.280678,
    "lng": 11.0014154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.280678,11.0014154"
  },
  {
    "name": "CAPORALI 2000 s.r.l. REHA SERVICE",
    "address": "Via C. Battisti, 65, DAVERIO VA 21020, Italia",
    "lat": 45.7663147,
    "lng": 8.7705055,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7663147,8.7705055"
  },
  {
    "name": "PRO-CHI-SAN SRL",
    "address": "Via Garibaldi, 77, GAVIRATE VA 21026, Italia",
    "lat": 45.833063,
    "lng": 8.78043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.833063,8.78043"
  },
  {
    "name": "SANITARIA ORTOPEDIA SALUS MEDICAL di Bacciardi Debora",
    "address": "Viale Oberdan, 6, FOSSOMBRONE PU 61034, Italia",
    "lat": 43.6931564,
    "lng": 12.8192454,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6931564,12.8192454"
  },
  {
    "name": "FARMACIA CALABRESI s.a.s. di ANNALISA CALABRESI & C.",
    "address": "Via Romagnoli, 58, LATINA LT 04100, Italia",
    "lat": 41.4718738,
    "lng": 12.8909951,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.4718738,12.8909951"
  },
  {
    "name": "PARAFARMACIA LANZE S.N.C. di Monandro Dott.ssa Giulia & C.",
    "address": "Piazza San Bartolomeo, 11, CASTAGNOLE DELLE LANZE AT 14054, Italia",
    "lat": 44.7493907,
    "lng": 8.1498172,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7493907,8.1498172"
  },
  {
    "name": "FARMACIA DI MATTEO Dr.ssa LAURA",
    "address": "Viale Vochieri, 6, VIGNOLE BORBERA AL 15060, Italia",
    "lat": 44.7084331,
    "lng": 8.8905467,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7084331,8.8905467"
  },
  {
    "name": "Centro Ortopedico Marchigiano Srl",
    "address": "Via Flaminia, 309/310, ANCONA AN 60126, Italia",
    "lat": 43.6125206,
    "lng": 13.4451989,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6125206,13.4451989"
  },
  {
    "name": "FARMACIA CONIGLIARO della Dr.ssa S. Ferraguto",
    "address": "Viale Italia, 188, AUGUSTA SR 96011, Italia",
    "lat": 37.246364,
    "lng": 15.2195343,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.246364,15.2195343"
  },
  {
    "name": "SANITARIA LENO di LOMBARDELLI MARCO",
    "address": "Via W. Zannini, 10, LENO BS 25024, Italia",
    "lat": 45.3597156,
    "lng": 10.2188329,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3597156,10.2188329"
  },
  {
    "name": "ALBANI E ALTOMARI CALZATURE SNC DI ALBANI A.E S. E ALTOMARI R.",
    "address": "Via Guarnerio, 9/A, TREZZO SULL'ADDA MI 20056, Italia",
    "lat": 45.6088692,
    "lng": 9.5009607,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6088692,9.5009607"
  },
  {
    "name": "La Sanitaria Foianese di Fei Ilaria e C. s.n.c.",
    "address": "C.so Vittorio Emanuele, 52, FOIANO DELLA CHIANA AR 52045, Italia",
    "lat": 43.2535678,
    "lng": 11.8169024,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2535678,11.8169024"
  },
  {
    "name": "SALUS Sanitaria di Valentina Bosco",
    "address": "Viale C. Battisti 107, MATELICA MC 62024, Italia",
    "lat": 43.2522638,
    "lng": 13.0080412,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2522638,13.0080412"
  },
  {
    "name": "SANITARIA ORTOPEDIA FLAMINIA di Patrizia Cristofori",
    "address": "Via Flaminia, 79, SPOLETO PG 06049, Italia",
    "lat": 42.7467921,
    "lng": 12.7435344,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7467921,12.7435344"
  },
  {
    "name": "LA NUOVA SANITARIA DI ORLANDI STEFANINA",
    "address": "Via Tarantelli, 1, AVEZZANO AQ 67051, Italia",
    "lat": 42.0523771,
    "lng": 13.4251231,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0523771,13.4251231"
  },
  {
    "name": "Berto Vassilli S.R.L.",
    "address": "Via Falloppio, 69, PADOVA PD 35121, Italia",
    "lat": 45.4053182,
    "lng": 11.8867376,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4053182,11.8867376"
  },
  {
    "name": "SANYFARM SANITARIA ORTOPEDICA di PETRILLO ANNA",
    "address": "Via Cristoforo Colombo, 360, CIVITANOVA MARCHE MC 62012, Italia",
    "lat": 43.3269455,
    "lng": 13.7148616,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3269455,13.7148616"
  },
  {
    "name": "EL.PER. S.A.S. di Bianchi Pierluigi & C.",
    "address": "Via S.Tommaso d'Aquino, 23, PERUGIA PG 06126, Italia",
    "lat": 43.0978078,
    "lng": 12.3886217,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0978078,12.3886217"
  },
  {
    "name": "SANITARIA CENTRO SALUTE ROSATI di ROSATI M. ANTONIETTA & C. snc",
    "address": "Via Matteotti, 1/7, GUBBIO PG 06024, Italia",
    "lat": 43.3508846,
    "lng": 12.5757946,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3508846,12.5757946"
  },
  {
    "name": "SANITARIA ORTOPEDIA FIORUCCI di VENTURINI SRL",
    "address": "Via Corcianese, 234, CORCIANO - Ellera PG 06070, Italia",
    "lat": 43.1042093,
    "lng": 12.3170069,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1042093,12.3170069"
  },
  {
    "name": "Beni S.r.l.",
    "address": "Via C.Cattaneo, 54 A/C, VICENZA VI 36100, Italia",
    "lat": 45.5463964,
    "lng": 11.5338532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5463964,11.5338532"
  },
  {
    "name": "FARMACIA DELLA REGINA SRL",
    "address": "VIA ABRUZZI, 18, SAN BENEDETTO DEL TRONTO AP 63039, Italia",
    "lat": 42.9457923,
    "lng": 13.8841704,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9457923,13.8841704"
  },
  {
    "name": "ORTOPEDIA GUADAGNI DI MARCELLO FANTI & C. S.A.S.",
    "address": "Viale Gorizia, 17/A, MANTOVA MN 46100, Italia",
    "lat": 45.1512022,
    "lng": 10.7798735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1512022,10.7798735"
  },
  {
    "name": "SANITARIA GIULIANI TARQUINIA SAS DI PIOZZI GIULIANI ENRICO",
    "address": "Viale Igea, 9/11, TARQUINIA VT 01016, Italia",
    "lat": 42.250365,
    "lng": 11.75922,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.250365,11.75922"
  },
  {
    "name": "LA SANITARIA HOSPITAL SRL",
    "address": "VIA PANDINA 1, C/O OSPEDALE VIZZOLO, VIZZOLO PREDABISSI MI 20070, Italia",
    "lat": 45.3595867,
    "lng": 9.3377999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3595867,9.3377999"
  },
  {
    "name": "Babysana di Carone Giacomo",
    "address": "Via IV Novembre, 24, POLIGNANO A MARE BA 70044, Italia",
    "lat": 40.9920285,
    "lng": 17.2253814,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9920285,17.2253814"
  },
  {
    "name": "Nuova Farmacia di Bruna Mondino & C. snc",
    "address": "Via Cesare Battisti, 39, MONTANARO TO 10017, Italia",
    "lat": 45.2323609,
    "lng": 7.8555935,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2323609,7.8555935"
  },
  {
    "name": "ORTOPEDIA-SANITARI LOVATI SILVANO DI GIORGIO LOVATI & C.SNC",
    "address": "Piazza Libertà, 1, GALLARATE VA 21013, Italia",
    "lat": 45.6597649,
    "lng": 8.7938055,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6597649,8.7938055"
  },
  {
    "name": "FARMACIA CASOLA VALSENIO DEL DOTT. AGNETTI LUCA & C. sas",
    "address": "Via della Sorgente, 1, CASOLA VALSENIO RA 48010, Italia",
    "lat": 44.2244183,
    "lng": 11.6253404,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2244183,11.6253404"
  },
  {
    "name": "ORTOPEDIA AGOSTINI SRL",
    "address": "Via Pezzana, 56, CARPI MO 41012, Italia",
    "lat": 44.7927479,
    "lng": 10.8857613,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7927479,10.8857613"
  },
  {
    "name": "BP S.N.C. DI ALESSANDRA FORGIARINI E ROBERTO FRESCO",
    "address": "VIA DEI CARPINI, 23, CODROIPO UD 33033, Italia",
    "lat": 45.965953,
    "lng": 12.9745782,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.965953,12.9745782"
  },
  {
    "name": "LA SANITARIA di Ferro Valeria & C. sas",
    "address": "Via Ospedale, 11, SAN BONIFACIO VR 37047, Italia",
    "lat": 45.3983351,
    "lng": 11.2722409,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3983351,11.2722409"
  },
  {
    "name": "ORTHOPLUS s.a.s. di Luca Cesare e C.",
    "address": "Via Gerenzano, 13, CASTELLANZA VA 21053, Italia",
    "lat": 45.6120664,
    "lng": 8.9099828,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6120664,8.9099828"
  },
  {
    "name": "ORT. PINI MARIA di Bevilacqua Luciana snc",
    "address": "Via Fabiani, 49, MORBEGNO SO 23017, Italia",
    "lat": 46.133486,
    "lng": 9.5679012,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.133486,9.5679012"
  },
  {
    "name": "COMUNE DI MORRO D'ORO",
    "address": "P.zza Duca degli Abruzzi, 1, MORRO D'ORO TE 64020, Italia",
    "lat": 42.6637888,
    "lng": 13.9195272,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6637888,13.9195272"
  },
  {
    "name": "PARAFARMACIA ORTOPEDIA SALUTESTORE di Dott. Palumbo Salvatore Luca",
    "address": "Via Balegno, 1, RIVALTA DI TORINO TO 10040, Italia",
    "lat": 45.0300159,
    "lng": 7.5258456,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0300159,7.5258456"
  },
  {
    "name": "Sanitaria Baby Shop di Giuseppe Messina & C. s.a.s.",
    "address": "Viale Pio XI, 3, MOLFETTA BA 70056, Italia",
    "lat": 41.1995344,
    "lng": 16.6044958,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.1995344,16.6044958"
  },
  {
    "name": "FARMACIA SAN LORENZO sas",
    "address": "VIA XXV APRILE, 43, CHIGNOLO D'ISOLA BG 24040, Italia",
    "lat": 45.6706938,
    "lng": 9.5303505,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6706938,9.5303505"
  },
  {
    "name": "SANILAB S.R.L.",
    "address": "Via Cremona, 46, BRESCIA BS 25124, Italia",
    "lat": 45.5203159,
    "lng": 10.2247019,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5203159,10.2247019"
  },
  {
    "name": "SANITAS VADO di BASSO ANDREA & C. S.A.S.",
    "address": "Via Aurelia, 124, VADO LIGURE SV 17047, Italia",
    "lat": 44.2661804,
    "lng": 8.4412133,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2661804,8.4412133"
  },
  {
    "name": "ERBORISTERIA-PARAFARMACIA ERBAFARMA di Marzia Dott.ssa BORGHI",
    "address": "Piazza Gramsci 11/A, SAN PROSPERO MO 41030, Italia",
    "lat": 44.7899314,
    "lng": 11.0239583,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7899314,11.0239583"
  },
  {
    "name": "CPO Mobility S.r.l.",
    "address": "Strada Mercati 18/A, PARMA PR 43100, Italia",
    "lat": 44.8141549,
    "lng": 10.3090512,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8141549,10.3090512"
  },
  {
    "name": "FARMACIA SPARVIERI SNC",
    "address": "CORSO TRENTO E TRIESTE 36, LANCIANO CH 66034, Italia",
    "lat": 42.2299314,
    "lng": 14.3912657,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2299314,14.3912657"
  },
  {
    "name": "ORTOPEDIA GIUBILATO DR. STEFANO SRL",
    "address": "VIA G. GARIBALDI 17, CONEGLIANO TV 31015, Italia",
    "lat": 45.88273,
    "lng": 12.2930185,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.88273,12.2930185"
  },
  {
    "name": "FARMACIA LANZONI DELLA DOTT.SSA LANZONI ANNA MARIA E C. S.A.S.",
    "address": "Viale Matteotti 17, CESENA FC 47522, Italia",
    "lat": 44.1396887,
    "lng": 12.2344275,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1396887,12.2344275"
  },
  {
    "name": "FARMACIA MURA SAN CARLO SAS",
    "address": "Via Galletta 58/C, SAN LAZZARO DI SAVENA BO 40068, Italia",
    "lat": 44.4492558,
    "lng": 11.417178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4492558,11.417178"
  },
  {
    "name": "SANITARIA CM snc di Mastrantuomo Antonia & C.",
    "address": "Via Volturno, 41, VENAFRO IS 86079, Italia",
    "lat": 41.483487,
    "lng": 14.04748,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.483487,14.04748"
  },
  {
    "name": "ISTITUTO ORTOPEDICO PICENO s.r.l.",
    "address": "Via delle Petunie, 1, ASCOLI PICENO AP 63100, Italia",
    "lat": 42.8502051,
    "lng": 13.6172969,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8502051,13.6172969"
  },
  {
    "name": "FARMACIA REGINA PACIS SNC delle Dott.sse MONTINARI GRETA, CONTEH NASRA",
    "address": "Via Regina Pacis 88, SASSUOLO MO 41049, Italia",
    "lat": 44.5491598,
    "lng": 10.7829856,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5491598,10.7829856"
  },
  {
    "name": "PARAFARMACIA PUNTO SALUTE Dott.ssa Pessiglione Cuni Elena",
    "address": "C.so Italia 6, MONDOVI' CN 12084, Italia",
    "lat": 44.3953356,
    "lng": 7.8164369,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3953356,7.8164369"
  },
  {
    "name": "FARMACIA CENTRALE S.A.S. DEL DOTT. ARGANO GUIDO E C.",
    "address": "Piazza Leumann, 4/A, PIANEZZA TO 10044, Italia",
    "lat": 45.1012088,
    "lng": 7.5476341,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1012088,7.5476341"
  },
  {
    "name": "FARMACIA DI LEONE SRL",
    "address": "Via delle Vigne, 163, ROMA RM 00148, Italia",
    "lat": 41.8423853,
    "lng": 12.4214148,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8423853,12.4214148"
  },
  {
    "name": "MEDISAN DI LERATTI MARILISA",
    "address": "Via Credaro Luigi, 14, SONDRIO SO 23100, Italia",
    "lat": 46.1703277,
    "lng": 9.878883,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1703277,9.878883"
  },
  {
    "name": "FARMACIA LE CICOGNE DELLE DOTT.SSE CARDINALI, PIERSANTI E ZACCHINI SNC",
    "address": "VIA G. GALILEI, 4, FAENZA RA 48018, Italia",
    "lat": 44.2961067,
    "lng": 11.8604295,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2961067,11.8604295"
  },
  {
    "name": "ORTOPEDIA DI GREGORIO SAS",
    "address": "Via Trieste 47B, PATTI ME 98066, Italia",
    "lat": 38.142132,
    "lng": 14.974718,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.142132,14.974718"
  },
  {
    "name": "FARMACIA PONTE OSPEDALETTO SNC",
    "address": "Via della Solidarietà, 2, LONGIANO - Budrio FC 47020, Italia",
    "lat": 44.1083734,
    "lng": 12.3177408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1083734,12.3177408"
  },
  {
    "name": "VON ZIEGLAUER ELISABETH",
    "address": "Via Andreas Hofer, 15/A, BRUNICO BZ 39031, Italia",
    "lat": 46.7990439,
    "lng": 11.9382783,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.7990439,11.9382783"
  },
  {
    "name": "ORTHOSANITARI PASCUCCI S.A.S. DI DICEGLIA NATALIZIA",
    "address": "Via Roma, 15, PERGINE VALSUGANA TN 38057, Italia",
    "lat": 46.059967,
    "lng": 11.2397532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.059967,11.2397532"
  },
  {
    "name": "CENTRO ORTOPEDICO TRENTINO SRL",
    "address": "Via Milano, 41, TRENTO TN 38100, Italia",
    "lat": 46.0624189,
    "lng": 11.1300384,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0624189,11.1300384"
  },
  {
    "name": "FARMACIA VARALDO DI VARALDO CORRADO & C. S.N.C.",
    "address": "Via M. Libertà, 37, DEGO SV 17058, Italia",
    "lat": 44.4480093,
    "lng": 8.3084911,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4480093,8.3084911"
  },
  {
    "name": "La Sanità ORTOPEDIA di Sguario Mario & C. s.a.s.",
    "address": "V.lo del Messaggero, 19, ROVERETO TN 38068, Italia",
    "lat": 45.8901779,
    "lng": 11.0441809,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8901779,11.0441809"
  },
  {
    "name": "Articoli Sanitari A.S.V. di Voltolini e C.",
    "address": "Via Segantini, 59, ARCO TN 38062, Italia",
    "lat": 45.9196929,
    "lng": 10.8879849,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9196929,10.8879849"
  },
  {
    "name": "Medika service srls",
    "address": "Via Rondò San Giorgio, 16/18, TRIGGIANO BA 70019, Italia",
    "lat": 41.067913,
    "lng": 16.932833,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.067913,16.932833"
  },
  {
    "name": "FARMACIA GIARDINI DOTT. GIACOMO",
    "address": "Via Cavour 74, MELDOLA FC 47014, Italia",
    "lat": 44.1255238,
    "lng": 12.0604897,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1255238,12.0604897"
  },
  {
    "name": "L.O.A. Laboratorio Ortopedico Astigiano srl",
    "address": "Corso Venezia, 67, ASTI AT 14100, Italia",
    "lat": 44.8920422,
    "lng": 8.2085474,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8920422,8.2085474"
  },
  {
    "name": "ORTOPEDIA MARINI S.R.L.",
    "address": "Via Piceno Aprutina, 81, ASCOLI PICENO AP 63100, Italia",
    "lat": 42.8469871,
    "lng": 13.6090409,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8469871,13.6090409"
  },
  {
    "name": "BONGINI DI MARTINELLI RENATA",
    "address": "Via XXV Aprile, 22, FALOPPIO CO 22020, Italia",
    "lat": 45.8040071,
    "lng": 8.9785689,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8040071,8.9785689"
  },
  {
    "name": "Ortopedia La Rimessa srl",
    "address": "Piazza della Vittoria, 14/16 A, GENOVA GE 16121, Italia",
    "lat": 44.403074,
    "lng": 8.9449881,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.403074,8.9449881"
  },
  {
    "name": "PODOSTUDIO s.a.s.",
    "address": "Via Volta, 4/E, TORINO TO 10121, Italia",
    "lat": 45.0640573,
    "lng": 7.6777946,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0640573,7.6777946"
  },
  {
    "name": "FARMACIA FUTURA S.N.C.",
    "address": "Via Valdelatorre, 131/A, ALPIGNANO TO 10091, Italia",
    "lat": 45.097147,
    "lng": 7.5256082,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.097147,7.5256082"
  },
  {
    "name": "Farmacia Reale del Dott. Alberto Ferrante e C. snc",
    "address": "Via Reale 17, BAGNACAVALLO RA 48012, Italia",
    "lat": 44.4720648,
    "lng": 12.0789494,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4720648,12.0789494"
  },
  {
    "name": "SABBATINI PISTELLI LUCIANO",
    "address": "Stradone Misa, 4, SENIGALLIA AN 60019, Italia",
    "lat": 43.7107979,
    "lng": 13.2139173,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7107979,13.2139173"
  },
  {
    "name": "Parafarmacia Augusta di Borra Samuele",
    "address": "Piazza Martiri della Libertà, 13/a, BENE VAGIENNA CN 12041, Italia",
    "lat": 44.5440026,
    "lng": 7.829296,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5440026,7.829296"
  },
  {
    "name": "FARMACIA OSELLA srl",
    "address": "PIAZZA BORGO NUOVO, 3, MASIO AL 15024, Italia",
    "lat": 45.6518917,
    "lng": 13.7741845,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6518917,13.7741845"
  },
  {
    "name": "S.O.S. SANITARIA DI BUCCIARELLI RAIMONDO",
    "address": "Via C. Battisti, 48, SENIGALLIA AN 60019, Italia",
    "lat": 43.712482,
    "lng": 13.2171863,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.712482,13.2171863"
  },
  {
    "name": "ORTOPEDIA CENTRO POSTURALE FALCONE DI FALCONE GIANLUIGI",
    "address": "Piazza F.Redi, 23/25, PESARO PU 61100, Italia",
    "lat": 43.8993449,
    "lng": 12.9220892,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8993449,12.9220892"
  },
  {
    "name": "SGDS MULTISERVIZI SRL",
    "address": "Strada Pompeiana, 41, PORTO SAN GIORGIO FM 63822, Italia",
    "lat": 43.1634865,
    "lng": 13.7911246,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1634865,13.7911246"
  },
  {
    "name": "ORTOPEDIA BALDINI di Baldini Maria Antonia",
    "address": "Via Petronelli 1, BISCEGLIE BT 76011, Italia",
    "lat": 41.2369965,
    "lng": 16.5000116,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2369965,16.5000116"
  },
  {
    "name": "FARMACIA SANT'ALFONSO Dott.ssa Gambino Francesca",
    "address": "Corso Alessandro Tassoni, 66, Torino TO 10144, Italia",
    "lat": 45.0844169,
    "lng": 7.6561504,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0844169,7.6561504"
  },
  {
    "name": "ALLEGRETTI SRL",
    "address": "Salita Santa Caterina, 44 R, GENOVA GE 16123, Italia",
    "lat": 44.4101737,
    "lng": 8.9358267,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4101737,8.9358267"
  },
  {
    "name": "ORTOPEDIA NOLI SRL",
    "address": "Via Emilia, 178, VOGHERA PV 27058, Italia",
    "lat": 44.9945113,
    "lng": 9.01099,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9945113,9.01099"
  },
  {
    "name": "FARMACIA FORMENTINI DR. BRUNO",
    "address": "Viale Trieste, 21, PONZANO DI FERMO - Capparuccia AP 63020, Italia",
    "lat": 43.1325031,
    "lng": 13.6251706,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1325031,13.6251706"
  },
  {
    "name": "SANITARIA ORTOPEDIA SONIA DI PANDOLFO SONIA",
    "address": "Via della Crocetta, 6, ARZIGNANO VI 36071, Italia",
    "lat": 45.5191818,
    "lng": 11.3290495,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5191818,11.3290495"
  },
  {
    "name": "FARMACIA CREMASCHI S.N.C. della Dott.ssa Paola Cremaschi e Marchetti",
    "address": "Via Alcide de Gasperi, 73, GAMBETTOLA FC 47035, Italia",
    "lat": 44.1083903,
    "lng": 12.3378211,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1083903,12.3378211"
  },
  {
    "name": "MALALAN SANART",
    "address": "VIA NAZIONALE, 47/1, TRIESTE TS 34154, Italia",
    "lat": 45.6869469,
    "lng": 13.7883212,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6869469,13.7883212"
  },
  {
    "name": "EMMEGI SRLS",
    "address": "VIA GIULIO CESARE 95, VASTO CH 66054, Italia",
    "lat": 42.1235366,
    "lng": 14.70619,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.1235366,14.70619"
  },
  {
    "name": "SANITARIA PROFUMERIA DEL PORTO di Simoncelli Loretta e C. Sas",
    "address": "via A. Cecchi 39/1, PESARO PU 61100, Italia",
    "lat": 43.8831754,
    "lng": 12.9395145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8831754,12.9395145"
  },
  {
    "name": "OFFICINE ORTOPEDICHE DR. AMEDEO INCERPI s.r.l.",
    "address": "Via Simeto, 13, CAGLIARI CA 09122, Italia",
    "lat": 39.2342981,
    "lng": 9.0943422,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.2342981,9.0943422"
  },
  {
    "name": "TEXAN SRL",
    "address": "via Corradino d'Ascanio 3, ALANNO PE 65020, Italia",
    "lat": 42.2957111,
    "lng": 14.0229744,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2957111,14.0229744"
  },
  {
    "name": "SANITARIA ORTOPEDIA CENTRALE S.N.C.",
    "address": "Corso Vittorio Emanuele, 20, URBANIA PU 61049, Italia",
    "lat": 43.6680689,
    "lng": 12.5231731,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6680689,12.5231731"
  },
  {
    "name": "D.O.S. s.a.s. di Manfredi G. & C.",
    "address": "Via Roma, 29, CASTELLEONE DI SUASA AN 60010, Italia",
    "lat": 43.6081928,
    "lng": 12.9792037,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6081928,12.9792037"
  },
  {
    "name": "ANTICA FARMACIA LUGARESI SNC DELLA DOTT.SSA STEFANIA MARINI & C.",
    "address": "Corso G. Garibaldi, 57, ALFONSINE RA 48011, Italia",
    "lat": 44.5006028,
    "lng": 12.0440785,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5006028,12.0440785"
  },
  {
    "name": "PARAFARMACIA CORSO CAVOUR",
    "address": "Via Guglielmo Marconi, 10, PERUGIA PG 06121, Italia",
    "lat": 43.1075255,
    "lng": 12.3903018,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1075255,12.3903018"
  },
  {
    "name": "PUNTO SCARPE NICOLI S.R.L.",
    "address": "Via Cave, 5, ALBINO BG 24021, Italia",
    "lat": 45.7541004,
    "lng": 9.7988896,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7541004,9.7988896"
  },
  {
    "name": "PROFUMERIA SANITARIA LORY di Tombesi Gilberto & C. s.a.s",
    "address": "C.so Matteotti 60/B, MACERATA MC 62100, Italia",
    "lat": 43.3005606,
    "lng": 13.4518178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3005606,13.4518178"
  },
  {
    "name": "FARMACISTA DOTT. FORLUCCI LUCA",
    "address": "Via del Mare, 28, MISANO ADRIATICO RN 47843, Italia",
    "lat": 43.9795706,
    "lng": 12.6870059,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9795706,12.6870059"
  },
  {
    "name": "ANTICA FARMACIA AL LIDO SNC DEI DOTTORI M. MURATORI, R. VERTAGLIA",
    "address": "Piazza Marvelli, 7, RIMINI RN 47900, Italia",
    "lat": 44.0636757,
    "lng": 12.5851497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0636757,12.5851497"
  },
  {
    "name": "SANITARY SERVICE S.A.S. DI FERRARO DARIO & C.",
    "address": "Via Ippocrate, 68, ACRI CS 87041, Italia",
    "lat": 39.4910164,
    "lng": 16.3883548,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.4910164,16.3883548"
  },
  {
    "name": "FARMACIA DI CROCE Sas del Dr. Mario Di Croce & C.",
    "address": "C.so Umberto I, 35, SAN SALVO CH 66050, Italia",
    "lat": 42.0444769,
    "lng": 14.7310097,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0444769,14.7310097"
  },
  {
    "name": "ORTHOSANIT s.r.l.",
    "address": "Corso Monte Grappa, 50/C, TORINO TO 10145, Italia",
    "lat": 45.0786919,
    "lng": 7.6374196,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0786919,7.6374196"
  },
  {
    "name": "MONTANARI s.n.c. di Alessia e Marta Montanari",
    "address": "Via Matteotti, 4A, SANTA MARIA MAGGIORE VB 28857, Italia",
    "lat": 46.1340541,
    "lng": 8.4661364,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1340541,8.4661364"
  },
  {
    "name": "FARMACIA SCIACCA RIZZO del Dott. Rizzo Giuseppe",
    "address": "Via Generale Liotta, 7, SANT'AGATA DI MILITELLO ME 98076, Italia",
    "lat": 38.0680207,
    "lng": 14.6346967,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0680207,14.6346967"
  },
  {
    "name": "FARMACIA MORSILLO s.n.c. della Dr.ssa Carmela Satta & C.",
    "address": "Via M. Garibaldi, 72/73, LIPARI - Canneto ME 98055, Italia",
    "lat": 38.466388,
    "lng": 14.955601,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.466388,14.955601"
  },
  {
    "name": "Ortopedia Landi srl",
    "address": "Via M. Natola, 51/53, FOGGIA FG 71100, Italia",
    "lat": 41.463028,
    "lng": 15.54409,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.463028,15.54409"
  },
  {
    "name": "FARMACIA DELL'OCA MARIA FRANCESCA",
    "address": "Via Garibaldi, 95, FINO MORNASCO CO 22073, Italia",
    "lat": 45.745129,
    "lng": 9.0499276,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.745129,9.0499276"
  },
  {
    "name": "SANITARIA CENTRALE di Maggio Marisa",
    "address": "Via V. Emanuele II , 15, CONSELVE PD 35026, Italia",
    "lat": 45.2321639,
    "lng": 11.8730235,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2321639,11.8730235"
  },
  {
    "name": "FARMACIA MESSORE s.a.s. del Dr. Messore Pasquale & C.",
    "address": "Via Provinciale, 39, AUSONIA FR 03040, Italia",
    "lat": 41.4425024,
    "lng": 13.7892464,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.4425024,13.7892464"
  },
  {
    "name": "Farmacia SAN ROCCO s.r.l.",
    "address": "Corso Asti, 2, NIZZA MONFERRATO AT 14049, Italia",
    "lat": 44.7726202,
    "lng": 8.3492698,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7726202,8.3492698"
  },
  {
    "name": "PARAFARMACIA Dott.ssa Liana Marafini",
    "address": "Via Appia, 752, MINTURNO - Scauri LT 04028, Italia",
    "lat": 41.2532327,
    "lng": 13.7218472,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2532327,13.7218472"
  },
  {
    "name": "PARAFARMACIA Dott.ssa DE MARE di Concetta De Mare",
    "address": "Via Mantova, SNC, TUSCANIA VT 01017, Italia",
    "lat": 42.415652,
    "lng": 11.866938,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.415652,11.866938"
  },
  {
    "name": "Sanicenter srl",
    "address": "Via del Vantaggio, 18, CITTA' DI CASTELLO PG 06012, Italia",
    "lat": 43.454731,
    "lng": 12.2416504,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.454731,12.2416504"
  },
  {
    "name": "COMUNE DI FIORANO MODENESE",
    "address": "Piazza Ciro Menotti, 1, FIORANO MODENESE MO 41042, Italia",
    "lat": 44.5390735,
    "lng": 10.8115345,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5390735,10.8115345"
  },
  {
    "name": "COMUNE DI CASTELFRANCO EMILIA",
    "address": "Piazza della Vittoria, 8, CASTELFRANCO EMILIA MO 41013, Italia",
    "lat": 44.5962603,
    "lng": 11.0533124,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5962603,11.0533124"
  },
  {
    "name": "OFFICINA ORTOPEDICA S.R.L.",
    "address": "Viale Ettore Fieramosca, 139, CORATO BA 70033, Italia",
    "lat": 41.1546407,
    "lng": 16.4073392,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.1546407,16.4073392"
  },
  {
    "name": "Farmacia Borgo Vittoria s.n.c",
    "address": "Via Chiesa della Salute, 64, TORINO TO 10147, Italia",
    "lat": 45.0976725,
    "lng": 7.6801001,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0976725,7.6801001"
  },
  {
    "name": "FARMACIA BIANCHI D.SSA MARCELLA",
    "address": "Via Agorà, 5, PASTURANA AL 15060, Italia",
    "lat": 44.7501283,
    "lng": 8.7532257,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7501283,8.7532257"
  },
  {
    "name": "SNUG S.R.L.",
    "address": "Via Madama Cristina, 19 bis/C, TORINO TO 10125, Italia",
    "lat": 45.0556994,
    "lng": 7.6814922,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0556994,7.6814922"
  },
  {
    "name": "Farmacia Presbitero Bracco della Dott.ssa Presbitero Bracco Chiara",
    "address": "Via Provinciale, 2/2, VAL DI CHY TO 10039, Italia",
    "lat": 45.4612109,
    "lng": 7.7712017,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4612109,7.7712017"
  },
  {
    "name": "MUNFORTE GIOVANNI",
    "address": "Via V.Veneto, 55/57, RANDAZZO CT 95036, Italia",
    "lat": 37.8759513,
    "lng": 14.9526284,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.8759513,14.9526284"
  },
  {
    "name": "LABORATORI PIAZZA srl",
    "address": "Via Henry Dunant, 25, GUIDIZZOLO MN 46040, Italia",
    "lat": 45.3239003,
    "lng": 10.5706969,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3239003,10.5706969"
  },
  {
    "name": "LA SANITARIA DI MARIO CARBONE",
    "address": "Corso G.di Vittorio, 35, GRAVINA IN PUGLIA BA 70024, Italia",
    "lat": 40.8224896,
    "lng": 16.4203059,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.8224896,16.4203059"
  },
  {
    "name": "LA NUOVA SANITARIA NEGRI ERICA",
    "address": "Via Dante Alighieri, 17, GOITO MN 46044, Italia",
    "lat": 45.2569504,
    "lng": 10.6746736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2569504,10.6746736"
  },
  {
    "name": "ORTOTECNICA SERVICE DI SONCIN ALEX",
    "address": "Via Veneto, 7, PORTOGRUARO VE 30026, Italia",
    "lat": 45.7742375,
    "lng": 12.8433792,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7742375,12.8433792"
  },
  {
    "name": "PARAFARMACIA BARTOLUCCI DR.SSA ELISA",
    "address": "Corso Vecchio, 211/213, TERNI TR 05100, Italia",
    "lat": 42.5636718,
    "lng": 12.6503735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5636718,12.6503735"
  },
  {
    "name": "FARMACIA DI RASTIGNANO Dr. NIZZI MAURO & M. srl",
    "address": "Via A. Costa, 58, PIANORO - Rastignano BO 40067, Italia",
    "lat": 44.4441981,
    "lng": 11.3569306,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4441981,11.3569306"
  },
  {
    "name": "SANITARIA-ORTOPEDIA CRISTINA di CRISTINA RIMBANI",
    "address": "Via Roma, 20, GORLA MINORE VA 21055, Italia",
    "lat": 45.6424911,
    "lng": 8.8991312,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6424911,8.8991312"
  },
  {
    "name": "MODERNA SOCIETA' A RESPONSABILITA' LIMITATA",
    "address": "Via Aspromonte c/o Centro Commerciale Agorà, FOLIGNO PG 06034, Italia",
    "lat": 42.963176,
    "lng": 12.690133,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.963176,12.690133"
  },
  {
    "name": "PHARMAKEIA s.a.s della Dott.ssa Silvia Bonardi e C.",
    "address": "Strada Camporelle N.1, GROSSO TO 10070, Italia",
    "lat": 45.252574,
    "lng": 7.5566365,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.252574,7.5566365"
  },
  {
    "name": "ERBAMEDICA VARALLO DI COSTANZI MARCO & C. SAS",
    "address": "Viale Cesare Battisti, 12, VARALLO VC 13019, Italia",
    "lat": 45.8116591,
    "lng": 8.2680104,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8116591,8.2680104"
  },
  {
    "name": "LA SANITARIA di ROSA CONTINO",
    "address": "Via Vittorio Emanuele, 22, AGIRA EN 94011, Italia",
    "lat": 37.6576995,
    "lng": 14.5257225,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6576995,14.5257225"
  },
  {
    "name": "FARMACIA LUCIANI snc del Dr. Luciani Augusto Anna",
    "address": "Via Strozzacapponi, 88/F, PERUGIA-Castel del Piano PG 06132, Italia",
    "lat": 43.0651186,
    "lng": 12.3116037,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0651186,12.3116037"
  },
  {
    "name": "ORTOPEDIA LANFRANCHI di Annalisa Barcellari e c. sas",
    "address": "Via Belfiore, 12, ASOLA MN 46041, Italia",
    "lat": 45.2209844,
    "lng": 10.4163909,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2209844,10.4163909"
  },
  {
    "name": "TURTURRO LUCIA ORTOSAN",
    "address": "Via Gramsci, 70, SEGRATE MI 20090, Italia",
    "lat": 45.4931291,
    "lng": 9.2940192,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4931291,9.2940192"
  },
  {
    "name": "RIZZI SANDRO-ORTOPEDIA E ARTICOLI SANITARI",
    "address": "Via Roma, 44, MANTOVA MN 46100, Italia",
    "lat": 45.0353574,
    "lng": 10.7620313,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0353574,10.7620313"
  },
  {
    "name": "FARMACIA REVIGLIO snc dei Dottori Reviglio Gianpiero e Federica",
    "address": "Via Stazione, 10, GIAVENO TO 10094, Italia",
    "lat": 45.0413787,
    "lng": 7.3539936,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0413787,7.3539936"
  },
  {
    "name": "ORTOPEDIA SANITARIA ANDREA MAZZOTTA",
    "address": "Via IV Novembre, 46, TREVIGNANO ROMANO RM 00069, Italia",
    "lat": 42.156927,
    "lng": 12.2442767,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.156927,12.2442767"
  },
  {
    "name": "ORTOPEDIA GRASSINI ALBERTO SRL",
    "address": "Via Cremona, BUSTO ARSIZIO VA 21052, Italia",
    "lat": 45.6238444,
    "lng": 8.8484396,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6238444,8.8484396"
  },
  {
    "name": "ORTOPEDIA RUBBINI 1832 S.R.L.",
    "address": "Via Ugo Bassi, 8H, BOLOGNA BO 40121, Italia",
    "lat": 44.4950204,
    "lng": 11.3417972,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4950204,11.3417972"
  },
  {
    "name": "Ortopedia e protesi Mele G.R.E.M. Srl",
    "address": "Viale Pio X, 168/176, CATANZARO CZ 88100, Italia",
    "lat": 38.9223933,
    "lng": 16.58206,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.9223933,16.58206"
  },
  {
    "name": "FARMACIA BONCI",
    "address": "Via I Maggio, 2/G-2/H, BUCINE - Badia agnano AR 52021, Italia",
    "lat": 43.4369641,
    "lng": 11.6442159,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4369641,11.6442159"
  },
  {
    "name": "SANITARIA FUTURA s.r.l.",
    "address": "Via Matteotti, 39, FOGGIA FG 71100, Italia",
    "lat": 41.5824401,
    "lng": 15.1200097,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.5824401,15.1200097"
  },
  {
    "name": "NUOVA ORTOPEDIA VITERBESE s.r.l.",
    "address": "Via V. Cardarelli, 13, VITERBO VT 01100, Italia",
    "lat": 42.4285919,
    "lng": 12.1030189,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4285919,12.1030189"
  },
  {
    "name": "PARAFARMACIA E VETERINARIA Dott.ssa Lorella Masciotra",
    "address": "Via  Giacomo Matteotti 12/14, AGNONE IS 86081, Italia",
    "lat": 41.808453,
    "lng": 14.373601,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.808453,14.373601"
  },
  {
    "name": "Farmacia Degli Stemmi Dott.ssa Maranzana Claudia",
    "address": "Via Po, 31, TORINO TO 10124, Italia",
    "lat": 45.067996,
    "lng": 7.6907357,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.067996,7.6907357"
  },
  {
    "name": "LABORATORIO ORTOPEDICO MAZZOCCHI srl",
    "address": "Via Torino, 2, CUORGNE' TO 10082, Italia",
    "lat": 45.3871264,
    "lng": 7.6572497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3871264,7.6572497"
  },
  {
    "name": "FARMACIA ALTEA srl",
    "address": "Via L. Zamenhof, 11, MODENA MO 41100, Italia",
    "lat": 44.628229,
    "lng": 10.9453334,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.628229,10.9453334"
  },
  {
    "name": "FARMACIA GRECO Dott.ssa ELISA",
    "address": "Via I.Martinelli, 2, CARPI - Fossoli MO 41012, Italia",
    "lat": 44.8211806,
    "lng": 10.8901436,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8211806,10.8901436"
  },
  {
    "name": "Farmacia Besurica snc dei D.ri Losi E. & Losi L.",
    "address": "Via Malaspina, 2, PIACENZA PC 29100, Italia",
    "lat": 45.0335993,
    "lng": 9.6635914,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0335993,9.6635914"
  },
  {
    "name": "IMAR S.R.L.",
    "address": "Via del Circuito, 54, PESCARA PE 65121, Italia",
    "lat": 42.4645864,
    "lng": 14.2052554,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4645864,14.2052554"
  },
  {
    "name": "FARMACIA BONADUCE SNC",
    "address": "Largo Buonarroti, 8, ALLERONA TR 05011, Italia",
    "lat": 41.992978,
    "lng": 12.10004,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.992978,12.10004"
  },
  {
    "name": "FARMACIA SANT'ANTONIO delle Dott.sse Monica Caporali e Rita Bertelli",
    "address": "Via Statale, 175/A, QUARRATA PT 51039, Italia",
    "lat": 43.8768873,
    "lng": 10.9788666,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8768873,10.9788666"
  },
  {
    "name": "FARMACIE COMUNALI PISA SPA",
    "address": "Via Cesare Battisti, 53, PISA PI 56125, Italia",
    "lat": 43.7101039,
    "lng": 10.3959612,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7101039,10.3959612"
  },
  {
    "name": "BARBARANCIA S.A.S. DI BARBARANCIA EUSEBI PAOLO & C.",
    "address": "Via delle Querce, 59, ORVIETO TR 05018, Italia",
    "lat": 42.7297322,
    "lng": 12.1387143,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7297322,12.1387143"
  },
  {
    "name": "TECNISAN SRL",
    "address": "VIA BENACENSE, 41, ROVERETO TN 38068, Italia",
    "lat": 45.8815919,
    "lng": 11.0377561,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8815919,11.0377561"
  },
  {
    "name": "Farmacia Eugeni di Olivieri Sonia Domenica & c. SAS",
    "address": "Via Faleriense Est, 29, MONTEGIORGIO FM 63833, Italia",
    "lat": 43.1181209,
    "lng": 13.5709239,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1181209,13.5709239"
  },
  {
    "name": "Farmacia Al Molino snc dei Dottori Alessandra Larini e Aldo Cocchini",
    "address": "Via Don Minzoni, 58/60/62, CERTALDO FI 50052, Italia",
    "lat": 43.5419497,
    "lng": 11.0390263,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5419497,11.0390263"
  },
  {
    "name": "FARMACIA PALAZZO DEL PERO S.A.S. DELLA DOTT.SSA MARINI FRANCA & C.",
    "address": "Località Palazzo del Pero, 57/B, AREZZO - Palazzo del pero AR 52100, Italia",
    "lat": 43.4214537,
    "lng": 11.9713887,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4214537,11.9713887"
  },
  {
    "name": "FARMACIE MENCARELLI SRL",
    "address": "VIA BENGASI, 2, GROSSETO GR 58100, Italia",
    "lat": 42.7606566,
    "lng": 11.1188266,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7606566,11.1188266"
  },
  {
    "name": "FARMACIA FINADRI SNC DEI DOTT.PISANO",
    "address": "VIA MONTALDO,14, PIETRA LIGURE SV 17027, Italia",
    "lat": 44.1489228,
    "lng": 8.2841507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1489228,8.2841507"
  },
  {
    "name": "A.C.F. FARMACOM",
    "address": "VIA SCARPETTINI 370/2, MONTEMURLO PO 59013, Italia",
    "lat": 43.9114013,
    "lng": 11.0267047,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9114013,11.0267047"
  },
  {
    "name": "AZIENDA MULTISERVIZI FORTE DEI MARMI SRL",
    "address": "PIAZZA H.MOORE 1, FORTE DEI MARMI LU 55042, Italia",
    "lat": 43.959462,
    "lng": 10.168841,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.959462,10.168841"
  },
  {
    "name": "AZIENDA SPECIALE FARMACIE",
    "address": "VIA VITTIME DEL DUOMO, 8, SAN MINIATO PI 56028, Italia",
    "lat": 43.6796417,
    "lng": 10.8525418,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6796417,10.8525418"
  },
  {
    "name": "CIVITAS MONTOPOLI SRL SOCIETA' UNIPERSONALE",
    "address": "VIA NAZIONALE 19/B, MONTOPOLI IN VAL D'ARNO - Capanne PI 56020, Italia",
    "lat": 43.6753988,
    "lng": 10.7337456,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6753988,10.7337456"
  },
  {
    "name": "FARMACIA S.RITA DR. MORENA ANTONINI",
    "address": "LARGO A.ELEMOSINA 7, CASCIA PG 06043, Italia",
    "lat": 42.7160023,
    "lng": 13.0144829,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7160023,13.0144829"
  },
  {
    "name": "FARMACIA BELLAVISTA S.N.C. DEL DR. DANIELE FABBRINI & C.",
    "address": "VIA IRLANDA 2/E, POGGIBONSI - Bellavista SI 53036, Italia",
    "lat": 43.4404723,
    "lng": 11.1613831,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4404723,11.1613831"
  },
  {
    "name": "FARMACIA BENINI S.A.S. DEL DOTT. NICOLA GIGLIONI E C.",
    "address": "VIA MAIORCA 149, MARINA DI PISA PI 56013, Italia",
    "lat": 43.6733223,
    "lng": 10.2728645,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6733223,10.2728645"
  },
  {
    "name": "FARMACIA BOLOGNI DR.ALESSANDRO",
    "address": "P.ZZA DEL TEATRO 16, CHIUSI CITTA' SI 53043, Italia",
    "lat": 43.0160615,
    "lng": 11.9501275,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0160615,11.9501275"
  },
  {
    "name": "FARMACIA BUFALINI SNC",
    "address": "P.ZZA NAZIONI UNITE 22, TORRITA DI SIENA SI 53049, Italia",
    "lat": 43.1699449,
    "lng": 11.7785043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1699449,11.7785043"
  },
  {
    "name": "FARMACIA CAROTI GHELLI DR.MARCELLO SNC",
    "address": "VIALE DEL TIRRENO 133, TIRRENIA PI 56018, Italia",
    "lat": 43.6279574,
    "lng": 10.2917694,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6279574,10.2917694"
  },
  {
    "name": "FARMACIA CASOTTO DR.SSA MARIA PIA & C.",
    "address": "VIA PROVINCIALE DI TALAMONE 4, FONTEBLANDA GR 58010, Italia",
    "lat": 40.501728,
    "lng": 15.052734,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.501728,15.052734"
  },
  {
    "name": "FARMACIA ALFANI CECCARELLI DI MAGDA CECCARELLI E C. SNC",
    "address": "VIA LUIGI GORI 10, BIBBIENA AR 52011, Italia",
    "lat": 43.695693,
    "lng": 11.8165999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.695693,11.8165999"
  },
  {
    "name": "FARMACIA CENTRALE SNC DR.FUSI & C.",
    "address": "P.ZZA CAVOUR 20, PORTOFERRAIO LI 57037, Italia",
    "lat": 42.8148339,
    "lng": 10.3304871,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8148339,10.3304871"
  },
  {
    "name": "FARMACIA CHELLINI SNC DI L.CHELLINI & C.",
    "address": "VIA DI PORTA NUOVA 1/A, RAPOLANO TERME SI 53040, Italia",
    "lat": 43.2878313,
    "lng": 11.60246,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2878313,11.60246"
  },
  {
    "name": "FARMACIA COLETTI SNC",
    "address": "VIA TOSCO ROMAGNOLA 131, FORNACETTE PI 56012, Italia",
    "lat": 43.6698743,
    "lng": 10.5870963,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6698743,10.5870963"
  },
  {
    "name": "FARMACIA COLI DR.SSA ALESSANDRA",
    "address": "P.ZZA DEL POPOLO 11, PORTOFERRAIO LI 57037, Italia",
    "lat": 42.8150221,
    "lng": 10.3253133,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8150221,10.3253133"
  },
  {
    "name": "FARMACIA COMUNALE DI CRESPINA SRL",
    "address": "VIA V.VENETO 158/A, CENAIA PI 56040, Italia",
    "lat": 43.6066802,
    "lng": 10.5346578,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6066802,10.5346578"
  },
  {
    "name": "FARMACIA COMUNALE MASSA MARITTIMA",
    "address": "Via Don Luigi Rossi, 15, MASSA MARITTIMA GR 58024, Italia",
    "lat": 43.0488123,
    "lng": 10.8927892,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0488123,10.8927892"
  },
  {
    "name": "FARMACIA CESARE CONTICINI SAS DI GIUSEPPE CONTICINI",
    "address": "VIA LIVORNESE 703, PISA PI 56122, Italia",
    "lat": 43.6879904,
    "lng": 10.3663675,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6879904,10.3663675"
  },
  {
    "name": "FARMACIA DEGLI OLEANDRI SAS",
    "address": "VIA DEGLI OLEANDRI 12/14, LIVORNO LI 57128, Italia",
    "lat": 43.524238,
    "lng": 10.3230383,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.524238,10.3230383"
  },
  {
    "name": "FARMACIA DEI RONCHI DEL DR. CHEMELLO CARLO",
    "address": "VIA DEI RONCHI 48, MASSA - Ronchi MS 54100, Italia",
    "lat": 43.9985569,
    "lng": 10.1197256,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9985569,10.1197256"
  },
  {
    "name": "FARMACIA DEL BRACCAGNI DR.SSA PIANELLI",
    "address": "VIA AURELIA 42, BRACCAGNI GR 58100, Italia",
    "lat": 42.8722012,
    "lng": 11.0756268,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8722012,11.0756268"
  },
  {
    "name": "FARMACIA DI CARMIGNANO DEL DR. FRANCO TRABUCCHI E C. SNC",
    "address": "PIAZZA VITTORIO EMANUELE II, 33, CARMIGNANO PO 59100, Italia",
    "lat": 43.8140581,
    "lng": 11.0191112,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8140581,11.0191112"
  },
  {
    "name": "FARMACIA DI LEGNAIA di Giovanna e Silvia Bertolotti snc",
    "address": "VIA PISANA 195r, FIRENZE FI 50143, Italia",
    "lat": 43.7702592,
    "lng": 11.2188132,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7702592,11.2188132"
  },
  {
    "name": "FARMACIA DI SIGILLO SNC",
    "address": "VIA G.MATTEOTTI 47/49, SIGILLO PG 06028, Italia",
    "lat": 43.3293146,
    "lng": 12.74451,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3293146,12.74451"
  },
  {
    "name": "FARMACIA DINUCCI DR.FRANCESCO",
    "address": "VIA M.L.KING 16, S.GIULIANO TERME PI 56017, Italia",
    "lat": 43.7623023,
    "lng": 10.43653,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7623023,10.43653"
  },
  {
    "name": "FARMACIA FACHINETTI SNC",
    "address": "VIA GALILEI 122, VICARELLO LI 57019, Italia",
    "lat": 43.6130831,
    "lng": 10.4653377,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6130831,10.4653377"
  },
  {
    "name": "FARMACIA Dott. Carlo Fassorra",
    "address": "VIA TOSCO ROMAGNALA EST, 348, LA ROTTA PI 56020, Italia",
    "lat": 43.6634545,
    "lng": 10.6890581,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6634545,10.6890581"
  },
  {
    "name": "FARMACIA GALEAZZI dei Dottori Sergio e Giulio Galeazzi snc",
    "address": "PIAZZA MATTEOTTI 38, S.CROCE SULL'ARNO PI 56029, Italia",
    "lat": 43.7104284,
    "lng": 10.7804852,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7104284,10.7804852"
  },
  {
    "name": "FARMACIA GAZZINI SNC",
    "address": "VIA L.BIANCHI 55, PISA PI 56100, Italia",
    "lat": 43.7258472,
    "lng": 10.4025058,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7258472,10.4025058"
  },
  {
    "name": "FARMACIA IL DELFINO S.N.C.",
    "address": "PIASTRA SERVIZI 4, PUNTA ALA GR 58040, Italia",
    "lat": 42.8042427,
    "lng": 10.7363115,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8042427,10.7363115"
  },
  {
    "name": "FARMACIA LAGUARDIA DR.ANTONIO",
    "address": "P.ZZA TOGLIATTI 9, SIENA SI 53100, Italia",
    "lat": 43.3475491,
    "lng": 11.3264562,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3475491,11.3264562"
  },
  {
    "name": "FARMACIA LENZI DR.SSA MARIA PAOLA",
    "address": "VIA MASCAGNI 33, MARINA DI CAMPO LI 57034, Italia",
    "lat": 42.7612686,
    "lng": 10.2392264,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7612686,10.2392264"
  },
  {
    "name": "FARMACIA LUPETTI DR.SSA ANTONELLA LUPETTI",
    "address": "VIA S.GIOVANNI 26, PIEVE FOSCIANA LU 55036, Italia",
    "lat": 44.1321887,
    "lng": 10.4107982,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1321887,10.4107982"
  },
  {
    "name": "FARMACIA MAGGIOLI SNC",
    "address": "VIA ROMA 34, TERRICCIOLA PI 56030, Italia",
    "lat": 43.524775,
    "lng": 10.6773572,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.524775,10.6773572"
  },
  {
    "name": "FARMACIA MANNORI DEL DR. RICCARDO MANNORI E C S.A.S.",
    "address": "VIALE P.TOGLIATTI 106, VINCI - Sovigliana FI 50059, Italia",
    "lat": 43.7286079,
    "lng": 10.935311,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7286079,10.935311"
  },
  {
    "name": "FARMACIA MILIARDI SNC",
    "address": "VIA T.DI LORENZO 1, QUERCIANELLA LI 57015, Italia",
    "lat": 43.4589252,
    "lng": 10.3682232,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4589252,10.3682232"
  },
  {
    "name": "FARMACIA MILIO SNC DR. RICCARDO BARDELLI E C.",
    "address": "VIALE DANTE ALIGHIERI 59, REGGELLO FI 50066, Italia",
    "lat": 45.5400615,
    "lng": 11.55129,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5400615,11.55129"
  },
  {
    "name": "FARMACIA DR. NANNI SNC DI ANDREA E PAOLO NANNI",
    "address": "Via Dante, 13, PONTEDERA PI 56025, Italia",
    "lat": 43.6626881,
    "lng": 10.6315735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6626881,10.6315735"
  },
  {
    "name": "FARMACIA PANNI DR.LORENZO",
    "address": "VIA DEL CANCELLONE, VALPIANA GR 58024, Italia",
    "lat": 43.0030306,
    "lng": 10.8477753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0030306,10.8477753"
  },
  {
    "name": "FARMACIA PINOTTI SNC",
    "address": "VIA DANTE ALIGHIERI 53, BUONCONVENTO SI 53022, Italia",
    "lat": 43.1330276,
    "lng": 11.482241,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1330276,11.482241"
  },
  {
    "name": "FARMACIA PORTA ROMANA SRL",
    "address": "VIA DOGANA VECCHIA 2, SANSEPOLCRO AR 52037, Italia",
    "lat": 43.5685251,
    "lng": 12.1492053,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5685251,12.1492053"
  },
  {
    "name": "Farmacia Raimo Dott. Giovanni S.A.S. del Dott. Renato Raimo",
    "address": "Via Venezia Giulia, 10/A C/O CENTRO COMMERCIALE PISANOVA, PISA PI 56100, Italia",
    "lat": 43.7074368,
    "lng": 10.43011,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7074368,10.43011"
  },
  {
    "name": "FARMACIA S.ANTONIO DR.MARTINOZZI",
    "address": "VIA COLOMBO 39, FOLLONICA GR 58022, Italia",
    "lat": 42.925078,
    "lng": 10.7554275,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.925078,10.7554275"
  },
  {
    "name": "FARMACIA SALVIONI DOTT.SSA LEILI' DE MARCO",
    "address": "VIA OBERDAN 3, PISA PI 56127, Italia",
    "lat": 43.7182941,
    "lng": 10.4019877,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7182941,10.4019877"
  },
  {
    "name": "FARMACIA SAPORI Dott.ssa BELCAPO PAOLA",
    "address": "Via Banchi di Sotto, 77, SIENA SI 53100, Italia",
    "lat": 43.3189963,
    "lng": 11.3330407,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3189963,11.3330407"
  },
  {
    "name": "FARMACIA SAVORANI S.a.s. del Dott. Favilli Lorenzo & C.",
    "address": "VIA TOSCO ROMAGNOLA 1991, NAVACCHIO PI 56023, Italia",
    "lat": 43.6891387,
    "lng": 10.4777925,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6891387,10.4777925"
  },
  {
    "name": "FARMACIA SINISI DI LENA PAOLO e LENA CLAUDIO s.n.c.",
    "address": "V.VENEZIA ANG.V.INGOLSTADT, MARINA DI CARRARA MS 54033, Italia",
    "lat": 44.038908,
    "lng": 10.0389465,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.038908,10.0389465"
  },
  {
    "name": "FARMACIA TUTINO RANZANI SNC",
    "address": "VIA NUOVA PER PISA 5784, S.MARIA DEL GIUDICE LU 55058, Italia",
    "lat": 43.7770398,
    "lng": 10.4590123,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7770398,10.4590123"
  },
  {
    "name": "FARMACIA UGURGIERI DI MALINVERNO F.& C. SNC",
    "address": "P.ZZA INDIPENDENZA 8, ARCIDOSSO GR 58031, Italia",
    "lat": 42.8713207,
    "lng": 11.5394639,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8713207,11.5394639"
  },
  {
    "name": "FARMACIE ALTOPASCIO SRL",
    "address": "VIA ROMANA 21, ALTOPASCIO LU 55011, Italia",
    "lat": 43.8287027,
    "lng": 10.6417122,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8287027,10.6417122"
  },
  {
    "name": "FARMACIE COMUNALI LIVORNO S.R.L.U.",
    "address": "P.ZZA GRANDE 38, LIVORNO LI 57123, Italia",
    "lat": 43.5508663,
    "lng": 10.3083736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5508663,10.3083736"
  },
  {
    "name": "FAR.COM.SPA",
    "address": "VIA P.I. DESIDERI, 34, PISTOIA PT 51100, Italia",
    "lat": 43.9363877,
    "lng": 10.9085867,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9363877,10.9085867"
  },
  {
    "name": "FAR.MAS SRL",
    "address": "VIA DELLE SEZIONI 5245, CORSANICO MASSAROSA LU 55040, Italia",
    "lat": 43.9039761,
    "lng": 10.3075981,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9039761,10.3075981"
  },
  {
    "name": "FARMACIA ANGLO AMERICANA SRL",
    "address": "CORSO MATTEOTTI 21, RAPALLO GE 16035, Italia",
    "lat": 44.3485654,
    "lng": 9.2278007,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3485654,9.2278007"
  },
  {
    "name": "FARMACIA ATTIAS SNC DEI DOTT.RI BRUNO E ROBERTO ALESSANDRI",
    "address": "VIA GIOVANNI MARRADI 2, LIVORNO LI 57126, Italia",
    "lat": 43.5443856,
    "lng": 10.3132097,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5443856,10.3132097"
  },
  {
    "name": "FARMACIA BELLO di GIUDICI GIORGIO &C. SNC",
    "address": "VIA ROMA 50, LERICI SP 19032, Italia",
    "lat": 44.0744594,
    "lng": 9.9101066,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0744594,9.9101066"
  },
  {
    "name": "FARMACIA BORDONE DR.A.MILENA",
    "address": "VIA PROVINCIALE MOLINO V., VALBREVENNA GE 16010, Italia",
    "lat": 44.5521613,
    "lng": 9.0768045,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5521613,9.0768045"
  },
  {
    "name": "FARMACIA BURLANDO di Pedrini Alessandro",
    "address": "VIA GRANELLO, 3-5 R., GENOVA GE 16121, Italia",
    "lat": 44.4035792,
    "lng": 8.9430114,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4035792,8.9430114"
  },
  {
    "name": "FARMACIA CANTORE SNC",
    "address": "VIA CANTORE, 53/R, GENOVA GE 16149, Italia",
    "lat": 44.41051,
    "lng": 8.8985984,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.41051,8.8985984"
  },
  {
    "name": "FARMACIA CARRARA SRL",
    "address": "VIA COLOMBO, 47, CISANO SUL NEVA SV 17035, Italia",
    "lat": 44.0883085,
    "lng": 8.1428559,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0883085,8.1428559"
  },
  {
    "name": "FARMACIA CAVI BERTOLDI LUCIANA DI NICOLINI GIULIO SERGIO & C SAS",
    "address": "VIA AURELIA, 2185, LAVAGNA - Cavi GE 16033, Italia",
    "lat": 44.297156,
    "lng": 9.3659213,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.297156,9.3659213"
  },
  {
    "name": "FARMACIA CENTRALE DI VITTORIA CEVA S.A.S.",
    "address": "VIA GARIBALDI,36, PIETRA LIGURE SV 17027, Italia",
    "lat": 44.1482922,
    "lng": 8.2815774,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1482922,8.2815774"
  },
  {
    "name": "FARMACIA CENTRALE SARTORELLI SNC",
    "address": "Viale Brigata Bisagno, 14/27, GENOVA GE 16129, Italia",
    "lat": 44.4030262,
    "lng": 8.9468578,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4030262,8.9468578"
  },
  {
    "name": "FARMACIA CHIANTIGIANA S.N.C. di BISCONTI E SANSONI",
    "address": "VIA GIOVANNI XXIII, 5, MONTERIGGIONI SI 53035, Italia",
    "lat": 43.3476037,
    "lng": 11.3087769,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3476037,11.3087769"
  },
  {
    "name": "FARMACIA DAGNINO DAGNINO MICHELA",
    "address": "VIA STRUPPA,146/I, GENOVA GE 16165, Italia",
    "lat": 44.4482495,
    "lng": 9.0001219,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4482495,9.0001219"
  },
  {
    "name": "FARMACIA DEI GIOVI di dott.ssa MONICA REBESCO",
    "address": "VIA PIAVE 8/R, MIGNANEGO GE 16018, Italia",
    "lat": 44.5293057,
    "lng": 8.9156503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5293057,8.9156503"
  },
  {
    "name": "FARMACIA DEL MAESTRALE DR.GAGGERO MAIDE",
    "address": "VIA GARIBALDI, 15, FINALE LIGURE SV 17024, Italia",
    "lat": 44.1694432,
    "lng": 8.3450307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1694432,8.3450307"
  },
  {
    "name": "FARMACIA DEL PORTO SAS DI GRAZIELLA ROSSO E C.",
    "address": "VIA V. VENETO, 154, LA SPEZIA SP 19124, Italia",
    "lat": 44.1127988,
    "lng": 9.8339337,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1127988,9.8339337"
  },
  {
    "name": "FARMACIA DI PORTAFIORENTINA sas",
    "address": "PIAZZA DELLA REPUBBLICA, 1, SANSEPOLCRO AR 52037, Italia",
    "lat": 43.5738098,
    "lng": 12.1362089,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5738098,12.1362089"
  },
  {
    "name": "FARMACIA DI PRIMA ALESSANDRA",
    "address": "VIA GENOVA 186, LA SPEZIA SP 19123, Italia",
    "lat": 44.11697,
    "lng": 9.8057083,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.11697,9.8057083"
  },
  {
    "name": "FARMACIA FREZZATO DR. OLIVERI GRAZIA",
    "address": "VIA ROMA,36-38, LAVAGNA GE 16033, Italia",
    "lat": 44.3089413,
    "lng": 9.3466903,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3089413,9.3466903"
  },
  {
    "name": "FARMACIA GIUDICI",
    "address": "VIA PISACANE, 13, LERICI SP 19032, Italia",
    "lat": 44.074542,
    "lng": 9.9105315,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.074542,9.9105315"
  },
  {
    "name": "FARMACIA IMPERIA DELLE DOTTORESSE LEONE E SCARELLA S.N.C.",
    "address": "Via Armelio, 61, IMPERIA IM 18100, Italia",
    "lat": 43.8879551,
    "lng": 8.0333532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8879551,8.0333532"
  },
  {
    "name": "FARMACIA LA RUGGINOSA DEL DR. DISCEPOLI e DELLA DR.SSA CHELINI S.r.l.",
    "address": "VIA AURELIA NORD 217A LA RUGGINOSA, GROSSETO GR 58100, Italia",
    "lat": 42.7833389,
    "lng": 11.0971736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7833389,11.0971736"
  },
  {
    "name": "FARMACIA MICHETTI SNC delle Dott.sse Elena e Adriana Filippelli",
    "address": "VIA REPUBBLICA, 5, ROSIGNANO SOLVAY LI 57016, Italia",
    "lat": 43.3910419,
    "lng": 10.4373303,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3910419,10.4373303"
  },
  {
    "name": "FARMACIA MOCCIA S.R.L.",
    "address": "Viale Guido Baccelli, 70, CHIANCIANO TERME SI 53042, Italia",
    "lat": 43.0389791,
    "lng": 11.8191264,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0389791,11.8191264"
  },
  {
    "name": "FARMACIA MODERNA Dott.MIRABELLI FRANCESCO",
    "address": "LARGO BASSANITE, 1, GENOVA GE 16167, Italia",
    "lat": 44.3836068,
    "lng": 9.042935,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3836068,9.042935"
  },
  {
    "name": "FARMACIA MODERNA DI DE MARCHIS MASSIMO & C.SOCIETA' IN NOME COLLETTIVO",
    "address": "VIA DANTE ALIGHIERI,131, SANREMO IM 18038, Italia",
    "lat": 43.8276938,
    "lng": 7.7712934,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8276938,7.7712934"
  },
  {
    "name": "FARMACIA MONTECALCOLI SNC",
    "address": "VIA SALICELLO, 163, CASTELNUOVO MAGRA SP 19033, Italia",
    "lat": 44.0840067,
    "lng": 10.009929,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0840067,10.009929"
  },
  {
    "name": "FARMACIA MONTEVERDE DR. MAGLIONE & C. SNC",
    "address": "VIA GRIMALDI, 3, CHIAVARI GE 16043, Italia",
    "lat": 44.3158795,
    "lng": 9.3291026,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3158795,9.3291026"
  },
  {
    "name": "FARMACIA NUOVA PETRINI DR. PATRIZIO",
    "address": "VIA F.LLI CANEPA, 48, SERRA RICCO' - Castagna GE 16010, Italia",
    "lat": 44.4976628,
    "lng": 8.9220692,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4976628,8.9220692"
  },
  {
    "name": "FARMACIA OLIVIERI SNC",
    "address": "P.ZZA CORVETTO,12/R, GENOVA GE 16122, Italia",
    "lat": 44.4098591,
    "lng": 8.9383361,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4098591,8.9383361"
  },
  {
    "name": "FARMACIA PADRE PIO DR. VALLERINI MICHELE",
    "address": "VIA FIASCHERINO 4, TELLARO SP 19100, Italia",
    "lat": 44.0580608,
    "lng": 9.930901,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0580608,9.930901"
  },
  {
    "name": "FARMACIA PENNINO DI F.PENNINO",
    "address": "PIAZZA CAPRERA, 10, S.MARGHERITA LIGURE GE 16038, Italia",
    "lat": 44.3346304,
    "lng": 9.2128299,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3346304,9.2128299"
  },
  {
    "name": "FARMACIA PIVA DR. SSA BIANCHI MARIAGRAZIA",
    "address": "VIA BERTUCCIONI, 3/R, GENOVA GE 16139, Italia",
    "lat": 44.4172235,
    "lng": 8.9543753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4172235,8.9543753"
  },
  {
    "name": "FARMACIA POPOLARE DR. SPELTA S.N.C.",
    "address": "Largo Merlo Augusto, 256R, GENOVA GE 16144, Italia",
    "lat": 44.4194686,
    "lng": 8.9666615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4194686,8.9666615"
  },
  {
    "name": "FARMACIA RICHERI SAS",
    "address": "CORSO EUROPA,21, FINALE LIGURE SV 17024, Italia",
    "lat": 44.1711815,
    "lng": 8.3534851,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1711815,8.3534851"
  },
  {
    "name": "FARMACIA ROJA S.A.S.",
    "address": "CORSO LIMONE PIEMONTE, 134, VENTIMIGLIA IM 18039, Italia",
    "lat": 43.8064588,
    "lng": 7.595106,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8064588,7.595106"
  },
  {
    "name": "FARMACIA RUTA & C.SNC",
    "address": "VIA AURELIA, 207/R, CAMOGLI - Ruta GE 16032, Italia",
    "lat": 44.3440403,
    "lng": 9.1704633,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3440403,9.1704633"
  },
  {
    "name": "FARMACIA S. ANTONIO S.N.C.",
    "address": "C.SO ITALIA, 59, DEIVA MARINA SP 19013, Italia",
    "lat": 44.2160771,
    "lng": 9.5179651,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2160771,9.5179651"
  },
  {
    "name": "FARMACIA SAN BERNARDO S.A.S. DI PRATO LORENZO E C.",
    "address": "VIA MOGADISCIO, 30 rosso, GENOVA GE 16141, Italia",
    "lat": 44.4374543,
    "lng": 8.9665932,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4374543,8.9665932"
  },
  {
    "name": "FARMACIA S.CATERINA SNC DOTT.VERCELLETTI & C",
    "address": "VIA P. GARELLO, 32, CENGIO SV 17056, Italia",
    "lat": 44.3897788,
    "lng": 8.2064162,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3897788,8.2064162"
  },
  {
    "name": "FARMACIA SAN GIOVANNI S.N.C. DI PACCIONE FRANCESCA E C",
    "address": "VIA GARIBALDI 153, LOANO SV 17025, Italia",
    "lat": 44.1260823,
    "lng": 8.2588778,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1260823,8.2588778"
  },
  {
    "name": "FARMACIA SALUS Di GERVASONE DANIELA e ALESSANDRO S.N.C.",
    "address": "VIA GIOBERTI, ANG. VIA ROMA, 12/14, SANREMO IM 18038, Italia",
    "lat": 43.878734,
    "lng": 7.905215,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.878734,7.905215"
  },
  {
    "name": "FARMACIA SAN MARTINO DI BELLA VALENTINA & C. S.a.s.",
    "address": "C.SO CAVALLOTTI 211, SANREMO IM 18038, Italia",
    "lat": 43.8219412,
    "lng": 7.7946056,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8219412,7.7946056"
  },
  {
    "name": "FARMACIA SAN ROCCO S.N.C. DI MANZI DOTT.SSA LAURA MARIA E C.",
    "address": "VIA AURELIA 146, CERIALE SV 17023, Italia",
    "lat": 44.0919621,
    "lng": 8.2293069,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0919621,8.2293069"
  },
  {
    "name": "FARMACIA SAN ROCCO snc",
    "address": "VIA ALDO MORO, 126, PIANA BATTOLLA SP 19020, Italia",
    "lat": 44.192725,
    "lng": 9.851146,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.192725,9.851146"
  },
  {
    "name": "FARMACIA TERRALBA S.n.c. di SCRIVANO M. & C.",
    "address": "VIA MARCONI, 200, ARENZANO GE 16011, Italia",
    "lat": 44.4024353,
    "lng": 8.6641932,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4024353,8.6641932"
  },
  {
    "name": "FARMACIA VAL DI CAVA S.N.C.",
    "address": "VIA DELLE COLLINE, 44 FRAZIONE VAL DI CAVA, VAL DI CAVA - PONSACCO PI 56038, Italia",
    "lat": 43.6285262,
    "lng": 10.659943,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6285262,10.659943"
  },
  {
    "name": "FARMACIA VEZZANESE S.R.L.",
    "address": "VIA PROVINCIALE PIANA BATTAGNA, VEZZANO LIGURE SP 19020, Italia",
    "lat": 44.1309122,
    "lng": 9.9249402,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1309122,9.9249402"
  },
  {
    "name": "FARMACIA BOSCHI MENICHETTI SNC",
    "address": "VIA DEL CASTELLO 4, LARI PI 56035, Italia",
    "lat": 43.5657416,
    "lng": 10.5922,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5657416,10.5922"
  },
  {
    "name": "FARMACIA CODECA' della Dott.ssa BENEDETTA CHIOSTRI & C. sas",
    "address": "Via Baccio da Montelupo, 159/161, Firenze FI 50142, Italia",
    "lat": 43.7686981,
    "lng": 11.1907036,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7686981,11.1907036"
  },
  {
    "name": "FARMACIA DI GALCETI SRL",
    "address": "VIA VII MARZO 15/11, PRATO PO 59100, Italia",
    "lat": 43.9062861,
    "lng": 11.0922591,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9062861,11.0922591"
  },
  {
    "name": "FARMACIA DI PORTOVENERE di MASSELLANI DEBORA",
    "address": "P.ZZA BASTRIERI, 4, PORTOVENERE SP 19025, Italia",
    "lat": 44.0513028,
    "lng": 9.8353073,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0513028,9.8353073"
  },
  {
    "name": "FARMACIA GUGLIELMINO S.N.C. DEL DOTTOR FRANCESCO E C.",
    "address": "Corso Italia 168, PISA PI 56125, Italia",
    "lat": 43.7113748,
    "lng": 10.3994277,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7113748,10.3994277"
  },
  {
    "name": "FARMACIA PALERMO DEI DOTTORI PALERMO E LICATA",
    "address": "VIA BARELLAI 48, MONTE ARGENTARIO-PORTO SANTO STEFANO GR 58019, Italia",
    "lat": 42.4358889,
    "lng": 11.1203439,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4358889,11.1203439"
  },
  {
    "name": "FARMACIA PIERACCINI DR.PIERACCINI ALBERTO",
    "address": "VIA MARCONI 93, BAGNO DI GAVORRANO GR 58100, Italia",
    "lat": 42.9385972,
    "lng": 10.8875728,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9385972,10.8875728"
  },
  {
    "name": "FARMACIA SANTORO DR.SALVATORE SAS",
    "address": "VIA DANTE ALGHIERI 6, CASTELFRANCO DI SOPRA AR 52020, Italia",
    "lat": 43.6232803,
    "lng": 11.5546892,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6232803,11.5546892"
  },
  {
    "name": "FARMACIA AGHINULFA S.N.C.  DOTT.SSA DI NUNZIO",
    "address": "VIALE MARINA 80, MONTIGNOSO MS 54038, Italia",
    "lat": 43.9853593,
    "lng": 10.1454064,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9853593,10.1454064"
  },
  {
    "name": "FARMACIA AL BICCHIO DOTT.SSA ADA MIMMA DEL MESE E SAS",
    "address": "VIA AURELIA SUD 444, VIAREGGIO LU 55049, Italia",
    "lat": 43.8663796,
    "lng": 10.2606503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8663796,10.2606503"
  },
  {
    "name": "FARMACIA AMIDEI SAS della Dottoressa Botta",
    "address": "VIAM RICCIARELLI 2, VOLTERRA PI 56048, Italia",
    "lat": 43.402297,
    "lng": 10.859069,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.402297,10.859069"
  },
  {
    "name": "FARMACIA BARBANELLA  DR.SSA RUGGERI RITA",
    "address": "VIA GIUSTI 102, GROSSETO GR 58100, Italia",
    "lat": 42.7715059,
    "lng": 11.100377,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7715059,11.100377"
  },
  {
    "name": "COMUNE DI RAPALLO",
    "address": "VIA ARPINATI, 41, RAPALLO GE 16035, Italia",
    "lat": 44.3550898,
    "lng": 9.2116831,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3550898,9.2116831"
  },
  {
    "name": "FARMACIA DEL CIRCOLINO S.A.S.",
    "address": "STRADA PROVINCIALE 28 - LOC.SCHIOPPARELLO, PORTOFERRAIO LI 57037, Italia",
    "lat": 42.7938765,
    "lng": 10.3452418,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7938765,10.3452418"
  },
  {
    "name": "FARMACIA DEL DUOMO SRL",
    "address": "VIALE EUROPA 22, PESCIA PT 51017, Italia",
    "lat": 43.8971995,
    "lng": 10.6913555,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8971995,10.6913555"
  },
  {
    "name": "FARMACIA FABBRINI s.a.s.",
    "address": "VIA C.HAMMAN 18, ABBADIA SAN SALVATORE SI 53021, Italia",
    "lat": 42.8823015,
    "lng": 11.6688909,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8823015,11.6688909"
  },
  {
    "name": "FARMACIA FRATTI DELLA PINETA S.N.C.",
    "address": "VIA ANTONIO FRATTI, 538, VIAREGGIO LU 55049, Italia",
    "lat": 43.8778725,
    "lng": 10.2442256,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8778725,10.2442256"
  },
  {
    "name": "FARMACIA GUARDA di ETHICA s.n.c.",
    "address": "PIAZZA CAVOUR 9, LIVORNO LI 57123, Italia",
    "lat": 43.547265,
    "lng": 10.3118082,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.547265,10.3118082"
  },
  {
    "name": "FARMACIA GUGLIELMI della Dott.ssa Paola Guglielmi & C. Snc",
    "address": "CORSO ROMA n. 127, DIANO MARINA IM 18013, Italia",
    "lat": 43.9091269,
    "lng": 8.0809388,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9091269,8.0809388"
  },
  {
    "name": "FARMACIA ITALICA sas Dott.ssa Siciliano e Dr.Jori",
    "address": "VIA ITALICA 172, LIDO DI CAMAIORE LU 55041, Italia",
    "lat": 43.9080171,
    "lng": 10.2418433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9080171,10.2418433"
  },
  {
    "name": "FARMACIA MAIMONE SNC",
    "address": "VIA SARZANA, 717, LA SPEZIA SP 19100, Italia",
    "lat": 44.1232052,
    "lng": 9.844153,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1232052,9.844153"
  },
  {
    "name": "FARMACIA MARTINI SNC Dottori Martini e Baccetti",
    "address": "VIA MATTEOTTI 119, S.ROMANO-MONTOPOLI VAL D'ARNO PI 56020, Italia",
    "lat": 43.6861392,
    "lng": 10.7562353,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6861392,10.7562353"
  },
  {
    "name": "FARMACIA MONTENERO DELLA DOTTORESSA COSTANZA SALERNO",
    "address": "VIA DELLE PIANACCIE 10, LIVORNO LI 57128, Italia",
    "lat": 43.497554,
    "lng": 10.3444177,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.497554,10.3444177"
  },
  {
    "name": "FARMACIA MORELLINE snc",
    "address": "VIA GUIDO ROSSA 1 bis, ROSIGNANO MARITTIMO LI 57016, Italia",
    "lat": 43.386855,
    "lng": 10.462089,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.386855,10.462089"
  },
  {
    "name": "FARMACIA PONTE PILA Dott.Sandro Francesco Garuzzo &C. S.N.C.",
    "address": "VIALE BRIGATA BISAGNO, 28 R., GENOVA GE 16129, Italia",
    "lat": 44.4017953,
    "lng": 8.9462307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4017953,8.9462307"
  },
  {
    "name": "FARMACIA POPPI DEL DR. BERIOLI GIOVANNI & C. SAS",
    "address": "PIAZZA AMERIGHI 2, POPPI AR 52014, Italia",
    "lat": 43.7230321,
    "lng": 11.7658063,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7230321,11.7658063"
  },
  {
    "name": "FARMACIA RIVE ETRUSCHE SNC",
    "address": "VIALE ETRURIA 58/60/62, STAZIONE DI POPULONIA LI 57025, Italia",
    "lat": 42.9964116,
    "lng": 10.5395749,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9964116,10.5395749"
  },
  {
    "name": "FARMACIA SAN GIOVANNI S.N.C",
    "address": "VIA MARTIRI DI NASSIRIYA 26, CASTIGLION FIORENTINO AR 52043, Italia",
    "lat": 43.3492112,
    "lng": 11.9072593,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3492112,11.9072593"
  },
  {
    "name": "FARMACIA SAN LORENZO S.N.C.",
    "address": "VIA CIVITELLA PAGANICO 5, GROSSETO GR 58100, Italia",
    "lat": 42.7605002,
    "lng": 11.0961992,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7605002,11.0961992"
  },
  {
    "name": "FARMACIA SANSONI SNC",
    "address": "CORSO ITALIA 113, SAN GIOVANNI VALDARNO AR 52027, Italia",
    "lat": 43.5649972,
    "lng": 11.5302427,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5649972,11.5302427"
  },
  {
    "name": "FARMACIA SCARAMUCCI SNC",
    "address": "VIA A DA PIOMBINO 7, PIOMBINO LI 57025, Italia",
    "lat": 42.9269653,
    "lng": 10.5302996,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9269653,10.5302996"
  },
  {
    "name": "FARMACIA SCARLINO SAS Dr.Petitto",
    "address": "Strada Provinciale Aurelia Vecchia, 20, SCARLINO SCALO GR 58020, Italia",
    "lat": 42.944475,
    "lng": 10.8371295,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.944475,10.8371295"
  },
  {
    "name": "FARMACIA ULIVI SNC DEL DR.FABRIZIO PIANELLI & C.",
    "address": "CORSO ITALIA N.5, ORBETELLO GR 58015, Italia",
    "lat": 42.4373367,
    "lng": 11.2092451,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4373367,11.2092451"
  },
  {
    "name": "FARMACIA ZUCCHERI DOTT.SSA COSTANZA",
    "address": "VIA XXIV MAGGIO 72, MARINA DI GROSSETO GR 58100, Italia",
    "lat": 42.7178686,
    "lng": 10.9808802,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7178686,10.9808802"
  },
  {
    "name": "FARMALABI s.a.s.",
    "address": "PIAZZA SAN JACOPINO, 4/B, FIRENZE FI 50144, Italia",
    "lat": 43.78076,
    "lng": 11.2346006,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.78076,11.2346006"
  },
  {
    "name": "FARMALUNAE S.R.L.",
    "address": "VIALE DELLA PACE 1a TRAV. c/o Centro Commerciale La Miniera, CASTELNUOVO MAGRA SP 19033, Italia",
    "lat": 44.098282,
    "lng": 10.016912,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.098282,10.016912"
  },
  {
    "name": "FARMAVALDARNO SPA",
    "address": "Piazza della Fattoria,14/15, FIGLINE VALDARNO FI 50063, Italia",
    "lat": 43.6214739,
    "lng": 11.4685264,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6214739,11.4685264"
  },
  {
    "name": "FARMAVALDERA SRL",
    "address": "VIA DEL COMMERCIO 11, CAPANNOLI PI 56030, Italia",
    "lat": 46.0904029,
    "lng": 11.106654,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0904029,11.106654"
  },
  {
    "name": "FARMESCHI UNIPERSONALE SRL",
    "address": "VIA MAREMMANA 10, ORBETELLO - Albinia GR 58010, Italia",
    "lat": 42.5002816,
    "lng": 11.2083537,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5002816,11.2083537"
  },
  {
    "name": "FRB Farmacia di Simone Cagidiaco & C. S.A.S.",
    "address": "VIA GRAMSCI 58, CASCIANA TERME PI 56034, Italia",
    "lat": 43.605156,
    "lng": 10.59473,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.605156,10.59473"
  },
  {
    "name": "I CARE S.r.l.",
    "address": "VIA G. PASCOLI, 6, VIAREGGIO LU 55049, Italia",
    "lat": 43.8272756,
    "lng": 10.2828299,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8272756,10.2828299"
  },
  {
    "name": "PARAFARMACIA ELVETICA SAS",
    "address": "C.SO BIGLIATI 116R, ALBISSOLA MARINA SV 17012, Italia",
    "lat": 44.326155,
    "lng": 8.5008208,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.326155,8.5008208"
  },
  {
    "name": "PARAFARMACIA GHERZI",
    "address": "Via Blengino, 1, ARMA DI TAGGIA IM 18018, Italia",
    "lat": 43.832304,
    "lng": 7.8526898,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.832304,7.8526898"
  },
  {
    "name": "PARAFARMACIA SANTA BARBARA DOTT.SSA DOTTA CRISTIANA",
    "address": "VIA VALBORMIDA, 77, CENGIO SV 17056, Italia",
    "lat": 44.390925,
    "lng": 8.192791,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.390925,8.192791"
  },
  {
    "name": "PARAFARMACIA SANTA CATERINA DOTT.SSA MICHELA CINI",
    "address": "VIA UGO BASSI 13, FOLLONICA GR 58022, Italia",
    "lat": 42.9282273,
    "lng": 10.753247,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9282273,10.753247"
  },
  {
    "name": "PARAFARMACIA CESARINI ANTONELLA",
    "address": "PIAZZA SS.ANNUNZIATA 2/A, MANCIANO GR 58014, Italia",
    "lat": 42.0615555,
    "lng": 12.9990145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0615555,12.9990145"
  },
  {
    "name": "PARAFARMACIA CIRELLI di CIRELLI LUISELLA",
    "address": "VIA MAZZINI, 65, ARMA DI TAGGIA IM 18018, Italia",
    "lat": 43.8323016,
    "lng": 7.8534837,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8323016,7.8534837"
  },
  {
    "name": "PARAFARMACIA DEL CENTRO Dr.ssa Ansaldi Elda",
    "address": "CORSO ROMA, 63, DIANO MARINA IM 18013, Italia",
    "lat": 43.9105261,
    "lng": 8.0831003,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9105261,8.0831003"
  },
  {
    "name": "PARAFARMACIA DR.SSA GAROFALO",
    "address": "Coop, Strada Provinciale del Padule, Lotto 7 c/o Centro commerciale \"Le Paduline, CASTIGLIONE DELLA PESCAIA GR 58043, Italia",
    "lat": 42.806724,
    "lng": 10.764983,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.806724,10.764983"
  },
  {
    "name": "PARAFARMACIA Dr.ssa LAURA MARSILI",
    "address": "VIA C.COLOMBO 26, CASTIGLIONE DELLA PESCAIA GR 58043, Italia",
    "lat": 42.7636254,
    "lng": 10.8789926,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7636254,10.8789926"
  },
  {
    "name": "PARAFARMACIA FARMABENESSERE",
    "address": "VIALE DEL TIRRENO 86/C, CALAMBRONE PI 56128, Italia",
    "lat": 43.5913794,
    "lng": 10.2974745,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5913794,10.2974745"
  },
  {
    "name": "PARAFARMACIA LA LUCE DELLA SALUTE",
    "address": "VIA INDIPENDENZA, 100, VENTURINA LI 57021, Italia",
    "lat": 43.028464,
    "lng": 10.6022272,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.028464,10.6022272"
  },
  {
    "name": "PARAFARMACIA LE FERRIERE S.A.S. di ANTONELLI MAURIZIO & C.",
    "address": "VIA L. VESPUCCI 84/86, IMPERIA IM 18100, Italia",
    "lat": 43.8812363,
    "lng": 8.0132881,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8812363,8.0132881"
  },
  {
    "name": "PARAFARMACIA LONGO di Dott.ssa Antonella Longo",
    "address": "Via Martiri della Libertà, 92R, GENOVA GE 16158, Italia",
    "lat": 44.426864,
    "lng": 8.8115518,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.426864,8.8115518"
  },
  {
    "name": "PARAFARMACIA SAN LEOPOLDO D.ssa Trifance",
    "address": "VIA CASSARELLO 60, FOLLONICA GR 58022, Italia",
    "lat": 42.9189313,
    "lng": 10.7721734,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9189313,10.7721734"
  },
  {
    "name": "PLURISERVIZI CAMAIORE SPA",
    "address": "VIA BADIA, 13, CAMAIORE LU 55041, Italia",
    "lat": 43.936387,
    "lng": 10.3071602,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.936387,10.3071602"
  },
  {
    "name": "SANITARIA ROTONDI SAS di Marco Rotondi & C.",
    "address": "VIA ROMA 29, TERNI TR 05100, Italia",
    "lat": 42.5602077,
    "lng": 12.646004,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5602077,12.646004"
  },
  {
    "name": "STELLA POLARE SPA",
    "address": "Via VAL DI CANEPA, 33, SESTRI LEVANTE GE 16039, Italia",
    "lat": 44.2711152,
    "lng": 9.3992204,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2711152,9.3992204"
  },
  {
    "name": "DASTE di Ciarlantini Stefania e Daniele snc",
    "address": "Viale Italia, 23, LADISPOLI RM 00055, Italia",
    "lat": 41.9509573,
    "lng": 12.0797903,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9509573,12.0797903"
  },
  {
    "name": "ORTOPEDIA ROMITI s.r.l.",
    "address": "Via M. Romiti, 74, VITERBO VT 01100, Italia",
    "lat": 42.4119606,
    "lng": 12.1104391,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4119606,12.1104391"
  },
  {
    "name": "FARMACIA VALLEMIANO SRL",
    "address": "Via Martiri della Resistenza, 61/61A/61B, ANCONA AN 60125, Italia",
    "lat": 43.6087636,
    "lng": 13.5133607,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6087636,13.5133607"
  },
  {
    "name": "FA.RE.MA. S.N.C.",
    "address": "Via Aurelia, 358, ROSIGNANO MARITTIMO - Rosignano solvay LI 57016, Italia",
    "lat": 43.3972845,
    "lng": 10.4304618,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3972845,10.4304618"
  },
  {
    "name": "PROTOSAN SRL",
    "address": "Viale delle Rimembranze, 26, LANCIANO CH 66034, Italia",
    "lat": 42.2301345,
    "lng": 14.3941194,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2301345,14.3941194"
  },
  {
    "name": "FARMACIE COMUNALI EMPOLI SRL",
    "address": "piazza del Popolo, 33, EMPOLI FI 50053, Italia",
    "lat": 43.7186356,
    "lng": 10.9476999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7186356,10.9476999"
  },
  {
    "name": "PARAFARMACIA PLUS FARMA sas di Coccia Annamaria",
    "address": "Via della Stazione, 1/2 H, NORCIA PG 06046, Italia",
    "lat": 42.7916598,
    "lng": 13.094865,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7916598,13.094865"
  },
  {
    "name": "PARAFARMACIA UMBERTO I srl Dott.ssa Loredana Virdis SOCIETA' UNIPERSON",
    "address": "Via G.B. della Porta, 73, CORCIANO PG 06073, Italia",
    "lat": 44.226015,
    "lng": 12.06444,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.226015,12.06444"
  },
  {
    "name": "FARMACIA PERELLI sas di Claudia Perelli & C.",
    "address": "Via dell'Arte, 14/16, DERUTA PG 06053, Italia",
    "lat": 42.9878877,
    "lng": 12.4202138,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9878877,12.4202138"
  },
  {
    "name": "FARMACIA DELLE ERBE DI DELFINO MARINO E C. SNC",
    "address": "Via San Michele, 19-21 R, SAVONA SV 17100, Italia",
    "lat": 44.3010547,
    "lng": 8.4733242,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3010547,8.4733242"
  },
  {
    "name": "Adiuvo S.A.S di Sarasso Giovanni & C.",
    "address": "Via Ugo Foscolo, 21, VERCELLI VC 13100, Italia",
    "lat": 45.319371,
    "lng": 8.4144276,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.319371,8.4144276"
  },
  {
    "name": "FARMACIA DAVOLIO MARANI DOTT. FRANCESCO",
    "address": "Corso Roma, 42, FABBRICO RE 42042, Italia",
    "lat": 44.8714266,
    "lng": 10.8091721,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8714266,10.8091721"
  },
  {
    "name": "FARMACIA GAVASSA di Vandelli e Zaffagnini SNC",
    "address": "Via Don Luigi Messori, 2/D, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.7073434,
    "lng": 10.6816508,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7073434,10.6816508"
  },
  {
    "name": "FARMACIA FALINI del Dott. Mario Falini s.a.s.",
    "address": "Via Los Angeles, 64, ASSISI - Santa maria degli angeli PG 06081, Italia",
    "lat": 43.0568887,
    "lng": 12.5769496,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0568887,12.5769496"
  },
  {
    "name": "FARMACIA LE COLLINE SNC delle Dott.sse CIRRI PAOLA e FERRANTE TERESA",
    "address": "Via Laurentina, 1529, ROMA RM 00134, Italia",
    "lat": 41.7683251,
    "lng": 12.4935287,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7683251,12.4935287"
  },
  {
    "name": "Parafarmacia Obiettivo Salute snc",
    "address": "Via Faentina, 48/A, RAVENNA RA 48100, Italia",
    "lat": 44.4217412,
    "lng": 12.1836822,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4217412,12.1836822"
  },
  {
    "name": "C.O.S. Centro Ortopedico Siciliano s.r.l.",
    "address": "Via Palermo, 221, PALAGONIA CT 95046, Italia",
    "lat": 37.3298199,
    "lng": 14.7452342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.3298199,14.7452342"
  },
  {
    "name": "FARMACIA SAETTONE SRL",
    "address": "Via Paleocapa, 147/R, SAVONA SV 17100, Italia",
    "lat": 44.3083536,
    "lng": 8.47844,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3083536,8.47844"
  },
  {
    "name": "FARMACIA ROMAGNANO SNC",
    "address": "Via Formentini, 7/25, MASSA MS 54100, Italia",
    "lat": 44.0424285,
    "lng": 10.1186858,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0424285,10.1186858"
  },
  {
    "name": "FARMACIA RONCADELLO SNC",
    "address": "Largo Roccatella, 6/D, FORLI' - Roncadello FC 47100, Italia",
    "lat": 44.2658918,
    "lng": 12.04459,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2658918,12.04459"
  },
  {
    "name": "GRUPPO 3 S.N.C. DI ANTONIO SALANDIN E C.",
    "address": "Via Andreetti, 14, SAN FEDELE INTELVI CO 22028, Italia",
    "lat": 45.9670471,
    "lng": 9.077364,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9670471,9.077364"
  },
  {
    "name": "FARMACIA SAN NICOLA DR. MENSI G. & C. S.N.C.",
    "address": "Via Borzoli, 20/R, GENOVA GE 16153, Italia",
    "lat": 44.4296575,
    "lng": 8.8591247,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4296575,8.8591247"
  },
  {
    "name": "Medical Farma srl",
    "address": "Via Ponchielli, 2, BERGAMO BG 24125, Italia",
    "lat": 45.6943754,
    "lng": 9.690581,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6943754,9.690581"
  },
  {
    "name": "FARMACIA POGGIO BERNI s.n.c. di Vandi Claudia e C.",
    "address": "Via Santarcangiolese, 3032/A, POGGIO TORRIANA RN 47824, Italia",
    "lat": 44.0202911,
    "lng": 12.4121305,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0202911,12.4121305"
  },
  {
    "name": "FARMACIA SAN BARTOLOMEO snc di Rondini Meris & C.",
    "address": "Via E. Aprea, 4, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.6749513,
    "lng": 10.5390507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6749513,10.5390507"
  },
  {
    "name": "FARMACIA MODERNA VASSALLO DEL DOTT. BOCCARDO",
    "address": "Via Tabarrani, 38, CAMAIORE LU 55041, Italia",
    "lat": 43.9379214,
    "lng": 10.3062224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9379214,10.3062224"
  },
  {
    "name": "Farmacia Valsangone s.a.s della Dott.ssa Masera Roberta e C.",
    "address": "Via Coazze, 234, GIAVENO TO 10094, Italia",
    "lat": 45.0439441,
    "lng": 7.3166296,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0439441,7.3166296"
  },
  {
    "name": "ERREBI SANITARIA SNC",
    "address": "Via Nazionale, 573, ROSETO DEGLI ABRUZZI TE 64026, Italia",
    "lat": 42.6677346,
    "lng": 14.021763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6677346,14.021763"
  },
  {
    "name": "Farmacia Vittoria di Dott.ssa Mongardi Vittoria Maria",
    "address": "Piazza Cavallero, 1, RIVOLI TO 10098, Italia",
    "lat": 45.0630331,
    "lng": 7.5187551,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0630331,7.5187551"
  },
  {
    "name": "FARMACIA SERRI CASINA snc di Serri Elisabetta e Giovanni",
    "address": "Via Roma, 9/E, CASINA RE 42034, Italia",
    "lat": 44.5113935,
    "lng": 10.500421,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5113935,10.500421"
  },
  {
    "name": "PARAFARMACIA DOTT. ZUNINO GIOVANNI",
    "address": "Via dei Mille, 160, ALBENGA SV 17031, Italia",
    "lat": 44.0484083,
    "lng": 8.2176587,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0484083,8.2176587"
  },
  {
    "name": "FARMACIA STURLA DELLA DR.SSA ELISA MACHI & C SNC.",
    "address": "Via Palestro, 44, SANTA MARGHERITA LIGURE GE 16038, Italia",
    "lat": 44.3348893,
    "lng": 9.2119108,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3348893,9.2119108"
  },
  {
    "name": "FARMACIA CHIAPPARI di CHIAPPARI ROSA MARIA",
    "address": "Via Strada Cava in Vigatto, PARMA - Vigatto PR 43124, Italia",
    "lat": 44.7236174,
    "lng": 10.2935442,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7236174,10.2935442"
  },
  {
    "name": "FARMACIA ZONA Dott. Piero Cavallini",
    "address": "Via Mazzini, 3/E, FINALE EMILIA MO 41034, Italia",
    "lat": 44.8367507,
    "lng": 11.3004547,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8367507,11.3004547"
  },
  {
    "name": "FARMACIA TERCINOD della Dott.ssa Silvia Borchi & C. SAS",
    "address": "Via Bologna, 72 h/g, PRATO PO 59100, Italia",
    "lat": 43.9040943,
    "lng": 11.1079799,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9040943,11.1079799"
  },
  {
    "name": "FARMACIA SAN DOMENICO SNC",
    "address": "Corso Volta, 101/A, ASTI AT 14100, Italia",
    "lat": 44.9049576,
    "lng": 8.2117597,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9049576,8.2117597"
  },
  {
    "name": "FARMACIA MONTANARO S.R.L.",
    "address": "Vicolo Morchio, 9, VARAZZE SV 17019, Italia",
    "lat": 44.359813,
    "lng": 8.57929,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.359813,8.57929"
  },
  {
    "name": "SUPERMERCATO NUOVA BARAGALLA S.R.L.",
    "address": "Via Torre Rossa, 2/i, MONTECHIARUGOLO PR 43022, Italia",
    "lat": 44.7033882,
    "lng": 10.4076346,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7033882,10.4076346"
  },
  {
    "name": "Farmacia Del Piano srl",
    "address": "Piazza Ugo Bassi,4, ANCONA AN 60127, Italia",
    "lat": 43.6036147,
    "lng": 13.5079416,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6036147,13.5079416"
  },
  {
    "name": "NUOVA FARMACIA DELLA FERRERA di PANIZZA F. & C. sas",
    "address": "Corso Italia, 153, SAVONA SV 17100, Italia",
    "lat": 44.1522006,
    "lng": 8.2899342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1522006,8.2899342"
  },
  {
    "name": "FARMACIA NANNINI DR VITALE VIRGILIO",
    "address": "Piazza XXIV Maggio, 1, PIETRASANTA - Marina di pietrasanta LU 55045, Italia",
    "lat": 43.9272755,
    "lng": 10.1991196,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9272755,10.1991196"
  },
  {
    "name": "FARMACIA SPEDITO DR ANGELA",
    "address": "Via Gramsci, 1/A, CASTELNUOVO DI VAL DI CECINA PI 56041, Italia",
    "lat": 43.2150877,
    "lng": 10.8989886,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2150877,10.8989886"
  },
  {
    "name": "Farmacia S.Francesco s.a.s di Francesco Valperga e C.",
    "address": "Via Casale, 11, CHIVASSO - Castelrosso TO 10034, Italia",
    "lat": 45.1982145,
    "lng": 7.9337717,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1982145,7.9337717"
  },
  {
    "name": "PARAFARMACIA 4 FORTI di ANGI SNC",
    "address": "Via Don Gino Paradisi, 13, MONTE ARGENTARIO - Porto ercole GR 58018, Italia",
    "lat": 42.3930927,
    "lng": 11.203323,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3930927,11.203323"
  },
  {
    "name": "HEALTH & JOY SANITARIA S.R.L.",
    "address": "Via di Casalotti, 52/B, ROMA RM 00166, Italia",
    "lat": 41.9170319,
    "lng": 12.3760529,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9170319,12.3760529"
  },
  {
    "name": "FARMACIA DOTT. UGO NOVELLI s.a.s. del Dott. Ingrosso Salvatore & C.",
    "address": "Via Sarzanese, 1821, LUCCA - Ponte san pietro LU 55100, Italia",
    "lat": 43.853746,
    "lng": 10.4461486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.853746,10.4461486"
  },
  {
    "name": "FARMACIA CULLA DR. FRULLANO F.A.",
    "address": "Via del Mare, 80, LIVORNO LI 57128, Italia",
    "lat": 43.517025,
    "lng": 10.3228743,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.517025,10.3228743"
  },
  {
    "name": "COMUNE DI SAN MARCELLO PITEGLIO",
    "address": "Via Marconi, 49, SAN MARCELLO PISTOIESE PT 51028, Italia",
    "lat": 44.0559861,
    "lng": 10.7853756,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0559861,10.7853756"
  },
  {
    "name": "FARMACIA MONTI SRL",
    "address": "Via Narni, 23, TERNI TR 05100, Italia",
    "lat": 42.5465088,
    "lng": 12.6173753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5465088,12.6173753"
  },
  {
    "name": "FARMACIA MARTINELLI",
    "address": "Via Pisana, 962, LUCCA LU 55100, Italia",
    "lat": 43.8426343,
    "lng": 10.4909475,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8426343,10.4909475"
  },
  {
    "name": "FARMACIA PALIDORO SRL",
    "address": "Via della Stazione di Palidoro, 4, FIUMICINO RM 00054, Italia",
    "lat": 41.922624,
    "lng": 12.1825669,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.922624,12.1825669"
  },
  {
    "name": "POLIPHARMA S.R.L.",
    "address": "Via Virgilio Angolo J.J.Rosseau, SNC, SANT'EGIDIO ALLA VIBRATA TE 64016, Italia",
    "lat": 42.821334,
    "lng": 13.712219,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.821334,13.712219"
  },
  {
    "name": "FARMACIA MADONNA DELLA CONSOLATA di GIOVANNI TORTORA",
    "address": "Via Provinciale, 59, CESARA VB 28891, Italia",
    "lat": 45.8331978,
    "lng": 8.3679631,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8331978,8.3679631"
  },
  {
    "name": "CENTRO PODOLOGICO ORTOPEDICO MONTINI S.r.l.",
    "address": "Viale Italia, 151, LA SPEZIA SP 19124, Italia",
    "lat": 44.1122494,
    "lng": 9.8372476,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1122494,9.8372476"
  },
  {
    "name": "SANITARIA ORTOPEDIA SAN PIETRO DEL DOTT.SABATINO PAOLO E ROMANI SRL",
    "address": "P.ZZA ARTURO TOSCANINI 6/E, FUCECCHIO FI 50054, Italia",
    "lat": 43.73222,
    "lng": 10.80914,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.73222,10.80914"
  },
  {
    "name": "Ortopedia Ortosan Sanitaria di Poma Vincenzo Francesco",
    "address": "Via Alessandro Manzoni, 122, ERICE - Casa santa TP 91016, Italia",
    "lat": 38.0221407,
    "lng": 12.5474191,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0221407,12.5474191"
  },
  {
    "name": "L'ORTOPEDIA DI SIGNA SAS DI GUIDOTTI GIULIA & C.",
    "address": "Via della Stazione, 2/4/6, SIGNA FI 50058, Italia",
    "lat": 43.7766092,
    "lng": 11.0959699,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7766092,11.0959699"
  },
  {
    "name": "Farmacia Canale Albani snc Del Dr. E. Feduzi e Dr.ssa M. Biondini",
    "address": "Via Canale Albani, 7/C, FANO PU 61032, Italia",
    "lat": 43.8351542,
    "lng": 13.0132459,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8351542,13.0132459"
  },
  {
    "name": "FARMASANITARIA di Mazzacca Alessandro",
    "address": "Via Provinciale Pisana, 78A/82, LIVORNO LI 57121, Italia",
    "lat": 43.5607999,
    "lng": 10.3278581,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5607999,10.3278581"
  },
  {
    "name": "FARMACIA LA TORRE V.M.P. SNC di Varsaldi Federica & C.",
    "address": "Via Monte Nero, 73/B, GALLIATE NO 28066, Italia",
    "lat": 45.4699582,
    "lng": 8.691749,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4699582,8.691749"
  },
  {
    "name": "ORTOPEDIA ADRIANO MARCELLETTI",
    "address": "Viale XXX Giugno, 48, TOLENTINO MC 62029, Italia",
    "lat": 43.2128668,
    "lng": 13.2821326,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2128668,13.2821326"
  },
  {
    "name": "MASSEI ETTORE",
    "address": "Via Maggi, 74/76, LIVORNO LI 57125, Italia",
    "lat": 43.5486361,
    "lng": 10.3151733,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5486361,10.3151733"
  },
  {
    "name": "FARMACIA GUERRA SAS di Guerra Dr. Giancarlo",
    "address": "Via Sempione, 6, PALLANZENO VB 28884, Italia",
    "lat": 46.0453862,
    "lng": 8.2603111,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0453862,8.2603111"
  },
  {
    "name": "FARMACIA PAGNONI DI PAGNONI ALBERTO MARIA & C. S.N.C.",
    "address": "Via De Gasperi, 63, SPINETOLI AP 63036, Italia",
    "lat": 42.8713737,
    "lng": 13.7675556,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8713737,13.7675556"
  },
  {
    "name": "FARMACIA ROTONDI DR.SSA RITA",
    "address": "Via Piave, 30, TERNI TR 05100, Italia",
    "lat": 42.5540502,
    "lng": 12.6476667,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5540502,12.6476667"
  },
  {
    "name": "FARMACIA OTTAVIA SNC",
    "address": "Via Monte Catria, 2, OSIMO - Casenuove AN 60027, Italia",
    "lat": 43.4858524,
    "lng": 13.3930884,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4858524,13.3930884"
  },
  {
    "name": "FARMACIA CASTELMASSIMO S.N.C.",
    "address": "Via Maria, 55/A, CASTELMASSIMO FR 03029, Italia",
    "lat": 41.6622699,
    "lng": 13.3771926,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6622699,13.3771926"
  },
  {
    "name": "PARAFARMACIA PIAVE DI MARIGNANI ELENA",
    "address": "VIA PIAVE, 81, SINALUNGA SI 53048, Italia",
    "lat": 43.2198071,
    "lng": 11.7522812,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2198071,11.7522812"
  },
  {
    "name": "FARMACIA GIOTTI SRL",
    "address": "Via Nazionale, 24, CHIUSI DELLA VERNA - Corsalone AR 52010, Italia",
    "lat": 43.6816004,
    "lng": 11.8293875,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6816004,11.8293875"
  },
  {
    "name": "INSALUTE S.N.C. DI UBERTONI FRANCESCO E DAMIANI SUSANNA",
    "address": "Via San Donà, 356/G, VENEZIA VE 30173, Italia",
    "lat": 45.5024662,
    "lng": 12.2742593,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5024662,12.2742593"
  },
  {
    "name": "SANITARIA ORTOPEDICA GROSSETANA S.R.L.",
    "address": "VIA FIUME N.13/C, GROSSETO GR 58100, Italia",
    "lat": 42.7656366,
    "lng": 11.1140781,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7656366,11.1140781"
  },
  {
    "name": "FARMACIA MARUCELLI DEI DOTTORI ANGELA E CARLO PANFILO S.N.C.",
    "address": "Viale De Amicis, 87/A, FIRENZE FI 50137, Italia",
    "lat": 43.7765252,
    "lng": 11.2883789,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7765252,11.2883789"
  },
  {
    "name": "Ortopedia Pratese s.r.l.",
    "address": "Via G. Inghirami, 19, PRATO PO 59100, Italia",
    "lat": 43.8651951,
    "lng": 11.0981577,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8651951,11.0981577"
  },
  {
    "name": "FARMACIA PESCETTO DOTT. MARCO",
    "address": "Via Luigi Rizzo, 48, GENOVA GE 16157, Italia",
    "lat": 44.428787,
    "lng": 8.8085031,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.428787,8.8085031"
  },
  {
    "name": "Farmacia Angelini Simplicio di Angelini Alberto & C. s.a.s.",
    "address": "Via Roma, 27, APPIGNANO DEL TRONTO AP 63031, Italia",
    "lat": 42.898002,
    "lng": 13.666762,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.898002,13.666762"
  },
  {
    "name": "FARMACIA BOZZA DOTT. LUCIANO",
    "address": "Viale Vittorio Emanuele, 1/D, MARSCIANO - San valentino PG 06055, Italia",
    "lat": 42.959847,
    "lng": 12.343841,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.959847,12.343841"
  },
  {
    "name": "FARMACIA NUCCI S.A.S. del DOTT. GINO NUCCI e C.",
    "address": "Via della Libertà, 48, AGLIANA PT 51031, Italia",
    "lat": 43.9043513,
    "lng": 11.0053933,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9043513,11.0053933"
  },
  {
    "name": "FARMACIA COMUNALE CHIARAVALLE S.R.L.",
    "address": "Via Circonvallazione, 31/E, CHIARAVALLE AN 60033, Italia",
    "lat": 43.5995714,
    "lng": 13.331365,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5995714,13.331365"
  },
  {
    "name": "FARMACIA PARRETTI",
    "address": "Via S. Pertini, 49-51, CAMPI BISENZIO - Sant'angelo FI 50013, Italia",
    "lat": 39.036143,
    "lng": 16.990449,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.036143,16.990449"
  },
  {
    "name": "FARMACIA VAL D'ARBIA del Dr. David Madioni & C. snc",
    "address": "Via IV Novembre, 133, MONTERONI D'ARBIA SI 53014, Italia",
    "lat": 43.2290688,
    "lng": 11.4208568,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2290688,11.4208568"
  },
  {
    "name": "FARMACIA D.SSA IGLIO ROSARIA",
    "address": "Via Garibaldi, 1/A, BELVEGLIO AT 14040, Italia",
    "lat": 44.8297151,
    "lng": 8.3299918,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8297151,8.3299918"
  },
  {
    "name": "FARMACIA Dott.ssa CAPELLO DEBORAH",
    "address": "Piazza Municipio, 3, CASTELNUOVO BELBO AT 14043, Italia",
    "lat": 44.8015158,
    "lng": 8.4121919,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8015158,8.4121919"
  },
  {
    "name": "FARMACIA BERT SNC delle dott.sse Camussa E. e Bert F.",
    "address": "Via Cottolengo, 1, PINEROLO TO 10064, Italia",
    "lat": 44.8856257,
    "lng": 7.3208119,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8856257,7.3208119"
  },
  {
    "name": "FARMACIA LA GABELLA s.a.s. Dr. CAMPEOL-CAVALLINI-STOPPELLI & C.",
    "address": "Via Ettore Tozzini, 1M, CALCI - Gabella PI 56011, Italia",
    "lat": 43.7212519,
    "lng": 10.4972474,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7212519,10.4972474"
  },
  {
    "name": "LA SANITARIA MOGLIANESE di Michielan Katia",
    "address": "Via Selve, 28/F, MOGLIANO VENETO TV 31021, Italia",
    "lat": 45.5708228,
    "lng": 12.2202853,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5708228,12.2202853"
  },
  {
    "name": "FARMACIA QUERCIOLI SNC",
    "address": "Viale Cerboni, 5, MARCIANA MARINA LI 57033, Italia",
    "lat": 42.8041309,
    "lng": 10.2002446,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8041309,10.2002446"
  },
  {
    "name": "UTOPHA GROUP SRL",
    "address": "Via Severino Celli, 3, SANT'AGATA FELTRIA RN 47866, Italia",
    "lat": 43.8638245,
    "lng": 12.2082912,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8638245,12.2082912"
  },
  {
    "name": "FARMACIA FILIPPETTI di LUCIANO FILIPPETTI & C. S.A.S.",
    "address": "Via Briniati, 11, BRUGNATO SP 19020, Italia",
    "lat": 44.2364224,
    "lng": 9.7275908,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2364224,9.7275908"
  },
  {
    "name": "ORTOPEDIA OLIVI S.R.L.",
    "address": "Largo Giambellino, 5, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.7082608,
    "lng": 10.6063648,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7082608,10.6063648"
  },
  {
    "name": "Farmacia Rossetti di Bianco Dott.ssa Luciana",
    "address": "Via Rossetti, 7, CIRIE' TO 10073, Italia",
    "lat": 45.227216,
    "lng": 7.6013236,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.227216,7.6013236"
  },
  {
    "name": "LA SANITARIA DI DE CAROLIS COSIMO",
    "address": "Corso Italia, 42, FASANO - Pezze di greco BR 72010, Italia",
    "lat": 40.8131332,
    "lng": 17.4135032,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.8131332,17.4135032"
  },
  {
    "name": "COMUNE DI CASTIGLIONE DELLA PESCAIA",
    "address": "Via Ansedonia, 47, CASTIGLIONE DELLA PESCAIA GR 58043, Italia",
    "lat": 42.7614111,
    "lng": 10.8888731,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7614111,10.8888731"
  },
  {
    "name": "PARAFARMACIA DEL BORGO DI PRATO CHIARA",
    "address": "Via Scarincio, 106, IMPERIA IM 18100, Italia",
    "lat": 43.8768828,
    "lng": 8.0187285,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8768828,8.0187285"
  },
  {
    "name": "Farmacia della Rocchetta della Dott.ssa Malpassi Mariangela e C. SAS",
    "address": "Via Ponte, 5 loc. Riola, GRIZZANA MORANDI BO 40030, Italia",
    "lat": 44.22912,
    "lng": 11.05554,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.22912,11.05554"
  },
  {
    "name": "FARMACIA INGAUNA SNC",
    "address": "Via Panero, 22, ALBENGA - San fedele SV 17031, Italia",
    "lat": 41.923861,
    "lng": 12.511968,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.923861,12.511968"
  },
  {
    "name": "PARAFARMACIA PHARMATEKA SAS",
    "address": "Via Colonnello Aprosio, 34, VALLECROSIA IM 18019, Italia",
    "lat": 43.7863479,
    "lng": 7.6390237,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7863479,7.6390237"
  },
  {
    "name": "AGI DI GALLO GLORIA E C. S.A.S.",
    "address": "Via Garibaldi, 27/1, FINALE LIGURE SV 17024, Italia",
    "lat": 44.1694432,
    "lng": 8.3450307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1694432,8.3450307"
  },
  {
    "name": "Farmacia del Santuario s.n.c",
    "address": "Via Musinè, 18/20, PIANEZZA TO 10044, Italia",
    "lat": 45.1092833,
    "lng": 7.5430407,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1092833,7.5430407"
  },
  {
    "name": "FARMACIA BEDESCHI DELLA DR.SSA M. GRAZIA TUMIDEI & C. SNC",
    "address": "Via Torre San Michele, 12/14, CERVIA RA 48015, Italia",
    "lat": 44.2619872,
    "lng": 12.3512186,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2619872,12.3512186"
  },
  {
    "name": "FARMACIA CAPONE DOTT.SSA ALESSIA SAS DI ALESSIA CAPONE & C",
    "address": "Via XX Settembre, 12, VICOPISANO PI 56010, Italia",
    "lat": 43.6958792,
    "lng": 10.5144668,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6958792,10.5144668"
  },
  {
    "name": "FARMACIA SANTA GIULIA SRL",
    "address": "Via dei Martiri, 11, CALCINAIA PI 56012, Italia",
    "lat": 43.6914785,
    "lng": 10.6147837,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6914785,10.6147837"
  },
  {
    "name": "FARMACIA Dott. Rudoni Gianfranco",
    "address": "Piazza Garibaldi, 6, TREQUANDA SI 53020, Italia",
    "lat": 43.1888885,
    "lng": 11.6674944,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1888885,11.6674944"
  },
  {
    "name": "TRAPPER FARMACEUTICI SAS di Alessandra Frizone & C.",
    "address": "Località San Rocco, 8, ANDORA SV 17051, Italia",
    "lat": 43.9752832,
    "lng": 8.1385476,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9752832,8.1385476"
  },
  {
    "name": "FARMACIA PIANI SAS di Stefano Masserini & C.",
    "address": "Via Littardi, 188, IMPERIA IM 18100, Italia",
    "lat": 43.9070247,
    "lng": 7.9519781,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9070247,7.9519781"
  },
  {
    "name": "PF GIUSTI di Giusti Jessica & Gabriela s.n.c.",
    "address": "Piazza dei Gerani, 7, BIBBONA LI 57020, Italia",
    "lat": 43.2459694,
    "lng": 10.5334752,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2459694,10.5334752"
  },
  {
    "name": "FARMACIA ROBIOLIO & C. sas",
    "address": "Via Libertà, 100, CANDELO BI 13878, Italia",
    "lat": 45.5432131,
    "lng": 8.1111057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5432131,8.1111057"
  },
  {
    "name": "FARMACIA BERNARDINI S.R.L.",
    "address": "Via Corridoni, 1, GRAVELLONA TOCE VB 28883, Italia",
    "lat": 45.9289527,
    "lng": 8.4306348,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9289527,8.4306348"
  },
  {
    "name": "FARMACIA SAN GREGORIO DOTT. GRAMONI",
    "address": "Via Negarè, 1, CAMBIASCA VB 28814, Italia",
    "lat": 45.9607962,
    "lng": 8.5428497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9607962,8.5428497"
  },
  {
    "name": "FARMAENATURA di Tittarelli Michela",
    "address": "Via Breccione, 18/A, STAFFOLO AN 60039, Italia",
    "lat": 43.438727,
    "lng": 13.212621,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.438727,13.212621"
  },
  {
    "name": "JOLLY CASA MEDICAL SRL",
    "address": "Via dei Laghi, snc, COLLI AL METAURO PU 61036, Italia",
    "lat": 43.7621324,
    "lng": 12.9392679,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7621324,12.9392679"
  },
  {
    "name": "APOTEK S.R.L.",
    "address": "Via Flaminio, 71, ROMA RM 00196, Italia",
    "lat": 41.9273503,
    "lng": 12.4732505,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9273503,12.4732505"
  },
  {
    "name": "ORTOPEDIA SANITARIA OVEST SRL",
    "address": "Viale della Repubblica,154, TREVISO TV 31100, Italia",
    "lat": 45.6804231,
    "lng": 12.2411735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6804231,12.2411735"
  },
  {
    "name": "GILDA ITALIA SRL",
    "address": "Viale Crotone, 149/C, CATANZARO - Catanzaro lido CZ 88100, Italia",
    "lat": 38.8355278,
    "lng": 16.6365615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.8355278,16.6365615"
  },
  {
    "name": "FARMAPOINT FORTUNA S.R.L.",
    "address": "Via dei Sabini, 28, ASCOLI PICENO AP 63100, Italia",
    "lat": 42.8558023,
    "lng": 13.5767035,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8558023,13.5767035"
  },
  {
    "name": "CENTRO ORTOPEDICO SANITARIO BECHERELLI",
    "address": "Via Torcicoda, 91/R, FIRENZE FI 50142, Italia",
    "lat": 43.776875,
    "lng": 11.215157,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.776875,11.215157"
  },
  {
    "name": "FARMACIA SAPORI DI GUIDO E GIULIA SAPORI & C. - S.A.S.",
    "address": "Viale G. Mazzini, 8, VIGNOLA MO 41058, Italia",
    "lat": 44.4793948,
    "lng": 11.0101837,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4793948,11.0101837"
  },
  {
    "name": "SANITAS DI BERNERI MARCO",
    "address": "Via Mincio, 29, CREMONA CR 26100, Italia",
    "lat": 45.1328194,
    "lng": 10.0086205,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1328194,10.0086205"
  },
  {
    "name": "ORTOPEDIA SAN PIETRO SRL",
    "address": "Via Carlo Forlanini, 19, PONTE SAN PIETRO BG 24036, Italia",
    "lat": 45.6979196,
    "lng": 9.5742737,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6979196,9.5742737"
  },
  {
    "name": "PARAFARMACIA CAU MARIA LIDIA",
    "address": "Via delle Rose Antiche, 55, OLBIA OT 07026, Italia",
    "lat": 40.8904025,
    "lng": 9.5867289,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.8904025,9.5867289"
  },
  {
    "name": "FARMACIA FAGGIANI DI PEVIANI ANGELA E PAOLA SNC",
    "address": "Piazza Brundiano, 8, OSILO SS 07033, Italia",
    "lat": 40.7438652,
    "lng": 8.6723404,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7438652,8.6723404"
  },
  {
    "name": "FARMACIA MANNAZZU SNC DEI DR.I DI GIULIO S. CLAUDIO e CARLO",
    "address": "Via XX Settembre, 40/44, ALGHERO SS 07041, Italia",
    "lat": 40.5572817,
    "lng": 8.31689,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5572817,8.31689"
  },
  {
    "name": "FARMACIA DI DR. MURRU G. A. e FIGLIO S.R.L.",
    "address": "Via Olbia, snc, CARDEDU OG 08040, Italia",
    "lat": 39.7947336,
    "lng": 9.626695,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.7947336,9.626695"
  },
  {
    "name": "FARMACIA FARMATEST DR. TESTONI GIOVANNINO",
    "address": "Via Roma, 28, THIESI SS 07047, Italia",
    "lat": 40.5257271,
    "lng": 8.719908,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5257271,8.719908"
  },
  {
    "name": "ORTOPEDIA MENICALLI s.r.l.",
    "address": "Via S. Lavagnini, 101/C, SAN GIOVANNI VALDARNO AR 52027, Italia",
    "lat": 43.5574037,
    "lng": 11.5368985,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5574037,11.5368985"
  },
  {
    "name": "FARMACIA SAN BARTOLOMEO DI RONDINI ILARIA",
    "address": "Via Adua, 12, COSSERIA SV 17017, Italia",
    "lat": 44.366601,
    "lng": 8.234433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.366601,8.234433"
  },
  {
    "name": "ORTOPEDIA GENOVA DI CASAMASSIMA DAVIDE",
    "address": "Strada Genova, 120, MONCALIERI TO 10024, Italia",
    "lat": 44.9899791,
    "lng": 7.720299,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9899791,7.720299"
  },
  {
    "name": "SANITARIA BIANCHELLI SRL",
    "address": "Via Montello, 6A, JESI AN 60035, Italia",
    "lat": 43.5199867,
    "lng": 13.2378379,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5199867,13.2378379"
  },
  {
    "name": "FARMACIA CECCHINI SRL",
    "address": "Via Madonna dello Schioppo, 38, CESENA FC 47023, Italia",
    "lat": 44.1509668,
    "lng": 12.2433381,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1509668,12.2433381"
  },
  {
    "name": "FARMACIA SAN PALMERIO SNC DI GIAMMARCO E MATTEO MELE",
    "address": "Corso Umberto, 150, GHILARZA OR 09074, Italia",
    "lat": 40.1200902,
    "lng": 8.827844,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.1200902,8.827844"
  },
  {
    "name": "Farmacia Sircana del Dott. Sircana & C. snc",
    "address": "Piazza Marginesu, 32, SORSO SS 07037, Italia",
    "lat": 40.7973846,
    "lng": 8.5769537,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7973846,8.5769537"
  },
  {
    "name": "NUOVA ORTOPEDIA DELLO STRETTO SRL",
    "address": "VIALE DELLA LIBERTà, 43/45/47/49, MESSINA ME 98121, Italia",
    "lat": 38.2139806,
    "lng": 15.5627068,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.2139806,15.5627068"
  },
  {
    "name": "SANITARIA ORTOPEDIA SQUECCO DI SQUECCO FABIO",
    "address": "Via Dante Alighieri, 157, GEMONA DEL FRIULI UD 33013, Italia",
    "lat": 46.2762983,
    "lng": 13.1374604,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.2762983,13.1374604"
  },
  {
    "name": "SANITAS ORTOPEDIA SRL",
    "address": "Via Matteotti, 53, VITERBO VT 01100, Italia",
    "lat": 42.6276896,
    "lng": 12.092318,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6276896,12.092318"
  },
  {
    "name": "SANITASHOP SrL",
    "address": "Piazza Umberto I, 101C, SAN GIOVANNI LUPATOTO VR 37057, Italia",
    "lat": 45.3814097,
    "lng": 11.0451443,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3814097,11.0451443"
  },
  {
    "name": "FARMACIA DR.SSA MAZZEO CICCHETTI",
    "address": "Via Nazionale, 24, POPPI - Badia prataglia AR 52010, Italia",
    "lat": 43.79162,
    "lng": 11.8773894,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.79162,11.8773894"
  },
  {
    "name": "FARMACIA ZAMPARINI DEL DOTT. RICCARDO GIUBILEI",
    "address": "Via Prampolini Camillo,23, CESENA FC 47023, Italia",
    "lat": 44.1401919,
    "lng": 12.290344,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1401919,12.290344"
  },
  {
    "name": "FARMACIA SAN PAOLO s.n.c. di Margini Carlotta e Margini Elisabetta",
    "address": "Via Gramsci, 5, SAN POLO D'ENZA RE 42020, Italia",
    "lat": 44.6258793,
    "lng": 10.4237971,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6258793,10.4237971"
  },
  {
    "name": "FARMACIA DOTT.SSA FRANCESCA PISANU",
    "address": "Via Margherita di Savoia, NUGHEDU SAN NICOLO' SS 07010, Italia",
    "lat": 40.5565755,
    "lng": 9.0226495,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5565755,9.0226495"
  },
  {
    "name": "Sanitas Sas di Maestro Enrica & C.",
    "address": "Viale Risorgimento, 59, BRA CN 12042, Italia",
    "lat": 44.7011275,
    "lng": 7.8424065,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7011275,7.8424065"
  },
  {
    "name": "PARAFARMACIA MARIPHARM",
    "address": "via Nazario Sauro n.64, SINISCOLA - La caletta NU 08020, Italia",
    "lat": 40.6034042,
    "lng": 9.7406152,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.6034042,9.7406152"
  },
  {
    "name": "C.RO.M SERVIZI S.R.L.",
    "address": "Via dei Lavoratori, 21, ROSIGNANO MARITTIMO LI 57016, Italia",
    "lat": 43.4016715,
    "lng": 10.4706604,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4016715,10.4706604"
  },
  {
    "name": "ORTOPEDIA SANITARIA NALDI",
    "address": "Via Nasica, 47/49, CASTENASO BO 40055, Italia",
    "lat": 44.5032967,
    "lng": 11.4793123,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5032967,11.4793123"
  },
  {
    "name": "PRIMA.VERA ORTOPEDIA SNC DI DISANTO ROSSANA & C.",
    "address": "Piazza San Pietro in Vincoli, 2, SETTIMO TORINESE TO 10036, Italia",
    "lat": 45.1371115,
    "lng": 7.7704234,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1371115,7.7704234"
  },
  {
    "name": "FARMACIA SANTA VITTORIA SNC",
    "address": "Via Santa Vittoria, 15 A, SENNORI SS 07036, Italia",
    "lat": 40.7868655,
    "lng": 8.6004892,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7868655,8.6004892"
  },
  {
    "name": "FARMACIA ALL'ADIGE S.N.C.",
    "address": "Via Marconi, 20, CAVAION VERONESE VR 37010, Italia",
    "lat": 45.5152534,
    "lng": 10.7998998,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5152534,10.7998998"
  },
  {
    "name": "LA BOUTIQUE DELLA SALUTE SRL UNIPERSONALE",
    "address": "Via Buoso Da Dovara, 52, Cremona CR 26100, Italia",
    "lat": 45.1347348,
    "lng": 10.0390321,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1347348,10.0390321"
  },
  {
    "name": "FARMACIA DEL PORTO DEL DOTTOR LUIGI MANCA E C. S.N.C.",
    "address": "VIA DEL PORTO MARINA DI PERD E SALIS, SARROCH CA 09018, Italia",
    "lat": 39.065568,
    "lng": 9.010963,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.065568,9.010963"
  },
  {
    "name": "ORTOPEDIA NEGRI snc di Zanarella e Grossi",
    "address": "Corso Vercelli, 23, NOVARA NO 28100, Italia",
    "lat": 45.4338307,
    "lng": 8.5977087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4338307,8.5977087"
  },
  {
    "name": "FARMACIA DI VAIANO Soc. Coop.",
    "address": "Via G. Braga, 250, VAIANO PO 59021, Italia",
    "lat": 43.9691594,
    "lng": 11.1239909,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9691594,11.1239909"
  },
  {
    "name": "FARMACIA FAEDI di Alfredo Calisesi & C. snc",
    "address": "Viale Trento, 12, CESENATICO FC 47042, Italia",
    "lat": 44.1947103,
    "lng": 12.4032782,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1947103,12.4032782"
  },
  {
    "name": "ORTOPEDIA SANITARIA-PODOLOGIA di Taormina",
    "address": "Via G.B. Ughetti, 50, PALERMO PA 90131, Italia",
    "lat": 38.0984141,
    "lng": 13.3567221,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0984141,13.3567221"
  },
  {
    "name": "ORTOPEDIA E ARTICOLI MEDICO SANITARI PIEDE & SALUTE",
    "address": "Via San Valentino, 18/A, PORDENONE PN 33170, Italia",
    "lat": 45.9669955,
    "lng": 12.6672067,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9669955,12.6672067"
  },
  {
    "name": "FARMACIA MARANO SAS",
    "address": "Viale D'Annunzio, 181 D/E, RICCIONE RN 47838, Italia",
    "lat": 44.0134484,
    "lng": 12.6455197,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0134484,12.6455197"
  },
  {
    "name": "FARMACIA NUOVA BELLARIA SNC",
    "address": "Via Fratelli Cervi, 27, BELLARIA IGEA MARINA RN 47814, Italia",
    "lat": 44.1551399,
    "lng": 12.4514316,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1551399,12.4514316"
  },
  {
    "name": "FARMACIA SAN PANCRAZIO SAS DELLA DOTT.SSA CARLOTTA FARNETI",
    "address": "Via Molinaccio, 106, RUSSI - San pancrazio RA 48026, Italia",
    "lat": 44.3573633,
    "lng": 12.0747163,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3573633,12.0747163"
  },
  {
    "name": "FARMACIA SOPHARMA D.SSA RITA SORO",
    "address": "Via Nazionale, 14, SANTA TERESA GALLURA OT 07028, Italia",
    "lat": 41.2301557,
    "lng": 9.1848399,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2301557,9.1848399"
  },
  {
    "name": "Farmacia Vecchietti Elvira & c. SAS",
    "address": "Via Nazionale, 121, URBINO - Canavaccio PU 61029, Italia",
    "lat": 43.696175,
    "lng": 12.6952923,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.696175,12.6952923"
  },
  {
    "name": "Farmacia Regoli S.R.L.",
    "address": "Via Gavinana, 60, ALTOPASCIO LU 55011, Italia",
    "lat": 43.8220617,
    "lng": 10.6837448,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8220617,10.6837448"
  },
  {
    "name": "FARMACIA LO STRADONE DEL DOTTOR BONAGURA ANTONIO e C. S.A.S.",
    "address": "Via Buozzi, 18, BORGHI - Lo stradone FC 47030, Italia",
    "lat": 44.03228,
    "lng": 12.3871908,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.03228,12.3871908"
  },
  {
    "name": "SANITARIA VILLA BIANCA SRL",
    "address": "Via Leuca, 90/A, LECCE LE 73100, Italia",
    "lat": 40.3277902,
    "lng": 18.1819096,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.3277902,18.1819096"
  },
  {
    "name": "CENTRO SERVIZI ABILIA di SIMONA PAOLONI",
    "address": "Via G.Matteotti, 15, PRIVERNO LT 04015, Italia",
    "lat": 41.4717073,
    "lng": 13.1780824,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.4717073,13.1780824"
  },
  {
    "name": "Farmacie dei Sibillini s.a.s. Dott.Leonardo Casaroli & C.",
    "address": "Area Parco Ruggeri, Fraz. Fluminata, USSITA MC 62039, Italia",
    "lat": 42.931421,
    "lng": 13.084787,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.931421,13.084787"
  },
  {
    "name": "SANITARIA ORTOPEDIA DEL VIALE",
    "address": "VIALE BAUCHIERO, 22, CONDOVE TO 10055, Italia",
    "lat": 45.1142592,
    "lng": 7.311446,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1142592,7.311446"
  },
  {
    "name": "FARMACIA BROCCOLI di Farmacia Arrigoni s.a.s.",
    "address": "Via San Rocco, 6, GATTEO FC 47043, Italia",
    "lat": 44.1135896,
    "lng": 12.391645,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1135896,12.391645"
  },
  {
    "name": "NI.OR.SA. SRL",
    "address": "Piazza Vincenzo Lanza, 16 A/B/C/D/E/F, CATANIA CT 95123, Italia",
    "lat": 37.5141041,
    "lng": 15.0795651,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.5141041,15.0795651"
  },
  {
    "name": "FARMACIA FALCONE S.A.S. Dott.ssa P.G. PALAZZOLO & C.",
    "address": "Via Milano, 31, ALESSANDRIA AL 15100, Italia",
    "lat": 44.9150017,
    "lng": 8.6137157,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9150017,8.6137157"
  },
  {
    "name": "FARMACIA DOTT.SSA GIORGIA MUGHEDDU",
    "address": "Via Roma, 67, SIAMAGGIORE OR 09070, Italia",
    "lat": 39.9493059,
    "lng": 8.6397016,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9493059,8.6397016"
  },
  {
    "name": "OMEOPHYTO SRL",
    "address": "Via Mistrangelo, 7/4, SAVONA SV 17100, Italia",
    "lat": 44.3095239,
    "lng": 8.4815125,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3095239,8.4815125"
  },
  {
    "name": "Parafarmacia Farmapiù di Franceschelli Dott.ssa Monica",
    "address": "Via Ticino, 1/D, OSIMO AN 60027, Italia",
    "lat": 43.4711575,
    "lng": 13.4647815,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4711575,13.4647815"
  },
  {
    "name": "PARAFARMACIA RATTAZZI SNC",
    "address": "Piazza Urbano Rattazzi, 5, CASALE MONFERRATO AL 15033, Italia",
    "lat": 45.1362492,
    "lng": 8.451733,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1362492,8.451733"
  },
  {
    "name": "FARMACIA DOTT. ANTONIO MASIA",
    "address": "Via Roma, 40, LOTZORAI OG 08040, Italia",
    "lat": 39.9682453,
    "lng": 9.6603698,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9682453,9.6603698"
  },
  {
    "name": "FARMACIA PULIGHEDDU FRANCA di MARCELLO e ORNELLA PUDDU s.n.c.",
    "address": "Via Grazia Deledda, 2, OLIENA NU 08025, Italia",
    "lat": 40.2713403,
    "lng": 9.4052298,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.2713403,9.4052298"
  },
  {
    "name": "FARMACIA CALDERARA DONATELLA & C. S.A.S.",
    "address": "Corso XXV Aprile, 31, GOZZANO NO 28024, Italia",
    "lat": 45.7429724,
    "lng": 8.4344735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7429724,8.4344735"
  },
  {
    "name": "Medical Center soc. Coop.",
    "address": "viale Oganto 15, FOGGIA FG 71100, Italia",
    "lat": 41.45866,
    "lng": 15.535898,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.45866,15.535898"
  },
  {
    "name": "FARMACIA SANTA CHIARA DELLA D.SSA M.VITTORIA DUI e C. SAS",
    "address": "Via Togliatti, snc, SASSARI SS 07100, Italia",
    "lat": 40.7216094,
    "lng": 8.5830287,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7216094,8.5830287"
  },
  {
    "name": "Farmacia BERNARDINI di Bernardini M. Carla erede Guarparini",
    "address": "Via XX Settembre, 24, BUTI PI 56032, Italia",
    "lat": 43.7271842,
    "lng": 10.5874581,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7271842,10.5874581"
  },
  {
    "name": "PARAFARMACIA DEL SINIS di Dott. Stefano Sanna",
    "address": "Corso Italia, 39, CABRAS OR 09072, Italia",
    "lat": 39.9249024,
    "lng": 8.5377691,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9249024,8.5377691"
  },
  {
    "name": "FARMACIA ECONOMICA D.SSA LEONARDI GIOVANNA",
    "address": "Via Fieschi, 17R, GENOVA GE 16121, Italia",
    "lat": 44.4058374,
    "lng": 8.936986,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4058374,8.936986"
  },
  {
    "name": "FARMACIA MONICCHI S.R.L.",
    "address": "Via Romagna, 104, TERNI TR 05100, Italia",
    "lat": 42.5685642,
    "lng": 12.6618597,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5685642,12.6618597"
  },
  {
    "name": "ANTICA FARMACIA CELESIA OLEGGIO SAS",
    "address": "Piazza Martiri, 33, OLEGGIO NO 28047, Italia",
    "lat": 45.5974967,
    "lng": 8.637156,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5974967,8.637156"
  },
  {
    "name": "FARMACIA GISMONDI",
    "address": "Piazza Colombo, 6, SAN REMO IM 18038, Italia",
    "lat": 43.8186417,
    "lng": 7.7781154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8186417,7.7781154"
  },
  {
    "name": "RICATTO MARZIA",
    "address": "VIA CAROZZANI 58, SAN DONA' DI PIAVE VE 30027, Italia",
    "lat": 45.6349069,
    "lng": 12.5841503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6349069,12.5841503"
  },
  {
    "name": "Parafarmacia L'Araba Fenice di Boria Eleonora",
    "address": "Via del Rivo, 222, TERNI TR 05100, Italia",
    "lat": 42.5805858,
    "lng": 12.6233222,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5805858,12.6233222"
  },
  {
    "name": "NE.PA. SRL",
    "address": "Piazza Dante, 4, TRESCORE BALNEARIO BG 24069, Italia",
    "lat": 45.6955348,
    "lng": 9.8397805,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6955348,9.8397805"
  },
  {
    "name": "NUOVA ORTOPEDIA LUCANA S.R.L.",
    "address": "Viale Tommaso Merlino snc, SANT'ARCANGELO PZ 85037, Italia",
    "lat": 40.2590408,
    "lng": 16.2535715,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.2590408,16.2535715"
  },
  {
    "name": "FARMACIA PAGLIACCI SAS DI PATRIZIA E SILVIA PAGLIACCI",
    "address": "Piazza G. Tempioni, 1, VALFABBRICA PG 06029, Italia",
    "lat": 43.1558004,
    "lng": 12.6023753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1558004,12.6023753"
  },
  {
    "name": "ORTOPEDICA 2000 SAS DI ALESSANDRO VISENTIN",
    "address": "CORSO DE GREGORI, 22, VERCELLI VC 13100, Italia",
    "lat": 45.3210964,
    "lng": 8.4246407,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3210964,8.4246407"
  },
  {
    "name": "ORTOPEDIA VISCA DOTT. FORTE SRL",
    "address": "Via Chianoc, 31, SAVIGLIANO CN 12038, Italia",
    "lat": 44.64243,
    "lng": 7.6595607,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.64243,7.6595607"
  },
  {
    "name": "ARTE IN ORTOPEDIA S.R.L.",
    "address": "Viale volontari della libertà,8, UDINE UD 33100, Italia",
    "lat": 46.0719004,
    "lng": 13.234494,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0719004,13.234494"
  },
  {
    "name": "TECNOLOGIE SANITARIE E SPORTIVE SRL",
    "address": "Via Casilina Sud KM 77 100, FERENTINO FR 03013, Italia",
    "lat": 41.686199,
    "lng": 13.266934,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.686199,13.266934"
  },
  {
    "name": "FARMA BIO DI PAINI FRANCESCA",
    "address": "Via XXV Aprile, 8, ANCONA AN 60125, Italia",
    "lat": 43.6093165,
    "lng": 13.5164779,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6093165,13.5164779"
  },
  {
    "name": "FARMACIA INSIEME DI CIOCCA ILARIA E ROSSI LORELLA SNC",
    "address": "Via del Mulino - Via Paganica, 10, L'AQUILA - Tempera AQ 67100, Italia",
    "lat": 42.3653719,
    "lng": 13.458897,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3653719,13.458897"
  },
  {
    "name": "Centro Ortopedico Dauno di Giacometti Giulio",
    "address": "Via Isonzo 6, MANFREDONIA FG 71043, Italia",
    "lat": 41.6327665,
    "lng": 15.9195666,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6327665,15.9195666"
  },
  {
    "name": "FARMACIA ACCORSI SRL",
    "address": "VIA P. GORI ,80/A, SARZANA SP 19038, Italia",
    "lat": 44.1112628,
    "lng": 9.9566751,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1112628,9.9566751"
  },
  {
    "name": "ORTOPEDIA SANITARIA DI ZUPPARDO LIDIA",
    "address": "Via Catolica Eraclea, 11, PALMA DI MONTECHIARO AG 92020, Italia",
    "lat": 37.1897793,
    "lng": 13.7709057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.1897793,13.7709057"
  },
  {
    "name": "OFFICINA ORTOPEDICA BELLOMO DOTT. DOMENICO",
    "address": "Via Porta Agrigento, 88, RAFFADALI AG 92015, Italia",
    "lat": 37.3982449,
    "lng": 13.533007,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.3982449,13.533007"
  },
  {
    "name": "FARMACIA SANNA COCCONE DELLE D.SSE MICHELINA e MARIA FRANCESCA SNC",
    "address": "Corso Repubblica, 3, ORUNE NU 08020, Italia",
    "lat": 40.4129778,
    "lng": 9.3669831,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.4129778,9.3669831"
  },
  {
    "name": "DAHLIA SRL",
    "address": "Via del Popolo, 61, PONTEDERA PI 56025, Italia",
    "lat": 43.6444616,
    "lng": 10.6131819,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6444616,10.6131819"
  },
  {
    "name": "Sanitaria Dolese di Piva Marina",
    "address": "Via Cadorna, 46, MONSELICE PD 35043, Italia",
    "lat": 45.2382511,
    "lng": 11.752358,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2382511,11.752358"
  },
  {
    "name": "FARMACIA DOTT.SSA ROSA MARIA DI MINO",
    "address": "Viale L. Sciascia, 194, AGRIGENTO AG 92100, Italia",
    "lat": 37.2723676,
    "lng": 13.6157828,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.2723676,13.6157828"
  },
  {
    "name": "FARMACIA MEDITERRANEA DOTT.SSA ALESSANDRA RIZZO",
    "address": "Via Aurelia, 2/26, IMPERIA IM 18100, Italia",
    "lat": 43.869806,
    "lng": 8.0006499,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.869806,8.0006499"
  },
  {
    "name": "Farmacia San Firmano srl",
    "address": "Contrada Aneto, 11/C, MONTELUPONE MC 62010, Italia",
    "lat": 43.3732551,
    "lng": 13.5793889,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3732551,13.5793889"
  },
  {
    "name": "FARMACIA TORTI DOTT. PAOLO SNC",
    "address": "Via Paolo Ercole, 78, FELIZZANO AL 15023, Italia",
    "lat": 44.8979791,
    "lng": 8.4338884,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8979791,8.4338884"
  },
  {
    "name": "PHARMALIFE SRL",
    "address": "Corso Italia, 46/48, AMANTEA - Campora san giovanni CS 87032, Italia",
    "lat": 39.0693647,
    "lng": 16.0977216,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.0693647,16.0977216"
  },
  {
    "name": "FARMACIA BONANNO CONTI CINZIA",
    "address": "Via Asmara, 46, VALDERICE TP 91019, Italia",
    "lat": 38.0641838,
    "lng": 12.5968104,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0641838,12.5968104"
  },
  {
    "name": "FARMACIA DI GIORGIO DELLA DOTT.SSA FUNDARO' DALIA",
    "address": "Corso VI Aprile, 180, ALCAMO TP 91011, Italia",
    "lat": 37.980456,
    "lng": 12.9611596,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.980456,12.9611596"
  },
  {
    "name": "FARMACIA IACHETTI DEL DOTT. GIUSEPPE DI STEFANO",
    "address": "Via P. Anfossi, 102R, GENOVA GE 16164, Italia",
    "lat": 44.499194,
    "lng": 8.9039136,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.499194,8.9039136"
  },
  {
    "name": "MEDICAL SAN DI PIGNATI MELANIA",
    "address": "Via Cividale, 10, SAN BENEDETTO DEL TRONTO AP 63039, Italia",
    "lat": 42.9451843,
    "lng": 13.8799641,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9451843,13.8799641"
  },
  {
    "name": "F.I.A. Puglia  Coop. Soc.",
    "address": "Via XXI Aprile  50, CORSANO LE 73033, Italia",
    "lat": 39.8899232,
    "lng": 18.3662247,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.8899232,18.3662247"
  },
  {
    "name": "PARAFARMACIA WELLNESS SRLS",
    "address": "Via Luigi Galvani, 56, VITERBO VT 01100, Italia",
    "lat": 42.4259229,
    "lng": 12.0929762,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4259229,12.0929762"
  },
  {
    "name": "ORTOPEDIA SAN PAOLO DI AVIGNONE VINCENZA",
    "address": "Via Volvera, 13, TORINO TO 10141, Italia",
    "lat": 45.0631023,
    "lng": 7.648382,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0631023,7.648382"
  },
  {
    "name": "ORTOPEDIA MARCHETTI SRL",
    "address": "Via G. Verdi, 2/a, VILLONGO BG 24060, Italia",
    "lat": 45.6750333,
    "lng": 9.9413026,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6750333,9.9413026"
  },
  {
    "name": "SANITARIA DEL BENESSERE DI GLORIOSO MASSIMILIANO",
    "address": "PIAZZA F. BELLIPANNI 13/14, CEFALU' PA 90015, Italia",
    "lat": 38.0339494,
    "lng": 14.0192139,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0339494,14.0192139"
  },
  {
    "name": "Ortopedia Sanitaria Pallanza di Labriola Antonio",
    "address": "Via Crocetta, 14, VERBANIA VB 28922, Italia",
    "lat": 45.9281435,
    "lng": 8.5504912,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9281435,8.5504912"
  },
  {
    "name": "FARMACIA PIEVESESTINA DOTT.SSA OLIVIERI ELENA",
    "address": "Via Dismano, 4593, CESENA FC 47023, Italia",
    "lat": 44.14557,
    "lng": 12.2191787,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.14557,12.2191787"
  },
  {
    "name": "FARMACIA SABAZIA DOTTOR SILVIO ROSSI & C. S.A.S.",
    "address": "Via Antonio Gramsci, 62, VADO LIGURE SV 17047, Italia",
    "lat": 44.2701816,
    "lng": 8.4379045,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2701816,8.4379045"
  },
  {
    "name": "FARMACIA CANONICA SNC delle Dr.sse N.Emenskaia e A.L. Comastri",
    "address": "Piazza A. Panzini, 6, SANTARCANGELO DI ROMAGNA RN 47822, Italia",
    "lat": 44.0557381,
    "lng": 12.401554,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0557381,12.401554"
  },
  {
    "name": "PARAFARMACIA NADILA SRLS",
    "address": "PIAZZALE DEL LAVORO 1, SISSA PR 43018, Italia",
    "lat": 44.9352712,
    "lng": 10.2681342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9352712,10.2681342"
  },
  {
    "name": "LABORATORIO ORTOPEDICO MELIS S.R.L.",
    "address": "Viale Monastir, 229, CAGLIARI CA 09122, Italia",
    "lat": 39.2554091,
    "lng": 9.0906886,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.2554091,9.0906886"
  },
  {
    "name": "FARMACIA PROF. CAVANNA S.N.C.",
    "address": "Via Gaetano Mosca, 1, TORINO TO 10147, Italia",
    "lat": 45.1011823,
    "lng": 7.677329,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1011823,7.677329"
  },
  {
    "name": "FARMACIA GALASSI SOCIETA' A RESPONSABILITA' LIMITATA",
    "address": "Via Ardeatina, 170, ANZIO RM 00042, Italia",
    "lat": 41.5150558,
    "lng": 12.5806124,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.5150558,12.5806124"
  },
  {
    "name": "FARMACIA OPERAIA S.R.L.",
    "address": "Via Gonzaga, 1, GUASTALLA RE 42016, Italia",
    "lat": 44.919847,
    "lng": 10.6542019,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.919847,10.6542019"
  },
  {
    "name": "COSSIA ORTOPEDIA DI ELISABETTA COSSIA",
    "address": "Via Fuser 2/B, SOMMA LOMBARDO VA 21019, Italia",
    "lat": 45.6831674,
    "lng": 8.7107412,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6831674,8.7107412"
  },
  {
    "name": "FARMACIA DELUIGI del Dott. ROBERTO DELUIGI e C. s.n.c.",
    "address": "Via di Mezzo, 65, RIMINI RN 47900, Italia",
    "lat": 44.0522377,
    "lng": 12.5529501,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0522377,12.5529501"
  },
  {
    "name": "MONDOBABY SANITARIA DI CECCAGNOLI SIMONETTA",
    "address": "Via Maria Montessori, 4, CITTA' DI CASTELLO PG 06012, Italia",
    "lat": 43.3687799,
    "lng": 12.235789,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3687799,12.235789"
  },
  {
    "name": "FARMACIA ROI OLIVIERI SNC",
    "address": "Via 42 Martiri, 13/A, BAVENO - Feriolo VB 28831, Italia",
    "lat": 45.9328026,
    "lng": 8.4801523,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9328026,8.4801523"
  },
  {
    "name": "ARIEL SRL soc. Unipersonale",
    "address": "Via Uguaglianza, 9, VERGIATE VA 21029, Italia",
    "lat": 45.7212298,
    "lng": 8.695474,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7212298,8.695474"
  },
  {
    "name": "FARMACIA GIORDANI S.A.S. del Dott. Alessandro Giordani e C.",
    "address": "VIA DELLA REPUBBLICA 7/B, DONORATICO LI 57024, Italia",
    "lat": 43.1685241,
    "lng": 10.565363,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1685241,10.565363"
  },
  {
    "name": "FARMACIA MERCURIO SNC di RIGGIO ROMEO SRLS",
    "address": "Loc. Montecchio 89/c, CORTONA AR 52044, Italia",
    "lat": 43.2330401,
    "lng": 11.9299279,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2330401,11.9299279"
  },
  {
    "name": "FARMACIA CASTAGNA SNC DI DI GIOVANNA E FILIPPO CASTAGNA",
    "address": "VIA ROMA 45/47, COLONNELLA TE 64010, Italia",
    "lat": 42.8704741,
    "lng": 13.869171,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8704741,13.869171"
  },
  {
    "name": "FARMACIA RAZZETTO DI SIMONETTA RAZZETTO",
    "address": "Via Marconi, 6/8, CAPOLONA AR 52010, Italia",
    "lat": 43.563668,
    "lng": 11.8560064,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.563668,11.8560064"
  },
  {
    "name": "FARMACIA VILLAFRANCA SAS della Dott.ssa Carla Roncaglia",
    "address": "Via Lughese, 248, FORLI' - Villafranca FC 47100, Italia",
    "lat": 44.3032652,
    "lng": 12.0251069,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3032652,12.0251069"
  },
  {
    "name": "AZIENDA SPECIALE MONTESERVIZI",
    "address": "Corso Sangallo, 38, MONTE SAN SAVINO AR 52048, Italia",
    "lat": 43.3325898,
    "lng": 11.7244701,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3325898,11.7244701"
  },
  {
    "name": "PROGETTO.DOMUS SRL",
    "address": "VIA ROMA 61-F, BAGNOLI DEL TRIGNO IS 86091, Italia",
    "lat": 44.794956,
    "lng": 10.684166,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.794956,10.684166"
  },
  {
    "name": "FARMACIA DI PIETRO DR. BRUNO S.N.C.",
    "address": "VIA NAZIONALE, 20, PINETO TE 64025, Italia",
    "lat": 42.6116222,
    "lng": 14.0607999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6116222,14.0607999"
  },
  {
    "name": "FARMACIA BULLA ANGELA",
    "address": "Via Garibaldi, 13, ALGHERO SS 07041, Italia",
    "lat": 40.5605923,
    "lng": 8.3156,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5605923,8.3156"
  },
  {
    "name": "PARAFARMACIA DOTT. CARDUCCI di Luca Carducci",
    "address": "Via Campidoglio prima traversa, 4, CEPRANO FR 03024, Italia",
    "lat": 41.544366,
    "lng": 13.5164517,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.544366,13.5164517"
  },
  {
    "name": "FARMACIA SCORCELLETTI DI POFFERI S.N.C.",
    "address": "Via Porta al Borgo, 110, PISTOIA PT 51100, Italia",
    "lat": 43.9362029,
    "lng": 10.912307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9362029,10.912307"
  },
  {
    "name": "FARMACIA COMUNALE DEGLI ULIVI DI TERAMO SRL",
    "address": "VIA DON LORENZO MILANI SNC, TERAMO - Colleatterrato basso TE 64100, Italia",
    "lat": 42.6760751,
    "lng": 13.7390317,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6760751,13.7390317"
  },
  {
    "name": "Farmacia S.Maria Maddalena",
    "address": "Via Nazionale, 50, MERCENASCO TO 10010, Italia",
    "lat": 45.3614984,
    "lng": 7.8804494,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3614984,7.8804494"
  },
  {
    "name": "PARAFARMACIA DOTT.SSA MELANIA DI PIAZZA",
    "address": "VIA VENEZIA 39, CAMMARATA AG 92022, Italia",
    "lat": 37.6342842,
    "lng": 13.6302617,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6342842,13.6302617"
  },
  {
    "name": "FARMACIA DEL LEVANTE SNC",
    "address": "Via Malta, 70, MARUGGIO TA 74020, Italia",
    "lat": 40.3205603,
    "lng": 17.571793,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.3205603,17.571793"
  },
  {
    "name": "FAMILY HOUSE DI MARTELLINI STELLA",
    "address": "Via IV Novembre, 75 C/D, GROSSETO - Marina di grosseto GR 58100, Italia",
    "lat": 42.717721,
    "lng": 10.982249,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.717721,10.982249"
  },
  {
    "name": "FARMACIA CASTELNUOVO S.N.C.",
    "address": "Viale Enrico Fermi, 21/E, SUBBIANO AR 52010, Italia",
    "lat": 43.5584858,
    "lng": 11.8508659,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5584858,11.8508659"
  },
  {
    "name": "FARMACIA BELLI di Cestari Carla e Belli Francesco SNC",
    "address": "Piazza Roma, 34, CONCORDIA SULLA SECCHIA MO 41033, Italia",
    "lat": 44.913758,
    "lng": 10.9851368,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.913758,10.9851368"
  },
  {
    "name": "FARMACIA MARINI S.N.C. delle Dott.sse Alessia e Chiara Zunino",
    "address": "Via Opisso, 186, GENOVA GE 16155, Italia",
    "lat": 44.4278794,
    "lng": 8.8200226,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4278794,8.8200226"
  },
  {
    "name": "ORTOPEDIA SANITARIA DI TUZZOLINO SARA",
    "address": "CORSO DEI MILLE 956, PALERMO PA 90123, Italia",
    "lat": 38.1018268,
    "lng": 13.3811247,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1018268,13.3811247"
  },
  {
    "name": "ORTOPEDIA SANITARI LUCA S.R.L.",
    "address": "Viale Piave, 41, LIMBIATE MB 20812, Italia",
    "lat": 45.6003205,
    "lng": 9.1221799,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6003205,9.1221799"
  },
  {
    "name": "Farmacia Fenile srl Dott. Ferdinando Talamo",
    "address": "Via Girardengo,8, FANO - Fenile PU 61032, Italia",
    "lat": 43.8404054,
    "lng": 12.9671194,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8404054,12.9671194"
  },
  {
    "name": "FARMACIA CANTUCCI di Cantucci Maria Luisa",
    "address": "Via XX Settembre, 90, SANSEPOLCRO AR 52037, Italia",
    "lat": 43.5708873,
    "lng": 12.1405562,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5708873,12.1405562"
  },
  {
    "name": "FARMACIA DA SETTIMO SAS DEL DOTT. PAOLO BENEDETTTINI E C.",
    "address": "Via Toscoromagnola n. 929, CASCINA PI 56021, Italia",
    "lat": 43.6754348,
    "lng": 10.5600035,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6754348,10.5600035"
  },
  {
    "name": "La Sanitaria di Minchillo Angela",
    "address": "Via Soccorso 191 D, SAN SEVERO FG 71016, Italia",
    "lat": 41.6806115,
    "lng": 15.3878853,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6806115,15.3878853"
  },
  {
    "name": "PARAFARMACIA WELLWORK DI CALABRESE MARIA GIOVANNA",
    "address": "VIA COLLE GENOVESE 11, CONTROGUERRA TE 64010, Italia",
    "lat": 42.852644,
    "lng": 13.8300174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.852644,13.8300174"
  },
  {
    "name": "FARMACIA ADRIATICA DELLA D.SSA RAPAGNA MARIA PAOLA & C. SAS",
    "address": "Via Adriatica, 9/A, ALBA ADRIATICA TE 64011, Italia",
    "lat": 42.8238892,
    "lng": 13.9332933,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8238892,13.9332933"
  },
  {
    "name": "CITTADELLESE SRL",
    "address": "Via Borgo Vicenza, 109, CITTADELLA PD 35013, Italia",
    "lat": 45.6481316,
    "lng": 11.7784394,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6481316,11.7784394"
  },
  {
    "name": "SENZA LIMITI Di Raimondi Marco & C. SAS",
    "address": "Via Circonvallazione 44, RICCIONE RN 47838, Italia",
    "lat": 43.9934153,
    "lng": 12.6500558,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9934153,12.6500558"
  },
  {
    "name": "GUASTI ELISABETTA",
    "address": "Via Gramsci, 9, SANT'ILARIO D'ENZA RE 42049, Italia",
    "lat": 44.7633159,
    "lng": 10.4486145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7633159,10.4486145"
  },
  {
    "name": "Parafarmacia Dr. Khorassani",
    "address": "Via Grande Torino 2, OSTRA AN 60010, Italia",
    "lat": 43.6330859,
    "lng": 13.1469378,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6330859,13.1469378"
  },
  {
    "name": "BIOPHARMACY SRL",
    "address": "Viale Europa, 38/A, GROSSETO GR 58100, Italia",
    "lat": 42.7743615,
    "lng": 11.1140486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7743615,11.1140486"
  },
  {
    "name": "FARMACIA CENTRALE di Bonifazi Viviana & C. s.a.s.",
    "address": "Piazza della Libertà, 20, TOLENTINO MC 62029, Italia",
    "lat": 43.2088833,
    "lng": 13.2850702,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2088833,13.2850702"
  },
  {
    "name": "CENTRO ORTHOMED",
    "address": "VIA PALESTRINA, 68/70, CAGLIARI CA 09129, Italia",
    "lat": 39.2968236,
    "lng": 9.1980601,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.2968236,9.1980601"
  },
  {
    "name": "Farmacia Santa Chiara di Belli Federica",
    "address": "Via Borgaro 103, TORINO TO 10149, Italia",
    "lat": 45.1020794,
    "lng": 7.6627768,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1020794,7.6627768"
  },
  {
    "name": "ORTOPEDIA LA SOLUZIONE SRLS",
    "address": "Via Carlo Alberto 192/E, TRIGGIANO BA 70019, Italia",
    "lat": 41.0663911,
    "lng": 16.9208544,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0663911,16.9208544"
  },
  {
    "name": "FARMACIA BRUNI S.R.L.",
    "address": "VIA ROMANA, 44, BOLANO - Ceparana SP 19020, Italia",
    "lat": 44.1692914,
    "lng": 9.8854299,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1692914,9.8854299"
  },
  {
    "name": "FARMACIA FISCHETTI ANTONIO & C. S.n.c.",
    "address": "Via Piave, 20, ROCCASECCA FR 03038, Italia",
    "lat": 41.5305706,
    "lng": 13.6487621,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.5305706,13.6487621"
  },
  {
    "name": "BELSHOE SPRL",
    "address": "RUE DE GRUPONT, 94A, WELLIN - CHANLY 6921, Belgio",
    "lat": 50.0785905,
    "lng": 5.1553695,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=50.0785905,5.1553695"
  },
  {
    "name": "SILVIA FUMAGALLI DI FUMAGALLI SILVIA E C. SAS",
    "address": "Corso Europa 40, VALLEDORIA SS 07039, Italia",
    "lat": 40.9289909,
    "lng": 8.8264174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9289909,8.8264174"
  },
  {
    "name": "PARAFARMACIA OLTRETORRENTE DEL DOTT. MARTINELLI STEFANO",
    "address": "STRADA ABBEVERATORIA, 27/C, ANGOLO VIA CAVEDAGNI, PARMA PR 43100, Italia",
    "lat": 44.803524,
    "lng": 10.306696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.803524,10.306696"
  },
  {
    "name": "FARMACIA DEL MARE S.N.C.",
    "address": "VIA C. COLOMBO, 132, TERMOLI CB 86039, Italia",
    "lat": 42.0057816,
    "lng": 14.981471,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0057816,14.981471"
  },
  {
    "name": "Centro Specialistico Sas",
    "address": "Via A. Gramsci, 50, SANDIGLIANO BI 13876, Italia",
    "lat": 45.5223011,
    "lng": 8.0744914,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5223011,8.0744914"
  },
  {
    "name": "FARMACIA DEL RABBI D.SSA BILLI ANNA MARIA & C. Sas",
    "address": "Piazza Sandro Pertini, 5, PREDAPPIO - Fiumana FC 47016, Italia",
    "lat": 44.1451064,
    "lng": 11.9863738,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1451064,11.9863738"
  },
  {
    "name": "FARMACIA MACCHI s.a.s. di Macchi Jacopo",
    "address": "Piazza IV Novembre, 13, CAMPAGNATICO GR 58042, Italia",
    "lat": 42.883102,
    "lng": 11.2747707,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.883102,11.2747707"
  },
  {
    "name": "FARMACIA SAN MASSIMO di d.ssa ANNA FILIPPONI",
    "address": "VIALE RINGA 6, PENNE PE 65017, Italia",
    "lat": 42.4586993,
    "lng": 13.9248614,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4586993,13.9248614"
  },
  {
    "name": "FARMACIA SANTO STEFANO S.N.C.",
    "address": "Via Roma, 41, PALAZZUOLO SUL SENIO FI 50035, Italia",
    "lat": 44.1135189,
    "lng": 11.5484067,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1135189,11.5484067"
  },
  {
    "name": "FARMACIA DELLA PIETA' DEL DR. U.BOTTARI E C. SAS",
    "address": "Via Cesare Balbo, 50, PRATO PO 59100, Italia",
    "lat": 43.8858657,
    "lng": 11.1052737,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8858657,11.1052737"
  },
  {
    "name": "FARMACIA SILVESTRINI SAS di MIRELLA SILVESTRINI & C.",
    "address": "Via Martiri d'Ungheria, 11, MERCATELLO SUL METAURO PU 61040, Italia",
    "lat": 43.6476188,
    "lng": 12.3398566,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6476188,12.3398566"
  },
  {
    "name": "Link Multiservice srl",
    "address": "Via di Fontana candida 72, ROMA RM 00132, Italia",
    "lat": 41.8544693,
    "lng": 12.694454,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8544693,12.694454"
  },
  {
    "name": "Farmacia Sant'Ambrogio Della Dott.ssa Celeste Calvelli e C. sas",
    "address": "Via Pietrapiana 2/r, FIRENZE FI 50121, Italia",
    "lat": 43.7714446,
    "lng": 11.2661497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7714446,11.2661497"
  },
  {
    "name": "FARMACIA KURSAAL S.N.C. DI KURSAAL S.N.C. DI FRANCA RINALDI",
    "address": "Via Vittorio Veneto, 1/F, RIMINI RN 47900, Italia",
    "lat": 43.8956777,
    "lng": 12.5309087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8956777,12.5309087"
  },
  {
    "name": "Gabrielis Parafarmacia s.r.l",
    "address": "Corso Susa 305/307, RIVOLI TO 10098, Italia",
    "lat": 45.0769505,
    "lng": 7.51675,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0769505,7.51675"
  },
  {
    "name": "FARMACIA SPEDALETTO SNC",
    "address": "Via degli Scoperti, 34, SAN CASCIANO IN VAL DI PESA FI 50026, Italia",
    "lat": 43.6942965,
    "lng": 11.2020898,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6942965,11.2020898"
  },
  {
    "name": "FARMACIA FERRARI MARIA GIOVANNA",
    "address": "Via Val D'Enza, 31/A, VETTO RE 42020, Italia",
    "lat": 44.4836284,
    "lng": 10.3393951,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4836284,10.3393951"
  },
  {
    "name": "PARAFARMACIA VIALE UMBERTO DI MET - HASANI EMINALDA",
    "address": "Viale Umberto I, 17/D, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.6903605,
    "lng": 10.6288489,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6903605,10.6288489"
  },
  {
    "name": "HUSKO AG",
    "address": "Rieden, 2, STANS 6370, Svizzera",
    "lat": 46.9649122,
    "lng": 8.3832078,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.9649122,8.3832078"
  },
  {
    "name": "FARMACIA GANGEMI SAS della Dott.ssa Gangemi Anna Maria A. & Co.",
    "address": "Via Garibaldi, 45, LENTELLA CH 66050, Italia",
    "lat": 41.9967341,
    "lng": 14.6769177,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9967341,14.6769177"
  },
  {
    "name": "92-08 FARMACEUTICA S.R.L.",
    "address": "Corso Felice Cavallotti, 2/A, ASTI AT 14100, Italia",
    "lat": 44.8978608,
    "lng": 8.2139788,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8978608,8.2139788"
  },
  {
    "name": "FARMACIA CONTICINI S.A.S. DEL DOTT. GIUSEPPE CONTICINI E C.",
    "address": "VIA ROMA, 20, PISA PI 56126, Italia",
    "lat": 43.7167104,
    "lng": 10.3949677,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7167104,10.3949677"
  },
  {
    "name": "FARMACIA CORINTI S.R.L.",
    "address": "Via Nuova n. 7, COLLEDARA TE 64042, Italia",
    "lat": 42.5389816,
    "lng": 13.675079,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5389816,13.675079"
  },
  {
    "name": "FARMACIA SAN PIETRO SNC",
    "address": "Via Luciano Tondelli, 2, CORREGGIO RE 42015, Italia",
    "lat": 44.7610988,
    "lng": 10.7742597,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7610988,10.7742597"
  },
  {
    "name": "Farmacia Acque Chiare snc della Dott.ssa Diana Maria immacolata",
    "address": "Via Aristotele, 6/A, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.6683689,
    "lng": 10.6440879,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6683689,10.6440879"
  },
  {
    "name": "FARMACIA SANT'EGIDIO DELLA DOTT.SSA CALISESI ROBERTA E C. S.N.C.",
    "address": "Via A. Manuzzi, 80, CESENA FC 47023, Italia",
    "lat": 44.1381305,
    "lng": 12.2441036,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1381305,12.2441036"
  },
  {
    "name": "L'HORTOPEDICO 2.0 SRL",
    "address": "Via Galileo Galilei, 6, STANGHELLA PD 35048, Italia",
    "lat": 45.124035,
    "lng": 11.7648188,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.124035,11.7648188"
  },
  {
    "name": "FARMACIA LE FORNACI SAS di Rannazzo F. e Amico T.A. e C.",
    "address": "Piazza N. Mandela, 22, PISTOIA PT 51100, Italia",
    "lat": 43.9426679,
    "lng": 10.9318835,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9426679,10.9318835"
  },
  {
    "name": "GELATERIA ITALIANA S.R.L.",
    "address": "Via Trebocche, 5, BEDIZZOLE BS 25081, Italia",
    "lat": 45.5084549,
    "lng": 10.389957,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5084549,10.389957"
  },
  {
    "name": "FARMACIA DI GREGORIO S.N.C.",
    "address": "Via Cavalieri di Vittorio Veneto, 52/A, AVEZZANO AQ 67051, Italia",
    "lat": 42.043434,
    "lng": 13.4270125,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.043434,13.4270125"
  },
  {
    "name": "PARAFARMACIA DOTT.SSA PESCE DI PESCE MARIA",
    "address": "Via Piave 28/B, CODROIPO UD 33033, Italia",
    "lat": 45.9615605,
    "lng": 12.9759772,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9615605,12.9759772"
  },
  {
    "name": "FARMACIA SANTA RITA DEI DOTTORI PICCININI RITA E SGARBI GIOVANNI SNC",
    "address": "Via Pietro Liverani, 8, FILO ALFONSINE RA 48011, Italia",
    "lat": 44.5865725,
    "lng": 11.9286426,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5865725,11.9286426"
  },
  {
    "name": "FARMACIA TOLA D.SSA TONINA",
    "address": "Via Garibaldi, 6, BITTI NU 08021, Italia",
    "lat": 40.4783347,
    "lng": 9.3815311,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.4783347,9.3815311"
  },
  {
    "name": "FARMACIA DOTT. RITA IURLO",
    "address": "Via Angiolo Cabrini, 32/34, ROMA RM 00139, Italia",
    "lat": 41.9545645,
    "lng": 12.5280034,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9545645,12.5280034"
  },
  {
    "name": "Farmacia San Giorio s.a.s del Dott. Pincetti Enrico e C.",
    "address": "Piazza Velino, 11, SAN GIORIO DI SUSA TO 10050, Italia",
    "lat": 45.1283331,
    "lng": 7.177118,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1283331,7.177118"
  },
  {
    "name": "LE NAIADI S.A.S. DI UGOLINI VALERIA E PICOTTI CLAUDIA",
    "address": "Via IV Novembre, 11, TERNI TR 05100, Italia",
    "lat": 42.5178769,
    "lng": 12.5189102,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5178769,12.5189102"
  },
  {
    "name": "Farmacia Comunale di Podenzano di Acel srl",
    "address": "Via Cherubini, 7, PODENZANO PC 29027, Italia",
    "lat": 44.9874426,
    "lng": 9.6867539,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9874426,9.6867539"
  },
  {
    "name": "FARMACIA CORBELLINI Dott.ssa Elena Bestagini",
    "address": "Frazione Falcero, 43/A, VALDILANA BI 13835, Italia",
    "lat": 45.6269456,
    "lng": 8.1510556,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6269456,8.1510556"
  },
  {
    "name": "FARMACIA LANA di Lana Marina S.a.s",
    "address": "Via G. Garibaldi, 7, TERNI TR 05100, Italia",
    "lat": 42.5600781,
    "lng": 12.6497268,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5600781,12.6497268"
  },
  {
    "name": "FARMACIA SAN DONNINO del Dr. MARINI DAVIDE E C. SNC",
    "address": "Strada Vignolese nr. 1501-1507, MODENA - San donnino MO 41100, Italia",
    "lat": 44.5847562,
    "lng": 10.97167,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5847562,10.97167"
  },
  {
    "name": "FARMACIA LA PISANA SRL",
    "address": "Via Pisana n.69/75, POGGIBONSI SI 53036, Italia",
    "lat": 43.4768266,
    "lng": 11.1369491,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4768266,11.1369491"
  },
  {
    "name": "FARMACIA VERNILE SRL",
    "address": "VIA MARSICANA, 107, SORA FR 03039, Italia",
    "lat": 41.7264119,
    "lng": 13.6236509,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7264119,13.6236509"
  },
  {
    "name": "FARMACIA DOTT. CARLO BOSSI SRL",
    "address": "Via Giuseppe Saragat, 3, CASTELVETRO PIACENTINO PC 29010, Italia",
    "lat": 45.0999441,
    "lng": 9.9856736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0999441,9.9856736"
  },
  {
    "name": "FARMACIA LE REGGIANE",
    "address": "Via dell'Aeronautica, 12, REGGIO EMILIA RE 42100, Italia",
    "lat": 44.7014984,
    "lng": 10.6575425,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7014984,10.6575425"
  },
  {
    "name": "FARMACIA D.SSA MAGI MARIA PAOLA S.r.l.",
    "address": "VIA CLARIS APPIANI 2, RIO MARINA LI 57038, Italia",
    "lat": 42.8149233,
    "lng": 10.4269193,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8149233,10.4269193"
  },
  {
    "name": "FARMACIA SIGURANI & C. SAS",
    "address": "PIAZZA SANTA MARIA 32, SASSARI SS 07100, Italia",
    "lat": 40.7263512,
    "lng": 8.5554162,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7263512,8.5554162"
  },
  {
    "name": "LA NUOVA SANITARIA S.R.L.",
    "address": "Via Galvani, 4/D, MARTINA FRANCA TA 74015, Italia",
    "lat": 40.7066153,
    "lng": 17.3396109,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7066153,17.3396109"
  },
  {
    "name": "FARMACIA F.LLI MARCIANI DR. MARCELLO",
    "address": "PIAZZA PLEBISCITO 66, LANCIANO CH 66034, Italia",
    "lat": 42.2310637,
    "lng": 14.3906148,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2310637,14.3906148"
  },
  {
    "name": "FARMACIA SAN GIORGIO PIETRO",
    "address": "Via Poggio, 30, GINOSA TA 74013, Italia",
    "lat": 40.5756683,
    "lng": 16.755025,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5756683,16.755025"
  },
  {
    "name": "BURZONI S.N.C. DI BURZONI M. E MUNDULA C.",
    "address": "Via Vincenzo Fascie, 44-46, SESTRI LEVANTE GE 16039, Italia",
    "lat": 44.2712599,
    "lng": 9.4045433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2712599,9.4045433"
  },
  {
    "name": "PARAFARMACIA ORTOPEDIA DI KONAKOVA TATIANA",
    "address": "Via Bettoja, 87, CALUSO TO 10014, Italia",
    "lat": 45.3069472,
    "lng": 7.8889825,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3069472,7.8889825"
  },
  {
    "name": "OR.ME.SA DI ZAULI MARTINA & CECCARELLI CLAUDIA SNC",
    "address": "Via Liri, 56, GROSSETO GR 58100, Italia",
    "lat": 42.7644374,
    "lng": 11.1202666,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7644374,11.1202666"
  },
  {
    "name": "FARMACIA SARLO SRL",
    "address": "VIA FRATELLI BANDIERA, 67/1, COLLE DI VAL D'ELSA - Gracciano di colle val d'elsa SI 53034, Italia",
    "lat": 43.3961969,
    "lng": 11.1320959,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3961969,11.1320959"
  },
  {
    "name": "PARAFARMACIA IL FARO DEL BENESSERE",
    "address": "Via Amendola 220, LA SPEZIA SP 19122, Italia",
    "lat": 44.0692895,
    "lng": 9.9665342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0692895,9.9665342"
  },
  {
    "name": "SISTEMI ORTOPEDICI DI BLASI DI MARCELLO DI BLASI",
    "address": "Corso Calatafimi, 610/614, PALERMO PA 90129, Italia",
    "lat": 38.1071458,
    "lng": 13.3403804,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1071458,13.3403804"
  },
  {
    "name": "FARMACIA MACARIO SNC di MACARIO LUCILLA e GRAGLIA MARIA LUISA",
    "address": "Piazza Garibaldi, 1, LAIGUEGLIA SV 17053, Italia",
    "lat": 43.9796099,
    "lng": 8.1588955,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9796099,8.1588955"
  },
  {
    "name": "TANBROWN GENERAL TRADING L.L.C.",
    "address": "5004 West Heights 1 Executive Tower M, Business Bay, PO BOX: 454134, DUBAI 500001, Emirati Arabi Uniti",
    "lat": 25.25809,
    "lng": 55.297558,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=25.25809,55.297558"
  },
  {
    "name": "FARMACIA BUCCI di Deborah Bucci e Pietro Bucci e C. s.n.c.",
    "address": "Piazza Umberto I, 5-6-7, ALANNO PE 65020, Italia",
    "lat": 42.2944897,
    "lng": 13.9714431,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2944897,13.9714431"
  },
  {
    "name": "ORTHOTECNICA DI SCROFANI GIONATA",
    "address": "Viale Lombardia, 7, GALLARATE VA 21013, Italia",
    "lat": 45.6624332,
    "lng": 8.8020915,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6624332,8.8020915"
  },
  {
    "name": "AZIENDA FARMACEUTICA DI CAMERI E TRECATE S.P.A.",
    "address": "Via Novara, 45, CAMERI NO 28062, Italia",
    "lat": 45.5004553,
    "lng": 8.6613798,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5004553,8.6613798"
  },
  {
    "name": "AG.SAN DI AGLIASTRO ROBERTO",
    "address": "Via Virgilio, 111/113, TRAPANI TP 91100, Italia",
    "lat": 38.0162245,
    "lng": 12.5229111,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0162245,12.5229111"
  },
  {
    "name": "CALZATURE DICORATO di DICORATO GIUSEPPE",
    "address": "Corso Garibaldi, 7/9a, BARLETTA BT 76121, Italia",
    "lat": 41.3191627,
    "lng": 16.2821839,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.3191627,16.2821839"
  },
  {
    "name": "FARMACIA DI BARBIANO S.R.L.",
    "address": "Piazza Alberico, 10, COTIGNOLA - Barbiano RA 48010, Italia",
    "lat": 44.3860378,
    "lng": 11.8853803,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3860378,11.8853803"
  },
  {
    "name": "FARMACIA TESTA S.R.L.",
    "address": "Via Diano Castello, 50, DIANO CASTELLO IM 18013, Italia",
    "lat": 43.9188042,
    "lng": 8.0710098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9188042,8.0710098"
  },
  {
    "name": "Farmacia di Pelago del Dott.Vanni Campo e C. sas",
    "address": "Via V.Emanuele,30, PELAGO FI 50060, Italia",
    "lat": 43.7718458,
    "lng": 11.5042249,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7718458,11.5042249"
  },
  {
    "name": "Orthocare di Calà Campana Andrea",
    "address": "Via Garibaldi 101, Adrano CT 95031, Italia",
    "lat": 37.6656933,
    "lng": 14.836878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6656933,14.836878"
  },
  {
    "name": "DOTTORBIANCHI DI FABIO BIANCHI",
    "address": "Via Genova, 159, ALESSANDRIA - Spinetta marengo AL 15100, Italia",
    "lat": 44.8852056,
    "lng": 8.6811322,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8852056,8.6811322"
  },
  {
    "name": "REHA GROUP SRL",
    "address": "Via Emanuele carnevale 75, ROMA RM 00173, Italia",
    "lat": 41.8498199,
    "lng": 12.6034611,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8498199,12.6034611"
  },
  {
    "name": "SPORT SANIT S.R.L.S",
    "address": "Via Cristoforo Colombo 10, SAN NICOLO A TORDINO TE 64100, Italia",
    "lat": 42.6870112,
    "lng": 13.7745805,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6870112,13.7745805"
  },
  {
    "name": "ORTOPEDIA CARAVAGGIO SRL",
    "address": "Via Accademia degli agiati 75, ROMA RM 00147, Italia",
    "lat": 41.8496957,
    "lng": 12.4916871,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8496957,12.4916871"
  },
  {
    "name": "FARMACIA VILLA SRL",
    "address": "Piazza Arborea 5, SAN PANTALEO SS 07026, Italia",
    "lat": 41.046606,
    "lng": 9.4679653,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.046606,9.4679653"
  },
  {
    "name": "FARMACIA FALCHETTI SAS DELLA DR.SSA FRANCESCA MARIA FALCHETTI & C.",
    "address": "Via Vittorio Veneto, 32, CASTIGLIONE DELLA PESCAIA GR 58043, Italia",
    "lat": 42.7625548,
    "lng": 10.8781543,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7625548,10.8781543"
  },
  {
    "name": "FARMACIA FERRO SNC",
    "address": "Via Principe Amedeo, 19, PARTINICO PA 90047, Italia",
    "lat": 38.0505257,
    "lng": 13.1143924,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0505257,13.1143924"
  },
  {
    "name": "FARMACIA CARIOLI",
    "address": "Via E. Farini, 83, RAVENNA - San pietro in vincoli RA 48100, Italia",
    "lat": 44.2999897,
    "lng": 12.1463994,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2999897,12.1463994"
  },
  {
    "name": "FARMACIA SALA di Costante Barducci e Milena Barchi s.n.c.",
    "address": "Via Campone Sala, 387, CESENATICO - Sala FC 47042, Italia",
    "lat": 44.1533839,
    "lng": 12.3838647,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1533839,12.3838647"
  },
  {
    "name": "FARMACIA DELLE FONTI s.r.l.",
    "address": "Piazza A. Colitto, 5, BERTINORO - Fratta terme FC 47032, Italia",
    "lat": 44.143856,
    "lng": 12.101718,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.143856,12.101718"
  },
  {
    "name": "ABSA DI MANASSERO GABRIELE E C. SNC",
    "address": "Via Mombasiglio, 55/B, TORINO TO 10136, Italia",
    "lat": 45.0492357,
    "lng": 7.6428163,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0492357,7.6428163"
  },
  {
    "name": "FARMACIA SIAGURA DOTT. LUIGI",
    "address": "Via Dante, 59, PALERMO PA 90141, Italia",
    "lat": 38.1238328,
    "lng": 13.3507181,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1238328,13.3507181"
  },
  {
    "name": "FARMACIA OFFISANA S.R.L.",
    "address": "VIALE TRENTO 8 , SASSARI  SS 07100, Italia",
    "lat": 40.7259607,
    "lng": 8.5669979,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.7259607,8.5669979"
  },
  {
    "name": "CENTRO ORTOPEDICO FERRANTI - GRUPPO VIVITOP S.R.L.",
    "address": "Via dei Nebrodi, 29, PALERMO PA 90144, Italia",
    "lat": 38.1459888,
    "lng": 13.3317212,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1459888,13.3317212"
  },
  {
    "name": "CALZATURE E PELLETTERIE BIAGIO ELIA s.a.s.",
    "address": "Via Pace, 32/40, COMISO RG 97013, Italia",
    "lat": 36.9451613,
    "lng": 14.6069616,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=36.9451613,14.6069616"
  },
  {
    "name": "Parafarmacia Sanitaria Betti srl",
    "address": "P.zza Ugo Bassi 26, ANCONA AN 60127, Italia",
    "lat": 43.6035474,
    "lng": 13.5067423,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6035474,13.5067423"
  },
  {
    "name": "FARMACIA FERRANDO DI PAGNINI MARCO",
    "address": "Via E. Channoux, 34, CHATILLON AO 11024, Italia",
    "lat": 45.7486312,
    "lng": 7.6103073,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7486312,7.6103073"
  },
  {
    "name": "SUPERMERCATO LE FORNACI SRL",
    "address": "Via XI Settembre, 6/I, GUASTALLA RE 42016, Italia",
    "lat": 44.9109004,
    "lng": 10.6501086,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9109004,10.6501086"
  },
  {
    "name": "La sanitaria di Cagnetta Porzia Ornella",
    "address": "Piazza Garibaldi 19, CASSANO DELLE MURGE BA 70020, Italia",
    "lat": 40.8903397,
    "lng": 16.7689812,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.8903397,16.7689812"
  },
  {
    "name": "PARAFARMACIA BIOFARM",
    "address": "CORSO EUROPA 97/B, VALLEDORIA  SS 07039, Italia",
    "lat": 40.9272412,
    "lng": 8.819914,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9272412,8.819914"
  },
  {
    "name": "FARMACIA DR. PUDDU GIOVANNI ",
    "address": "VIA Z. MULAS 18, ONIFAI  NU 08020, Italia",
    "lat": 40.4049275,
    "lng": 9.6511256,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.4049275,9.6511256"
  },
  {
    "name": "FARMACIA OLBIA SAN NICOLA DI 3D FARM SNC ",
    "address": "VIA PETTA 100, OLBIA  OT 07026, Italia",
    "lat": 40.9325195,
    "lng": 9.4845426,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9325195,9.4845426"
  },
  {
    "name": "FARMACIA SAN NICOLA DI RAFFA GIUSEPPE",
    "address": "Via re Desiderio snc, LONGOBARDI CS 87030, Italia",
    "lat": 44.73323,
    "lng": 10.754238,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.73323,10.754238"
  },
  {
    "name": "ITOP S.P.A. OFFICINE ORTOPEDICHE",
    "address": "Via Prenestina Nuova, 307/A, PALESTRINA RM 00036, Italia",
    "lat": 41.8237252,
    "lng": 12.860232,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8237252,12.860232"
  },
  {
    "name": "MEDICAL RO SNC DI FERRARI C. E ZANINI S.",
    "address": "Corso Sardegna, 265 R, GENOVA GE 16142, Italia",
    "lat": 44.4123088,
    "lng": 8.955393,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4123088,8.955393"
  },
  {
    "name": "CENTRO ORTOPEDICO BIOTECH S.R.L.",
    "address": "Via Soldano Barbera, 23, CAMPOBELLO DI LICATA AG 92023, Italia",
    "lat": 37.2630377,
    "lng": 13.9176528,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.2630377,13.9176528"
  },
  {
    "name": "SANIFARM DI NOCE ANTONELLA",
    "address": "Via Mignardi, 3, VEROLI FR 03029, Italia",
    "lat": 41.6917304,
    "lng": 13.4175041,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6917304,13.4175041"
  },
  {
    "name": "FARMACIA MAZZINI SNC",
    "address": "Via Giuseppe Mazzini, 160, BOLOGNA BO 40139, Italia",
    "lat": 44.4849192,
    "lng": 11.371282,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4849192,11.371282"
  },
  {
    "name": "BIOMEDICA ROMA SRL",
    "address": "Via Silicella, 126, ROMA RM 00169, Italia",
    "lat": 41.860376,
    "lng": 12.5982549,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.860376,12.5982549"
  },
  {
    "name": "LA SANITARIA DI GIANNUZZI LUCIANA",
    "address": "Via Soldato Di Leo    27, CONVERSANO BA 70014, Italia",
    "lat": 40.963303,
    "lng": 17.1112602,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.963303,17.1112602"
  },
  {
    "name": "PARAFARMACIA DE MARE di Antonio Ripa",
    "address": "Via Mantova, snc, TUSCANIA VT 01017, Italia",
    "lat": 42.415652,
    "lng": 11.866938,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.415652,11.866938"
  },
  {
    "name": "FARMACIA FUSTANEO D.SSA MARIA A.",
    "address": "Piazza G. Abbate, 1, LASCARI PA 90010, Italia",
    "lat": 38.0005683,
    "lng": 13.9407152,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0005683,13.9407152"
  },
  {
    "name": "COMUNE DI MARANELLO",
    "address": "Piazza Libertà, 33, MARANELLO MO 41053, Italia",
    "lat": 44.525202,
    "lng": 10.8673841,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.525202,10.8673841"
  },
  {
    "name": "FARMACIA AMADASI SNC DI N.CORBELLI,C.DARDANI",
    "address": "VIA PERTINI 10, PARMA PR 43100, Italia",
    "lat": 44.6999533,
    "lng": 10.354581,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6999533,10.354581"
  },
  {
    "name": "LA FARMACIA DI BORGHETTO SRL",
    "address": "Via Giuseppe Taschini, 11, CIVITA CASTELLANA - Borghetto VT 01033, Italia",
    "lat": 42.342901,
    "lng": 12.455526,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.342901,12.455526"
  },
  {
    "name": "FARMACIA DEL CENTRO S.A.S. di CAMPOREALE CLORINDA",
    "address": "Corso Principe di Piemonte, 4, SABAUDIA LT 04016, Italia",
    "lat": 41.2947933,
    "lng": 13.0138777,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2947933,13.0138777"
  },
  {
    "name": "FARMACIA GUERINO ",
    "address": "VIA NAZIONALE 156, VILLANOVA MONTELEONE  SS 07019, Italia",
    "lat": 40.5013578,
    "lng": 8.4718785,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5013578,8.4718785"
  },
  {
    "name": "ARAS di Virna Francavilla",
    "address": "Viale Abruzzo 181, CHIETI CH 66100, Italia",
    "lat": 42.3403769,
    "lng": 14.1337709,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3403769,14.1337709"
  },
  {
    "name": "PARAFARMACIA DEL GOLFO EMMEDUE sas",
    "address": "Via Aurelia, 55, SAN BARTOLOMEO AL MARE IM 18016, Italia",
    "lat": 43.9201759,
    "lng": 8.0980412,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9201759,8.0980412"
  },
  {
    "name": "ORTHOPEDIC CENTER di Francesco Fantaci & C. s.a.s.",
    "address": "Via dei Quartieri, 1/A, PALERMO PA 90146, Italia",
    "lat": 38.1626017,
    "lng": 13.3280941,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1626017,13.3280941"
  },
  {
    "name": "ORTOPEDIA VICTORIA FD SRL",
    "address": "Via Giulio Petroni, 26, BARI BA 70124, Italia",
    "lat": 41.0915116,
    "lng": 16.865938,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0915116,16.865938"
  },
  {
    "name": "BENESSERE & SALUTE di CURIA DONATELLA",
    "address": "Via Sibari, 1, ROSSANO CS 87067, Italia",
    "lat": 39.5981117,
    "lng": 16.6401967,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.5981117,16.6401967"
  },
  {
    "name": "LA SCARPA di Rivola Beatrice",
    "address": "Via Lunga, 89/D, RAVENNA - Campiano RA 48100, Italia",
    "lat": 44.3189778,
    "lng": 12.231593,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3189778,12.231593"
  },
  {
    "name": "FARMACIA TITONE DR. Nicolò Michele",
    "address": "Piazza Marconi, 66, MARSALA TP 91025, Italia",
    "lat": 37.8025377,
    "lng": 12.4366,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.8025377,12.4366"
  },
  {
    "name": "FARMACIA SAN FRANCESCO SRL ",
    "address": "VIA SENATORE MONNI 2 , NUORO NU 08100, Italia",
    "lat": 40.2780005,
    "lng": 9.3907353,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.2780005,9.3907353"
  },
  {
    "name": "Parafarmacia Sanitaria Dottoressa Melino Lucia",
    "address": "Corso Garibaldi 34 , BITETTO BA 70020, Italia",
    "lat": 41.0352412,
    "lng": 16.7470079,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0352412,16.7470079"
  },
  {
    "name": "GANDALF SRL",
    "address": "Via Fanti D'Italia, 9, LANGHIRANO PR 43013, Italia",
    "lat": 44.6087561,
    "lng": 10.2639531,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6087561,10.2639531"
  },
  {
    "name": "PERFETTA LETIZIA - SOCIETA' COOPERATIVA SOCIALE",
    "address": "Via San Daniele, 58, LONIGO VI 36045, Italia",
    "lat": 45.3867451,
    "lng": 11.3958524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3867451,11.3958524"
  },
  {
    "name": "SANITARIA MAFALDA di Festi Monia",
    "address": "Via di Corticella, 33, BOLOGNA BO 40128, Italia",
    "lat": 44.5147048,
    "lng": 11.3477335,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5147048,11.3477335"
  },
  {
    "name": "ORTOPEDIA BELLARIA sas di BARONI MASSIMO & C.",
    "address": "Via Bellaria, 28/H, BOLOGNA BO 40139, Italia",
    "lat": 44.476848,
    "lng": 11.3862454,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.476848,11.3862454"
  },
  {
    "name": "FARMACIA LENCI S.R.L.",
    "address": "Via Bassa Tambura, 131, MASSA - Canevara MS 54100, Italia",
    "lat": 44.0403639,
    "lng": 10.1403954,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0403639,10.1403954"
  },
  {
    "name": "ORTOPEDIA SOAV",
    "address": "Viale del vignola 17, ROMA RM 00196, Italia",
    "lat": 41.9253693,
    "lng": 12.4661997,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9253693,12.4661997"
  },
  {
    "name": "MAS SPA",
    "address": "Viale Regina Margherita, 158, ROMA RM 00198, Italia",
    "lat": 41.9163995,
    "lng": 12.502426,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9163995,12.502426"
  },
  {
    "name": "FARMACIA CERCONE DOTT.SSA VIRGINIA",
    "address": "Via G. Marconi, 4/B, CAMPO DI GIOVE AQ 67030, Italia",
    "lat": 42.0105903,
    "lng": 14.0441335,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0105903,14.0441335"
  },
  {
    "name": "CASA DELLA GOMMA di Vespignani Gianni",
    "address": "Corso Saffi, 28/A, FAENZA RA 48018, Italia",
    "lat": 44.2851168,
    "lng": 11.8850101,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2851168,11.8850101"
  },
  {
    "name": "FARMACIA SCIARRETTA  DR MARCO PIEDIFERRO",
    "address": "VIA ROMA, 183/189, CASTELLIRI FR 03030, Italia",
    "lat": 41.6772671,
    "lng": 13.5520375,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6772671,13.5520375"
  },
  {
    "name": "RIZZOLLI F. S.R.L.",
    "address": "Via Portici, 60, BOLZANO BZ 39100, Italia",
    "lat": 46.6715117,
    "lng": 11.1635786,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.6715117,11.1635786"
  },
  {
    "name": "Farmácia Gonçalves Sociedade Unipessoal Lda",
    "address": "Avenida Dr. Francisco Sá Carneiro, Bloco A, Oliveira do Hospital 3400-059, Portogallo",
    "lat": 40.3601,
    "lng": -7.857304,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.3601,-7.857304"
  },
  {
    "name": "Farmácia Saúde Lavos, Paula Gonçalves Pereira Lda.",
    "address": "Bairro Alto, Lavos,, Figueira da Foz 3090-452, Portogallo",
    "lat": 40.0866388,
    "lng": -8.8250953,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.0866388,-8.8250953"
  },
  {
    "name": "Farmácia Moderna, Isabel Maria Duarte Coelho da Cunha Unipessoal Lda",
    "address": "Rua Oliveira Matos, 17, Arganil 3300-062, Portogallo",
    "lat": 40.2180017,
    "lng": -8.053994,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.2180017,-8.053994"
  },
  {
    "name": "PARAFARMACIA ROSA-FARM SNC",
    "address": "P.zza Matteotti,1, CERRETO D'ESI AN 60043, Italia",
    "lat": 43.3162272,
    "lng": 12.9860428,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3162272,12.9860428"
  },
  {
    "name": "PARAFARMACIA DOTT.SSA ROBERTA CORONITI",
    "address": "Via Nazionale, SNC, MONTEPAONE CZ 88060, Italia",
    "lat": 38.482869,
    "lng": 16.5781153,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.482869,16.5781153"
  },
  {
    "name": "FARMACIA SAN GIOVANNI DI VITALI SILVIA",
    "address": "Via Gravellone, 1, SAN MARTINO SICCOMARIO PV 27028, Italia",
    "lat": 45.1651675,
    "lng": 9.1399443,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1651675,9.1399443"
  },
  {
    "name": "ORTHOSANITARIA BERNARDINI snc di Bernardini Gianfranco e C.",
    "address": "Via Garibaldi, 8/1, SAN GIORGIO DI PIANO BO 40016, Italia",
    "lat": 44.645706,
    "lng": 11.3766288,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.645706,11.3766288"
  },
  {
    "name": "FARMACIA GUERRA di Guerra Francesca & C. sas",
    "address": "Piazzale Torconca, 18, SAN GIOVANNI IN MARIGNANO RN 47842, Italia",
    "lat": 43.9613463,
    "lng": 12.7293224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9613463,12.7293224"
  },
  {
    "name": "PARAFARMACIA BEHFAR SARA",
    "address": "Strada Maggiore, 28/C-D, BOLOGNA BO 40125, Italia",
    "lat": 44.4930568,
    "lng": 11.3495339,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4930568,11.3495339"
  },
  {
    "name": "FARMACIA DEL SOLE SNC DI COSTANZO A. & DI BIASE C.",
    "address": "Via Trieste, 23/25, PIANELLA - Cerratina PE 65019, Italia",
    "lat": 42.3867081,
    "lng": 14.0948916,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3867081,14.0948916"
  },
  {
    "name": "PARAFARMACIA DEI SERVIZI DI NEBIOSI E BOTTA S.N.C.",
    "address": "Via Camillo Benso Conte di Cavour, 1, VEROLANUOVA BS 25028, Italia",
    "lat": 45.3259973,
    "lng": 10.0749017,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3259973,10.0749017"
  },
  {
    "name": "LA SANITARIA DI GIORGI PATRIZIA e C. SNC",
    "address": "Corso Vendemini, 40, SAVIGNANO SUL RUBICONE FC 47039, Italia",
    "lat": 44.092608,
    "lng": 12.3968551,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.092608,12.3968551"
  },
  {
    "name": "FARMACIA DR. S. SUSTA 60 di Lucilla Cogolli & C. s.n.c.",
    "address": "Via Roma, 36, PASSIGNANO SUL TRASIMENO PG 06065, Italia",
    "lat": 43.1858117,
    "lng": 12.1349497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1858117,12.1349497"
  },
  {
    "name": "FARMACIA SAN CARLO di ALESSANDRA BEGHETTI e DANIELE DE MARCHI s.n.c.",
    "address": "Via San Marco, 45, SASSUOLO MO 41049, Italia",
    "lat": 44.5453086,
    "lng": 10.7940038,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5453086,10.7940038"
  },
  {
    "name": "ORTOPEDIA SALUS di Zuccarello Margherita Roberta",
    "address": "Via De Gasperi, 51, BELLARIA IGEA MARINA RN 47814, Italia",
    "lat": 44.1469231,
    "lng": 12.4567386,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1469231,12.4567386"
  },
  {
    "name": "PARAFARMACIA DI SALICE TERME DI DOTT.SSA MARIANNA GARAVANA",
    "address": "Viale Marconi, 21, GODIASCO - Salice terme PV 27052, Italia",
    "lat": 44.9063522,
    "lng": 9.0338364,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9063522,9.0338364"
  },
  {
    "name": "PARAFARMACIA CANDIAN",
    "address": "Via Mazzini, 9, SANNAZZARO DE' BURGONDI PV 27039, Italia",
    "lat": 45.103286,
    "lng": 8.9064442,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.103286,8.9064442"
  },
  {
    "name": "ORTHOTECNICA DOTT. AMATO LUCIANO S.R.L.",
    "address": "Via Castelvetrano, 27/B, MAZARA DEL VALLO TP 91026, Italia",
    "lat": 37.6501484,
    "lng": 12.5970025,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6501484,12.5970025"
  },
  {
    "name": "CENTRO SERVIZI CLINICA DEL PIEDE",
    "address": "Via Bela Bartok, 24, FERRARA FE 44100, Italia",
    "lat": 44.8163325,
    "lng": 11.5859235,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8163325,11.5859235"
  },
  {
    "name": "FARMACIE COMUNALI DI BRESCIA SPA",
    "address": "Via Achille Grandi, 18, BRESCIA BS 25125, Italia",
    "lat": 45.4704889,
    "lng": 10.5994036,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4704889,10.5994036"
  },
  {
    "name": "AZIENDA SERVIZI FARMACEUTICI S.R.L. - A.S.F. S.R.L.",
    "address": "Via Matteotti, 79, GARDONE VAL TROMPIA BS 25063, Italia",
    "lat": 45.6992219,
    "lng": 10.1899446,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6992219,10.1899446"
  },
  {
    "name": "LA NUOVA FARMACIA DI MIAVALDI E. E UBEZIO L. SNC",
    "address": "Corso Pavia, 73, VIGEVANO PV 27029, Italia",
    "lat": 45.3089248,
    "lng": 8.8658011,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3089248,8.8658011"
  },
  {
    "name": "FARMACIA MORANDI SRL",
    "address": "Via Cesare Battisti, 8, LONATO BS 25017, Italia",
    "lat": 45.4607054,
    "lng": 10.4876885,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4607054,10.4876885"
  },
  {
    "name": "FARMACIA TRONCONI",
    "address": "Via XXV Aprile, 5/1, SECUGNAGO LO 26826, Italia",
    "lat": 45.2298675,
    "lng": 9.5956449,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2298675,9.5956449"
  },
  {
    "name": "ORTOPEDIA SANITARIA S. GIOVANNI SRL",
    "address": "Via Aosta, 40, ROMA RM 00182, Italia",
    "lat": 41.8839843,
    "lng": 12.5148224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8839843,12.5148224"
  },
  {
    "name": "CRISTAL CONSORZIO",
    "address": "Piazza Volontari della Libertà, 8, BUSTO ARSIZIO VA 21052, Italia",
    "lat": 45.6156095,
    "lng": 8.8634193,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6156095,8.8634193"
  },
  {
    "name": "FARMACIA DAVIDI di Felisi Laura",
    "address": "Via C. Battisti, 46, SOMAGLIA LO 26867, Italia",
    "lat": 45.1476938,
    "lng": 9.6392101,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1476938,9.6392101"
  },
  {
    "name": "FARMACIA PIANINI S.A.S.",
    "address": "Piazza Vittorio Emanuele, 18, NOVAFELTRIA RN 47863, Italia",
    "lat": 43.8952685,
    "lng": 12.290296,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8952685,12.290296"
  },
  {
    "name": "ONERACE TECH - LAB SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA",
    "address": "Via Angelo Colombaroli, 22, ROMA RM 00124, Italia",
    "lat": 41.7522142,
    "lng": 12.315904,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7522142,12.315904"
  },
  {
    "name": "BERGAMO SUPERMERCATI s.r.l.",
    "address": "Corso Europa, 10, GHISALBA BG 24050, Italia",
    "lat": 45.5912965,
    "lng": 9.7564848,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5912965,9.7564848"
  },
  {
    "name": "FARMACIA CABRAS SNC ",
    "address": "VIA FRATELLI KENNEDY 10, ALGHERO  SS 07041, Italia",
    "lat": 40.5564055,
    "lng": 8.3159512,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5564055,8.3159512"
  },
  {
    "name": "SAN GIORGIO SERVIZI SRL",
    "address": "Via Legnaghese, 20, MANTOVA MN 46100, Italia",
    "lat": 45.1659939,
    "lng": 10.8348074,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1659939,10.8348074"
  },
  {
    "name": "FARMOGLIASTRA SRL",
    "address": "Corso Umberto, 58, TORTOLI' OG 08048, Italia",
    "lat": 39.9263453,
    "lng": 9.6598431,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9263453,9.6598431"
  },
  {
    "name": "FARMACIA DI CONCESA della Dr.ssa C. Pirola & C. snc",
    "address": "Piazza Cereda, 6, TREZZO SULL'ADDA MI 20056, Italia",
    "lat": 45.6022456,
    "lng": 9.5264201,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6022456,9.5264201"
  },
  {
    "name": "FARMACIA PORTESI di Portesi Nicola & C. s.a.s.",
    "address": "Via IV Novembre, 90, REZZATO BS 25086, Italia",
    "lat": 45.5142514,
    "lng": 10.3158293,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5142514,10.3158293"
  },
  {
    "name": "LA ROCCA SNC DI GRAZIANI MARCO E MICHELE & C.",
    "address": "Via M. Valgimigli, 3/A, BAGNO DI ROMAGNA - San piero in bagno FC 47021, Italia",
    "lat": 43.8554488,
    "lng": 11.9790229,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8554488,11.9790229"
  },
  {
    "name": "SANITARIA VALENTINA di Marano Cristina",
    "address": "Via Tibullo, 70, BELLARIA IGEA MARINA RN 47814, Italia",
    "lat": 44.1313425,
    "lng": 12.4843528,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1313425,12.4843528"
  },
  {
    "name": "FARMACIA MONTE SAN GIOVANNI S.A.S. DOTT.SSA MONDANELLI MARZIA & C.",
    "address": "Via Vicenza, 6, MONTE SAN PIETRO BO 40050, Italia",
    "lat": 44.4136237,
    "lng": 11.1689488,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4136237,11.1689488"
  },
  {
    "name": "ANTICA FARMACIA GHIDINI ANNA",
    "address": "Via Enrico Ferri, 46, SAN BENEDETTO PO MN 46027, Italia",
    "lat": 45.0404579,
    "lng": 10.9290178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0404579,10.9290178"
  },
  {
    "name": "FARMACIA MACULOTTI DOTT. ENRICO",
    "address": "Via Marconi, 24, ANNICCO CR 26021, Italia",
    "lat": 45.2438821,
    "lng": 9.8801001,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2438821,9.8801001"
  },
  {
    "name": "FARMACIA RAIMONDI DI RAIMONDI DOTTOR VIRGINIO & C. SAS",
    "address": "Viale Europa, 34, GORLA MAGGIORE VA 21050, Italia",
    "lat": 45.675256,
    "lng": 8.8947723,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.675256,8.8947723"
  },
  {
    "name": "BUFALINI SRL",
    "address": "Via Pisacane, 56, CESENA FC 47023, Italia",
    "lat": 44.1415501,
    "lng": 12.2380226,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1415501,12.2380226"
  },
  {
    "name": "LA SANITARIA DI CASTEL MAGGIORE DI DORATELLI ADRIANA",
    "address": "Via Gramsci,140, CASTEL MAGGIORE BO 40013, Italia",
    "lat": 44.5740088,
    "lng": 11.3627011,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5740088,11.3627011"
  },
  {
    "name": "FARMACIA ZERBIO DI ANNA E PAOLA ZERBIO SNC",
    "address": "Via Alcide de Gasperi, 74, CASTELCOVATI BS 25030, Italia",
    "lat": 45.5016068,
    "lng": 9.9497884,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5016068,9.9497884"
  },
  {
    "name": "FARMACIA COMUNALE DI VIADANA S.R.L.",
    "address": "Via Alcide de Gasperi, 1/3, VIADANA MN 46019, Italia",
    "lat": 45.3759348,
    "lng": 10.3385101,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3759348,10.3385101"
  },
  {
    "name": "FARMACIA POZZOLO DI MORETTI ARNALDO & C. S.A.S.",
    "address": "Via Roma, 38, MARMIROLO - Pozzolo MN 46045, Italia",
    "lat": 45.3028253,
    "lng": 10.7159042,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3028253,10.7159042"
  },
  {
    "name": "OTTICA MALALAN S.R.L.",
    "address": "Via di Prosecco, 2/B, TRIESTE TS 34151, Italia",
    "lat": 45.6921337,
    "lng": 13.7844525,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6921337,13.7844525"
  },
  {
    "name": "ORTOPEDIA NICOLETTA 3 SNC",
    "address": "Corso Perticari, 95, SAVIGNANO SUL RUBICONE FC 47039, Italia",
    "lat": 44.0930344,
    "lng": 12.403418,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0930344,12.403418"
  },
  {
    "name": "PARODO VIVIANA",
    "address": "Via Alessandro Manzoni,25, NUORO NU 08100, Italia",
    "lat": 40.3203684,
    "lng": 9.3308726,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.3203684,9.3308726"
  },
  {
    "name": "FARMACIA BRESCIANI & C. s.n.c. D.ri G.Bresciani - M.Piccinelli",
    "address": "Via Guglielmo Marconi, 9, SERIATE BG 24068, Italia",
    "lat": 45.6821003,
    "lng": 9.7281911,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6821003,9.7281911"
  },
  {
    "name": "FARMACIA LANDINI GESTIONE EREDITARIA MAURO DI MAURO",
    "address": "VIA AURELIA NORD 10, PISA PI 56122, Italia",
    "lat": 43.7236712,
    "lng": 10.3794057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7236712,10.3794057"
  },
  {
    "name": "PARAFARMACIA LA MELISSA DI CATTAROZZI MELISSA",
    "address": "Via Papa Giovanni XXIII PRESSO CENTRO COMMERCIALE, PERGOLA PU 61045, Italia",
    "lat": 43.493103,
    "lng": 12.776256,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.493103,12.776256"
  },
  {
    "name": "FARMACIA MONTANARA SRL",
    "address": "Viale Lombardia, 41/43, CURTATONE - Montanara MN 46010, Italia",
    "lat": 45.1399061,
    "lng": 10.7275115,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1399061,10.7275115"
  },
  {
    "name": "FARMACIA BARONI DOTTSSA MARIAGRAZIA",
    "address": "Piazza Roma, 15, CASALMAIOCCO LO 26831, Italia",
    "lat": 45.3532914,
    "lng": 9.37335,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3532914,9.37335"
  },
  {
    "name": "FARMILIAGVA S.N.C.",
    "address": "Via Allegretti, 5, CASTELNUOVO RANGONE MO 41051, Italia",
    "lat": 44.5458016,
    "lng": 10.9388976,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5458016,10.9388976"
  },
  {
    "name": "FARMACIA GALASSI S.R.L.",
    "address": "Via Roma, 24, REMEDELLO BS 25010, Italia",
    "lat": 45.2786204,
    "lng": 10.3697322,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2786204,10.3697322"
  },
  {
    "name": "AZIENDA FARMACEUTICA MUNICIPALIZZATA",
    "address": "Piazza Duomo, 25, CREMA CR 26013, Italia",
    "lat": 45.3629824,
    "lng": 9.6871676,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3629824,9.6871676"
  },
  {
    "name": "OFFICINA TECNICA ORTOPEDICA S.R.L.",
    "address": "Via Orosei, 3, CASCINA - Navacchio PI 56023, Italia",
    "lat": 43.6658649,
    "lng": 10.4756583,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6658649,10.4756583"
  },
  {
    "name": "FARMACIA MUCCHIATI DI BUSTO GAROLFO SNC di Prazzini A. & C.",
    "address": "Piazza Concordia, 15, BUSTO GAROLFO MI 20020, Italia",
    "lat": 45.5463785,
    "lng": 8.8829389,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5463785,8.8829389"
  },
  {
    "name": "REGIA FARMACIA DI MONCHIERO LUCA & C. S.A.S.",
    "address": "Via XX Settembre, 87, TORINO TO 10122, Italia",
    "lat": 45.0730728,
    "lng": 7.6844574,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0730728,7.6844574"
  },
  {
    "name": "FARMACIA TERZIOTTI SAS",
    "address": "Via Ugo Ruberti, 14, QUISTELLO MN 46026, Italia",
    "lat": 45.0036608,
    "lng": 10.984999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0036608,10.984999"
  },
  {
    "name": "FARMACIA DEGLI ANGELI DI MATTIOLI DOTTORESSA LUISA",
    "address": "Via Aldrigo, 3, MANTOVA MN 46100, Italia",
    "lat": 45.1552852,
    "lng": 10.752507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1552852,10.752507"
  },
  {
    "name": "RONCADELLE SERVIZI SRL",
    "address": "Via Roma, 13, RONCADELLE BS 25030, Italia",
    "lat": 45.5263304,
    "lng": 10.1487463,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5263304,10.1487463"
  },
  {
    "name": "AGESP ATTIVITA' STRUMENTALI SRL",
    "address": "Via Marco Polo, 12, BUSTO ARSIZIO VA 21052, Italia",
    "lat": 45.6051478,
    "lng": 8.8413555,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6051478,8.8413555"
  },
  {
    "name": "FARMACIA GORNATI DOTT.SSA MARIA GRAZIA",
    "address": "Piazza S. Martino, 9, INVERUNO MI 20010, Italia",
    "lat": 45.5140499,
    "lng": 8.8522121,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5140499,8.8522121"
  },
  {
    "name": "LA SANITARIA SNC DI CANNONE ROSANNA E TARTAGLIA ELISA",
    "address": "Via Cavour, 61, CASTEL SAN PIETRO TERME BO 40024, Italia",
    "lat": 44.3998057,
    "lng": 11.5909067,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3998057,11.5909067"
  },
  {
    "name": "ASET S.P.A.",
    "address": "Via Luigi Einaudi, 1, FANO PU 61032, Italia",
    "lat": 43.801351,
    "lng": 13.0152057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.801351,13.0152057"
  },
  {
    "name": "SANITARIA MEDIKA s.r.l.",
    "address": "Via Vaccarella, 8/B, BARI - Carbonara di bari BA 70131, Italia",
    "lat": 41.0728058,
    "lng": 16.8637664,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0728058,16.8637664"
  },
  {
    "name": "SANITARIA MARINI DI GONNELLI BEATRICE",
    "address": "Via G. Masini, 23/21, CASTELFIORENTINO FI 50051, Italia",
    "lat": 43.6095859,
    "lng": 10.9668135,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6095859,10.9668135"
  },
  {
    "name": "FARMACIA SANTA CHIARA EREDI Dr.ssa MARINA DELORENZI S.A.S.",
    "address": "Via Chiarlone, 52bis, PIANA CRIXIA SV 17058, Italia",
    "lat": 44.485454,
    "lng": 8.3069285,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.485454,8.3069285"
  },
  {
    "name": "IASO FARMACIE MONTI SRL",
    "address": "Via Narni, 23, TERNI TR 05100, Italia",
    "lat": 42.5465088,
    "lng": 12.6173753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5465088,12.6173753"
  },
  {
    "name": "TECNOSANITARIA di Lambrughi Carola e C. sas",
    "address": "Via Santa Valeria, 57, SEREGNO MB 20831, Italia",
    "lat": 45.6532237,
    "lng": 9.1967573,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6532237,9.1967573"
  },
  {
    "name": "FARMACIE VITTORIA SRL",
    "address": "Via Enrico Ferri, 6, SAN BENEDETTO PO MN 46027, Italia",
    "lat": 45.0404579,
    "lng": 10.9290178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0404579,10.9290178"
  },
  {
    "name": "FARMACIA CENTRALE DI BREVIGLIERI PIETRO E ILARIA S.A.S.",
    "address": "VIA GIUSEPPE GARIBALDI, 1/B, SUZZARA MN 46029, Italia",
    "lat": 44.9870955,
    "lng": 10.7546228,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9870955,10.7546228"
  },
  {
    "name": "SANITAS 3.0 SRLS",
    "address": "Piazza. Ludovico. Ariosto   13, LECCE LE 73100, Italia",
    "lat": 40.3582255,
    "lng": 18.1793845,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.3582255,18.1793845"
  },
  {
    "name": "Centro Servizi Ortopedici Gavardo di Bassi Viola",
    "address": "Via G. Falcone,10, GAVARDO BS 25085, Italia",
    "lat": 45.5910407,
    "lng": 10.4407241,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5910407,10.4407241"
  },
  {
    "name": "FORLIFARMA S.P.A.",
    "address": "Via Passo Buole, 54, FORLI' FC 47122, Italia",
    "lat": 44.2319499,
    "lng": 12.0459163,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2319499,12.0459163"
  },
  {
    "name": "FARMACIA BERNI SNC di BERNI F. e BERNI N.",
    "address": "Via XX Settembre, 11, MOGLIA MN 46024, Italia",
    "lat": 44.9319496,
    "lng": 10.9120086,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9319496,10.9120086"
  },
  {
    "name": "FARMACIA DOTT.SSA OTTAVIA SCIARRILLO",
    "address": "Via Ascoli Piceno, 23, ANCONA AN 60126, Italia",
    "lat": 43.6007055,
    "lng": 13.5045529,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6007055,13.5045529"
  },
  {
    "name": "FARMACIA PETRACCI del Dr. Marco Petracci",
    "address": "Viale Piave, 6, MACERATA MC 62100, Italia",
    "lat": 43.2977141,
    "lng": 13.4535229,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2977141,13.4535229"
  },
  {
    "name": "SANITARIA ELLE di Nordi Noemi",
    "address": "Viale Giosuè Carducci, 86, COMACCHIO - Lido degli estensi FE 44029, Italia",
    "lat": 44.6680511,
    "lng": 12.2432916,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6680511,12.2432916"
  },
  {
    "name": "PARAFARMACIA 23 DELLA DOTT.SSA TEODORI VALENTINA",
    "address": "Via Faleriense Ovest, 21, MONTEGIORGIO FM 63833, Italia",
    "lat": 43.1132221,
    "lng": 13.5633428,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1132221,13.5633428"
  },
  {
    "name": "FARMACIA PIANO MARINA SNC",
    "address": "Via Indipendenza, 1/A, MONDOLFO - Marotta PU 61037, Italia",
    "lat": 43.759212,
    "lng": 13.153462,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.759212,13.153462"
  },
  {
    "name": "FARMACIA CRUDI S.N.C.",
    "address": "Corso Roma, 87, LUNANO PU 61026, Italia",
    "lat": 43.7281276,
    "lng": 12.4404815,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7281276,12.4404815"
  },
  {
    "name": "FARMACIA OSPEDALE SRL",
    "address": "CORSO BONOMELLI SILVIO 138, ROVATO BS 25038, Italia",
    "lat": 45.5683145,
    "lng": 9.999886,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5683145,9.999886"
  },
  {
    "name": "ORTOPEDIA MORETTI s.r.l.",
    "address": "Corso XXVI Febbraio, 2, AOSTA AO 11100, Italia",
    "lat": 45.7405542,
    "lng": 7.3169717,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7405542,7.3169717"
  },
  {
    "name": "FARMACIA FORNACI SRL",
    "address": "Via Adelaide Malanotte,4, BRESCIA BS 25131, Italia",
    "lat": 45.5035018,
    "lng": 10.1732759,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5035018,10.1732759"
  },
  {
    "name": "LA PARAFARMACIA DEL CORSO KT. V.",
    "address": "CORSO GIACOMO MATTEOTTI 33, TEMPIO PAUSANIA  SS 07029, Italia",
    "lat": 40.9012067,
    "lng": 9.1040856,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9012067,9.1040856"
  },
  {
    "name": "CENTRO ORTOPEDICO LIVORNESE SAS M.VENTURI DE VINCENZO BARBARA",
    "address": "Via Roma, 1H, LIVORNO LI 57126, Italia",
    "lat": 43.5423815,
    "lng": 10.3131998,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5423815,10.3131998"
  },
  {
    "name": "ORTOPEDIA SANITARIA SAN LORENZO SRL",
    "address": "Via Bandini, 12, BORGO SAN LORENZO FI 50032, Italia",
    "lat": 43.954257,
    "lng": 11.3872174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.954257,11.3872174"
  },
  {
    "name": "FARMACIA SOLZI SRL",
    "address": "Via Barbò, 40, SORESINA CR 26015, Italia",
    "lat": 45.2844495,
    "lng": 9.8535237,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2844495,9.8535237"
  },
  {
    "name": "FARMACIA BONFANTI DOTT.SSA ANTONELLA",
    "address": "Via Castello, 1, PIZZIGHETTONE CR 26026, Italia",
    "lat": 45.1864702,
    "lng": 9.7812714,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1864702,9.7812714"
  },
  {
    "name": "PARAFARMACIA DEL PRATELLO DI CAVALIERI DANIELA",
    "address": "Via S. Maria in Pratello, 4/A, PAULLO MI 20067, Italia",
    "lat": 45.4159968,
    "lng": 9.4027807,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4159968,9.4027807"
  },
  {
    "name": "FARMACIA CROCE DI DOTT.SSA PASOTTI MARGHERITA",
    "address": "Via Vallone, 2, CASTELLETTO DI BRANDUZZO PV 27040, Italia",
    "lat": 45.0705334,
    "lng": 9.1018006,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0705334,9.1018006"
  },
  {
    "name": "FARMACIA BIELLI DOTT. RENATA",
    "address": "VIA XX SETTEMBRE 1, CANELLI AT 14053, Italia",
    "lat": 44.7193325,
    "lng": 8.2866678,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7193325,8.2866678"
  },
  {
    "name": "LABOR. ORTOPEDICO GIORGIONE SRL",
    "address": "Piazza della serenissima,70, CASTELFRANCO VENETO TV 31033, Italia",
    "lat": 45.6831656,
    "lng": 11.9418111,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6831656,11.9418111"
  },
  {
    "name": "ORTOPEDIA SANITARIA LUPPI SNC di Bonaga Marco",
    "address": "Via Mentana, 11/13, BUDRIO BO 40054, Italia",
    "lat": 44.5383822,
    "lng": 11.5371024,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5383822,11.5371024"
  },
  {
    "name": "MONTICHIARI MULTISERVIZI S.R.L.",
    "address": "Piazza Senatore Mario Pedini n.1, MONTICHIARI BS 25018, Italia",
    "lat": 45.417836,
    "lng": 10.404553,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.417836,10.404553"
  },
  {
    "name": "FARMACIA ROTELLI DELLA DOTT.SSA ALESSANDRA ROTELLI - S.R.L.",
    "address": "Via Guglielmo Marconi, 8, CENE BG 24020, Italia",
    "lat": 45.7811823,
    "lng": 9.8268719,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7811823,9.8268719"
  },
  {
    "name": "FARMACIA FULGARO S.R.L.",
    "address": "VIA DANTE ALIGHIERI 183, SAREZZO BS 25068, Italia",
    "lat": 45.6680419,
    "lng": 10.1918463,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6680419,10.1918463"
  },
  {
    "name": "FARMABIOTICA S.R.L.",
    "address": "Via della Querciola, 45, SESTO FIORENTINO FI 50019, Italia",
    "lat": 43.8345145,
    "lng": 11.1888659,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8345145,11.1888659"
  },
  {
    "name": "FARMACIA BIANCHI S.A.S. DI BIANCHI CLARA E CIOCCA ANDREA",
    "address": "Via Roma, 73/b, TREVIOLO BG 24048, Italia",
    "lat": 45.6712965,
    "lng": 9.6105395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6712965,9.6105395"
  },
  {
    "name": "FARMACIE MARCONI SRL",
    "address": "Viale Città D'Europa, 618, ROMA RM 00144, Italia",
    "lat": 41.8196385,
    "lng": 12.4469083,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8196385,12.4469083"
  },
  {
    "name": "FARMACIA MINELLI DEL DR. GIANCARLO MINELLI & C. S.N.C.",
    "address": "VIA STATALE 94, TOSCOLANO MADERNO BS 25088, Italia",
    "lat": 45.6564684,
    "lng": 10.6355076,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6564684,10.6355076"
  },
  {
    "name": "FARMACIA GANDOLFI S.N.C.",
    "address": "Via Monsignor Antonio Novasconi, 1, CASTIGLIONE D'ADDA LO 26823, Italia",
    "lat": 45.2197712,
    "lng": 9.6927503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2197712,9.6927503"
  },
  {
    "name": "FARMACIA CONSUMATI ILARIA",
    "address": "Via del Porto, 5, FORANO - Gavignano sabino RI 02044, Italia",
    "lat": 42.28958,
    "lng": 12.57106,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.28958,12.57106"
  },
  {
    "name": "F.CIA PROVENZANO GABRIELLA CARMELA",
    "address": "Piazza Vittorio Emanuele, 9/10, FORANO RI 02044, Italia",
    "lat": 37.2734486,
    "lng": 14.7940221,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.2734486,14.7940221"
  },
  {
    "name": "FARMACIA GIOVANNETTI FABIO",
    "address": "Via Salaria KM. 63,900, TORRICELLA IN SABINA RI 02030, Italia",
    "lat": 42.279178,
    "lng": 12.84661,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.279178,12.84661"
  },
  {
    "name": "PARAFARMACIA ERBORISTERIA DE MATERIA MEDICA DR. ENRICO D'ALBERTI",
    "address": "Via Gabriello Chiabrera, 41/43, ROMA RM 00145, Italia",
    "lat": 41.8547562,
    "lng": 12.4794468,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8547562,12.4794468"
  },
  {
    "name": "ORTOPEDIA SANITARIA ARDENZA DI BUSONI IRENE",
    "address": "Via del Mare, 81, LIVORNO LI 57128, Italia",
    "lat": 43.5169994,
    "lng": 10.3208395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5169994,10.3208395"
  },
  {
    "name": "FARMACIA BERETTA DI BERETTA MARIO",
    "address": "Via g. Verdi 5, PADENGHE SUL GARDA BS 25080, Italia",
    "lat": 45.508231,
    "lng": 10.5076407,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.508231,10.5076407"
  },
  {
    "name": "FARMACIA LE MAGNOLIE S.R.L.",
    "address": "Via Cassia, 1277/C (Ang. Via Piccinini), ROMA RM 00135, Italia",
    "lat": 41.864296,
    "lng": 12.6344568,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.864296,12.6344568"
  },
  {
    "name": "SANITARIA ALTEDO di Minghini Roberta",
    "address": "Piazza della Pace, 5/C, MALALBERGO - Altedo BO 40051, Italia",
    "lat": 44.6675823,
    "lng": 11.488184,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6675823,11.488184"
  },
  {
    "name": "F.CIA S. BERNARDINO SAS DI RIVA S. E MAZZOLA D'AURIA M.",
    "address": "VIA SAN BERNARDINO 16, FROSSASCO TO 10060, Italia",
    "lat": 44.9339979,
    "lng": 7.3494776,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9339979,7.3494776"
  },
  {
    "name": "MEDICAL TREND ITALIA SRLS",
    "address": "Via Cesare Pavese, 8, SANTARCANGELO DI ROMAGNA RN 47822, Italia",
    "lat": 44.0677245,
    "lng": 12.4459676,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0677245,12.4459676"
  },
  {
    "name": "AMISI - SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA",
    "address": "Via Gregorio VII, 95, ROMA RM 00165, Italia",
    "lat": 41.8936908,
    "lng": 12.4333763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8936908,12.4333763"
  },
  {
    "name": "ESMERALDA S.R.L. ",
    "address": "CORSO GARIBALDI 22, ARZACHENA  SS 07021, Italia",
    "lat": 41.081318,
    "lng": 9.3881464,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.081318,9.3881464"
  },
  {
    "name": "A&G CALZATURE  SRL",
    "address": "Via F. Santi, 22, TOSCANELLA DI DOZZA BO 40060, Italia",
    "lat": 44.3797227,
    "lng": 11.6477386,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3797227,11.6477386"
  },
  {
    "name": "COOPERATIVA SOCIALE STATALE 9 VIA EMILIA",
    "address": "Via P. Nenni 6 L, IMOLA BO 40026, Italia",
    "lat": 44.3795344,
    "lng": 11.7281445,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3795344,11.7281445"
  },
  {
    "name": "FRAVALOR S.N.C.",
    "address": "Via Ariana 216, VELLETRI RM 00049, Italia",
    "lat": 41.699912,
    "lng": 12.7982136,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.699912,12.7982136"
  },
  {
    "name": "PARAFARMACIA SAN FRANCESCO DI F.CAMMARELLA E M. VOMMARO SNC",
    "address": "Via Sant’Agata, 83, PAOLA CS 87027, Italia",
    "lat": 39.3712165,
    "lng": 16.0278228,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.3712165,16.0278228"
  },
  {
    "name": "PARAFARMACIA VITAPHARM S.N.C.",
    "address": "Via Nazionale, snc, BONIFATI - Cittadella del capo CS 87020, Italia",
    "lat": 39.623072,
    "lng": 15.9845,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.623072,15.9845"
  },
  {
    "name": "SANITARIA SAN DONATO FERRISE MARIA",
    "address": "Via Bettini,3g, GRANAROLO DELL'EMILIA - Quarto inferiore BO 40057, Italia",
    "lat": 44.5273213,
    "lng": 11.4226023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5273213,11.4226023"
  },
  {
    "name": "FARMACIA DONEDA di DONEDA MARIA ANGELA SNC",
    "address": "Piazza Castello, 34, AGNADELLO CR 26020, Italia",
    "lat": 45.4447013,
    "lng": 9.5584205,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4447013,9.5584205"
  },
  {
    "name": "FARMACIA ALBINO BIANCHI SRL",
    "address": "Via Vittorio Veneto, 99, CROTONE KR 88900, Italia",
    "lat": 39.0790443,
    "lng": 17.124093,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.0790443,17.124093"
  },
  {
    "name": "FARMA CHIMIFARM SRL",
    "address": "Via Plateia  67, Taranto  TA 74121, Italia",
    "lat": 40.4651715,
    "lng": 17.2629385,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.4651715,17.2629385"
  },
  {
    "name": "A&M OFFICINE DI ANNALISA PALUMBO",
    "address": "Viale Venezia Giulia  196/B, Andria  BT 76123, Italia",
    "lat": 41.2324879,
    "lng": 16.2976556,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.2324879,16.2976556"
  },
  {
    "name": "FARMACIA COOPERATIVA MANTOVANA",
    "address": "Via Giuseppe Verdi 58, MANTOVA MN 46100, Italia",
    "lat": 45.159558,
    "lng": 10.7926005,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.159558,10.7926005"
  },
  {
    "name": "SANITARIA ORTOPEDIA EUR PAVESE S.R.L.",
    "address": "Viale Cesare Pavese, 431, ROMA RM 00144, Italia",
    "lat": 41.8193317,
    "lng": 12.4675484,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8193317,12.4675484"
  },
  {
    "name": "FARMACIA BRANDI S.R.L.",
    "address": "Via Daniele Manin, 84, BAGNO DI ROMAGNA FC 47021, Italia",
    "lat": 43.8359595,
    "lng": 11.9602703,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8359595,11.9602703"
  },
  {
    "name": "FARMACIA LA PARADISA DI GIUSEPPE E ANTONELLA ROSSI SNC",
    "address": "VIA F. NICOLAI,46, CAPRAROLA VT 01032, Italia",
    "lat": 42.3275083,
    "lng": 12.2384279,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3275083,12.2384279"
  },
  {
    "name": "FARMACIA RICCI SRL",
    "address": "PIAZZA COLA DI RIENZO, 31, ROMA RM 00192, Italia",
    "lat": 41.9084826,
    "lng": 12.4676527,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9084826,12.4676527"
  },
  {
    "name": "ORTOPEDIA SANITARIA RIZZOLI ROBERTO SRL",
    "address": "Via settembrini,4/b, Rimini RN 47923, Italia",
    "lat": 43.9755242,
    "lng": 12.6944441,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9755242,12.6944441"
  },
  {
    "name": "CALZOLERIA MODERNA SAS DI GRADI FIORETTA & C.",
    "address": "Via Garibaldi,68/A, COPPARO FE 44034, Italia",
    "lat": 44.894727,
    "lng": 11.8317505,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.894727,11.8317505"
  },
  {
    "name": "FARMACIA GELLINI DELLA DR.SSA FABRO CRISTINA",
    "address": "Corso Italia, 100, ROMA RM 00198, Italia",
    "lat": 41.9103074,
    "lng": 12.5003241,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9103074,12.5003241"
  },
  {
    "name": "FARMACIA SAN GIUSTO S.R.L.",
    "address": "Via di Boccea, 488/A, ROMA RM 00166, Italia",
    "lat": 41.9136609,
    "lng": 12.3894586,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9136609,12.3894586"
  },
  {
    "name": "FARMACIA JUNGANO S.N.C. della Dr.ssa MARIA VITA JUNGANO & C.",
    "address": "Via della Pisana, 116/M, ROMA RM 00163, Italia",
    "lat": 41.8807807,
    "lng": 12.4172612,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8807807,12.4172612"
  },
  {
    "name": "SANITARIA ORTOPEDIA DI TAZZARI ELENA",
    "address": "Via Matteotti ,22, BAGNACAVALLO RA 48012, Italia",
    "lat": 44.4159588,
    "lng": 11.9786188,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4159588,11.9786188"
  },
  {
    "name": "FARMACIA BENSO DR.SSA ANTONELLA",
    "address": "Piazza Manzini, 5, CASTELL'ALFERO AT 14033, Italia",
    "lat": 44.9824812,
    "lng": 8.2090158,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9824812,8.2090158"
  },
  {
    "name": "ERBORISTERIA SANITARIA ARTEMISIA DI BANZOLA SILVIA",
    "address": "Corso sforza 46, COTIGNOLA RA 48010, Italia",
    "lat": 44.3842749,
    "lng": 11.9417639,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3842749,11.9417639"
  },
  {
    "name": "FARMACIA DOTT.SSA CLAUDIA MUSSIO & C. SAS",
    "address": "Via Giacomo Matteotti ,43, MAIRANO BS 25030, Italia",
    "lat": 45.44831,
    "lng": 10.0791571,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.44831,10.0791571"
  },
  {
    "name": "STORICHE FARMACIE DI GUSSAGO TOSINI E ANTONELLI SNC",
    "address": "Via Peracchia 4/C, GUSSAGO BS 25064, Italia",
    "lat": 45.5922216,
    "lng": 10.1532584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5922216,10.1532584"
  },
  {
    "name": "FARMACIA LAMBERTI DI BRUSCHI D.SSA ANGELA",
    "address": "Via S.Allende,8, SAN GIOVANNI DEL DOSSO MN 46020, Italia",
    "lat": 44.9661795,
    "lng": 11.0811882,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9661795,11.0811882"
  },
  {
    "name": "FARMACIA ROSSI DOTT.SSA ROBERTA SRL",
    "address": "Via Manzoni,  166, LENO - Castelletto BS 25024, Italia",
    "lat": 45.3286145,
    "lng": 10.239695,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3286145,10.239695"
  },
  {
    "name": "SANI'TARJO SRLS",
    "address": "Via Alessandro Turco, 45, CATANZARO CZ 88051, Italia",
    "lat": 38.9111031,
    "lng": 16.585518,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.9111031,16.585518"
  },
  {
    "name": "NUOVA ORTOPEDIA SRL",
    "address": "Via Sibari 12, MELITO DI PORTO SALVO RC 89063, Italia",
    "lat": 37.9182838,
    "lng": 15.7862967,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.9182838,15.7862967"
  },
  {
    "name": "MANESCHI SRL",
    "address": "Via Lauretana, 17, CORTONA - Camucia AR 52044, Italia",
    "lat": 43.2598036,
    "lng": 11.9743476,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2598036,11.9743476"
  },
  {
    "name": "FARMACIA COMUNALE DI BEDIZZOLE",
    "address": "Via monsignor A.bontacchio ,5, BEDIZZOLE BS 25081, Italia",
    "lat": 45.5127744,
    "lng": 10.4190588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5127744,10.4190588"
  },
  {
    "name": "ORTOPEDIA S.N.C. DI LUISE SILIO & C.",
    "address": "Via Nazionale, 87D, CORIGLIANO CALABRO CS 87064, Italia",
    "lat": 39.595173,
    "lng": 16.5175366,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.595173,16.5175366"
  },
  {
    "name": "SANITARIA COVELLO GIANFRANCO",
    "address": "Via A. Manzoni 121, MONTALTO UFFUGO CS 87046, Italia",
    "lat": 39.4297667,
    "lng": 16.2213298,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.4297667,16.2213298"
  },
  {
    "name": "IGEA SANITARIA DI TROVATO MARIA GRAZIA",
    "address": "Via Sila, 16, SERSALE CZ 88054, Italia",
    "lat": 39.0087535,
    "lng": 16.7377066,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.0087535,16.7377066"
  },
  {
    "name": "FARMACIA IL PALAGIO S.N.C.",
    "address": "Via Volta Prata, 66, CAMPI BISENZIO FI 50013, Italia",
    "lat": 43.8190429,
    "lng": 11.1223486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8190429,11.1223486"
  },
  {
    "name": "LA SANITARIA ORTOPEDICA DI TANINI MARCELLO",
    "address": "Via Madonna del Rivaio, 120/B, CASTIGLION FIORENTINO AR 52043, Italia",
    "lat": 43.3446009,
    "lng": 11.918969,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3446009,11.918969"
  },
  {
    "name": "ORTHOPEDIA DI CANCLINI LORENA",
    "address": "Via Galileo Galilei, 12, BORMIO SO 23032, Italia",
    "lat": 46.4685454,
    "lng": 10.3737154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4685454,10.3737154"
  },
  {
    "name": "FARMACIA SANTA ROSALIA DELLE DOTT.SSE TROJA ELISABETTA E LUCIA SNC",
    "address": "Via M.Chiesa, 9, SANTO STEFANO QUISQUINA AG 92020, Italia",
    "lat": 37.6233842,
    "lng": 13.4912212,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.6233842,13.4912212"
  },
  {
    "name": "SANITARIA CENTRALE DI ANGELA FORNASARI DI MURATORI GIOVANNI",
    "address": "Via Merenda, 11, FORLI' FO 47121, Italia",
    "lat": 44.2210788,
    "lng": 12.0385968,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2210788,12.0385968"
  },
  {
    "name": "NUOVA FARMACIA MIRTENSE DEL DR. IWAN DONATEO & C. S.A.S.",
    "address": "Via G. Matteotti, 11, POGGIO MIRTETO RI 02047, Italia",
    "lat": 42.2657099,
    "lng": 12.6855271,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2657099,12.6855271"
  },
  {
    "name": "RC BIO DOTT.SSA CORSI RITA",
    "address": "Via Nazionale snc, CROPANI - Cropani marina CZ 88050, Italia",
    "lat": 39.018844,
    "lng": 16.742348,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.018844,16.742348"
  },
  {
    "name": "FARMASERVICE SRL A SOCIO UNICO",
    "address": "Via G. Cantafio, 13, CATANZARO CZ 88100, Italia",
    "lat": 38.974077,
    "lng": 16.5280064,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.974077,16.5280064"
  },
  {
    "name": "FARMACIA BONVINI DR.SSA BEATRICE CANTONI",
    "address": "Via Papa Giovanni XXIII, 17, MOZZANICA BG 24050, Italia",
    "lat": 45.4804721,
    "lng": 9.6868105,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4804721,9.6868105"
  },
  {
    "name": "FARMACIA DELLA VIA APPIA DEL DOTTOR CELADON MICHELE E C. S.A.S.",
    "address": "Via Appia n.24/B, IMOLA BO 40026, Italia",
    "lat": 44.3543138,
    "lng": 11.7147242,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3543138,11.7147242"
  },
  {
    "name": "CAMMARERI E BARDELLI SNC DI AMALIA CAMMARERI E GRETA BARDELLI",
    "address": "Via Quarantadue Martiri, 107, VERBANIA VB 28924, Italia",
    "lat": 45.9456463,
    "lng": 8.4905521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9456463,8.4905521"
  },
  {
    "name": "FARMACIA DR. RANIERI DI LIMONTA RANIERI & C. SAS",
    "address": "Via Pio XI, 2, RONCO BRIANTINO MB 20885, Italia",
    "lat": 45.6675726,
    "lng": 9.3981646,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6675726,9.3981646"
  },
  {
    "name": "FARMACIA BRAGUTI S.N.C. DI FRANCESCA BRAGUTI E GIULIA CAPORICCIO",
    "address": "Via Verentana, 8, MONTEFIASCONE VT 01027, Italia",
    "lat": 42.5396314,
    "lng": 12.0338114,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5396314,12.0338114"
  },
  {
    "name": "MCM SAS DEL DR.GIULIO CAMANZI & C.",
    "address": "Via Garibaldi,53, CONSELICE RA 48017, Italia",
    "lat": 44.5138185,
    "lng": 11.8294141,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5138185,11.8294141"
  },
  {
    "name": "FARMACIA PICCIOLO DI ITALIANO MARIA LAURA S.N.C",
    "address": "Via Rossini 12 A/C, ALBANO LAZIALE RM 00041, Italia",
    "lat": 41.7255612,
    "lng": 12.6555414,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7255612,12.6555414"
  },
  {
    "name": "FARMACIA ORMEA DEI DR.RI MARIELLA E GIAN BATTISTA ORMEA - S.N.C.",
    "address": "Via Salaria, 84/86, ROMA RM 00198, Italia",
    "lat": 41.9164546,
    "lng": 12.4968812,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9164546,12.4968812"
  },
  {
    "name": "FARMACIA LE TORRETTE S.R.L.",
    "address": "Via Guglielmo Marconi, 39/N, RANICA BG 24020, Italia",
    "lat": 45.72567,
    "lng": 9.719083,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.72567,9.719083"
  },
  {
    "name": "SI.VI. FARMA S.R.L.",
    "address": "Viale XI Febbraio, 2, PAVIA PV 27100, Italia",
    "lat": 45.1897507,
    "lng": 9.1561156,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1897507,9.1561156"
  },
  {
    "name": "SANITARIA DI ZOEDDU PAOLO",
    "address": "Via Garibaldi, 105, AREZZO AR 52100, Italia",
    "lat": 43.5507255,
    "lng": 11.5861944,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.5507255,11.5861944"
  },
  {
    "name": "DESENZANO AZIENDA SPECIALE SERVIZI",
    "address": "Via Eridio, 2, DESENZANO DEL GARDA BS 25015, Italia",
    "lat": 45.4634474,
    "lng": 10.5519657,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4634474,10.5519657"
  },
  {
    "name": "FARMACIA DESPALJ S.R.L.",
    "address": "Viale paolo VI , 16, AZZANO MELLA BS 25020, Italia",
    "lat": 45.457946,
    "lng": 10.1102329,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.457946,10.1102329"
  },
  {
    "name": "PARAFARMACIA SANITARIA ORTOPEDIA DOTT.SSA MERLO DI MERLO FRANCESCA",
    "address": "Via del Troi 39, PORDENONE PN 33170, Italia",
    "lat": 45.9696828,
    "lng": 12.6348051,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9696828,12.6348051"
  },
  {
    "name": "SANITARIA VIALARGA S.R.L. - UNIPERSONALE",
    "address": "VIA G. GARIBALDI 16, SASSO MARCONI BO 40037, Italia",
    "lat": 44.396413,
    "lng": 11.2476021,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.396413,11.2476021"
  },
  {
    "name": "PARAFARMACIA CHIEFALO PASQUALE",
    "address": "Viale Pio X, 144, CATANZARO CZ 88100, Italia",
    "lat": 38.9223933,
    "lng": 16.58206,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.9223933,16.58206"
  },
  {
    "name": "PARAFARMACIA DUE LEONI SRL",
    "address": "Via Siculiana 73/73A, ROMA RM 00133, Italia",
    "lat": 41.8785787,
    "lng": 12.6487603,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8785787,12.6487603"
  },
  {
    "name": "FARMACIA DUE LEONI S.R.L.",
    "address": "Via Casilina 1787 P/Q, ROMA RM 00132, Italia",
    "lat": 41.8638685,
    "lng": 12.6944079,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8638685,12.6944079"
  },
  {
    "name": "FARMACIE MANTOVANE SRL",
    "address": "Viale Pompilio 30, MANTOVA MN 46100, Italia",
    "lat": 45.1445715,
    "lng": 10.7699715,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1445715,10.7699715"
  },
  {
    "name": "FARMAVENTITRE SRL",
    "address": "Piazza Roma 5, CANTERANO RM 00020, Italia",
    "lat": 41.9422999,
    "lng": 13.0374399,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9422999,13.0374399"
  },
  {
    "name": "AZIENDA SPECIALE GOITO SERVIZI",
    "address": "Piazza Gramsci,8, GOITO MN 46044, Italia",
    "lat": 45.255144,
    "lng": 10.6742395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.255144,10.6742395"
  },
  {
    "name": "FARMACIA AZZALI LINO",
    "address": "Via Dante Alighieri 13, GOITO MN 46044, Italia",
    "lat": 45.2569504,
    "lng": 10.6746736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2569504,10.6746736"
  },
  {
    "name": "SANITARIA GERMANA ANTONELLA",
    "address": "Via F.Crispi, 40/46, CAPO D'ORLANDO ME 98071, Italia",
    "lat": 38.1586188,
    "lng": 14.7449608,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1586188,14.7449608"
  },
  {
    "name": "FARMACIA FRANCESCHETTI S.A.S. DEL DR. FABIO AMICI & C.",
    "address": "C.so Trieste 55, MARINO RM 00047, Italia",
    "lat": 41.7694374,
    "lng": 12.660675,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7694374,12.660675"
  },
  {
    "name": "PARAFARMACIA DOTT. CARLONI DI CARLONI MANUEL",
    "address": "Via Sant'Anna, 3/B, CASTELRAIMONDO MC 62022, Italia",
    "lat": 43.2093961,
    "lng": 13.0566022,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2093961,13.0566022"
  },
  {
    "name": "FARMACIA LAPUCCI LORENZINA",
    "address": "Via Tiberina 31, FIANO ROMANO RM 00065, Italia",
    "lat": 42.1950708,
    "lng": 12.6048261,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.1950708,12.6048261"
  },
  {
    "name": "FARMACIA DEL BUON AUGURIO S.N.C. DELLA DOTT.SSA ARACRI ANTONELLA",
    "address": "Via Vecchia di Velletri 10, ROCCA DI PAPA RM 00040, Italia",
    "lat": 41.756376,
    "lng": 12.7132531,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.756376,12.7132531"
  },
  {
    "name": "FARMACIA GREGORIO VII S.A.S. DI CARMEN CARPENTIERO",
    "address": "Via Gregorio VII, 154/B, ROMA RM 00165, Italia",
    "lat": 41.8956234,
    "lng": 12.4485738,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8956234,12.4485738"
  },
  {
    "name": "FARMACIA DOTT. ALDO SERAFINI DI SERAFINI PAOLO & C. S.N.C.",
    "address": "Via G. Menconi, 8 bis, CARRARA - Avenza MS 54033, Italia",
    "lat": 44.0472646,
    "lng": 10.0614651,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0472646,10.0614651"
  },
  {
    "name": "FARMACIA BALDINI FRANCO",
    "address": "Via Roma 19 , SENIGA BS 25020, Italia",
    "lat": 45.243396,
    "lng": 10.1769087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.243396,10.1769087"
  },
  {
    "name": "LA SANITARIA DIETRO L'ANGOLO DI POCAI FABIOLA",
    "address": "Via Cesare Battisti, 93, VIAREGGIO LU 55049, Italia",
    "lat": 43.8289317,
    "lng": 10.2873285,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8289317,10.2873285"
  },
  {
    "name": "ANTICA FARMACIA SAN FRANCESCO SRL",
    "address": "Viale di Trastevere, 64/E, ROMA RM 00153, Italia",
    "lat": 41.8762469,
    "lng": 12.4658477,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8762469,12.4658477"
  },
  {
    "name": "FARMACIA DEL CAMPO SAS DELLA DR.SSA BEATRICE ANNA MARIA MOLINA & C.",
    "address": "Via Pontina Km. 50,850 snc, APRILIA LT 04011, Italia",
    "lat": 41.561409,
    "lng": 12.682838,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.561409,12.682838"
  },
  {
    "name": "A.S.C. 2000 S.N.C.",
    "address": "VIA FILIPPO BRUNELLESCHI , 41, ORISTANO OR 09170, Italia",
    "lat": 39.9025922,
    "lng": 8.58492,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9025922,8.58492"
  },
  {
    "name": "FARMACIA DR. VITA GIAMPAOLO",
    "address": "Via Flaminia Vecchia, 719/A, ROMA RM 00191, Italia",
    "lat": 41.9479362,
    "lng": 12.4754926,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9479362,12.4754926"
  },
  {
    "name": "FARMACIA PULKER SRL",
    "address": "Piazza Bologna, 22, ROMA RM 00162, Italia",
    "lat": 41.9133133,
    "lng": 12.5210861,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9133133,12.5210861"
  },
  {
    "name": "FARMACIA EUROPA SRL",
    "address": "Via Verdi, 305, RENDE CS 87036, Italia",
    "lat": 39.339123,
    "lng": 16.2440323,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.339123,16.2440323"
  },
  {
    "name": "MAROTTA SRL",
    "address": "Corso Susa 305/307, RIVOLI TO 10098, Italia",
    "lat": 45.0769505,
    "lng": 7.51675,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0769505,7.51675"
  },
  {
    "name": "FARMACIA MONTI TIBURTINI DELLA DOTT.SSA LIBRIANI LAURA & C. - S.A.S.",
    "address": "Via Monti Tiburtini, 598, ROMA RM 00157, Italia",
    "lat": 41.9151726,
    "lng": 12.5483644,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9151726,12.5483644"
  },
  {
    "name": "FARMACIA S.GIOVANNI SNC DEI DOTTORI SERENA SALAMONI E LUCA GUARNIERO",
    "address": "Piazza Umberto I, 21, ROVIGO - Grignano polesine RO 45100, Italia",
    "lat": 45.0421385,
    "lng": 11.7505462,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0421385,11.7505462"
  },
  {
    "name": "MB FARMASICURA s.n.c. della Dott.ssa Elisabetta Bosi e Figlie",
    "address": "Piazza Garibaldi, 7, FICAROLO RO 45036, Italia",
    "lat": 44.9529277,
    "lng": 11.4339748,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9529277,11.4339748"
  },
  {
    "name": "DOTTORBIANCHI SRL UNIPERSONALE",
    "address": "Via Genova, 159, ALESSANDRIA - Spinetta marengo AL 15100, Italia",
    "lat": 44.8852056,
    "lng": 8.6811322,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8852056,8.6811322"
  },
  {
    "name": "FARMACIA DELL'OSPEDALE DOTT.ALESSANDRO ALGANON",
    "address": "CORSO LIBERAZIONE 85, ARONA NO 28041, Italia",
    "lat": 45.7597657,
    "lng": 8.5588836,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7597657,8.5588836"
  },
  {
    "name": "FARMACIA DI PINCARA di TAMASELLI Dott.ssa LAURA",
    "address": "Piazza Martiri della Libertà, 222, PINCARA RO 45020, Italia",
    "lat": 44.9932403,
    "lng": 11.6102894,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9932403,11.6102894"
  },
  {
    "name": "FARMACIA RHODIGIUM S.N.C.",
    "address": "Via Umberto I, 44, ROVIGO RO 45100, Italia",
    "lat": 45.071992,
    "lng": 11.7865777,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.071992,11.7865777"
  },
  {
    "name": "FARMACIA PERANI DI ALBERTO PERANI & C. S.A.S.",
    "address": "Via XXIV MAGGIO 49, PARATICO BS 25030, Italia",
    "lat": 45.661067,
    "lng": 9.9563522,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.661067,9.9563522"
  },
  {
    "name": "PARAFARMACIA CENTRALE DI DOTT.SSA VALERIA PIZZAL",
    "address": "Corso Garibaldi, 2/A, PORDENONE PN 33170, Italia",
    "lat": 45.958789,
    "lng": 12.6583283,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.958789,12.6583283"
  },
  {
    "name": "HELTY PHARMA S.R.L.",
    "address": "VIA DELLA MECCANICA 1/O, VICENZA VI 36100, Italia",
    "lat": 45.5289739,
    "lng": 11.5121736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5289739,11.5121736"
  },
  {
    "name": "APOTHEKE GIRLAN FARMACIA SNC",
    "address": "Via Cornaiano, 12, APPIANO SULLA STRADA DEL VINO - Cornaiano BZ 39057, Italia",
    "lat": 46.462501,
    "lng": 11.2798524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.462501,11.2798524"
  },
  {
    "name": "PT TRANSMARCO",
    "address": "JALAN INDUSTRI NO. 6, TANGERANG, KARAWACI 15115, Indonesia",
    "lat": -6.2075161,
    "lng": 106.6201871,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=-6.2075161,106.6201871"
  },
  {
    "name": "PARAFARMACIA OLMO S.R.L. SEMPLIFICATA",
    "address": "Via Roma, 58, SOSSANO VI 36040, Italia",
    "lat": 45.3573,
    "lng": 11.5081087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3573,11.5081087"
  },
  {
    "name": "FARMACIA SAN ROCCO DEL DOTT. GIOVANNI MIOTTO & FIGLIO S.N.C.",
    "address": "Via Roma, 96, BRESSANVIDO VI 36050, Italia",
    "lat": 45.6438453,
    "lng": 11.6310878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6438453,11.6310878"
  },
  {
    "name": "FARMACIA MARCHI SRL",
    "address": "Via 4 Martiri, 78, ARZIGNANO VI 36071, Italia",
    "lat": 45.518734,
    "lng": 11.3409624,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.518734,11.3409624"
  },
  {
    "name": "FARMACIA SAN ROCCO DI MARTINI GIORGIO",
    "address": "Via IV Novembre, 44, CEMBRA TN 38034, Italia",
    "lat": 46.1558339,
    "lng": 11.1533246,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1558339,11.1533246"
  },
  {
    "name": "FARMACIA DI SEGONZANO DR.VILLACI PIERANGELO",
    "address": "FRAZIONE SCANCIO 63, SEGONZANO TN 38047, Italia",
    "lat": 46.1859904,
    "lng": 11.2517498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1859904,11.2517498"
  },
  {
    "name": "FARMACIA MONTE PENNA DI FRONGILLO MARIA LUISA",
    "address": "Via Flaminia, KM. 185,600, GUALDO TADINO PG 06023, Italia",
    "lat": 43.2070973,
    "lng": 12.7864156,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2070973,12.7864156"
  },
  {
    "name": "FARMACIA DALLAFINA SNC",
    "address": "Via monte grappa 4/a, COSTABISSARA VI 36030, Italia",
    "lat": 45.5919848,
    "lng": 11.4973158,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5919848,11.4973158"
  },
  {
    "name": "FARMACIA S.ERASMO S.R.L.",
    "address": "Viale Caravaggio, 101, MONTE ARGENTARIO - Porto ercole GR 58018, Italia",
    "lat": 42.3948463,
    "lng": 11.2035709,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3948463,11.2035709"
  },
  {
    "name": "FARMACIA DELLE GRAZIE DELLA DOTT.SSA GIOVANNA BURATTO",
    "address": "PIAZZA S.GIOVANNI BATTISTA, 157, COSTA DI ROVIGO RO 45023, Italia",
    "lat": 45.0487489,
    "lng": 11.6946971,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0487489,11.6946971"
  },
  {
    "name": "PARAPHYTOFARMACIA S.A.S. DI BRUN BIANCAMARIA & C.",
    "address": "VIALE F.CRISPI, 55, VICENZA VI 36100, Italia",
    "lat": 45.5428693,
    "lng": 11.5206426,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5428693,11.5206426"
  },
  {
    "name": "AMICI FARM S.R.L.",
    "address": "Via Bologna, 25/27, ASCOLI PICENO AP 63100, Italia",
    "lat": 42.853874,
    "lng": 13.5904267,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.853874,13.5904267"
  },
  {
    "name": "FARMACIA PIOVERA DI ENRICO E C.SNC",
    "address": "Via Torino 150, IVREA TO 10015, Italia",
    "lat": 45.4527103,
    "lng": 7.8786103,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4527103,7.8786103"
  },
  {
    "name": "LA FARMACOSMETICA DI SCARPONI VALENTINA & C. S.A.S.",
    "address": "Via dell'Industria, 258, CORRIDONIA MC 62014, Italia",
    "lat": 43.2654272,
    "lng": 13.4878171,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2654272,13.4878171"
  },
  {
    "name": "FARMACIA MERANO S.A.S. DI DE CARLO BORIS E MONTI LETIZIA & C.",
    "address": "Via Roma, 270, MERANO BZ 39012, Italia",
    "lat": 46.6570852,
    "lng": 11.1676009,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.6570852,11.1676009"
  },
  {
    "name": "FARMACIA ALPINA DI PACCHIONI SARA",
    "address": "VIA VAL PUSTERIA, 2, NAZ SCIAVES BZ 39040, Italia",
    "lat": 46.7699518,
    "lng": 11.6649698,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.7699518,11.6649698"
  },
  {
    "name": "FARMACIA ANGELICI SRL",
    "address": "Via Matteotti, 4/6, ARRONE TR 05031, Italia",
    "lat": 42.5853453,
    "lng": 12.7668447,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5853453,12.7668447"
  },
  {
    "name": "FARMACIA RAMPINO S.N.C. DI ALBERTO E MATTEO RAMPINO",
    "address": "Piazza Venezia, 16, SAN CANZIAN D'ISONZO GO 34075, Italia",
    "lat": 45.7967364,
    "lng": 13.4648093,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7967364,13.4648093"
  },
  {
    "name": "APOTHEKE SCHLERN KASTELRUTH O.H.G. DES DARIUSH DANAPOUR & CO",
    "address": "VIA O. VON WOLKENSTEIN, 6/B, CASTELROTTO BZ 39040, Italia",
    "lat": 46.567255,
    "lng": 11.5601193,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.567255,11.5601193"
  },
  {
    "name": "FARMACIA CHIENES DI BIRGIT PIRCHER & C. S.A.S.",
    "address": "VIA VALLE PUSTERIA, 13, CHIENES BZ 39030, Italia",
    "lat": 46.8219882,
    "lng": 11.8391981,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.8219882,11.8391981"
  },
  {
    "name": "FARMACIA DR. PUCE LUCA",
    "address": "VIA KENNEDY, 275, LAIVES BZ 39055, Italia",
    "lat": 46.4229897,
    "lng": 11.3329781,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4229897,11.3329781"
  },
  {
    "name": "APOTHEKE GADRIA DER DR. HALLER SIGRID O.H.G.",
    "address": "VIA VENOSTA, 39, LASA BZ 39023, Italia",
    "lat": 46.6295002,
    "lng": 10.6431832,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.6295002,10.6431832"
  },
  {
    "name": "FARMACIA DIECI S.N.C. DI DOTT.SSE CRISTINA BERTAGNOLLI E CHIARA PEZZIN",
    "address": "VIA ZUEGG, 24/A, MERANO BZ 39012, Italia",
    "lat": 46.6617008,
    "lng": 11.1485014,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.6617008,11.1485014"
  },
  {
    "name": "FARMACIA DR.BARBARA ZONTINI & C",
    "address": "VIA ROMA, 43, CONDINO TN 38083, Italia",
    "lat": 45.8818034,
    "lng": 10.5937417,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8818034,10.5937417"
  },
  {
    "name": "FARMACIA MAGAFARMA SRL",
    "address": "VIA A.DE GASPERI, 1, FIAVE' TN 38075, Italia",
    "lat": 46.0046341,
    "lng": 10.8424197,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0046341,10.8424197"
  },
  {
    "name": "FARMACIA NUOVA DEL GUERCINO SNC",
    "address": "VIA CIMAROSA, 1/B, CENTO FE 44042, Italia",
    "lat": 44.7261521,
    "lng": 11.2817186,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7261521,11.2817186"
  },
  {
    "name": "FARMACIA TREPPONTI S.R.L.",
    "address": "PIAZZA FOLEGATTI, 27, COMACCHIO FE 44022, Italia",
    "lat": 44.6945117,
    "lng": 12.1840342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6945117,12.1840342"
  },
  {
    "name": "FARMACIA TORREGGIANI SNC",
    "address": "VIA ARIOSTO, 42/44/46 - MIGLIARO, FISCAGLIA FE 44027, Italia",
    "lat": 44.7972421,
    "lng": 11.9707224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7972421,11.9707224"
  },
  {
    "name": "FARMACIA DEI MASI SAS della DOTT. MARIA HANAU",
    "address": "VIA 11 SETTEMBRE, 13, MASI TORELLO FE 44020, Italia",
    "lat": 44.7950528,
    "lng": 11.794753,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7950528,11.794753"
  },
  {
    "name": "FARMACIA SANT'EUFEMIA DOTT.SSA DIDONE' ELISABETTA",
    "address": "PIAZZA PAPA PIO X, 1, VILLA DEL CONTE - Abbazia pisani PD 35010, Italia",
    "lat": 45.552874,
    "lng": 11.842053,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.552874,11.842053"
  },
  {
    "name": "FARMACIA VITTORIA DI LUIGI PORZIO E GINA AVITABILE S.N.C.",
    "address": "VIA ALDO MORO, 140, BRUGINE PD 35020, Italia",
    "lat": 45.2792638,
    "lng": 11.9965413,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2792638,11.9965413"
  },
  {
    "name": "FARMACIA AL REDENTORE S.N.C. DELLA DOTT.SSA SILVIA PIAZZA",
    "address": "VIA A.GRAMSCI, 95 - MEJANIGA, CADONEGHE - Mejaniga PD 35010, Italia",
    "lat": 45.4502682,
    "lng": 11.8978854,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4502682,11.8978854"
  },
  {
    "name": "FARMACIA DI FIUMICELLO S.N.C.  DEI DOTTORI  ANDREATTA E ROSSETTO",
    "address": "VIA BASSA III, 20, CAMPODARSEGO PD 35011, Italia",
    "lat": 45.5090624,
    "lng": 11.9561344,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5090624,11.9561344"
  },
  {
    "name": "FARMACIA SANT'ANNA DEL DR. ISOLATO FABIO E C. SAS",
    "address": "VIA ROMA, 109, GALLIERA VENETA PD 35015, Italia",
    "lat": 45.6581458,
    "lng": 11.8167829,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6581458,11.8167829"
  },
  {
    "name": "FARMACIA BORDIGNON DR.SSA ANTONELLA",
    "address": "PIAZZA IV NOVEMBRE, GAZZO PD 35010, Italia",
    "lat": 45.5823666,
    "lng": 11.707288,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5823666,11.707288"
  },
  {
    "name": "FARMACIA AL CORSO SAS",
    "address": "CORSO DELLE TERME, 4, MONTEGROTTO TERME PD 35036, Italia",
    "lat": 45.3423468,
    "lng": 11.7802184,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3423468,11.7802184"
  },
  {
    "name": "PARAFARMACIA PORTELLO DI VALENTINI GIULIA",
    "address": "VIA DEL PORTELLO, 58 I°, PADOVA PD 35129, Italia",
    "lat": 45.4100805,
    "lng": 11.8927657,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4100805,11.8927657"
  },
  {
    "name": "FARMACIA PICCINALI DELLA DR.SSA ROTUNNO AURELIA",
    "address": "VIA VITTORIO EMANUELE, 23/A, SAONARA PD 35020, Italia",
    "lat": 45.369934,
    "lng": 11.9650093,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.369934,11.9650093"
  },
  {
    "name": "FARMACIA DOTT. BRESCIANI FILIPPO",
    "address": "VIA ROMA, 340, VIGODARZERE PD 35010, Italia",
    "lat": 45.4574449,
    "lng": 11.8826443,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4574449,11.8826443"
  },
  {
    "name": "FARMACIA NEGRELLI DEI DOTTORI SILVANO ED ANNA NEGRELLI S.N.C.",
    "address": "VIA ROMA, 10, GAIBA RO 45030, Italia",
    "lat": 44.9456792,
    "lng": 11.4819817,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9456792,11.4819817"
  },
  {
    "name": "FARMACIE ARDUIN BRAGA S.N.C.",
    "address": "Via Ramo di Palo Centro, LENDINARA RO 45026, Italia",
    "lat": 45.0809941,
    "lng": 11.5626116,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0809941,11.5626116"
  },
  {
    "name": "FARMACIA SAN BORTOLO DOTT.SSA FIORENZA CAZZUFFI",
    "address": "PIAZZA S.BARTOLOMEO, 28, ROVIGO RO 45100, Italia",
    "lat": 45.0647702,
    "lng": 11.796556,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0647702,11.796556"
  },
  {
    "name": "FARMACIA SANT'ILARIO SNC",
    "address": "VIA ANTONIO GRAMSCI, 34, ROVIGO RO 45100, Italia",
    "lat": 45.0800983,
    "lng": 11.7899507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0800983,11.7899507"
  },
  {
    "name": "FARMACIA ANCONA ANDREA",
    "address": "VIALE PADOVA, 6/G, CHIOGGIA - Sottomarina VE 30015, Italia",
    "lat": 45.2120795,
    "lng": 12.2915761,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2120795,12.2915761"
  },
  {
    "name": "FARMACIA DOTT. GIOVANNI PERINI & C. S.A.S.",
    "address": "VIA MILANO, 46, BOLZANO BZ 39100, Italia",
    "lat": 46.48979,
    "lng": 11.3315706,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.48979,11.3315706"
  },
  {
    "name": "FARMACIA DI CORTE PRINCIPEVESCOVILE DI MARCO DI BELLO",
    "address": "PORTICI MINORI, 2, BRESSANONE BZ 39042, Italia",
    "lat": 46.716406,
    "lng": 11.6553783,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.716406,11.6553783"
  },
  {
    "name": "APOTHEKE ST. PAULS DI GIULIANI SUSANNE",
    "address": "VIA CASTEL GUARDIA, 14/B, APPIANO SULLA STRADA DEL VINO - San paolo BZ 39050, Italia",
    "lat": 46.4711446,
    "lng": 11.2619485,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4711446,11.2619485"
  },
  {
    "name": "ALPS PHARMA DI RIZZO DANIELE & CO. SAS",
    "address": "VIA VILLAGGIO, 26, SAN MARTINO IN PASSIRIA BZ 39010, Italia",
    "lat": 46.7839532,
    "lng": 11.2276399,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.7839532,11.2276399"
  },
  {
    "name": "FARMACIA COMUNALE DI CASTELNUOVO (TN) S.R.L.",
    "address": "VIALE VENEZIA, 15/A, CASTELNUOVO TN 38050, Italia",
    "lat": 46.0522737,
    "lng": 11.4926158,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0522737,11.4926158"
  },
  {
    "name": "TIALFARMA S.R.L.",
    "address": "VIA LUIGI CANEPPELE, 31/A, TRENTO TN 38100, Italia",
    "lat": 46.0984636,
    "lng": 11.1020825,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0984636,11.1020825"
  },
  {
    "name": "FARMACIA DI MARINO DEL DOTT. GIAN ENRICO GASPARDIS & C. S.A.S.",
    "address": "VIA REDIPUGLIA, 77, FOGLIANO REDIPUGLIA GO 34070, Italia",
    "lat": 45.8625358,
    "lng": 13.4826614,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8625358,13.4826614"
  },
  {
    "name": "FARMACIA POLETTI DR. GIORGIO",
    "address": "VIA DANTE ALIGHIERI, 2, BRUGNERA PN 33070, Italia",
    "lat": 45.8993707,
    "lng": 12.537954,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8993707,12.537954"
  },
  {
    "name": "FARMACIA CRISTANTE E MARTIN S.N.C. DI CRISTANTE MANUELA & C.",
    "address": "VIA DELLA CHIESA, 5 - VILLANOVA, PRATA DI PORDENONE PN 33080, Italia",
    "lat": 45.8619997,
    "lng": 12.5717334,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8619997,12.5717334"
  },
  {
    "name": "FARMACIA SAN ROCCO S.R.L.",
    "address": "VIA XXVII FEBBRAIO 1511, 1, SAN VITO AL TAGLIAMENTO PN 33078, Italia",
    "lat": 45.9141891,
    "lng": 12.8501575,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9141891,12.8501575"
  },
  {
    "name": "FARMACIA PEANO DR.SSA ELENA",
    "address": "VIA CODROIPO, 2, CAMINO AL TAGLIAMENTO UD 33030, Italia",
    "lat": 45.9271321,
    "lng": 12.9460799,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9271321,12.9460799"
  },
  {
    "name": "FARMACIA BISSALDI CHIARA & C. S.A.S.",
    "address": "PIAZZA GARIBALDI, 3, GEMONA DEL FRIULI UD 33013, Italia",
    "lat": 46.2781586,
    "lng": 13.1396478,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.2781586,13.1396478"
  },
  {
    "name": "FARMACIA SAN PAOLO DI ANNA MARIA MUSSO E CONSUELO COLUSSI S.N.C.",
    "address": "PIAZZA SAN PAOLINO, 9/4, MORTEGLIANO - Lavariano UD 33050, Italia",
    "lat": 45.9565278,
    "lng": 13.2275762,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9565278,13.2275762"
  },
  {
    "name": "ANTICA FARMACIA SAN NICOLO' DI G.E M.CARPENEDO SNC",
    "address": "VIA ROMA, 46, PALUZZA UD 33026, Italia",
    "lat": 46.5281992,
    "lng": 13.0153152,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.5281992,13.0153152"
  },
  {
    "name": "FARMACIA SAN GIOVANNI SRL",
    "address": "VIA PLEBISCITO, 50/52 - S.GIOVANNI, CASARSA DELLA DELIZIA PN 33072, Italia",
    "lat": 45.949899,
    "lng": 12.8328963,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.949899,12.8328963"
  },
  {
    "name": "FARMACIA CORRADINI D'ELIA dei dottori Alberto e Claudio S.a.s.",
    "address": "VIA GRAMSCI, 18, AQUILEIA UD 33051, Italia",
    "lat": 45.7991352,
    "lng": 13.3338381,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7991352,13.3338381"
  },
  {
    "name": "FARMACIA CONS DI CONS. DOTT.SSA MANUELA",
    "address": "VIA JULIA, 15, GEMONA DEL FRIULI UD 33013, Italia",
    "lat": 46.273037,
    "lng": 13.1290584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.273037,13.1290584"
  },
  {
    "name": "FARMACIA DEL DR. ROMANO LUCIANO & C. S.A.S.",
    "address": "VIA ROMA, 28, MUZZANA DEL TURGNANO UD 33055, Italia",
    "lat": 45.8174092,
    "lng": 13.1274899,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8174092,13.1274899"
  },
  {
    "name": "PARAFARMACIA S.MARTINO DI ZAMPIS DOTT. DAVIDE",
    "address": "VIA DANTE, 8, PASIAN DI PRATO - Passons UD 33037, Italia",
    "lat": 46.0705553,
    "lng": 13.1900906,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0705553,13.1900906"
  },
  {
    "name": "FARMACIA ROMANO DI SPIZ STEFANIA",
    "address": "PIAZZA NASCIMBENI, 14/A, PAULARO UD 33027, Italia",
    "lat": 46.5303329,
    "lng": 13.1164438,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.5303329,13.1164438"
  },
  {
    "name": "FARMACIA MIGOTTI S. & C. SAS",
    "address": "VIA UDINE, 20, PORPETTO UD 33050, Italia",
    "lat": 45.8601838,
    "lng": 13.2155515,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8601838,13.2155515"
  },
  {
    "name": "FARMACIA SANT'ANDREA S.N.C.  DEI DOTTORI TOSOLINI E PIROMALLI",
    "address": "VIA LIGNANO, 41, POZZUOLO DEL FRIULI - Zugliano UD 33050, Italia",
    "lat": 46.0152767,
    "lng": 13.2117758,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0152767,13.2117758"
  },
  {
    "name": "FARMACIA SANT'ANTONIO DEI DOTTORI SCRIGNER E VENTRELLA S.N.C.",
    "address": "PIAZZA ROMA, 36, SEDEGLIANO UD 33039, Italia",
    "lat": 46.0136698,
    "lng": 12.9761261,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0136698,12.9761261"
  },
  {
    "name": "FARMACIA DR. FRANCESCO SPALIVIERO & C. S.N.C.",
    "address": "VIA ROMA, 18, TARVISIO UD 33018, Italia",
    "lat": 46.5053963,
    "lng": 13.5762461,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.5053963,13.5762461"
  },
  {
    "name": "FARMACIA GRIGOLINI DOTT.SSA RENATA",
    "address": "PIAZZA DEL POPOLO, 2, TORVISCOSA UD 33050, Italia",
    "lat": 45.8234886,
    "lng": 13.2747236,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8234886,13.2747236"
  },
  {
    "name": "FARMACIA COLUTTA DOTT. GIANPAOLO & C. SNC",
    "address": "VIA MAZZINI, 13, UDINE UD 33100, Italia",
    "lat": 46.0665397,
    "lng": 13.2317132,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0665397,13.2317132"
  },
  {
    "name": "FARMACIA TURCO DELLA DOTT.SSA R. TURCO",
    "address": "VIALE TRICESIMO, 103, UDINE UD 33100, Italia",
    "lat": 46.0802366,
    "lng": 13.2341253,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0802366,13.2341253"
  },
  {
    "name": "FARMACIE SORC DI SORC GIORGIO & ALENKA S.N.C.",
    "address": "VIA UDINE, 2, GORIZIA - Lucinico GO 34170, Italia",
    "lat": 45.9362343,
    "lng": 13.5748559,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9362343,13.5748559"
  },
  {
    "name": "FARMACIA ALLA FORTEZZA SNC",
    "address": "VIA UDINE, 27/F, GRADISCA D'ISONZO GO 34072, Italia",
    "lat": 45.8809389,
    "lng": 13.4821811,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8809389,13.4821811"
  },
  {
    "name": "FARMACIA DI MEDEA sas",
    "address": "VIA SCUOLE, 9, MEDEA GO 34076, Italia",
    "lat": 45.916997,
    "lng": 13.4248692,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.916997,13.4248692"
  },
  {
    "name": "FARMACIA RISMONDO DI TACCHINO DOTT.SSA ISABELLA & C. S.A.S.",
    "address": "VIA TOTI, 52, MONFALCONE GO 34074, Italia",
    "lat": 45.8079567,
    "lng": 13.538128,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8079567,13.538128"
  },
  {
    "name": "FARMACIA ALBINI DR. ETTORE",
    "address": "VIA ROMA, 12, FANNA PN 33092, Italia",
    "lat": 46.1861122,
    "lng": 12.7526975,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1861122,12.7526975"
  },
  {
    "name": "FARMACIA FIORETTI FRANCESCA SAS",
    "address": "VIA UMBERTO I°, 39, MANIAGO PN 33085, Italia",
    "lat": 46.1700665,
    "lng": 12.705584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1700665,12.705584"
  },
  {
    "name": "FARMACIA DI NAVE SNC DELLE DR.SSE GOBBO E. E ZAVATARELLI M.",
    "address": "VIA GIAN GIACOMO LIRUTTI, 49, FONTANAFREDDA - Nave PN 33074, Italia",
    "lat": 45.9769832,
    "lng": 12.502276,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9769832,12.502276"
  },
  {
    "name": "FARMACIA AQUILINIA SRL",
    "address": "VIA FLAVIA DI AQUILINIA, 17, MUGGIA - Aquilinia TS 34015, Italia",
    "lat": 45.6056777,
    "lng": 13.8079788,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6056777,13.8079788"
  },
  {
    "name": "PARAFARMACIA DOMIO",
    "address": "VIA DOMIO, 33, SAN DORLIGO DELLA VALLE TS 34018, Italia",
    "lat": 45.6079842,
    "lng": 13.820456,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6079842,13.820456"
  },
  {
    "name": "FARMACIA ALLA REDENZIONE S.R.L.",
    "address": "PIAZZA GARIBALDI, 6, TRIESTE TS 34131, Italia",
    "lat": 45.6457235,
    "lng": 13.7803681,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6457235,13.7803681"
  },
  {
    "name": "FARMACIA AI GEMELLI S.R.L.",
    "address": "VIA BARTOLOMEO D'ALVIANO, 23, TRIESTE TS 34148, Italia",
    "lat": 45.6350235,
    "lng": 13.7807654,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6350235,13.7807654"
  },
  {
    "name": "FARMACIA ALLA S.M.MADDALENA",
    "address": "VIA DELL'ISTRIA, 33, TRIESTE TS 34137, Italia",
    "lat": 45.6401165,
    "lng": 13.7829218,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6401165,13.7829218"
  },
  {
    "name": "FARM. ALL'IGEA DEL DOTT. TOMSICH GIUSEPPE & C. S.N.C.",
    "address": "VIA GINNASTICA, 6, TRIESTE TS 34125, Italia",
    "lat": 45.6503714,
    "lng": 13.7787119,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6503714,13.7787119"
  },
  {
    "name": "FARMACIA BIASOLETTO ALL'ORSO NERO DEL DOTT. MARZINI ADRIANO",
    "address": "VIA ROMA, 16, TRIESTE TS 34132, Italia",
    "lat": 45.6524743,
    "lng": 13.7722558,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6524743,13.7722558"
  },
  {
    "name": "FARMACIA DR. ALESSANDRO FUMANERI & C. SNC",
    "address": "VIA CURIEL, 7/B, TRIESTE TS 34148, Italia",
    "lat": 45.6203478,
    "lng": 13.8246132,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6203478,13.8246132"
  },
  {
    "name": "FARMACIA PICCIOLA ALLA CROCE BIANCA",
    "address": "VIA ALFREDO ORIANI, 2, TRIESTE TS 34131, Italia",
    "lat": 45.6473338,
    "lng": 13.7797532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6473338,13.7797532"
  },
  {
    "name": "FARMACIA SPONZA DELLA DOTT.SSA M.T. CADORE & C. SNC",
    "address": "VIA LIONELLO STOCK, 9, TRIESTE TS 34135, Italia",
    "lat": 45.6649905,
    "lng": 13.7710853,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6649905,13.7710853"
  },
  {
    "name": "FARMACIA SABBADINI DR.SSA MONICA",
    "address": "VIA DIVISIONE JULIA, 16, BUTTRIO UD 33042, Italia",
    "lat": 46.0137307,
    "lng": 13.3312432,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0137307,13.3312432"
  },
  {
    "name": "FARMACIA CHARALAMBOPOULOS VASSILIOS & C. S.A.S.",
    "address": "PIAZZA S.ROCCO, 11, CARLINO UD 33050, Italia",
    "lat": 45.8017182,
    "lng": 13.1885648,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8017182,13.1885648"
  },
  {
    "name": "FARMACIA TROJANI S.A.S.",
    "address": "VIA ROMA, 37, MAJANO UD 33030, Italia",
    "lat": 46.1848004,
    "lng": 13.0659335,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1848004,13.0659335"
  },
  {
    "name": "FARMACIA BRUSUTTI SAS",
    "address": "VIA G.FOSCHIANI, 21, MANZANO UD 33044, Italia",
    "lat": 45.9912267,
    "lng": 13.3843572,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9912267,13.3843572"
  },
  {
    "name": "FARMACIA PERSOLJA SNC",
    "address": "PIAZZA RISANAMENTO, 1, MARANO LAGUNARE UD 33050, Italia",
    "lat": 45.7648213,
    "lng": 13.1678386,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7648213,13.1678386"
  },
  {
    "name": "FARMACIA SAN GALLO DEL DR. LORENZO MIOLLI E C. SAS",
    "address": "VIA DELLA CHIESA, 13/B, MOGGIO UDINESE UD 33015, Italia",
    "lat": 46.4104222,
    "lng": 13.1966999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4104222,13.1966999"
  },
  {
    "name": "ANTICA FARMACIA FABRIS DEI DOTTORI CARLO E MARINA FABRIS SNC",
    "address": "VIA FABRIS, 5, OSOPPO UD 33010, Italia",
    "lat": 46.256513,
    "lng": 13.0813886,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.256513,13.0813886"
  },
  {
    "name": "FARMACIA FACINI S.A.S. DEL DOTT. FACINI STEFANO",
    "address": "BORGO CIVIDALE, 20, PALMANOVA UD 33057, Italia",
    "lat": 45.9063093,
    "lng": 13.3123716,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9063093,13.3123716"
  },
  {
    "name": "FARMACIA MUGANI S.N.C. DOTTORI GIACOMO E CRISTIANO MUGANI",
    "address": "PIAZZA ROMA, 12, TARCENTO UD 33017, Italia",
    "lat": 46.2160587,
    "lng": 13.2218371,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.2160587,13.2218371"
  },
  {
    "name": "FARMACIA ALLA FENICE RISORTA DI ASQUINI ALESSANDRA & C. SAS",
    "address": "VIA LOMBARDIA, 198/A, UDINE UD 33100, Italia",
    "lat": 46.0832069,
    "lng": 13.2044759,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0832069,13.2044759"
  },
  {
    "name": "FARMACIA SAN GOTTARDO DI CADAMURO LUCA & C. S.A.S.",
    "address": "VIA BARIGLARIA, 24, UDINE UD 33100, Italia",
    "lat": 46.0769962,
    "lng": 13.2775685,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0769962,13.2775685"
  },
  {
    "name": "FARMACIA SANTA MARIA DEI DOTTORI ITALO E ALESSIA DELBIANCO E C. S.N.C.",
    "address": "VIA SANT'ANTONIO, 30, VILLA VICENTINA UD 33059, Italia",
    "lat": 45.8007862,
    "lng": 13.4034158,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8007862,13.4034158"
  },
  {
    "name": "APOTHEKE ALDEIN DI MORANDELL DOTT. RUPERT",
    "address": "VIA EGGERER, 1/2, ALDINO BZ 39040, Italia",
    "lat": 46.3667698,
    "lng": 11.3501651,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.3667698,11.3501651"
  },
  {
    "name": "FARMACIA TREVISANI DR.SSA STEFANIA TREVISANI",
    "address": "VIA G.AMENDOLA, 98, ARGENTA - San biagio FE 44016, Italia",
    "lat": 44.5838662,
    "lng": 11.8643415,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.5838662,11.8643415"
  },
  {
    "name": "FARMACIA LABORATORIO MASTELLI S.A.S. DEL DOTT. MASSIMO MASTELLI",
    "address": "VIA CESARE BATTISTI, 7, LENDINARA RO 45026, Italia",
    "lat": 45.0831876,
    "lng": 11.600077,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0831876,11.600077"
  },
  {
    "name": "FARMACIA SAN MICHELE DEI DOTTORI CLAUDIO RIZZATO ED ENZO PATRIA S.N.C.",
    "address": "VIA ROMA, 63, VILLANOVA DEL GHEBBO RO 45020, Italia",
    "lat": 45.0554659,
    "lng": 11.6446559,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0554659,11.6446559"
  },
  {
    "name": "FARMACIA CASTELLANA DR. ROSA EMANUELE",
    "address": "PIAZZA VITTORIA, 71, MARTELLAGO VE 30030, Italia",
    "lat": 45.5463319,
    "lng": 12.1582436,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5463319,12.1582436"
  },
  {
    "name": "FARMACIA ROSSINI",
    "address": "VIA VELA, 2/A, ASIGLIANO VENETO VI 36020, Italia",
    "lat": 45.3073692,
    "lng": 11.4520025,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3073692,11.4520025"
  },
  {
    "name": "FARMACIA DAL ZOTTO DOTT.SSA BERTO GLORIA",
    "address": "VIA PONTE, 2 - LISIERA, BOLZANO VICENTINO VI 36050, Italia",
    "lat": 45.5794692,
    "lng": 11.6115407,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5794692,11.6115407"
  },
  {
    "name": "FARMACIA SAN GAETANO S.A.S. DI TOMASINI DOTT.SSA GAIA & C.",
    "address": "VIA CHIESA, 20 - RAMPAZZO, CAMISANO VICENTINO VI 36043, Italia",
    "lat": 45.5388475,
    "lng": 11.6859836,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5388475,11.6859836"
  },
  {
    "name": "FARMACIA ZENTILE MONICA",
    "address": "VIA LARGO MONTE GRAPPA, 2, MONTICELLO CONTE OTTO - Cavazzale VI 36010, Italia",
    "lat": 45.6003504,
    "lng": 11.5703627,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6003504,11.5703627"
  },
  {
    "name": "FARMACIA DR. PAOLO RIGO S.N.C.",
    "address": "VIA CAVOUR, 32, CORNEDO VICENTINO VI 36073, Italia",
    "lat": 45.6147072,
    "lng": 11.34488,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6147072,11.34488"
  },
  {
    "name": "B.Z. FARMA S.N.C. DEI DOTTORI NICOLA ZERBINATO E NATASCIA BARALDO",
    "address": "VIA ROMA, 13, DUEVILLE VI 36031, Italia",
    "lat": 45.6342981,
    "lng": 11.5476491,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6342981,11.5476491"
  },
  {
    "name": "PARAFARMACIA AL REDENTORE SRL",
    "address": "VIA LEVA', 60 C, MONTECCHIO PRECALCINO VI 36030, Italia",
    "lat": 45.6639145,
    "lng": 11.5328861,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6639145,11.5328861"
  },
  {
    "name": "FARMACIA RIVIERA BERICA S.R.L.",
    "address": "VIA PROLIN, 48, NOVENTA VICENTINA VI 36025, Italia",
    "lat": 45.2936396,
    "lng": 11.5494162,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2936396,11.5494162"
  },
  {
    "name": "AI GELSI DI SALERNO ELSA & C. S.A.S.",
    "address": "PIAZZA MAZZINI, 30 - FRAZ. LANZE', QUINTO VICENTINO VI 36050, Italia",
    "lat": 45.5850079,
    "lng": 11.6618546,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5850079,11.6618546"
  },
  {
    "name": "FARMACIA PRETTO DI PRETTO D.SSA MARINA & C. SAS",
    "address": "VIA BOLDRINI, 48, THIENE VI 36016, Italia",
    "lat": 45.7115981,
    "lng": 11.4673488,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7115981,11.4673488"
  },
  {
    "name": "FARMACIA BATTAGLIA S.N.C. DEI DR. BATTAGLIA ANDREA E CELLI C.",
    "address": "VIA PEDERIVA, 63bis, VAL LIONA VI 36044, Italia",
    "lat": 45.4187772,
    "lng": 11.4593707,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4187772,11.4593707"
  },
  {
    "name": "FARMACIA ROMANATO S.A.S. DEL DOTT. ROMANATO ANTONIO & C.",
    "address": "VIA LEVA' DEGLI ANGELI, 15, VICENZA VI 36100, Italia",
    "lat": 45.5500486,
    "lng": 11.5499535,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5500486,11.5499535"
  },
  {
    "name": "FARMACIA ALLA PACE SNC DI PRETTO MATTEO E C.",
    "address": "VIALE DELLA PACE, 117, VICENZA VI 36100, Italia",
    "lat": 45.542726,
    "lng": 11.5721696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.542726,11.5721696"
  },
  {
    "name": "PARAFARMACIA DR.SSA TRENTIN ROBERTA",
    "address": "VIA E.FERMI, 92, VICENZA VI 36100, Italia",
    "lat": 45.5387363,
    "lng": 11.5112842,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5387363,11.5112842"
  },
  {
    "name": "FARMACIA NOVOLEDO S.N.C. DELLE DOTT.SSE ROSA ZACCHELLO E MARIA ROSSI",
    "address": "VIA PALLADIO, 39/A, VILLAVERLA VI 36030, Italia",
    "lat": 45.6433533,
    "lng": 11.5248687,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6433533,11.5248687"
  },
  {
    "name": "FARMACIA ALL'IMMACOLATA S.R.L.",
    "address": "VIA MONTE PASUBIO, 188/1, ZANE' VI 36010, Italia",
    "lat": 45.7195785,
    "lng": 11.446849,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7195785,11.446849"
  },
  {
    "name": "FARMACIA DOTT.SSA MARIA GRAZIA BELLINI SAS",
    "address": "STRADA PROVINCIALE 2 ISOLELLA 52A, CEREA - Asparetto VR 37053, Italia",
    "lat": 45.221959,
    "lng": 11.1781543,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.221959,11.1781543"
  },
  {
    "name": "FARMACIA AMBROSINI DR. DANIELE",
    "address": "PIAZZA ROMA, 18, CAPRINO VERONESE VR 37013, Italia",
    "lat": 45.6059239,
    "lng": 10.7938627,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6059239,10.7938627"
  },
  {
    "name": "FARMACIA MAINIERI S.N.C. DI MAINIERI ELVIRA E VINCENZO",
    "address": "PIAZZALE ALFERIA, 1, CERRO VERONESE VR 37020, Italia",
    "lat": 45.5745998,
    "lng": 11.038158,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5745998,11.038158"
  },
  {
    "name": "FARMACIA MODERNA DELLA DOTT.SSA GIORGIA RIGHETTI E C. S.A.S.",
    "address": "VIA GARIBALDI, 1, ISOLA DELLA SCALA VR 37063, Italia",
    "lat": 45.2727668,
    "lng": 11.0069725,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2727668,11.0069725"
  },
  {
    "name": "FARMACIA FERRARI DR.SSA FIAMMETTA",
    "address": "VIA DEL LAVORO, 3 - VALGATARA, MARANO DI VALPOLICELLA VR 37020, Italia",
    "lat": 45.5236317,
    "lng": 10.9093696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5236317,10.9093696"
  },
  {
    "name": "PREMIATA FARMACIA MARCOLUNGO DI MARCOLUNGO DOTT. GUGLIELMO E C. S AS",
    "address": "VIA C.A.DALLA CHIESA, 25, NOGARA VR 37054, Italia",
    "lat": 45.1788081,
    "lng": 11.0623127,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1788081,11.0623127"
  },
  {
    "name": "FARMACIA SAN BENEDETTO SAS",
    "address": "VIA BELL'ITALIA, 47/B, PESCHIERA DEL GARDA VR 37019, Italia",
    "lat": 45.451661,
    "lng": 10.6627876,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.451661,10.6627876"
  },
  {
    "name": "FARMACIA DOMEGLIARA S.A.S. DEI DOTTORI ANTONIO ZONATO E RICCARDO SORGI",
    "address": "VIA DEL PONTIERE, 2/A, SANT'AMBROGIO DI VALPOLICELLA - Domegliara VR 37015, Italia",
    "lat": 45.51853,
    "lng": 10.8159047,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.51853,10.8159047"
  },
  {
    "name": "FARMACIA NIGRI SAS DI NIGRI MARCO E MATTEO",
    "address": "PIAZZA DEL POPOLO, 2, SAN MARTINO BUON ALBERGO VR 37036, Italia",
    "lat": 45.422791,
    "lng": 11.0923413,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.422791,11.0923413"
  },
  {
    "name": "FARMACIA TREGNAGO DR.SSA MONICA",
    "address": "PIAZZA CASTELLO, 34, SALIZZOLE VR 37056, Italia",
    "lat": 45.2427684,
    "lng": 11.0837909,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2427684,11.0837909"
  },
  {
    "name": "PARAFARMACIA DOTT.SSA BIONDARO S.A.S. DI BIONDARO ELISA & C.",
    "address": "VIA SORTE - C.C. SAN BONIFACIO, San bonifacio VR 37047, Italia",
    "lat": 45.3971023,
    "lng": 11.2777686,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3971023,11.2777686"
  },
  {
    "name": "FARMA.CO S.R.L. -FARMACIA GAROFOLI-",
    "address": "VIA GAROFOLI, 135/137, SAN GIOVANNI LUPATOTO VR 37057, Italia",
    "lat": 45.3952318,
    "lng": 11.0280379,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3952318,11.0280379"
  },
  {
    "name": "FARMACIA PIEROPAN DI CRACCO PAOLA E TESSARI MARIANGELA S.N.C.",
    "address": "VIA C.BATTISTI, 18, TREGNAGO VR 37039, Italia",
    "lat": 45.5179247,
    "lng": 11.1639713,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5179247,11.1639713"
  },
  {
    "name": "FARMACIA MONTANARI SNC DI TURRA MARIA GRAZIA & C.",
    "address": "VIA N.COPERNICO, 5, LAVAGNO - Vago VR 37030, Italia",
    "lat": 45.4193692,
    "lng": 11.132666,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4193692,11.132666"
  },
  {
    "name": "FARMACIA CAPRI S.N.C. DI CAPRI ARIANNA & C.",
    "address": "VIA BASSONE, 56/A, VERONA VR 37139, Italia",
    "lat": 45.4521899,
    "lng": 10.8992529,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4521899,10.8992529"
  },
  {
    "name": "FARMACIA AL GIGLIO S.N.C. DEI DOTTORI FESTOSO E ZAMBOTTO",
    "address": "CORSO PORTA BORSARI, 46, VERONA VR 37121, Italia",
    "lat": 45.4421032,
    "lng": 10.993567,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4421032,10.993567"
  },
  {
    "name": "FARMACIA DOTT.SSA PALLARO NELLA LARA E C. S.A.S.",
    "address": "VIA PODGORA, 16/B, VERONA VR 37127, Italia",
    "lat": 45.4716947,
    "lng": 10.9893919,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4716947,10.9893919"
  },
  {
    "name": "FARMACIA S. ANTONIO SNC DELLE DR.SSE ALESSANDRA CORBELLI E V",
    "address": "VIA FINCATO, 66, VERONA VR 37131, Italia",
    "lat": 45.4444224,
    "lng": 11.019109,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4444224,11.019109"
  },
  {
    "name": "PARAFARMACIA BERTOLDO DR.ROBERTO",
    "address": "CORSO ARNALDO FRACCAROLI, 14, VILLA BARTOLOMEA VR 37049, Italia",
    "lat": 45.1546225,
    "lng": 11.3484458,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1546225,11.3484458"
  },
  {
    "name": "FMP DI MARCHESINI PAOLO",
    "address": "VIA I MAGGIO, 8/B, ZEVIO - Santa maria di zevio VR 37059, Italia",
    "lat": 45.3694861,
    "lng": 11.1082748,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3694861,11.1082748"
  },
  {
    "name": "FARMACIA COPPINI VERONICA",
    "address": "VIA ROMA, 31, BORCA DI CADORE BL 32040, Italia",
    "lat": 46.4377331,
    "lng": 12.2219683,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4377331,12.2219683"
  },
  {
    "name": "FARMACIA DOTT. RICCI FEDERICO",
    "address": "VIA TREVIGIANA, 4, FELTRE BL 32032, Italia",
    "lat": 46.0139108,
    "lng": 11.9116097,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0139108,11.9116097"
  },
  {
    "name": "FARMACIA ALLA MADONNA SNC DI ZANNONI LUCIA & C.",
    "address": "VIA GUGLIELMO MARCONI, 23, FONZASO BL 32030, Italia",
    "lat": 46.0131304,
    "lng": 11.8138883,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0131304,11.8138883"
  },
  {
    "name": "FARMACIA MAZZOCATO DR.SSA GIULIA",
    "address": "VIA G.MARCONI, 19/1, SEREN DEL GRAPPA BL 32030, Italia",
    "lat": 45.9892222,
    "lng": 11.8420589,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9892222,11.8420589"
  },
  {
    "name": "FARMACIA ALLE VETTE S.A.S. DELLA DOTT.SSA DALL'AGNOL MONICA",
    "address": "VIA VETTE, 78, FELTRE - Villabruna BL 32032, Italia",
    "lat": 46.05347,
    "lng": 11.9232782,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.05347,11.9232782"
  },
  {
    "name": "FARMACIA ALLA TORRE SNC",
    "address": "VIA F.M. PRETI, 1, CASTELFRANCO VENETO TV 31033, Italia",
    "lat": 45.6714326,
    "lng": 11.9264494,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6714326,11.9264494"
  },
  {
    "name": "FARMACIA FIDES DI CHIARADIA DONATELLA",
    "address": "VIA MARCONI, 129, VILLORBA TV 31020, Italia",
    "lat": 45.7331497,
    "lng": 12.2652236,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7331497,12.2652236"
  },
  {
    "name": "FARMACIA CIMAVILLA S.N.C.",
    "address": "VIA ENRICO FERMI, 1, CODOGNE' TV 31013, Italia",
    "lat": 45.8670236,
    "lng": 12.398595,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8670236,12.398595"
  },
  {
    "name": "FARMACIA MARSON S.N.C. DEL DR.MARSON NICOLA E DELLA DR.SSA C",
    "address": "Piazza Vittorio Veneto, 34, CAPPELLA MAGGIORE TV 31012, Italia",
    "lat": 45.9692858,
    "lng": 12.3623647,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9692858,12.3623647"
  },
  {
    "name": "FARMACIA FAVERO DR. PAOLO",
    "address": "VIA FRACASSI, 39, GAIARINE - Francenigo TV 31018, Italia",
    "lat": 45.9080284,
    "lng": 12.5077792,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9080284,12.5077792"
  },
  {
    "name": "HIPPO 13 FARMA S.R.L.",
    "address": "VIA GIUSEPPE GARIBALDI, 18, ODERZO TV 31046, Italia",
    "lat": 45.7805703,
    "lng": 12.4926687,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7805703,12.4926687"
  },
  {
    "name": "PARAFARMACIA OPITERGINA S.N.C.",
    "address": "PIAZZALE EUROPA, 9, ODERZO TV 31046, Italia",
    "lat": 45.7852192,
    "lng": 12.4934532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7852192,12.4934532"
  },
  {
    "name": "FARMACIA BRUNELLO DR.SSA EMANUELA",
    "address": "VIA PALLADIO, 20, PREGANZIOL TV 31022, Italia",
    "lat": 45.6089572,
    "lng": 12.2400864,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6089572,12.2400864"
  },
  {
    "name": "FARMACIA GIRARDI S.A.S. DEL DOTT. ENRICOMARIA GIRARDI & C.",
    "address": "VIA VITTORIO EMANUELE, 13, QUINTO DI TREVISO TV 31055, Italia",
    "lat": 45.6463184,
    "lng": 12.1706223,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6463184,12.1706223"
  },
  {
    "name": "FARMACIA PILLA S.N.C.",
    "address": "VIA CASTELLANA, 10, RESANA TV 31023, Italia",
    "lat": 45.6375978,
    "lng": 11.9541682,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6375978,11.9541682"
  },
  {
    "name": "FARMACIA POSTUMIA SNC DOTT.SSE SILVIA E. GAIOTTO E S. LENA",
    "address": "VIA MANZONI, 4 - FAGARE', SAN BIAGIO DI CALLALTA TV 31048, Italia",
    "lat": 45.7068274,
    "lng": 12.4462211,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7068274,12.4462211"
  },
  {
    "name": "NATURALBA PARAFARMACIA DI MARTIN MATILDE",
    "address": "VIALE AURORA, 145, SAN MICHELE AL TAGLIAMENTO - Bibione VE 30020, Italia",
    "lat": 45.6354018,
    "lng": 13.0462608,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6354018,13.0462608"
  },
  {
    "name": "FARMACIA ZORZETTO DR.PAOLO",
    "address": "VIA FAUSTA, 69 (cons.seminterrato), CAVALLINO TREPORTI - Ca' savio VE 30013, Italia",
    "lat": 45.45291,
    "lng": 12.454069,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.45291,12.454069"
  },
  {
    "name": "FARMACIA PANCINO S.A.S. DELLA DR.SSA VALENTINA PANCINO & C.",
    "address": "VIA ROMA, 91, CINTO CAOMAGGIORE VE 30020, Italia",
    "lat": 45.8221792,
    "lng": 12.788747,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8221792,12.788747"
  },
  {
    "name": "FARMACIA MAZZINI S.A.S. DEL DOTT. DARIO BORIN & C.",
    "address": "VIA A.BAFILE, 445, JESOLO LIDO VE 30016, Italia",
    "lat": 45.4977808,
    "lng": 12.6263117,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4977808,12.6263117"
  },
  {
    "name": "FARMACIA ALLA MADONNA S.A.S DEL DOTT. MARZIO SALVAGNIN",
    "address": "VIA SAN DONA', 6, VENEZIA - Mestre VE 30175, Italia",
    "lat": 45.5048694,
    "lng": 12.2516968,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5048694,12.2516968"
  },
  {
    "name": "PARAFARMACIA FRANZ DR.SSA SABRINA",
    "address": "VIALE DON L.STURZO, 25, VENEZIA - Mestre VE 30174, Italia",
    "lat": 45.5084966,
    "lng": 12.2562033,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5084966,12.2562033"
  },
  {
    "name": "FARMACIA MASCARUCCI FRANCESCO E C. S.N.C.",
    "address": "PIAZZA XX SETTEMBRE, 12, NOALE VE 30033, Italia",
    "lat": 45.5500384,
    "lng": 12.0733615,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5500384,12.0733615"
  },
  {
    "name": "FARMACIA POLES DR.SSA RAFFAELLA",
    "address": "VIA PORDENONE, 30, PORTOGRUARO VE 30026, Italia",
    "lat": 45.7955278,
    "lng": 12.8205586,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7955278,12.8205586"
  },
  {
    "name": "FARMACIA QUINTAVALLE S.R.L.",
    "address": "VIA NOVENTA, 123, SAN DONA' DI PIAVE VE 30027, Italia",
    "lat": 45.6434828,
    "lng": 12.5513573,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6434828,12.5513573"
  },
  {
    "name": "FARMACIA MORETTO DI MORETTO WIEL ALVISE",
    "address": "VIA PAPA GIOVANNI XXIII, 10, SAN STINO DI LIVENZA VE 30029, Italia",
    "lat": 45.7287802,
    "lng": 12.6773228,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7287802,12.6773228"
  },
  {
    "name": "FARMACIA SALVADORI DR.SSA LAURA",
    "address": "CANNAREGIO S.LEONARDO 1339, VENEZIA VE 30121, Italia",
    "lat": 45.4437721,
    "lng": 12.3268305,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4437721,12.3268305"
  },
  {
    "name": "FARMACIA TANCREDI DELLA DOTT.SSA BEATRICE & C. S.A.S.",
    "address": "Via Edmondo de Amicis, 64, GONARS UD 33050, Italia",
    "lat": 45.8962949,
    "lng": 13.2371208,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8962949,13.2371208"
  },
  {
    "name": "FARMACIA AUSILIATRICE DI PAGANINI CARLO",
    "address": "Via Magellano, 27, CAMISANO VICENTINO VI 36043, Italia",
    "lat": 45.519098,
    "lng": 11.6897739,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.519098,11.6897739"
  },
  {
    "name": "LA SANITARIA SAS DI GALANTE BRUNO E C.",
    "address": "Via San Pardo  73/D, Matera MT 75100, Italia",
    "lat": 40.677886,
    "lng": 16.59254,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.677886,16.59254"
  },
  {
    "name": "FARMACIA PROPERZI DR. ROBERTO",
    "address": "Via Brodoloni, 24/B, TERNI TR 05100, Italia",
    "lat": 42.5445747,
    "lng": 12.6443713,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5445747,12.6443713"
  },
  {
    "name": "FARMACIA FRACASSINI S.A.S. DI MARIA CRISTINA LORENZINI",
    "address": "Via G. Di Vittorio, 22, CORCIANO - Ellera PG 06070, Italia",
    "lat": 43.1050594,
    "lng": 12.3073369,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1050594,12.3073369"
  },
  {
    "name": "FARMACIA S.PAOLO S.R.L.",
    "address": "Piazza IV Novembre, 32, AZZANO SAN PAOLO BG 24052, Italia",
    "lat": 45.6617156,
    "lng": 9.6749638,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6617156,9.6749638"
  },
  {
    "name": "FARMACIA SAN MAURO - DR.SSA SILVIA FARINA & C. S.A.S.",
    "address": "Piazza Santissimo Redentore, 33, SARNICO BG 24067, Italia",
    "lat": 45.6678423,
    "lng": 9.9564735,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6678423,9.9564735"
  },
  {
    "name": "FARMACIA BONETTI BULGARI S.R.L.",
    "address": "Viale Rimembranza 7, PISOGNE BS 25055, Italia",
    "lat": 40.6579865,
    "lng": 15.4006156,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.6579865,15.4006156"
  },
  {
    "name": "SANITARIA LEVANTE S.N.C. DI PARMA MARINA E SILVIA & C.",
    "address": "Via Emilia Levante,92, BOLOGNA BO 40139, Italia",
    "lat": 44.4819056,
    "lng": 11.3791268,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4819056,11.3791268"
  },
  {
    "name": "COMUNE DI BOLZANO",
    "address": "Piazza Municipio, 5, BOLZANO BZ 39100, Italia",
    "lat": 46.4554499,
    "lng": 11.2594045,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4554499,11.2594045"
  },
  {
    "name": "PHARMATRE S.R.L.",
    "address": "Via San Ciriaco 28, CIRIE' TO 10073, Italia",
    "lat": 45.2341725,
    "lng": 7.6048054,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2341725,7.6048054"
  },
  {
    "name": "STRINGHINI SNC DI DANILO E ALESSIO STRINGHINI",
    "address": "Via A. Volta,55, GENOVA GE 16128, Italia",
    "lat": 44.3993824,
    "lng": 8.9388038,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3993824,8.9388038"
  },
  {
    "name": "SANITARIA ROMAGNOLA S.R.L.",
    "address": "Via Provinciale Cotignola,22/1, LUGO RA 48022, Italia",
    "lat": 44.4132131,
    "lng": 11.9298878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4132131,11.9298878"
  },
  {
    "name": "FARMACIA SANTA CHIARA S.A.S. DR.SSA PONZETTO SABRINA & C.",
    "address": "Corso Re Umberto I n 27, CIGLIANO VC 13043, Italia",
    "lat": 45.3094164,
    "lng": 8.0211038,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3094164,8.0211038"
  },
  {
    "name": "FARMACIA REDA S.N.C. DELLE DOTT.SSE CARLA CONTI E SANDRA ROSSI",
    "address": "Piazza Don Milani, 5, FAENZA RA 48018, Italia",
    "lat": 44.3020232,
    "lng": 11.9698539,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3020232,11.9698539"
  },
  {
    "name": "SANIMED DI FORTI FRANCESCO & C. S.A.S.",
    "address": "Via Mazzini,116, MOLINELLA BO 40062, Italia",
    "lat": 44.6215689,
    "lng": 11.6696976,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6215689,11.6696976"
  },
  {
    "name": "FARMACIA ZAFFIRI DEL DOTT. ZAFFIRI G.M. & C. SNC",
    "address": "Via di Pietralata, 511, ROMA RM 00158, Italia",
    "lat": 41.9196821,
    "lng": 12.5489441,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9196821,12.5489441"
  },
  {
    "name": "FARMACIA DR.SSA LUCHINI ELDA",
    "address": "PIAZZA ANGELETTI, 5, SANT'ANGELO IN PONTANO MC 62020, Italia",
    "lat": 43.0989025,
    "lng": 13.3975943,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.0989025,13.3975943"
  },
  {
    "name": "ATHENA - LABORATORIO ORTOPEDICO SRL",
    "address": "Via Chiesa Della Salute, 7, TORINO TO 10147, Italia",
    "lat": 45.0930173,
    "lng": 7.6777513,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0930173,7.6777513"
  },
  {
    "name": "FARMACIA DEL SAGITTARIO DELLE DR.SSE PAPARELLI E CIABILLI S.N.C.",
    "address": "Piazza Asslar, 2, FOSSATO DI VICO PG 06022, Italia",
    "lat": 43.2924507,
    "lng": 12.7506861,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2924507,12.7506861"
  },
  {
    "name": "FARMACIA PATUNA SRL",
    "address": "CORSO SAN GIACOMO, 1, TRIESTE TS 34137, Italia",
    "lat": 45.6490827,
    "lng": 13.7775078,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6490827,13.7775078"
  },
  {
    "name": "MUGA S.A.S. DI GIACOMO MUGANI",
    "address": "VIA PRINCIPALE, 46, POVOLETTO - Savorgnano del torre UD 33040, Italia",
    "lat": 46.1642572,
    "lng": 13.2677133,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1642572,13.2677133"
  },
  {
    "name": "FARMACIE ZAMBONI S.N.C. DEI DOTTORI MARCO E VITTORIO ZAMBONI",
    "address": "Piazzale Gioberti, 8/f, TRIESTE TS 34128, Italia",
    "lat": 45.6562636,
    "lng": 13.8057878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6562636,13.8057878"
  },
  {
    "name": "UNA MELA AL GIORNO DI VICENTINI ELISABETTA",
    "address": "Via Madre Teresa di Calcutta, GONZAGA MN 46023, Italia",
    "lat": 44.9555422,
    "lng": 10.8290901,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9555422,10.8290901"
  },
  {
    "name": "FARMAPIU' DI LUITPRANDI LORETTA",
    "address": "Piazza Giacomo Matteotti 45, PEGOGNAGA MN 46020, Italia",
    "lat": 44.9958127,
    "lng": 10.8579251,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9958127,10.8579251"
  },
  {
    "name": "FARMACIA SAN ROCCO DELLA DOTTORESSA LABAGNARA SIMONETTA",
    "address": "Via monte santo 18, VILLESSE GO 34070, Italia",
    "lat": 45.8651188,
    "lng": 13.4426699,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.8651188,13.4426699"
  },
  {
    "name": "FARMACIA PISTONE S.A.S.",
    "address": "Via Annunziatella, 76, MATERA MT 75100, Italia",
    "lat": 40.6722417,
    "lng": 16.6032731,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.6722417,16.6032731"
  },
  {
    "name": "BELFARM SRL",
    "address": "Via S. Anselmo, 14, TORINO TO 10125, Italia",
    "lat": 45.1429694,
    "lng": 7.766111,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1429694,7.766111"
  },
  {
    "name": "FARMACIA LA PACIANA SRL",
    "address": "Via Vasari, snc, FOLIGNO PG 06034, Italia",
    "lat": 42.9643251,
    "lng": 12.6811873,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9643251,12.6811873"
  },
  {
    "name": "SANITARIA SCHISANO S.A.S. di SCHISANO GIUSEPPE & CO.",
    "address": "Via Giuseppe Verdi, 59, PRAIA A MARE CS 87028, Italia",
    "lat": 39.9027571,
    "lng": 15.7771539,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9027571,15.7771539"
  },
  {
    "name": "PHARMA FLORENCE SRL",
    "address": "Borgo La Croce, 4/r, FIRENZE FI 50121, Italia",
    "lat": 43.7709392,
    "lng": 11.2701395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7709392,11.2701395"
  },
  {
    "name": "AZIENDA FARMACIE COMUNALI SRL",
    "address": "Via dei Filosofi, 59, SPOLETO PG 06049, Italia",
    "lat": 42.7425831,
    "lng": 12.735292,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.7425831,12.735292"
  },
  {
    "name": "FARMACIA DOTT. GIROTTI FILIPPO",
    "address": "Via Alessandria, 119 A/B/C, ROMA RM 00198, Italia",
    "lat": 41.9128995,
    "lng": 12.504146,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9128995,12.504146"
  },
  {
    "name": "SANITARIA CAPRI DI BADALA PATRIZIA ANTONIA GIUSEPPINA",
    "address": "Viale Tirreno, 207, ROMA RM 00141, Italia",
    "lat": 41.9379586,
    "lng": 12.5308168,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9379586,12.5308168"
  },
  {
    "name": "SANITARIA ORTOPEDIA LUNGHINI",
    "address": "Via Firenze, 48/A, CASTIGLIONE DEL LAGO PG 06061, Italia",
    "lat": 43.1301038,
    "lng": 12.042854,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1301038,12.042854"
  },
  {
    "name": "LA FARMACISTA DELLA DOTT.SSA GIULIA MUGGIANU",
    "address": "Via Lamarmora, 69/B, DORGALI NU 08022, Italia",
    "lat": 40.2926561,
    "lng": 9.5883033,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.2926561,9.5883033"
  },
  {
    "name": "F.CIA S.PIO ARCANGELA AR & RA S.A.S. DI RANIERI PAOLINO",
    "address": "Via Cola di Rienzo, 212, ROMA RM 00192, Italia",
    "lat": 41.9072063,
    "lng": 12.4625351,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9072063,12.4625351"
  },
  {
    "name": "OTOPLUS 5 DI FIORENTINI FRANCO",
    "address": "Via F. Nullo, 6, FORLI' FC 47100, Italia",
    "lat": 44.2229699,
    "lng": 12.0435319,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2229699,12.0435319"
  },
  {
    "name": "INVERNIZZI ERNESTO SpA",
    "address": "Via Tor Cervara, 258, ROMA RM 00155, Italia",
    "lat": 41.9203997,
    "lng": 12.5975642,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9203997,12.5975642"
  },
  {
    "name": "FARMACIA CASTELLO SAS DI FERRARI A. & C.",
    "address": "Via Galileo Galilei 85/A, Brescia  BS 25128, Italia",
    "lat": 45.5486616,
    "lng": 10.227318,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5486616,10.227318"
  },
  {
    "name": "FARMACIA SANTI SNC DI MARIA FLORIANA E ANNA SANTI",
    "address": "Via del Molino, MONTE CASTELLO DI VIBIO PG 06057, Italia",
    "lat": 42.8413661,
    "lng": 12.3763124,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8413661,12.3763124"
  },
  {
    "name": "FARMACIA SALVIONI SRL",
    "address": "VIA OBERDAN 3, PISA PI 56127, Italia",
    "lat": 43.7182941,
    "lng": 10.4019877,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.7182941,10.4019877"
  },
  {
    "name": "FARMACIA BELLERI SNC",
    "address": "VIA MAMELI , 70, GAVI AL 15066, Italia",
    "lat": 44.6888785,
    "lng": 8.8020789,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6888785,8.8020789"
  },
  {
    "name": "FARMACIA SERENA DELLA DOTT.SSA SERENA ONGARO",
    "address": "Piazza Mercato, 6, VILLAMARZANA RO 45030, Italia",
    "lat": 45.01406,
    "lng": 11.69355,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.01406,11.69355"
  },
  {
    "name": "PIU' SALUTE DI MARTA OLIVIERI",
    "address": "Via Matteotti 17, MOGLIANO VENETO TV 31021, Italia",
    "lat": 45.5611895,
    "lng": 12.2338032,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5611895,12.2338032"
  },
  {
    "name": "NEW BE.BA. DI BARTOLUCCI KATIUSCIA",
    "address": "Via Circonvallazione, 51, URBINO PU 61029, Italia",
    "lat": 43.8136386,
    "lng": 12.7133048,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8136386,12.7133048"
  },
  {
    "name": "FARMACIA ORLANDI DOTT.SSA MONICA",
    "address": "Via Caterina Alberti 30, ASOLA - Castelnuovo MN 46041, Italia",
    "lat": 45.248125,
    "lng": 10.457054,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.248125,10.457054"
  },
  {
    "name": "SANITARIA ORTOPEDICA ARGENTANA S.R.L.",
    "address": "Via Matteotti,26/d, ARGENTA FE 44011, Italia",
    "lat": 44.6142032,
    "lng": 11.8369614,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6142032,11.8369614"
  },
  {
    "name": "FARMACIA S. TERESA S.N.C. DELLE DOTT.SSE TURCO E CASAROTTO",
    "address": "Via A. Ferrarin, 2, BREGANZE VI 36042, Italia",
    "lat": 45.7009976,
    "lng": 11.5638588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7009976,11.5638588"
  },
  {
    "name": "PARAFARMACIA PACIANA DT. M. T. TACCONI",
    "address": "Viale Firenze, 186/C, FOLIGNO PG 06034, Italia",
    "lat": 42.966504,
    "lng": 12.694972,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.966504,12.694972"
  },
  {
    "name": "FARMACIA BASSANO ROMANO SAS",
    "address": "Via L. Da Vinci, 4, BASSANO ROMANO VT 01030, Italia",
    "lat": 42.2222095,
    "lng": 12.1766612,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2222095,12.1766612"
  },
  {
    "name": "FARMACIA LUCIANI S.N.C. DI LUCIANI LIVIO ED ELISABETTA",
    "address": "Via Manzolli, 36, OSTELLATO - Rovereto ferrarese FE 44020, Italia",
    "lat": 44.7660709,
    "lng": 11.8718654,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.7660709,11.8718654"
  },
  {
    "name": "ONE RACE S.R.L.",
    "address": "Via Antonio Fogazzaro, 76, ROMA RM 00137, Italia",
    "lat": 41.9417164,
    "lng": 12.5486945,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9417164,12.5486945"
  },
  {
    "name": "PARAFARMACIA BETTI SNC",
    "address": "Via Roma, 27, FOLIGNO PG 06034, Italia",
    "lat": 42.9558943,
    "lng": 12.7039417,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9558943,12.7039417"
  },
  {
    "name": "FARMACIA DOTT.SSA CAPORUSSO ANNARITA",
    "address": "Via della Libertà, 256, BELLINZAGO NOVARESE NO 28043, Italia",
    "lat": 45.5542848,
    "lng": 8.6399208,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5542848,8.6399208"
  },
  {
    "name": "FARMACIA SABLONE SRL",
    "address": "Via Garibaldi,9, TRASACCO AQ 67059, Italia",
    "lat": 41.9564126,
    "lng": 13.5358725,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9564126,13.5358725"
  },
  {
    "name": "FARMACIA CASAVECCHIA ILARIA",
    "address": "Via Foglio, 1, SERRALUNGA D'ALBA CN 12050, Italia",
    "lat": 44.6093029,
    "lng": 8.0006498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6093029,8.0006498"
  },
  {
    "name": "PARAFARMACIA LA RIVIERA DI CHIFARI CRISTINA",
    "address": "VIA MARTIRI DELLA LIBERTA', 28, ALBENGA SV 17031, Italia",
    "lat": 44.0479268,
    "lng": 8.216178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0479268,8.216178"
  },
  {
    "name": "PARAFARMACIA L'APE REGINA S.R.L.S. UNIPERSONALE",
    "address": "VIA UMBERTO I, 48 , CASTEL DI SANGRO AQ 67031, Italia",
    "lat": 41.7843457,
    "lng": 14.1075734,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7843457,14.1075734"
  },
  {
    "name": "FARMACIA MONTEMAGGI DI DAVIDE E ISABELLA TAGLIAVINI SNC",
    "address": "P.zza A. Magnani, 29, CESENA FC 47522, Italia",
    "lat": 44.1362988,
    "lng": 12.226307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1362988,12.226307"
  },
  {
    "name": "FARMACIA CENTRALE DI MEDINA ANNA MARIA & C. S.A.S.",
    "address": "VIA G. MAZZINI 7, CORDENONS PN 33084, Italia",
    "lat": 45.9870953,
    "lng": 12.7055503,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9870953,12.7055503"
  },
  {
    "name": "FARMACIA AL DUOMO S.R.L.",
    "address": "Piazza Caduti della Julia, 27, LATISANA UD 33053, Italia",
    "lat": 45.7762833,
    "lng": 12.997059,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7762833,12.997059"
  },
  {
    "name": "FARMACIA MEDICATRIX EREDI MORETTO S.N.C. DI GIOVANNI BATTISTA E LEOPOL",
    "address": "Via G. Marconi, 15, PONTE DI PIAVE TV 31047, Italia",
    "lat": 45.7151703,
    "lng": 12.4626301,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7151703,12.4626301"
  },
  {
    "name": "FARMACIA BELLAVITIS DELLA DR.SSA ALBERTA BELLAVITIS",
    "address": "Via Postumia Centro, 75, SAN BIAGIO DI CALLALTA TV 31048, Italia",
    "lat": 45.6850063,
    "lng": 12.378019,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6850063,12.378019"
  },
  {
    "name": "FARMACIA DEL GRATICOLATO SRL",
    "address": "Via Desman, 51, SANTA MARIA DI SALA VE 30036, Italia",
    "lat": 45.5143662,
    "lng": 12.0539546,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5143662,12.0539546"
  },
  {
    "name": "TREVIFARMA S.R.L.",
    "address": "Via Postumia Ovest, 243, SAN BIAGIO DI CALLALTA TV 31048, Italia",
    "lat": 45.6718044,
    "lng": 12.3283473,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6718044,12.3283473"
  },
  {
    "name": "FARMACIA KENNEDY DI NOBILI ANDREA",
    "address": "Via Kennedy 75 b, Laives BZ 39055, Italia",
    "lat": 46.4279467,
    "lng": 11.3396846,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.4279467,11.3396846"
  },
  {
    "name": "SANITARIA RR DI RONCOLATO VANIA",
    "address": "Viale Europa 51, MONTECCHIO MAGGIORE VI 36075, Italia",
    "lat": 45.5010525,
    "lng": 11.413588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5010525,11.413588"
  },
  {
    "name": "FARMACIA MACERONE DEL DOTT. ANDREA BONDI E C. S.A.S.",
    "address": "Via Cesenatico n. 5579, CESENA - Macerone FC 47521, Italia",
    "lat": 44.155286,
    "lng": 12.329129,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.155286,12.329129"
  },
  {
    "name": "FARMACIA SAN VENERIO DEL DOTTOR FRANCESCO MANFREDI E C. S.A.S",
    "address": "Via G.Matteotti, n 47 , REGGIOLO RE 42046, Italia",
    "lat": 44.9179372,
    "lng": 10.8052214,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9179372,10.8052214"
  },
  {
    "name": "NEO FARMA 20 SRL",
    "address": "Via Paolo Lomazzo n. 19, MILANO MI 20139, Italia",
    "lat": 45.4808585,
    "lng": 9.1734756,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4808585,9.1734756"
  },
  {
    "name": "FARMACIA SAN PAOLO S.R.L.",
    "address": "Via Brancaleone 2 , GENAZZANO RM 00030, Italia",
    "lat": 41.8326117,
    "lng": 12.9729521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8326117,12.9729521"
  },
  {
    "name": "F.CIA SANCLETO DOTT. PLUCHINOTTA PALMIERI",
    "address": "Via Montecassiano, 163, ROMA RM 00156, Italia",
    "lat": 41.9432586,
    "lng": 12.5719293,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.9432586,12.5719293"
  },
  {
    "name": "FARMACIA BARBERO S.N.C.",
    "address": "Piazza Libertà, 12/A - 13, MONASTEROLO DI SAVIGLIANO CN 12030, Italia",
    "lat": 44.6871536,
    "lng": 7.6197542,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6871536,7.6197542"
  },
  {
    "name": "FARMACIA ROTTONDO DI RINALDI VALENTINA E RINALDI FEDERICO S.N.C.",
    "address": "Via Roma, 1, FOSSANO CN 12045, Italia",
    "lat": 44.551766,
    "lng": 7.7261487,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.551766,7.7261487"
  },
  {
    "name": "FARMACIA SAN VALENTINO S.A.S. DELLA DOTT.SSA PAOLUCCI & C.",
    "address": "Borgo Garibaldi, 8, PENNA IN TEVERINA TR 05028, Italia",
    "lat": 42.4921797,
    "lng": 12.3551024,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4921797,12.3551024"
  },
  {
    "name": "FARMACIA CANDELORI DOTT. ANDREA",
    "address": "Via Nazionale, 247, ROSETO DEGLI ABRUZZI TE 64026, Italia",
    "lat": 42.6765038,
    "lng": 14.0152151,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6765038,14.0152151"
  },
  {
    "name": "ARRO' & ZINGARELLI SRL",
    "address": "Via Croix de Ville, 68, AOSTA AO 11100, Italia",
    "lat": 45.7378159,
    "lng": 7.3163149,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7378159,7.3163149"
  },
  {
    "name": "FARMACIA VERDECCHIA SNC",
    "address": "Via Calcagni, 31, RECANATI MC 62019, Italia",
    "lat": 43.4023013,
    "lng": 13.5515493,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.4023013,13.5515493"
  },
  {
    "name": "FARMACIA PETROSELLI S.A.S. DELLA DR.SSA MARIA TERESA PETROSELLI",
    "address": "Via Carlo Cattaneo 30/D, VITERBO VT 01100, Italia",
    "lat": 42.4137307,
    "lng": 12.1161881,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4137307,12.1161881"
  },
  {
    "name": "FARMACIE SAN PIO S.A.S. DEL DOTT. DAVIDE ANNOSTINI",
    "address": "VIA BRAGGIO, 1, SANTA CATERINA D'ESTE PD 35049, Italia",
    "lat": 45.195729,
    "lng": 11.6163243,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.195729,11.6163243"
  },
  {
    "name": "FARMACIA SAN GIORGIO S.R.L.",
    "address": "Via Nazionale, 90, SAN MICHELE AL TAGLIAMENTO VE 30028, Italia",
    "lat": 45.7810067,
    "lng": 12.9786774,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7810067,12.9786774"
  },
  {
    "name": "AFAM SPA",
    "address": "Piazza Giacomini, 30, FOLIGNO PG 06034, Italia",
    "lat": 42.9573082,
    "lng": 12.7073248,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9573082,12.7073248"
  },
  {
    "name": "FARMACIA DELL'OSPEDALE DELLA DOTT.SSA TIZIANA PAZZAGLINI E C. S.A .S.",
    "address": "Via G. Pascoli, 1, SANTARCANGELO DI ROMAGNA RN 47822, Italia",
    "lat": 44.0632771,
    "lng": 12.4473983,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0632771,12.4473983"
  },
  {
    "name": "FARMACIA COMUNALE DI CAPRIOLO SRL",
    "address": "Piazza Mercato 3, CAPRIOLO BS 25031, Italia",
    "lat": 45.6392661,
    "lng": 9.9302627,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6392661,9.9302627"
  },
  {
    "name": "FARMACIA CINQUE ARCHI  S.N.C.",
    "address": "Via dei Cinque Archi 343, VELLETRI RM 00049, Italia",
    "lat": 41.6666199,
    "lng": 12.7739095,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6666199,12.7739095"
  },
  {
    "name": "SANITARIA LE RAYON DI BARBERINI ELEONORA",
    "address": "Via Gramsci 49/51, GATTEO A MARE FC 47043, Italia",
    "lat": 44.1705238,
    "lng": 12.4383557,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1705238,12.4383557"
  },
  {
    "name": "FARMACIA BETTELLI MAURIZIO SNC DI BETTELLI MAURIZIO E GRAZIANO",
    "address": "Corso Roma, 65, AVIGLIANO UMBRO TR 05020, Italia",
    "lat": 42.6523682,
    "lng": 12.4283742,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.6523682,12.4283742"
  },
  {
    "name": "FARMACIA FRANCIACORTA S.R.L.",
    "address": "Via provinciale 32 /A, ERBUSCO BS 25030, Italia",
    "lat": 45.5994946,
    "lng": 9.9680382,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5994946,9.9680382"
  },
  {
    "name": "FARMACIA ANDES S.N.C. DI MELCHIORI ANDREA E FORONI JACOPO FRANCES CO",
    "address": "Strada Romana, 109, BORGO VIRGILIO MN 46030, Italia",
    "lat": 45.1145335,
    "lng": 10.8146459,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1145335,10.8146459"
  },
  {
    "name": "COMUNE DI ARICCIA",
    "address": "Piazza San Nicola, ARICCIA RM 00040, Italia",
    "lat": 41.7198576,
    "lng": 12.6705145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7198576,12.6705145"
  },
  {
    "name": "FARMACIA PADRE PIO DI PORQUEDDU ELENA",
    "address": "Via Nazionale, 56, CARCARE SV 17043, Italia",
    "lat": 44.3560154,
    "lng": 8.2918048,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3560154,8.2918048"
  },
  {
    "name": "D&V PHARMA PARAFARMACIA DI MALANDRA DOTT.SSA VALERIA",
    "address": "Via Marrucina, 198/9, GUARDIAGRELE CH 66016, Italia",
    "lat": 42.2099666,
    "lng": 14.222985,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2099666,14.222985"
  },
  {
    "name": "FARMACIE CHIMENTI S.R.L.",
    "address": "VIALE GIOVANNI PAOLO I, 43/A, BELLUNO BL 32100, Italia",
    "lat": 46.1474233,
    "lng": 12.217363,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1474233,12.217363"
  },
  {
    "name": "FARMACIA GRAGNOLATI D.SSA PATRIZIA",
    "address": "VIA XX SETTEMBRE, 24, BOSCO MARENGO AL 15062, Italia",
    "lat": 44.8219562,
    "lng": 8.6801049,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8219562,8.6801049"
  },
  {
    "name": "FARMACIA D'ANNIBALE DOTT.SSA LUCIA",
    "address": "Via Ex Tiburtina Valeria, 12, TURRIVALIGNANI PE 65020, Italia",
    "lat": 42.2729245,
    "lng": 14.0204457,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.2729245,14.0204457"
  },
  {
    "name": "FARMACIA ROSSIGNOLI S.A.S. DELLA DOTT.SSA CRISTINA ROSSIGNOLI",
    "address": "Via della Repubblica, 3, RONCO ALL'ADIGE VR 37055, Italia",
    "lat": 45.3533357,
    "lng": 11.1918569,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.3533357,11.1918569"
  },
  {
    "name": "GRUPPO FARO S.A.S. DELLA DR.SSA MAREK E DEL DR. ROSSI",
    "address": "Via Romeo Gallenga, 120, PERUGIA PG 06127, Italia",
    "lat": 43.1070331,
    "lng": 12.3669106,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1070331,12.3669106"
  },
  {
    "name": "FARMACIE COMUNALI F.V.G. S.P.A. SOCIETA' BENEFIT",
    "address": "VIA GABELLI, 4, PORCIA PN 33080, Italia",
    "lat": 45.9602125,
    "lng": 12.6282199,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9602125,12.6282199"
  },
  {
    "name": "FARMACIA D.SSA DONATA PIZZI",
    "address": "Piazza San Lorenzo 23, MESOLA - Ariano ferrarese FE 44026, Italia",
    "lat": 44.9430065,
    "lng": 12.1204198,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9430065,12.1204198"
  },
  {
    "name": "FARMACIA DOTT.SSA PELLACCHI ANGELA",
    "address": "Piazza Duca degli Abruzzi, 70, TAGLIACOZZO AQ 67069, Italia",
    "lat": 42.0679926,
    "lng": 13.2531269,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.0679926,13.2531269"
  },
  {
    "name": "GRIMA S.A.S. DI MASINI MARIA TERESA & C.",
    "address": "Strada del Pasubio, 165, COSTABISSARA - Motta VI 36030, Italia",
    "lat": 45.600459,
    "lng": 11.4945311,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.600459,11.4945311"
  },
  {
    "name": "FARMACIA LIBRALESSO SNC DELLA DOTT.SSA MARIAROSA LIBRALESSO",
    "address": "Via Mocenigo, 30, MIRA - Mira porte VE 30034, Italia",
    "lat": 45.4395751,
    "lng": 12.1396401,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4395751,12.1396401"
  },
  {
    "name": "LA GRIMANA SANITARIA ORTOPEDIA FISIOTERAPIA SRL",
    "address": "Via Savorgnano, 7/1, SAN VITO AL TAGLIAMENTO PN 33078, Italia",
    "lat": 45.9120415,
    "lng": 12.8571277,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9120415,12.8571277"
  },
  {
    "name": "FUMAGALLI SILVIA",
    "address": "Corso Europa 40, VALLEDORIA SS 07039, Italia",
    "lat": 40.9289909,
    "lng": 8.8264174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.9289909,8.8264174"
  },
  {
    "name": "FARMACIA ALL'OROLOGIO SAS DI GIULIA GIOVANETTI E C.",
    "address": "Via dell'Orologio, 6, TRIESTE TS 34021, Italia",
    "lat": 45.6492948,
    "lng": 13.7668564,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6492948,13.7668564"
  },
  {
    "name": "FARMACIA SABBIADORO SRL",
    "address": "Via Tolmezzo, 3, LIGNANO SABBIADORO UD 33054, Italia",
    "lat": 45.6900626,
    "lng": 13.1444727,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6900626,13.1444727"
  },
  {
    "name": "FARMACIA LIVIERO S.N.C. di Alberto Liviero & C.",
    "address": "Via Roccolo, 1, BRENDOLA VI 36040, Italia",
    "lat": 45.4756026,
    "lng": 11.4422714,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4756026,11.4422714"
  },
  {
    "name": "BRESCIA SERVICE S.R.L.",
    "address": "Via della Volta, 122, BRESCIA BS 25124, Italia",
    "lat": 45.5064799,
    "lng": 10.2308396,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5064799,10.2308396"
  },
  {
    "name": "FARMACIA DOTT.SSA D'ISIDORO MARIA",
    "address": "Via San Michele, 9, CASTILENTI TE 64035, Italia",
    "lat": 42.5340519,
    "lng": 13.9189589,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.5340519,13.9189589"
  },
  {
    "name": "FARMACIA PERESSINI S.N.C. DELLE DR.SSE SCOTINI ELISABETTA E BIGAL ERIC",
    "address": "Via Roma, 1/A, CHIARANO TV 31040, Italia",
    "lat": 45.7348727,
    "lng": 12.5530543,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.7348727,12.5530543"
  },
  {
    "name": "FARMACIA MULAS REMO SNC",
    "address": "VIA DON MINZONI 118, ALGHERO SS 07041, Italia",
    "lat": 40.5751998,
    "lng": 8.3210953,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.5751998,8.3210953"
  },
  {
    "name": "FARMACIA ESSENZA S.R.L.",
    "address": "Via Madrid 1014/E, CASTEL GOFFREDO MN 46042, Italia",
    "lat": 45.2939101,
    "lng": 10.4654522,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2939101,10.4654522"
  },
  {
    "name": "FARMACIA CITTA' GIARDINO DELLA DR.SSA SARA LAURETTA & C. SAS",
    "address": "Via Sandro Gallo, 108, VENEZIA - Lido VE 30126, Italia",
    "lat": 45.4016606,
    "lng": 12.3609275,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4016606,12.3609275"
  },
  {
    "name": "FARMACIE ASSOCIATE PAM DI MONTORSI PAOLO E C. S.N.C.",
    "address": "Via Emilia Est, 799, MODENA MO 41100, Italia",
    "lat": 44.6362475,
    "lng": 10.9510553,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6362475,10.9510553"
  },
  {
    "name": "FARMACIA SAN MICHELE S.A.S. DEL DOTTOR FRANCESCO TRIMBOLI E",
    "address": "Via dei Mille, 30, ROCCASTRADA - Sticciano scalo GR 58036, Italia",
    "lat": 42.9276632,
    "lng": 11.1242845,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9276632,11.1242845"
  },
  {
    "name": "PARAFARMACIA LA PERLA DI RIGONI LUCA",
    "address": "Via BRONZETI, CAVALESE TN 38033, Italia",
    "lat": 46.291061,
    "lng": 11.4608403,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.291061,11.4608403"
  },
  {
    "name": "FARMACIA S. FRANCESCO DELLA DOTT.SSA ANNA MARIA FESTA S.A.S.",
    "address": "VIA TEMPIO 12, AGLIENTU  SS 07020, Italia",
    "lat": 41.0777628,
    "lng": 9.1124521,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.0777628,9.1124521"
  },
  {
    "name": "ASIAN TRADING COMPANY",
    "address": "Al quoz industrial area 3 - P O box 6275- Next to Makita power tools, DUBAI 6275, Emirati Arabi Uniti",
    "lat": 25.139584,
    "lng": 55.2187,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=25.139584,55.2187"
  },
  {
    "name": "FARMACIA DOTT. BENATI",
    "address": "Via A. Della Scala, 56, LAZISE VR 37017, Italia",
    "lat": 45.502534,
    "lng": 10.7429137,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.502534,10.7429137"
  },
  {
    "name": "FARMACIA DUE CAMPANE S.R.L.",
    "address": "Via E. Noris, 2B, VERONA VR 37121, Italia",
    "lat": 45.4403733,
    "lng": 10.9958042,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4403733,10.9958042"
  },
  {
    "name": "LA SANITARIA DEL BENESSERE SNC DI ZAMPIS DAVIDE E TOMASIN MARIA ELENA",
    "address": "Viale Venezia, 388, UDINE UD 33100, Italia",
    "lat": 46.0530972,
    "lng": 13.2121705,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0530972,13.2121705"
  },
  {
    "name": "FARMACIA ALLOCCO SNC",
    "address": "Via Torino, 63, SAN FRANCESCO AL CAMPO TO 10070, Italia",
    "lat": 45.2278014,
    "lng": 7.6452222,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.2278014,7.6452222"
  },
  {
    "name": "FARMACIA SAN MAMOLO S.N.C.",
    "address": "Via San Mamolo 25/D, BOLOGNA BO 40136, Italia",
    "lat": 44.4856005,
    "lng": 11.3394174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4856005,11.3394174"
  },
  {
    "name": "FARMACIA MINELLI DEL DOTT. MINELLI TULLIO SAS",
    "address": "Via Giuseppe Mazzini 28, BRENO BS 25043, Italia",
    "lat": 45.9558946,
    "lng": 10.3007187,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9558946,10.3007187"
  },
  {
    "name": "Farmacia di Grandola di Dott.ssa Rezzonico Laura",
    "address": "Via Italia 26, GRANDOLA ED UNITI CO 22010, Italia",
    "lat": 46.0243313,
    "lng": 9.2118866,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0243313,9.2118866"
  },
  {
    "name": "MEDISAN S.R.L.",
    "address": "Via Pasubio, 14, LEGNAGO VR 37045, Italia",
    "lat": 45.1853057,
    "lng": 11.3139873,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1853057,11.3139873"
  },
  {
    "name": "FARMACIA SANTA MARIA ASSUNTA DR.SSA LOREDANA FAZZOLARI",
    "address": "Via S. Egidio, 15, VALSAMOGGIA BO 40053, Italia",
    "lat": 44.4722918,
    "lng": 11.1185749,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4722918,11.1185749"
  },
  {
    "name": "FARMACIA SAN LEOPOLDO S.N.C. dei Dott. Bortolini Michele e Carlotta",
    "address": "Via Fini Augusto 12, VERGATO - Tole' BO 40038, Italia",
    "lat": 44.3301105,
    "lng": 11.060663,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.3301105,11.060663"
  },
  {
    "name": "FARMACIA ALL'ANGELO S.N.C. DI CARMIGNOTO LUCA & C.",
    "address": "Piazza Monsignor Pietro Nichele, 24, FONTANIVA PD 35014, Italia",
    "lat": 45.636054,
    "lng": 11.753175,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.636054,11.753175"
  },
  {
    "name": "FARMACIA VIA BOLLANA 39 S.R.L.",
    "address": "Via Bollana 39d, CERVIA RA 48015, Italia",
    "lat": 44.2119036,
    "lng": 12.3318172,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.2119036,12.3318172"
  },
  {
    "name": "FARMACIA SCHIAVONI S.N.C. DELLA DOTT.SSA LORETTA SCHIAVONI E FIGLI",
    "address": "Piazza Vittorio Veneto, 40, MESOLA - Bosco mesola FE 44026, Italia",
    "lat": 44.8760768,
    "lng": 12.228658,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.8760768,12.228658"
  },
  {
    "name": "FARMACIA DIDO S.R.L.",
    "address": "Via Roma, 51, MONTEROSI VT 01030, Italia",
    "lat": 42.1966553,
    "lng": 12.3078277,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.1966553,12.3078277"
  },
  {
    "name": "FARMACIA FALERI SAS DELLA DR.SSA STEFANIA DE VITO & C.",
    "address": "Via Falerina, 23, FABRICA DI ROMA VT 01034, Italia",
    "lat": 42.3338972,
    "lng": 12.3092962,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.3338972,12.3092962"
  },
  {
    "name": "ARTOSAN SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA",
    "address": "Via Monti Aurunci, 19, PESCARA PE 65124, Italia",
    "lat": 42.4643909,
    "lng": 14.2003285,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.4643909,14.2003285"
  },
  {
    "name": "FARMACIA SAN PAOLINO EREDI di Senni Rossana",
    "address": "Via Paolina 203, Viareggio LU 55049, Italia",
    "lat": 43.8724574,
    "lng": 10.2444815,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.8724574,10.2444815"
  },
  {
    "name": "FARMACIA MARTELLETTO SNC",
    "address": "Via Montanara, 32, COLOGNOLA AI COLLI VR 37030, Italia",
    "lat": 45.421829,
    "lng": 11.1765643,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.421829,11.1765643"
  },
  {
    "name": "LA SANITARIA DI MORUZZI ERICA",
    "address": "Via XXIV Maggio, 1, FORNOVO DI TARO PR 43045, Italia",
    "lat": 44.6909563,
    "lng": 10.0981325,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6909563,10.0981325"
  },
  {
    "name": "FARMACIA SAN BIAGIO SRL",
    "address": "Via Aldo Moro 36, MERCATO SARACENO FC 47025, Italia",
    "lat": 44.0482422,
    "lng": 12.179149,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0482422,12.179149"
  },
  {
    "name": "ORTOPEDIA SANITARIA PUNTO SALUTE S.R.L.",
    "address": "Via dei Mille, 23, VIMERCATE MB 20871, Italia",
    "lat": 45.6150148,
    "lng": 9.37628,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6150148,9.37628"
  },
  {
    "name": "FARMACIA SANT'ANDREA SNC  DEI DOTTORI CARNESALE E SALVATORE",
    "address": "Via del Casal Sansoni 56/A, ROMA RM 00135, Italia",
    "lat": 41.7911552,
    "lng": 12.3802971,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7911552,12.3802971"
  },
  {
    "name": "FARMACIA VITTORIA S.R.L.",
    "address": "Piazza Cavallero 1, RIVOLI TO 10098, Italia",
    "lat": 45.0630331,
    "lng": 7.5187551,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0630331,7.5187551"
  },
  {
    "name": "FARMACIA ALFIERI SRL",
    "address": "PIAZZA  ALFIERI, 3, ASTI AT 14100, Italia",
    "lat": 44.9008056,
    "lng": 8.2070925,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.9008056,8.2070925"
  },
  {
    "name": "FARMACIA VACIGLIO SNC",
    "address": "Strada Morane, MODENA MO 41100, Italia",
    "lat": 44.6372432,
    "lng": 10.9259312,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6372432,10.9259312"
  },
  {
    "name": "FARMACIE DOLOMITI SRL",
    "address": "Via Frontin, 2/A - Loc. Trichiana, BORGO VALBELLUNA BL 32026, Italia",
    "lat": 46.0388591,
    "lng": 12.1631876,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.0388591,12.1631876"
  },
  {
    "name": "FARMACIA FRANCESCHINI DR.SSA MARIA ELENA",
    "address": "Via Aretina, 2, ASCIANO - Arbia SI 53041, Italia",
    "lat": 43.2969561,
    "lng": 11.411498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2969561,11.411498"
  },
  {
    "name": "LORTOPEDICA S.R.L.",
    "address": "VIA BICE CREMAGNANI 15/O, VIMERCATE MB 20871, Italia",
    "lat": 45.6128018,
    "lng": 9.3596498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6128018,9.3596498"
  },
  {
    "name": "FARMACIA SASSETTA DEL DR. ENZO RONCO E C. SAS",
    "address": "Via Roma, 33, SASSETTA LI 57020, Italia",
    "lat": 43.1282503,
    "lng": 10.6440515,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.1282503,10.6440515"
  },
  {
    "name": "FARMACIA CARDINALI DEL DOTT. MARCO CARDINALI S.A.S.",
    "address": "C.so Mazzini 23, Osimo AN 60027, Italia",
    "lat": 43.486093,
    "lng": 13.48354,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.486093,13.48354"
  },
  {
    "name": "FARMACIA BLASI S.A.S. DOTT. ANNA BLASI e C.",
    "address": "Via Roma, 17, CORRIDONIA MC 62014, Italia",
    "lat": 43.2488245,
    "lng": 13.5109208,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.2488245,13.5109208"
  },
  {
    "name": "FARMACIA GUAZZIERI DR.SSA MARIA",
    "address": "Via A. Gramsci, 21, NERETO TE 64015, Italia",
    "lat": 42.817604,
    "lng": 13.8160588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.817604,13.8160588"
  },
  {
    "name": "FARMACIA EREDI DOTT. G.C. MONTAGNA S.N.C.",
    "address": "Via Cesare Ricotti, 42, ROMA RM 00159, Italia",
    "lat": 41.8994626,
    "lng": 12.5353441,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8994626,12.5353441"
  },
  {
    "name": "FARMACIA POGGI SNC DI ELENA POGGI & MANCINI ANNA",
    "address": "Via Empolitana,17 - Via Acquaregna,18, TIVOLI RM 00019, Italia",
    "lat": 41.957993,
    "lng": 12.803338,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.957993,12.803338"
  },
  {
    "name": "FARMACIA DR. PISANTI ADRIANO",
    "address": "Piazza C. Battisti 16, SEGNI RM 00037, Italia",
    "lat": 41.6916185,
    "lng": 13.0217112,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.6916185,13.0217112"
  },
  {
    "name": "FARMACIA COMUNALE DI TAVAGNACCO S.R.L.",
    "address": "Piazza di Prampero, 7/A, TAVAGNACCO UD 33010, Italia",
    "lat": 46.1271587,
    "lng": 13.2147684,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.1271587,13.2147684"
  },
  {
    "name": "FARMACIA PESCETTO MARCO SRL",
    "address": "Via Luigi Rizzo, 48, GENOVA GE 16156, Italia",
    "lat": 44.4289202,
    "lng": 8.8095464,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4289202,8.8095464"
  },
  {
    "name": "PARAFARMACIA L'ELISIR SNC",
    "address": "Via D.Alighieri, 2, SERMIDE MN 46028, Italia",
    "lat": 45.0063126,
    "lng": 11.3011087,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0063126,11.3011087"
  },
  {
    "name": "FARMACIA BELFORTE DI MARENCO PAOLA E C. S.A.S.",
    "address": "Via Pernigotti, 5/D, BELFORTE MONFERRATO AL 15070, Italia",
    "lat": 44.6299691,
    "lng": 8.6590175,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6299691,8.6590175"
  },
  {
    "name": "FARMA LOGICA DI ALBERTONI MONICA & C. SNC",
    "address": "Via Promessi Sposi, 19C, BERGAMO BG 24127, Italia",
    "lat": 45.6804431,
    "lng": 9.6458795,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.6804431,9.6458795"
  },
  {
    "name": "FARMACIA NOSTRA SIGNORA DEL SOCCORSO DI PANIZZA FABIO S.A.S.",
    "address": "Via C. Battisti, 385, PIETRA LIGURE SV 17027, Italia",
    "lat": 44.1540837,
    "lng": 8.2936122,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.1540837,8.2936122"
  },
  {
    "name": "FARMACIA MODERNA S.N.C. DI BOCCARDO DR. JUAN HECTOR EMILIO E C.",
    "address": "Via Tabarrani 38, CAMAIORE LU 55041, Italia",
    "lat": 43.9379214,
    "lng": 10.3062224,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.9379214,10.3062224"
  },
  {
    "name": "LA BOTTEGA DELLA SALUTE S.R.L.",
    "address": "Via Carlo Alberto 14/16, ROMA RM 00185, Italia",
    "lat": 41.8965656,
    "lng": 12.5008054,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.8965656,12.5008054"
  },
  {
    "name": "FARMACIA CUGINI SNC",
    "address": "Via Garibaldi 43, CARRARA - Marina di carrara MS 54033, Italia",
    "lat": 44.0377851,
    "lng": 10.0446652,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.0377851,10.0446652"
  },
  {
    "name": "FARMACIA BENSO S.A.S. DELLA DR.SSA ANTONELLA E C.",
    "address": "Piazza Mazzini, 5, CASTELL'ALFERO AT 14033, Italia",
    "lat": 44.981991,
    "lng": 8.2094374,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.981991,8.2094374"
  },
  {
    "name": "FARMACIA INTERNAZIONALE DI PIERANDREA CICCONETTI & C. SNC",
    "address": "Piazza Pia 11, ANZIO RM 00042, Italia",
    "lat": 41.4472095,
    "lng": 12.6286886,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.4472095,12.6286886"
  },
  {
    "name": "FARMACIA MASIA LOTZORAI DI MASIA MARIA FRANCESCA E C. S.A.S.",
    "address": "VIA ROMA 40, LOTZORAI NU 08040, Italia",
    "lat": 39.9682453,
    "lng": 9.6603698,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.9682453,9.6603698"
  },
  {
    "name": "FARMACIA CRISTALLO DOTT. GIANLUCA BASSO",
    "address": "Corso Italia, 242, CORTINA D'AMPEZZO BL 32043, Italia",
    "lat": 46.541776,
    "lng": 12.135627,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.541776,12.135627"
  },
  {
    "name": "LA SANITARIA S.N.C. DI BONIFACI CRISTINA E VALERI VALERIO",
    "address": "Via Roma, 37/A, LANGHIRANO PR 43013, Italia",
    "lat": 44.6160987,
    "lng": 10.2687609,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.6160987,10.2687609"
  },
  {
    "name": "IN SALUS DI PECCHI TOMMASO E C. SAS",
    "address": "P.zza D.Bargagli ,7, SARTEANO SI 53047, Italia",
    "lat": 42.9894141,
    "lng": 11.8688246,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.9894141,11.8688246"
  },
  {
    "name": "PARAFARMACIA DOTT. RUBETTI BENEDETTO",
    "address": "Via di Carpani, 92 , Portoferraio LI 57037 , Italia",
    "lat": 42.8032481,
    "lng": 10.306618,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.8032481,10.306618"
  },
  {
    "name": "FARMACIA PETRACCI SRL",
    "address": "Via Piave, 6, MACERATA MC 62100, Italia",
    "lat": 43.3674593,
    "lng": 13.6220545,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.3674593,13.6220545"
  },
  {
    "name": "FARMACIA VILLA DESIDERI S.A.S. DELLA DOTT.SSA MARIA ANGELA LIDONNICI",
    "address": "Via Marcantonio Colonna 2, MARINO RM 00047, Italia",
    "lat": 41.7720032,
    "lng": 12.664782,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.7720032,12.664782"
  },
  {
    "name": "ARTISAN DI CEPELLOTTI BEATRICE",
    "address": "Viale F.A Duodo, 18, CODROIPO UD 33033, Italia",
    "lat": 45.9607399,
    "lng": 12.9857959,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.9607399,12.9857959"
  },
  {
    "name": "FARMACIA FACHINETTI SRL",
    "address": "VIA GALILEO GALILEI 122, COLLESALVETTI LI 57014, Italia",
    "lat": 43.6130831,
    "lng": 10.4653377,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.6130831,10.4653377"
  },
  {
    "name": "FARMACIA PELLICCIARI DEI DOTTORI PELLICCIARI E BOTTIGLIERI S.N.C.",
    "address": "Via Pietrafitta, 51, GRIZZANA MORANDI BO 40030, Italia",
    "lat": 44.257607,
    "lng": 11.1521589,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.257607,11.1521589"
  },
  {
    "name": "ARKOT SRL",
    "address": "Viale Vittorio Veneto, 45, CHIVASSO TO 10034, Italia",
    "lat": 45.1884197,
    "lng": 7.8909205,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.1884197,7.8909205"
  },
  {
    "name": "FRUIT SRL",
    "address": "Via Ceccardi, 4/41, GENOVA GE 16121, Italia",
    "lat": 44.4066215,
    "lng": 8.9364486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.4066215,8.9364486"
  },
  {
    "name": "FARMACIA ASSEGGIANO SNC DEI DOTTORI F. LEONI E G. RESTO",
    "address": "VIA ASSEGGIANO, 216, VENEZIA VE 30174, Italia",
    "lat": 45.497044,
    "lng": 12.184183,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.497044,12.184183"
  },
  {
    "name": "ORTOPEDIA SANITARIA BRACALENTI SRLS",
    "address": "Via dei linacei,3, ROMA RM 00147, Italia",
    "lat": 41.855144,
    "lng": 12.497054,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.855144,12.497054"
  },
  {
    "name": "ORTOPEDIA ROCCA SRL",
    "address": "Viale Dante 16, Lucera FG 71036, Italia",
    "lat": 41.51379,
    "lng": 15.335775,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=41.51379,15.335775"
  },
  {
    "name": "PARAFARMACIA DOTT.SSA STIGLIANO TERESA",
    "address": "Via Giulio Pastore, 2, NOVA SIRI MT 75020, Italia",
    "lat": 40.129883,
    "lng": 16.637327,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.129883,16.637327"
  },
  {
    "name": "SANITARIA ORTOPEDIA GUBIAN di SIMONA TURLETTI",
    "address": "VIALE TRENTO TRIESTE 25, SAN DANIELE DEL FRIULI UD 33038, Italia",
    "lat": 46.15483,
    "lng": 13.01015,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.15483,13.01015"
  },
  {
    "name": "FARMACIA FOSSOLO 2 DEL DOTT.FRANCESCO RUFFA E C S.A.S.",
    "address": "Via Bombicci Luigi, 6, BOLOGNA BO 40139, Italia",
    "lat": 44.481287,
    "lng": 11.38952,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.481287,11.38952"
  },
  {
    "name": "PARAFARMACIA S. NICOLO' DI LAMPARELLI ALESSANDRA",
    "address": "Via Solferino, 6, BARDOLINO VR 37011, Italia",
    "lat": 45.547542,
    "lng": 10.72151,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.547542,10.72151"
  },
  {
    "name": "Parafarmacia Dott.ssa Giardina",
    "address": "Via Vittorio Emanuele, 1, Campobello di Licata AG 92023, ITALIA",
    "lat": 37.260366,
    "lng": 13.917838,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.260366,13.917838"
  },
  {
    "name": "F.cia Pace sas",
    "address": "Corso Umberto I, 159/161, Ribera AG 92016, ITALIA",
    "lat": 37.503605,
    "lng": 13.268361,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.503605,13.268361"
  },
  {
    "name": "F.cia Dr. Visini del Dr. Michele Visini & C. sas",
    "address": "Via Italia,2, Almè BG 24011, ITALIA",
    "lat": 45.713923,
    "lng": 9.59755,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.713923,9.59755"
  },
  {
    "name": "F.cia Maffeis delle Dr.sse F.e C. snc",
    "address": "Via Kennedy, 2, Bariano BG 24050, ITALIA",
    "lat": 45.472861,
    "lng": 9.685911,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.472861,9.685911"
  },
  {
    "name": "F.Cia Coop.Berg. Porta Nuova",
    "address": "Viale Papa Giovanni XXIII, 34, Bergamo BG 24121, ITALIA",
    "lat": 45.693557,
    "lng": 9.671149,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.693557,9.671149"
  },
  {
    "name": "F.cia Borgo Palazzo snc-Dr.ssa M.Bialetti & C.",
    "address": "Via Borgo Palazzo, 83, Bergamo BG 24125, ITALIA",
    "lat": 45.694823,
    "lng": 9.687336,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.694823,9.687336"
  },
  {
    "name": "F.cia Ruspini di Coop.F.tica Bergamasca",
    "address": "Via S.Alessandro, 7, Bergamo BG 24122, ITALIA",
    "lat": 45.684632,
    "lng": 9.674091,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.684632,9.674091"
  },
  {
    "name": "F.cia Clementina srl",
    "address": "Via Borgo Palazzo, 141, Bergamo BG 24125, ITALIA",
    "lat": 45.692016,
    "lng": 9.695379,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.692016,9.695379"
  },
  {
    "name": "F.cia Brembate di Sopra srl",
    "address": "Piazza Papa Giovanni Paolo II, 59, Brembate di Sopra BG 24030, ITALIA",
    "lat": 45.748529,
    "lng": 9.580242,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.748529,9.580242"
  },
  {
    "name": "F.cia Ghisalberti CLUB SALUTE",
    "address": "Via Roma, 46/48, Brembilla BG 24012, ITALIA",
    "lat": 45.818087,
    "lng": 9.599659,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.818087,9.599659"
  },
  {
    "name": "F.cia di Brusaporto sas",
    "address": "Via Tognoli, 12, Brusaporto BG 24060, ITALIA",
    "lat": 45.670303,
    "lng": 9.763494,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.670303,9.763494"
  },
  {
    "name": "F.cia Carrara Dr. Enrico",
    "address": "Via R. Ruggeri, 4/A, Casnigo BG 24020, ITALIA",
    "lat": 44.689818,
    "lng": 10.642227,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.689818,10.642227"
  },
  {
    "name": "F.cia Rando sas del Dott. P. Magoni & C.",
    "address": "P.zza Castello, 14/A, Castel Rozzone BG 24040, ITALIA",
    "lat": 45.555166,
    "lng": 9.624098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.555166,9.624098"
  },
  {
    "name": "F.cia S.Alessandro di Personeni dr.Stefano",
    "address": "Via Manzoni 17, Castione della Presolana BG 24020, ITALIA",
    "lat": 45.908768,
    "lng": 10.037016,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.908768,10.037016"
  },
  {
    "name": "Farmacia Gambera Dr. Francesca",
    "address": "Via Roma, 23, Castro BG 24063, ITALIA",
    "lat": 45.828971,
    "lng": 10.042115,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.828971,10.042115"
  },
  {
    "name": "F.cia Rotelli srl della Dott.ssa A. Rotelli",
    "address": "Via Marconi, 8, Cene BG 24020, ITALIA",
    "lat": 45.906416,
    "lng": 9.929178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.906416,9.929178"
  },
  {
    "name": "F.cia Cerete Dr.ssa Michetti Anna",
    "address": "Via Moscheni, 44, Cerete BG 24020, ITALIA",
    "lat": 45.860615,
    "lng": 9.992248,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.860615,9.992248"
  },
  {
    "name": "F.cia Colombo sas",
    "address": "Piazza Papa, Piazza Giovanni XXIII, Cividate al Piano BG 24050, ITALIA",
    "lat": 45.554788,
    "lng": 9.832091,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.554788,9.832091"
  },
  {
    "name": "F.Cia Sant’Anna sas di Clusone Farma srl",
    "address": "Viale Gusmini, 16, Clusone BG 24023, ITALIA",
    "lat": 45.888531,
    "lng": 9.943498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.888531,9.943498"
  },
  {
    "name": "F.cia Centrale D.ri F. e G. Personeni snc",
    "address": "Piazzetta Giangrisostomo Marinoni 1, Clusone BG 24023, ITALIA",
    "lat": 45.890492,
    "lng": 9.94559,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.890492,9.94559"
  },
  {
    "name": "F.cia Maffeis Dr. Mauro",
    "address": "Via G. De Micheli, 8, Covo BG 24050, ITALIA",
    "lat": 45.49984,
    "lng": 9.770634,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.49984,9.770634"
  },
  {
    "name": "F.Cia Invernizzi Snc",
    "address": "Via Bergamo 4, Curno BG 24035, ITALIA",
    "lat": 45.693266,
    "lng": 9.61214,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.693266,9.61214"
  },
  {
    "name": "F.cia Di Gandino sas Dr.ssa S. Gandossi e & C.",
    "address": "Via Papa Giovanni XXIII,24, Gandino BG 24024, ITALIA",
    "lat": 45.811089,
    "lng": 9.901763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.811089,9.901763"
  },
  {
    "name": "F.cia Del Santuario srl",
    "address": "Via Provinciale, 9, Ghisalba BG 24050, ITALIA",
    "lat": 45.595639,
    "lng": 9.756566,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.595639,9.756566"
  },
  {
    "name": "F.Cia Brizzi Snc Dr. Simone Brizzi & C.",
    "address": "Via Colombo,2, Grassobbio BG 24050, ITALIA",
    "lat": 45.656704,
    "lng": 9.7232,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.656704,9.7232"
  },
  {
    "name": "F.cia Taddei Snc di Taddei Giovanna e C.",
    "address": "Via Papa Giovanni XXIII, 56, Gromo BG 24020, ITALIA",
    "lat": 45.970503,
    "lng": 9.92991,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.970503,9.92991"
  },
  {
    "name": "F.cia Degli Spezieri sas di Micheli Dr.Mario & C.",
    "address": "Via I Maggio 5/A, Lallio BG 24040, ITALIA",
    "lat": 45.666956,
    "lng": 9.630588,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.666956,9.630588"
  },
  {
    "name": "F.cia Pancheri sas Dr.ssa S.Gandossi & C.",
    "address": "Via Mosconi, 10, Leffe BG 24026, ITALIA",
    "lat": 45.799269,
    "lng": 9.884613,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.799269,9.884613"
  },
  {
    "name": "F.Cia Ziosi Dr.ssa Barbara",
    "address": "Via Locatelli 27, Mapello BG 24030, ITALIA",
    "lat": 45.710457,
    "lng": 9.548807,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.710457,9.548807"
  },
  {
    "name": "F.cia Montello Mutti Dr.ssa Anita & C. snc",
    "address": "Via Suardi 20, Montello BG 24060, ITALIA",
    "lat": 45.671465,
    "lng": 9.80129,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.671465,9.80129"
  },
  {
    "name": "F.Cia Bonvini Dssa Cantoni Beatrice",
    "address": "Via Papa Giovanni XXIII, 17, Mozzanica BG 24050, ITALIA",
    "lat": 45.47759,
    "lng": 9.689213,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.47759,9.689213"
  },
  {
    "name": "F.cia di Gavarno srl",
    "address": "Via Gavarno, 10, Nembro BG 24027, ITALIA",
    "lat": 45.734305,
    "lng": 9.757317,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.734305,9.757317"
  },
  {
    "name": "F.cia Comunale Dott.ssa Viola Alessandra",
    "address": "Via F.lli Marelli, 1, Palosco BG 24050, ITALIA",
    "lat": 45.62417,
    "lng": 9.80954,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.62417,9.80954"
  },
  {
    "name": "F.Cia Doneda D.Ssa Antonella",
    "address": "Via Camozzi 1, Pedrengo BG 24066, ITALIA",
    "lat": 45.698425,
    "lng": 9.734381,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.698425,9.734381"
  },
  {
    "name": "Lafarmacia.Valle del Canto Srl",
    "address": "Via Martiri della Libertà, 16/A, Petosino di Sorisole BG 24011, ITALIA",
    "lat": 45.73235,
    "lng": 9.640395,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.73235,9.640395"
  },
  {
    "name": "Parafarmacia Carimb di Carrara Elvira & C. sas",
    "address": "Via Europa, 111/C, Ponte Nossa BG 24028, ITALIA",
    "lat": 45.863655,
    "lng": 9.88261,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.863655,9.88261"
  },
  {
    "name": "F.Cia Giacherio Dr.Marco Maria Giacherio",
    "address": "Via G.B. Camozzi 4, Ranica BG 24020, ITALIA",
    "lat": 45.678973,
    "lng": 9.731361,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.678973,9.731361"
  },
  {
    "name": "F.cia Le Torrette srl",
    "address": "Via G.Marconi, 39/N, Ranica BG 24020, ITALIA",
    "lat": 45.891751,
    "lng": 10.010311,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.891751,10.010311"
  },
  {
    "name": "F.cia Dott. Re Alberto",
    "address": "Via Tosi, 6, Rovetta BG 24020, ITALIA",
    "lat": 44.482887,
    "lng": 10.337893,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.482887,10.337893"
  },
  {
    "name": "F.cia Della Fonte di M.Micheli & C. snc",
    "address": "Via Papa Giovanni XXIII, 12, S. Pellegrino Terme BG 24016, ITALIA",
    "lat": 45.838287,
    "lng": 9.664298,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.838287,9.664298"
  },
  {
    "name": "Parafarmacia Dott.ssa Silvia Tameni",
    "address": "Via L. Suardo, 18/H, Sarnico BG 24067, ITALIA",
    "lat": 45.671126,
    "lng": 9.950221,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.671126,9.950221"
  },
  {
    "name": "Lafarmacia.Seriate srl",
    "address": "Via Marconi, 9, Seriate BG 24068, ITALIA",
    "lat": 45.684901,
    "lng": 9.726486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.684901,9.726486"
  },
  {
    "name": "F.cia Salvetti Dr. Lidia",
    "address": "Via V. Veneto, 71, Songavazzo BG 24020, ITALIA",
    "lat": 45.933774,
    "lng": 9.926855,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.933774,9.926855"
  },
  {
    "name": "F.cia Algisi snc",
    "address": "Via Suardi 10, Trescore Balneario BG 24069, ITALIA",
    "lat": 45.69541,
    "lng": 9.845538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.69541,9.845538"
  },
  {
    "name": "F.cia Bianchi sas dei Dr.i Bianchi C. & Ciocca",
    "address": "Via Roma, 73/B, Treviolo BG 24048, ITALIA",
    "lat": 45.67209,
    "lng": 9.613109,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.67209,9.613109"
  },
  {
    "name": "Antica F.cia di Urgnano della Dr.ssa Besutti & C. snc",
    "address": "Via Papa Giovanni XXIII, 45, Urgnano BG 24059, ITALIA",
    "lat": 45.595505,
    "lng": 9.695895,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.595505,9.695895"
  },
  {
    "name": "Farmacia di Verdello srl",
    "address": "Viale della Repubblica, 12/A, Verdello BG 24049, ITALIA",
    "lat": 45.60801,
    "lng": 9.635733,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.60801,9.635733"
  },
  {
    "name": "F.cia Villa D’Ogna sas",
    "address": "L.go Europa, 18, Villa D’Ogna BG 24020, ITALIA",
    "lat": 45.907041,
    "lng": 9.930613,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.907041,9.930613"
  },
  {
    "name": "F.cia Gualteri snc dei Dr.i G. e G. Gualteri",
    "address": "P.zza Repubblica, 1, Zanica BG 24050, ITALIA",
    "lat": 45.640088,
    "lng": 9.684142,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.640088,9.684142"
  },
  {
    "name": "F.cia Palombella",
    "address": "Via Padergnone, 21/3, Zanica BG 24050, ITALIA",
    "lat": 45.643622,
    "lng": 9.693121,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.643622,9.693121"
  },
  {
    "name": "F.cia De Rueda di Ghiselli F. & C. sas",
    "address": "Via XXIV Maggio, 23, Zogno BG 24019, ITALIA",
    "lat": 45.792432,
    "lng": 9.660699,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.792432,9.660699"
  },
  {
    "name": "Farmacia Podavini Dr.Lorena",
    "address": "Via Della Repubblica, 18, Acquafredda BS 25010, ITALIA",
    "lat": 45.30709,
    "lng": 10.413672,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.30709,10.413672"
  },
  {
    "name": "F.cia Despalj srl",
    "address": "V.le Paolo VI, 16, Azzano Mella BS 25020, ITALIA",
    "lat": 45.457381,
    "lng": 10.11428,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.457381,10.11428"
  },
  {
    "name": "F.cia Comunale di Bedizzole Azienda Speciale",
    "address": "Via Mons.Antonio Bontacchio 5, Bedizzole BS 25081, ITALIA",
    "lat": 45.510711,
    "lng": 10.420497,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.510711,10.420497"
  },
  {
    "name": "F.cia Già Spedali Civili Dr.ssa Tomasoni & C. sas",
    "address": "Via Luigi Einaudi, 7/9, Brescia BS 25121, ITALIA",
    "lat": 45.534877,
    "lng": 10.219057,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.534877,10.219057"
  },
  {
    "name": "F.cia Camuna srl",
    "address": "Via Aldo Moro, 24, Capo di Ponte BS 25044, ITALIA",
    "lat": 46.029248,
    "lng": 10.345311,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.029248,10.345311"
  },
  {
    "name": "F.cia Comunale di Capriolo",
    "address": "Piazza Mercato 3, Capriolo BS 25031, ITALIA",
    "lat": 45.639543,
    "lng": 9.930853,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.639543,9.930853"
  },
  {
    "name": "F.cia Casci Ceccacci della Dott.ssa E. Bendoni",
    "address": "Via Umerto I, 7, Castel Mella BS 25030, ITALIA",
    "lat": 45.495546,
    "lng": 10.14273,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.495546,10.14273"
  },
  {
    "name": "F.Cia Zerbio snc di Anna e Paola Zerbio",
    "address": "Via De Gasperi, 74, Castelcovati BS 25030, ITALIA",
    "lat": 45.501928,
    "lng": 9.947405,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.501928,9.947405"
  },
  {
    "name": "F.cia Comunale di Chiari Servizi srl",
    "address": "Via Mazzini, 6, Chiari BS 25032, ITALIA",
    "lat": 45.5648,
    "lng": 9.97722,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.5648,9.97722"
  },
  {
    "name": "F.cia Tosoni di Zuccotti B. & C. sas",
    "address": "Via Roma, 22, Cigole BS 25020, ITALIA",
    "lat": 45.308436,
    "lng": 10.193389,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.308436,10.193389"
  },
  {
    "name": "F.Cia Dottor-T srl",
    "address": "Via Camillo Golgi 95, Corteno Golgi BS 25040, ITALIA",
    "lat": 46.164555,
    "lng": 10.237584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.164555,10.237584"
  },
  {
    "name": "F.cia De Gressi Dott.ssa Emanuela",
    "address": "Via S. Maria, 1, Desenzano del Garda BS 25015, ITALIA",
    "lat": 45.469228,
    "lng": 10.541586,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.469228,10.541586"
  },
  {
    "name": "F.cia Comunale Desenzano Via Eridio",
    "address": "Via Eridio, 2, Desenzano sul Garda BS 25015, ITALIA",
    "lat": 45.575623,
    "lng": 10.706192,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.575623,10.706192"
  },
  {
    "name": "F.cia Santa Rita srl",
    "address": "Via Trieste, 85, Erbusco BS 25030, ITALIA",
    "lat": 45.586171,
    "lng": 9.998591,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.586171,9.998591"
  },
  {
    "name": "F.cia comunale Gardone Val Trompia",
    "address": "Via Matteotti 300/A, Gardone Val Trompia BS 25063, ITALIA",
    "lat": 45.689064,
    "lng": 10.185659,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.689064,10.185659"
  },
  {
    "name": "F.cia Tomasoni sas di Ft srl",
    "address": "V.le Italia, 1, Gussago BS 25064, ITALIA",
    "lat": 45.582867,
    "lng": 10.158113,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.582867,10.158113"
  },
  {
    "name": "F.cia S.Apollonio di F.cie Lanzani sas",
    "address": "P.zza Portegaia, 10, Lumezzane BS 25065, ITALIA",
    "lat": 45.651677,
    "lng": 10.277508,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.651677,10.277508"
  },
  {
    "name": "F.cia Canino Dott.ssa Giovanna Donatella",
    "address": "V.le F.lli Kennedy, 1, Mazzano BS 25080, ITALIA",
    "lat": 45.760581,
    "lng": 10.595357,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.760581,10.595357"
  },
  {
    "name": "F.cia Comunale di Montichiari (Via Brescia)",
    "address": "Via Brescia, 149 zona Fiera, Montichiari BS 25018, ITALIA",
    "lat": 45.420402,
    "lng": 10.376032,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.420402,10.376032"
  },
  {
    "name": "F.cia Mafezzoni Dr.ssa Monica",
    "address": "Via Scorine 1/B, Ome BS 25050, ITALIA",
    "lat": 45.625887,
    "lng": 10.120998,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.625887,10.120998"
  },
  {
    "name": "Parafarmacia Farma Pit Stop srl",
    "address": "Via Einaudi,3 -c/o C.C. Le Piazze, Orzinuovi BS 25034, ITALIA",
    "lat": 45.40678,
    "lng": 9.93697,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.40678,9.93697"
  },
  {
    "name": "F.Cia Beretta Dr.Mario",
    "address": "Via Giuseppe Verdi, 5, Padenghe S/G BS 25080, ITALIA",
    "lat": 45.574984,
    "lng": 10.529081,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.574984,10.529081"
  },
  {
    "name": "Rosfarm Unipersonale Srl-F.cia Comunale Rodengo",
    "address": "Via Marconi 5, Rodengo Saiano BS 25050, ITALIA",
    "lat": 45.945133,
    "lng": 10.228729,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.945133,10.228729"
  },
  {
    "name": "Roncadelle Servizi srl",
    "address": "Via Roma, 13/15, Roncadelle BS 25030, ITALIA",
    "lat": 45.526267,
    "lng": 10.148935,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.526267,10.148935"
  },
  {
    "name": "Storica F.cia del Benaco della Dr.ssa Tomasoni e C. sas",
    "address": "Via N.Sauro 7-7A, Salò BS 25087, ITALIA",
    "lat": 45.808104,
    "lng": 13.445241,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.808104,13.445241"
  },
  {
    "name": "F.cia Baldini Dr.Franco",
    "address": "Via Umberto I, 13, Seniga BS 25020, ITALIA",
    "lat": 45.241963,
    "lng": 10.17764,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.241963,10.17764"
  },
  {
    "name": "F.cia Minelli del Dr. Giancarlo Minelli e C. snc",
    "address": "Via Statale, 93, Toscolano Maderno BS 25088, ITALIA",
    "lat": 45.641293,
    "lng": 10.61022,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.641293,10.61022"
  },
  {
    "name": "F.cia Sfondrini e C. sas",
    "address": "Via Roma 2, Villachiara BS 25030, ITALIA",
    "lat": 45.35675,
    "lng": 9.930587,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.35675,9.930587"
  },
  {
    "name": "F.cia S.Antonio srl(Alzate)",
    "address": "Via A. Diaz, 20, Alzate Brianza CO 22040, ITALIA",
    "lat": 45.817505,
    "lng": 9.249888,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.817505,9.249888"
  },
  {
    "name": "F.cia di Bizzarone snc Dr.sse Erbisini",
    "address": "Via Delle Ginestre, 1/A, Bizzarone CO 22020, ITALIA",
    "lat": 45.833835,
    "lng": 8.950894,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.833835,8.950894"
  },
  {
    "name": "F.cia Comunale Cantù n.1",
    "address": "Via S.Giuseppe Vighizzolo, Cantù CO 22063, ITALIA",
    "lat": 45.739301,
    "lng": 9.128854,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.739301,9.128854"
  },
  {
    "name": "F.cia Fusi srl (Cantù)",
    "address": "Via Carcano 9, Cantu CO 22063, ITALIA",
    "lat": 45.781473,
    "lng": 9.199686,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.781473,9.199686"
  },
  {
    "name": "F.cia Zibetti dott.ssa Angela",
    "address": "Via Nazionale, 12, Cassina Rizzardi CO 22070, ITALIA",
    "lat": 45.750815,
    "lng": 9.031772,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.750815,9.031772"
  },
  {
    "name": "Antica F.cia Roma Dott.Leandro Surdo",
    "address": "Via Roma, 33, Castiglione Intelvi CO 22023, ITALIA",
    "lat": 45.955205,
    "lng": 9.090098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.955205,9.090098"
  },
  {
    "name": "F.cia Comunale di Cermenate di Besana Nadia",
    "address": "Via Don Borghi, 3/A, Cermenate CO 22072, ITALIA",
    "lat": 45.704177,
    "lng": 9.093143,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.704177,9.093143"
  },
  {
    "name": "F.cia di Gironico snc",
    "address": "Via Leonardo da Vinci, 2-Fraz. Gironico, Colverde CO 22041, ITALIA",
    "lat": 44.719223,
    "lng": 8.276186,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.719223,8.276186"
  },
  {
    "name": "F.cia Dott. Marelli Davide",
    "address": "Via Leoni, 26/A, Como CO 22100, ITALIA",
    "lat": 45.79872,
    "lng": 9.090982,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.79872,9.090982"
  },
  {
    "name": "F.cia Arienti snc dei Dr.i Andrea Mario e Marcella Arienti",
    "address": "Via Milano, 165, Como CO 22100, ITALIA",
    "lat": 45.802411,
    "lng": 9.086485,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.802411,9.086485"
  },
  {
    "name": "Nuova F.cia Assoc.P&G di Poggioli e Grieco snc",
    "address": "Via Pio XI, 157, Como CO 22100, ITALIA",
    "lat": 45.832255,
    "lng": 9.044477,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.832255,9.044477"
  },
  {
    "name": "F.Cia S.Anna snc di Dr.Bruno Carli Moretti & C.",
    "address": "Via Varesina, 93, Como CO 22100, ITALIA",
    "lat": 45.791308,
    "lng": 9.075163,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.791308,9.075163"
  },
  {
    "name": "F.cia Sant’Arialdo Dott.ssa Marchini & C. snc",
    "address": "Via Savoia, 10, Cucciago CO 22063, ITALIA",
    "lat": 40.239342,
    "lng": 18.256979,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.239342,18.256979"
  },
  {
    "name": "F.cia Dongo srl",
    "address": "P.zza Matteri, 4, Dongo CO 22014, ITALIA",
    "lat": 46.127619,
    "lng": 9.282342,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.127619,9.282342"
  },
  {
    "name": "F.cia Gerosa Dr.Matteo",
    "address": "Via G.Garibaldi, 42, Fino Mornasco CO 22073, ITALIA",
    "lat": 45.722361,
    "lng": 9.114769,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.722361,9.114769"
  },
  {
    "name": "F.cia di Lezzeno del Dott. Mignone F. & C. snc",
    "address": "Località Chiesa, 2, Lezzeno CO 22025, ITALIA",
    "lat": 45.946479,
    "lng": 9.194143,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.946479,9.194143"
  },
  {
    "name": "F.cia Bernardelli-Caione di Dott. Caione & C. sas",
    "address": "Via F.lli Rosselli, 4, Mozzate CO 22076, ITALIA",
    "lat": 44.254295,
    "lng": 12.347322,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.254295,12.347322"
  },
  {
    "name": "F.cia Dott. Caso srl",
    "address": "Via Ceresio 30 B, Porlezza CO 22018, ITALIA",
    "lat": 46.036883,
    "lng": 9.122364,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.036883,9.122364"
  },
  {
    "name": "F.cia Bruschi del Dott. S. Lucini & C. snc",
    "address": "Piazza A.Volta, 24, Turate CO 22078, ITALIA",
    "lat": 45.655113,
    "lng": 9.002006,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.655113,9.002006"
  },
  {
    "name": "F.cia Brioschi Dr.Gian Paolo",
    "address": "Via Roma, 6, Valbrona CO 22039, ITALIA",
    "lat": 45.87027,
    "lng": 9.287705,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.87027,9.287705"
  },
  {
    "name": "F.cia Briantea srl",
    "address": "Via Tevere, 2, Villa Guardia CO 22079, ITALIA",
    "lat": 45.775898,
    "lng": 9.028815,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.775898,9.028815"
  },
  {
    "name": "F.Cia Doneda di Doneda Maria Angela snc",
    "address": "P.zza Castello, 34, Agnadello CR 26020, ITALIA",
    "lat": 45.444685,
    "lng": 9.558185,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.444685,9.558185"
  },
  {
    "name": "F.Cia Tirloni Nicoletta srl",
    "address": "Piazza IV Novembre, 4, Capergnanica CR 26010, ITALIA",
    "lat": 45.337878,
    "lng": 9.64431,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.337878,9.64431"
  },
  {
    "name": "F.Cia Strada Dr.Giuseppe",
    "address": "Piazza Europa, 4, Capralba CR 26010, ITALIA",
    "lat": 45.444999,
    "lng": 9.645004,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.444999,9.645004"
  },
  {
    "name": "F.Cia Carnevali di Spena Dott.ssa Valentina",
    "address": "Via Cavallotti, 10, Casalbuttano CR 26011, ITALIA",
    "lat": 45.25207,
    "lng": 9.963933,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.25207,9.963933"
  },
  {
    "name": "Farmacia Castelverde Dott.ssa Simonetta Caviggia",
    "address": "Piazza Municipio, 7, Castelverde CR 26022, ITALIA",
    "lat": 45.187301,
    "lng": 9.996575,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.187301,9.996575"
  },
  {
    "name": "F.cia Bertolini srl",
    "address": "Piazza Garibaldi, 49, Crema CR 26013, ITALIA",
    "lat": 45.363265,
    "lng": 9.69261,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.363265,9.69261"
  },
  {
    "name": "F.Cia Galli Dr.Ssa Rosanna",
    "address": "Via Bissolati, 78, Cremona CR 26100, ITALIA",
    "lat": 45.13805,
    "lng": 10.011985,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.13805,10.011985"
  },
  {
    "name": "F.cia Sant’Ambrogio del Dottor Gugliemo Leggeri",
    "address": "Via Fabio Filzi, 40/E, Cremona CR 26100, ITALIA",
    "lat": 45.144948,
    "lng": 10.013713,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.144948,10.013713"
  },
  {
    "name": "F.Cia Melegari Srl",
    "address": "Piazza Roma 1-2, Grontardo CR 26044, ITALIA",
    "lat": 45.201481,
    "lng": 10.151145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.201481,10.151145"
  },
  {
    "name": "F.Cia S.Rita di Astorri Maria",
    "address": "Via Martiri della Libertà 17, Grumello Cremonese CR 26023, ITALIA",
    "lat": 45.194209,
    "lng": 9.865805,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.194209,9.865805"
  },
  {
    "name": "F.cia Dott.E.Guida dei Dr.i F.e G. Guida snc",
    "address": "Via Roma, 32, Gussola CR 26040, ITALIA",
    "lat": 45.011055,
    "lng": 10.348403,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.011055,10.348403"
  },
  {
    "name": "F.cia Dott.ssa Guarneri D. e C. sas",
    "address": "P.zza Volpari, 3, Olmeneta CR 26010, ITALIA",
    "lat": 45.23523,
    "lng": 10.02098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.23523,10.02098"
  },
  {
    "name": "F.Cia Taccani Giulio & C. Snc",
    "address": "Via Umberto I,49, Pandino CR 26025, ITALIA",
    "lat": 45.40505,
    "lng": 9.551785,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.40505,9.551785"
  },
  {
    "name": "F.Cia F.lli Pezzini di Pezzini Marco e Luca",
    "address": "Piazza Garibaldi, 25, Pescarolo CR 26033, ITALIA",
    "lat": 45.195578,
    "lng": 10.186547,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.195578,10.186547"
  },
  {
    "name": "F.cia Dott.ssa Priori Luigia & C. snc",
    "address": "Via Libertà, 31, Piadena CR 26034, ITALIA",
    "lat": 45.142039,
    "lng": 10.349047,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.142039,10.349047"
  },
  {
    "name": "F.cia Bonfanti dr.ssa Antonella",
    "address": "Via Castello, 1, Pizzighettone CR 26026, ITALIA",
    "lat": 45.186616,
    "lng": 9.781283,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.186616,9.781283"
  },
  {
    "name": "F.cia Ghisellini di Fontana D.ssa Annamaria& C.snc",
    "address": "Via Ferrante Aporti, 35, Rivarolo del Re ed Uniti CR 26036, ITALIA",
    "lat": 45.0289,
    "lng": 10.468451,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.0289,10.468451"
  },
  {
    "name": "F.cia Cavagnoli Marco e C. snc",
    "address": "Via Marconi 2, S. Daniele Po CR 26046, ITALIA",
    "lat": 45.064248,
    "lng": 10.180682,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.064248,10.180682"
  },
  {
    "name": "F.cia Corbari srl",
    "address": "Via Europa, 33-Castelponzone, Scandolara Ravara CR 26040, ITALIA",
    "lat": 45.044585,
    "lng": 10.311578,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.044585,10.311578"
  },
  {
    "name": "F.cia Dizioli di Francesca Dizioli",
    "address": "Via Matteotti, 38, Sesto ed Uniti CR 26028, ITALIA",
    "lat": 45.175809,
    "lng": 9.914538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.175809,9.914538"
  },
  {
    "name": "F.cia Dizioli srl",
    "address": "Via Matteotti, 38, Sesto ed Uniti CR 26028, ITALIA",
    "lat": 45.175809,
    "lng": 9.914538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.175809,9.914538"
  },
  {
    "name": "F.cia Bernelli snc di Bernelli Dr.sse M.E e L.",
    "address": "Via Matteotti, 63, Soncino CR 26029, ITALIA",
    "lat": 40.176942,
    "lng": 18.162884,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.176942,18.162884"
  },
  {
    "name": "F.cia Cooperativa di Ghezzi Ermete e C. sas",
    "address": "Via Genala 16, Soresina CR 26015, ITALIA",
    "lat": 45.287069,
    "lng": 9.856517,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.287069,9.856517"
  },
  {
    "name": "F.cia Solzi srl",
    "address": "Via Barbò, 40, Soresina CR 26015, ITALIA",
    "lat": 45.284459,
    "lng": 9.853472,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.284459,9.853472"
  },
  {
    "name": "F.cia Sarta CLUB SALUTE",
    "address": "Via Giani, 2, Vailate CR 26019, ITALIA",
    "lat": 45.461313,
    "lng": 9.603403,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.461313,9.603403"
  },
  {
    "name": "F.cia Bandera Snc Di Bandera Maria Cristina",
    "address": "Via Bissolati, 1, Vescovato CR 26039, ITALIA",
    "lat": 45.179059,
    "lng": 10.167374,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.179059,10.167374"
  },
  {
    "name": "F.cia Alma Salus di Pastore R. e C. snc",
    "address": "Via Serricella, Acri CS 87041, ITALIA",
    "lat": 39.471578,
    "lng": 16.372303,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.471578,16.372303"
  },
  {
    "name": "F.cia F. & C. De Luca srl",
    "address": "Via Lava Gaenza, 79/F-Ang. Via Stromboli, 177/F, Amantea CS 87032, ITALIA",
    "lat": 39.129582,
    "lng": 16.073529,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.129582,16.073529"
  },
  {
    "name": "Parafarmacia Pugliese Dr.ssa Anna",
    "address": "Via Polisportivo, 17, Castrovillari CS 87012, ITALIA",
    "lat": 39.821505,
    "lng": 16.195544,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.821505,16.195544"
  },
  {
    "name": "F.cia Liuzzi srl",
    "address": "Via Roma, 13, Colosimi CS 87050, ITALIA",
    "lat": 39.203777,
    "lng": 16.334561,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.203777,16.334561"
  },
  {
    "name": "Parafarmacia Salute & Benessere-Dr.ssa Grosso",
    "address": "Via Nazionale, 149, Guardia Piemontese CS 87020, ITALIA",
    "lat": 39.876323,
    "lng": 18.339789,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.876323,18.339789"
  },
  {
    "name": "F.cia Centrale Dr. Sganga Srl",
    "address": "C.so Roma, 1, Paola CS 87027, ITALIA",
    "lat": 39.359056,
    "lng": 16.040991,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.359056,16.040991"
  },
  {
    "name": "F.cia Noto Snc del Dott.G.V.Noto & C.",
    "address": "V.le S.Angelo, 7/9, Rossano CS 87067, ITALIA",
    "lat": 44.533256,
    "lng": 7.704894,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.533256,7.704894"
  },
  {
    "name": "F.cia Dott.ssa Rosa Catera",
    "address": "Via L. Settino, 53, San Pietro in Guarano CS 87047, ITALIA",
    "lat": 39.340749,
    "lng": 16.310754,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.340749,16.310754"
  },
  {
    "name": "F.cia San Filippo snc dei D.ri Patanè,Raciti e Timpanaro",
    "address": "Via Nizzeti, 143, Aci Catena CT 95022, ITALIA",
    "lat": 37.582543,
    "lng": 15.14147,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.582543,15.14147"
  },
  {
    "name": "F.cia Aricò Dott.ssa Giuseppina",
    "address": "P.zza Mazzini, 3, Acireale CT 95024, ITALIA",
    "lat": 37.611711,
    "lng": 15.164697,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.611711,15.164697"
  },
  {
    "name": "F.cia Borgonuovo srl (Bronte)",
    "address": "Via Messina, 269, Bronte CT 95034, ITALIA",
    "lat": 37.792838,
    "lng": 14.845353,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.792838,14.845353"
  },
  {
    "name": "F.cia Taranto della D.ssa Taranto R. & C. snc",
    "address": "Via Fisicara, 66 C, Caltagirone CT 95041, ITALIA",
    "lat": 37.218145,
    "lng": 14.523005,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.218145,14.523005"
  },
  {
    "name": "F.cia Rodomonte dei D.ri Rodomonte e Scollo snc",
    "address": "Via Roma, 115, Caltagirone CT 95041, ITALIA",
    "lat": 37.234165,
    "lng": 14.514512,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.234165,14.514512"
  },
  {
    "name": "F.cia Internazionale sas Dott.ssa Cavazzini",
    "address": "Via Giuffrida, 141, Catania CT 95127, ITALIA",
    "lat": 37.521854,
    "lng": 15.091125,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.521854,15.091125"
  },
  {
    "name": "F.cia Castiglione sas dei D.ri Battiato A. e D.",
    "address": "C.so Fondaco, 41, Maniace CT 95030, ITALIA",
    "lat": 37.858255,
    "lng": 14.808813,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.858255,14.808813"
  },
  {
    "name": "F.cia Caruso Dott.Giuseppe",
    "address": "Via Alcide De Gasperi, 58/A, Mascalucia CT 95030, ITALIA",
    "lat": 37.577979,
    "lng": 15.056605,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.577979,15.056605"
  },
  {
    "name": "F.cia Roma srl",
    "address": "Via Roma, 150/152, Mascalucia CT 95030, ITALIA",
    "lat": 37.571232,
    "lng": 15.043626,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.571232,15.043626"
  },
  {
    "name": "F.cia Sant’Anastasia srl",
    "address": "C.so Sicilia, 52, Motta Sant’Anastasia CT 95041, ITALIA",
    "lat": 37.518501,
    "lng": 14.967322,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.518501,14.967322"
  },
  {
    "name": "Parafarmacia Dr. Di Maria Di Eugenio Angelo di Maria",
    "address": "Via V. Emanuele, 162, Palagonia CT 95046, ITALIA",
    "lat": 37.32822,
    "lng": 14.747102,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.32822,14.747102"
  },
  {
    "name": "Farmacia Giuffrida Dr.a Catalano Silvana",
    "address": "Via Umberto, 63, Randazzo CT 95036, ITALIA",
    "lat": 37.878538,
    "lng": 14.948068,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.878538,14.948068"
  },
  {
    "name": "F.cia Trappeto snc",
    "address": "Via Duca degli Abruzzi, 171, San Giovanni La Punta CT 95037, ITALIA",
    "lat": 37.5592,
    "lng": 15.089636,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.5592,15.089636"
  },
  {
    "name": "F.cia Miceli Dott.ssa Vera",
    "address": "V.le Campanella, 114/116, Catanzaro CZ 88100, ITALIA",
    "lat": 38.915396,
    "lng": 16.569676,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.915396,16.569676"
  },
  {
    "name": "Parafarmacia De Caro Dr.ssa Francesca",
    "address": "Via Piave, 33/35, Lamezia Terme CZ 88046, ITALIA",
    "lat": 38.971378,
    "lng": 16.319339,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.971378,16.319339"
  },
  {
    "name": "F.cia Capocasale Dr. Rosa Anna",
    "address": "Via Nazionale, 23, Petronà CZ 88050, ITALIA",
    "lat": 39.04486,
    "lng": 16.761858,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.04486,16.761858"
  },
  {
    "name": "F.cia Grippaudo di G. e P. Spagnolo snc",
    "address": "Via Libertà, 57, Enna EN 94100, ITALIA",
    "lat": 37.56286,
    "lng": 14.271265,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.56286,14.271265"
  },
  {
    "name": "F.cia Sorelle Rizzo srl",
    "address": "Via Annunziata Trav. II, 6, Caccuri KR 88833, ITALIA",
    "lat": 39.245887,
    "lng": 16.783214,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.245887,16.783214"
  },
  {
    "name": "F.cia Malena Dr. Francesco",
    "address": "Via Roma, 13, Cirò Marina KR 88811, ITALIA",
    "lat": 39.368935,
    "lng": 17.131942,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.368935,17.131942"
  },
  {
    "name": "F.cia Dott. Paolo Aiello",
    "address": "Via Roma, 6, Cutro KR 88842, ITALIA",
    "lat": 39.032387,
    "lng": 16.981436,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.032387,16.981436"
  },
  {
    "name": "F.cia Dott. Affattati Giuseppe",
    "address": "P.zza Del Popolo, 11, Isola di Capo Rizzuto KR 88841, ITALIA",
    "lat": 38.959813,
    "lng": 17.096621,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.959813,17.096621"
  },
  {
    "name": "Parafarmacia Marra Dr.ssa MariaTeresa",
    "address": "C.so Giove, 78, Petilia Policastro KR 88837, ITALIA",
    "lat": 39.11252,
    "lng": 16.784842,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.11252,16.784842"
  },
  {
    "name": "F.cia Di Colico Di Luca Lacorte Srl",
    "address": "Via Nazionale, 22, Colico LC 23823, ITALIA",
    "lat": 46.135455,
    "lng": 9.371192,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.135455,9.371192"
  },
  {
    "name": "F.cia Paganoni della dott.M. Paganoni e C. sas",
    "address": "Via Provinciale 40, Dolzago LC 23843, ITALIA",
    "lat": 45.766016,
    "lng": 9.33868,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.766016,9.33868"
  },
  {
    "name": "F.cia Lambrughi di Dr.ssa Mirella Patrizia",
    "address": "Via Giovanni XXIII; 6, Ello LC 23848, ITALIA",
    "lat": 45.786763,
    "lng": 9.366154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.786763,9.366154"
  },
  {
    "name": "F.cia Lambrughi CLUB SALUTE",
    "address": "Via Giovanni XXIII, 6, Ello LC 23848, ITALIA",
    "lat": 45.786763,
    "lng": 9.366154,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.786763,9.366154"
  },
  {
    "name": "F.cia Dott. Bellan",
    "address": "Via IV Novembre, 25, Galbiate LC 23851, ITALIA",
    "lat": 45.815168,
    "lng": 9.377387,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.815168,9.377387"
  },
  {
    "name": "F.cia S.Antonio srl(La Valletta)",
    "address": "Via Brusadelli, 32, La Valletta Brianza LC 23888, ITALIA",
    "lat": 45.737158,
    "lng": 9.369969,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.737158,9.369969"
  },
  {
    "name": "F.cia Benessere srl",
    "address": "Via Statale 63-Perego, La Valletta Brianza LC 23888, ITALIA",
    "lat": 45.737661,
    "lng": 9.363177,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.737661,9.363177"
  },
  {
    "name": "F.Cia S.Francesco sas",
    "address": "Viale Turati 45, Lecco LC 23900, ITALIA",
    "lat": 45.861191,
    "lng": 9.388414,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.861191,9.388414"
  },
  {
    "name": "F.cia S.Paolo Dott. Bonfanti Carlo",
    "address": "Via Manzoni 25 - Fraz.Maresso, Missaglia LC 23873, ITALIA",
    "lat": 45.682301,
    "lng": 9.396146,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.682301,9.396146"
  },
  {
    "name": "F.cia Olginate Dr.ssa Fedeli Anna & C. snc",
    "address": "Via Redaelli 19/A, Olginate LC 23854, ITALIA",
    "lat": 45.661078,
    "lng": 9.145486,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.661078,9.145486"
  },
  {
    "name": "F.cia Santa Croce di Olginate srl",
    "address": "Via Spluga, 56/B, Olginate LC 23854, ITALIA",
    "lat": 45.790622,
    "lng": 9.416168,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.790622,9.416168"
  },
  {
    "name": "F.cia Cervini snc",
    "address": "Via Roma, 1, Osnago LC 23875, ITALIA",
    "lat": 45.681209,
    "lng": 9.392491,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.681209,9.392491"
  },
  {
    "name": "Parafarmacia Valsassina di F.Cia Panzeri Dr.Regina",
    "address": "Via Provinciale, 93, Pasturo LC 23818, ITALIA",
    "lat": 45.957045,
    "lng": 9.450252,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.957045,9.450252"
  },
  {
    "name": "F.Cia Plaisant Dr.M.Luisa",
    "address": "Via Indipendenza 42, Robbiate LC 23899, ITALIA",
    "lat": 45.691061,
    "lng": 9.439827,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.691061,9.439827"
  },
  {
    "name": "F.cia S.Antonio srl(Valmadrera)",
    "address": "Via Promessi Sposi, 68, Valmadrera LC 22049, ITALIA",
    "lat": 45.851792,
    "lng": 9.364482,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.851792,9.364482"
  },
  {
    "name": "F.cia Comunale 2 ",
    "address": "Via Fleming, 1, Casalpusterlengo LO 26841, ITALIA",
    "lat": 45.170174,
    "lng": 9.651368,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.170174,9.651368"
  },
  {
    "name": "F.cia Frontori Dr.Sergio",
    "address": "Via Verdi 12, Castiraga Vidardo LO 26866, ITALIA",
    "lat": 45.256246,
    "lng": 9.402687,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.256246,9.402687"
  },
  {
    "name": "F.cia Orsi snc",
    "address": "Via Roma, 142, Guardamiglio LO 26862, ITALIA",
    "lat": 45.10594,
    "lng": 9.684003,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.10594,9.684003"
  },
  {
    "name": "F.Cia Chioda Dr.Riatti Amedeo",
    "address": "C.so G. Mazzini, 7, Lodi LO 26900, ITALIA",
    "lat": 45.301872,
    "lng": 9.422141,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.301872,9.422141"
  },
  {
    "name": "F.cia Francigena Dott.ssa Elisa Ferri",
    "address": "Via Pio Rossi 1, Orio Litta LO 26863, ITALIA",
    "lat": 45.159015,
    "lng": 9.55766,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.159015,9.55766"
  },
  {
    "name": "F.cia S.Rocco di Roberto Rossi",
    "address": "Via Roma, 155, S.Rocco al Porto LO 26875, ITALIA",
    "lat": 45.080344,
    "lng": 9.701498,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.080344,9.701498"
  },
  {
    "name": "F.cia Cortese snc dei D.ri Pinciroli e Zanoni",
    "address": "Via F. Cortese, 8/A, Sant’Angelo Lodigiano LO 26866, ITALIA",
    "lat": 45.23809,
    "lng": 9.409593,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.23809,9.409593"
  },
  {
    "name": "F.cia Zangrandi D.ssa Sabrina",
    "address": "Via Trento Trieste 12, Santo Stefano Lodigiano LO 26849, ITALIA",
    "lat": 45.119167,
    "lng": 9.736644,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.119167,9.736644"
  },
  {
    "name": "F.cia Tronconi Dott. Tronconi Lino",
    "address": "Via Vittorio Veneto, 7, Secugnago LO 26826, ITALIA",
    "lat": 45.23221,
    "lng": 9.589901,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.23221,9.589901"
  },
  {
    "name": "Farmaicurzio srl",
    "address": "Via Rogorini, 18, Aicurzio MB 20886, ITALIA",
    "lat": 45.63915,
    "lng": 9.413443,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.63915,9.413443"
  },
  {
    "name": "Farmacia Segramora Dr. Alessandro Segramora",
    "address": "Via S.Fermo, 1, Albiate MB 20847, ITALIA",
    "lat": 45.657842,
    "lng": 9.253736,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.657842,9.253736"
  },
  {
    "name": "F.Cia Appennini snc di Silvia Giovanna & C.",
    "address": "Via Trivulzio 51 - Fraz. Capriano, Briosco MB 20836, ITALIA",
    "lat": 45.722634,
    "lng": 9.256073,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.722634,9.256073"
  },
  {
    "name": "F.cia Comunale di Cavenago",
    "address": "Via XXV Aprile, 4, Cavenago Brianza MB 20873, ITALIA",
    "lat": 45.584491,
    "lng": 9.415804,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.584491,9.415804"
  },
  {
    "name": "F.cia Pozzoli snc(Cesano M)",
    "address": "Via Nazionale dei Giovi, 46, Cesano Maderno MB 20811, ITALIA",
    "lat": 45.631263,
    "lng": 9.138348,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.631263,9.138348"
  },
  {
    "name": "F.cia Centrale di Corti Dott.ssa Laura & C. sas",
    "address": "Via Manzoni, 11, Cogliate MB 20815, ITALIA",
    "lat": 45.662026,
    "lng": 9.092388,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.662026,9.092388"
  },
  {
    "name": "F.cia Piccaluga di Piccaluga Dr.ssa Silvia",
    "address": "Via Garibaldi, 25, Desio MB 20832, ITALIA",
    "lat": 45.602419,
    "lng": 9.201072,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.602419,9.201072"
  },
  {
    "name": "F.cia Galbiati snc",
    "address": "Via Partigiani D’Italia 2, Desio MB 20832, ITALIA",
    "lat": 45.612645,
    "lng": 9.2121,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.612645,9.2121"
  },
  {
    "name": "F.cia Ambrosiana sas di Dott.ssa A. Redaelli & C.",
    "address": "Via Marconi 29, Lesmo MB 20855, ITALIA",
    "lat": 45.647972,
    "lng": 9.30793,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.647972,9.30793"
  },
  {
    "name": "F.cia San Francesco della Dott.ssa Ida Bizzarri & C. sas",
    "address": "Via Monza 20, Lissone MB 20851, ITALIA",
    "lat": 45.606619,
    "lng": 9.245507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.606619,9.245507"
  },
  {
    "name": "F.Cia Bareggia snc",
    "address": "V.le Martiri della Libertà 250, Lissone MB 20851, ITALIA",
    "lat": 45.628184,
    "lng": 9.242309,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.628184,9.242309"
  },
  {
    "name": "F.Cia Macherio Dr.Ugo Giovanni Arienti",
    "address": "Via Italia, 15, Macherio MB 20846, ITALIA",
    "lat": 45.641149,
    "lng": 9.268713,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.641149,9.268713"
  },
  {
    "name": "F.cia San Giacomo di Pettiti e Scarrone snc",
    "address": "Via Tiziano Vecellio, 19, Meda MB 20821, ITALIA",
    "lat": 45.66238,
    "lng": 9.167151,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.66238,9.167151"
  },
  {
    "name": "F.cia S. Siro Dr. Mambretti F.",
    "address": "Piazza Statuto, 14, Misinto MB 20826, ITALIA",
    "lat": 45.763491,
    "lng": 10.808046,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.763491,10.808046"
  },
  {
    "name": "F.Cia Mandelli snc Dr.Mandelli & C.",
    "address": "Via Borgazzi, 9, Monza MB 20900, ITALIA",
    "lat": 44.897719,
    "lng": 10.258718,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.897719,10.258718"
  },
  {
    "name": "F.cia Villa Dott. Corbisiero Roberto",
    "address": "Via de Gradi, 3, Monza MB 20900, ITALIA",
    "lat": 45.584447,
    "lng": 9.280538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.584447,9.280538"
  },
  {
    "name": "F.cia S.Fruttuoso snc",
    "address": "Via Leo Sorteni, 5/C, Monza MB 20900, ITALIA",
    "lat": 45.576705,
    "lng": 9.239936,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.576705,9.239936"
  },
  {
    "name": "F.cia S.Francesco snc di Marramao e Saggio",
    "address": "Via Ciro Menotti, 3, Muggiò MB 20835, ITALIA",
    "lat": 45.592872,
    "lng": 9.239698,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.592872,9.239698"
  },
  {
    "name": "F.cia Nova srl",
    "address": "Via Brodolini 1, Nova Milanese MB 20834, ITALIA",
    "lat": 45.583564,
    "lng": 9.195964,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.583564,9.195964"
  },
  {
    "name": "F.Cia Di Paina Dr.Taborelli Angelo",
    "address": "V.le Brianza, 14/C, Paina Di Giussano MB 20833, ITALIA",
    "lat": 45.674525,
    "lng": 9.204638,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.674525,9.204638"
  },
  {
    "name": "F.cia Dr. Ranieri di Limonta Ranieri & C. sas",
    "address": "Via Pio XI, 2, Ronco Briantino MB 20885, ITALIA",
    "lat": 45.667488,
    "lng": 9.398301,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.667488,9.398301"
  },
  {
    "name": "F.Cia Campagner sas",
    "address": "Via Ciceri, 30, Sulbiate MB 20884, ITALIA",
    "lat": 45.62933,
    "lng": 12.56962,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.62933,12.56962"
  },
  {
    "name": "F.Cia Beccarelli sas di Monti Annamaria",
    "address": "Viale Brianza 15, Varedo MB 20814, ITALIA",
    "lat": 45.599594,
    "lng": 9.169033,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.599594,9.169033"
  },
  {
    "name": "Az.Speciale Farmacie Comunali Vimercatesi",
    "address": "Via Don Lualdi, 6 Fraz. Ruginello, Vimercate MB 20871, ITALIA",
    "lat": 45.624685,
    "lng": 9.387408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.624685,9.387408"
  },
  {
    "name": "Parafarmacia Liotta snc",
    "address": "Via Generale Di Giorgio, 56, Acquedolci ME 98070, ITALIA",
    "lat": 38.016797,
    "lng": 14.598032,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.016797,14.598032"
  },
  {
    "name": "2C Pharma sas di Contartese & C.",
    "address": "Via Salvatore Cattafi, 31, Barcellona Pozzo di Goito ME 98051, ITALIA",
    "lat": 38.150686,
    "lng": 15.220739,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.150686,15.220739"
  },
  {
    "name": "F.cia Venuto Vincenzo",
    "address": "Via Umberto I ang. Via Moleti, Barcellona Pozzo di Gotto ME 98051, ITALIA",
    "lat": 38.1427,
    "lng": 15.21569,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.1427,15.21569"
  },
  {
    "name": "F.cia D.ssa Ida Arrigo del Dr.Velardi",
    "address": "Consolare Antica, 641, Capo D’Orlando ME 98071, ITALIA",
    "lat": 38.134008,
    "lng": 14.727625,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.134008,14.727625"
  },
  {
    "name": "Parafarmacia del Centro srls",
    "address": "P.zza G. Matteotti, 7, Capo D’Orlando ME 98071, ITALIA",
    "lat": 43.058366,
    "lng": 11.831359,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.058366,11.831359"
  },
  {
    "name": "F.cia San Martino Della Dott.ssa Angela Raccuia",
    "address": "Via Nazionale Palermo, 2, Capo d’Orlando ME 98071, ITALIA",
    "lat": 38.138905,
    "lng": 14.735798,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.138905,14.735798"
  },
  {
    "name": "F.cia Miranti Luisa & C. sas",
    "address": "P.zza Umberto I, 7, Castel di Lucio ME 98070, ITALIA",
    "lat": 37.887033,
    "lng": 14.313157,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.887033,14.313157"
  },
  {
    "name": "F.cia Dr. Manuli Carmela",
    "address": "Via IV Novembre, 800, Furci Siculo ME 98023, ITALIA",
    "lat": 37.961433,
    "lng": 15.382079,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.961433,15.382079"
  },
  {
    "name": "F.cia Cattafi Dr. Gaspare(Tonnarella)",
    "address": "Via Prestipaolo sn-Tonnarella, Furnari ME 98054, ITALIA",
    "lat": 38.125308,
    "lng": 15.113841,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.125308,15.113841"
  },
  {
    "name": "F.cia Russo sas",
    "address": "Via Nuova, 5, Gualtieri Sicamino ME 98040, ITALIA",
    "lat": 38.163409,
    "lng": 15.315708,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.163409,15.315708"
  },
  {
    "name": "F.cia Brancato sas della Dott.ssa C.Brancato e C.",
    "address": "Via Garibaldi, 373, Messina ME 98121, ITALIA",
    "lat": 38.148977,
    "lng": 15.222456,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.148977,15.222456"
  },
  {
    "name": "Parafarmacia Delia srl",
    "address": "V.le Europa, 207, Messina ME 98124, ITALIA",
    "lat": 38.183269,
    "lng": 15.542544,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.183269,15.542544"
  },
  {
    "name": "F.cia San Giovanni srl",
    "address": "Via San Giovanni, 58, Milazzo ME 98057, ITALIA",
    "lat": 38.215522,
    "lng": 15.235101,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.215522,15.235101"
  },
  {
    "name": "Parafarmacia Salus et Officia srl",
    "address": "Via Gaspare Amodeo, 36, Oliveri ME 98060, ITALIA",
    "lat": 38.123655,
    "lng": 15.060563,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.123655,15.060563"
  },
  {
    "name": "F.cia Gugliotta srl",
    "address": "Via XX Settembre, 46, Patti ME 98066, ITALIA",
    "lat": 38.137177,
    "lng": 14.966417,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.137177,14.966417"
  },
  {
    "name": "Parafarmacia Mongiove della Dr.ssa Cardone Deborah",
    "address": "Via Umberto I, 30-Mongiove, Patti ME 98066, ITALIA",
    "lat": 38.147983,
    "lng": 15.014475,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.147983,15.014475"
  },
  {
    "name": "F.cia Macchia sas di R. Badessa e C.",
    "address": "Via Nazionale, 330, Rometta Marea ME 98040, ITALIA",
    "lat": 38.230087,
    "lng": 15.407788,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.230087,15.407788"
  },
  {
    "name": "F.cia Cavallaro D.ssa Antonella",
    "address": "Via Nazionale, 68 - Olivarella, San Filippo Del Mela ME 98044, ITALIA",
    "lat": 38.182103,
    "lng": 15.271043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.182103,15.271043"
  },
  {
    "name": "F.cia Dott. Francesco Picciolo snc",
    "address": "Via Quasimodo, 9, Villafranca Tirrena ME 98049, ITALIA",
    "lat": 38.237521,
    "lng": 15.43478,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.237521,15.43478"
  },
  {
    "name": "Farmacia Milano srl",
    "address": "Via C. Matteotti, 48, Abbiategrasso MI 20081, ITALIA",
    "lat": 45.285573,
    "lng": 8.990754,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.285573,8.990754"
  },
  {
    "name": "F.cia Comunale n.2 Abbiategrasso",
    "address": "Via Mazzini 101, Abbiategrasso MI 20081, ITALIA",
    "lat": 39.859363,
    "lng": 18.298928,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.859363,18.298928"
  },
  {
    "name": "F.cia Comunale n.1 Abbiategrasso",
    "address": "Via Novara, 44, Abbiategrasso MI 20081, ITALIA",
    "lat": 45.403973,
    "lng": 8.911213,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.403973,8.911213"
  },
  {
    "name": "F.cia Gran Paradiso di Salvia srL",
    "address": "Via Valera, 25, Arese MI 20044, ITALIA",
    "lat": 45.549059,
    "lng": 9.070011,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.549059,9.070011"
  },
  {
    "name": "F.Cia Europea snc",
    "address": "Via Girotti 12, Bareggio MI 20008, ITALIA",
    "lat": 44.69601,
    "lng": 10.621921,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.69601,10.621921"
  },
  {
    "name": "F.cia San Martino sas della Dr.ssa Giuliana Magistrali e C.",
    "address": "Via F.lli Cervi, 1-Ang. Via Milano, Bareggio MI 20008, ITALIA",
    "lat": 45.493172,
    "lng": 9.26423,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.493172,9.26423"
  },
  {
    "name": "F.cia Della Canonica di Tizzoni e Cantoni srl",
    "address": "Via V.Emanuele, 3, Bernate Ticino MI 20010, ITALIA",
    "lat": 45.477917,
    "lng": 8.818123,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.477917,8.818123"
  },
  {
    "name": "F.cia S.Luigi srl",
    "address": "Via Caduti Bollatesi 32, Bollate MI 20021, ITALIA",
    "lat": 45.544473,
    "lng": 9.12524,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.544473,9.12524"
  },
  {
    "name": "F.cia Comunale 4 di Gaia Servizi srl",
    "address": "Via M. di Marzabotto, 7, Bollate MI 20021, ITALIA",
    "lat": 45.528099,
    "lng": 9.054214,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.528099,9.054214"
  },
  {
    "name": "F.cia Della Corte snc",
    "address": "Via Magenta, 33, Bollate MI 20021, ITALIA",
    "lat": 45.541752,
    "lng": 9.115092,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.541752,9.115092"
  },
  {
    "name": "F.cia Iampietro",
    "address": "Via Anna Frank, 11, Bollate MI 20021, ITALIA",
    "lat": 45.553424,
    "lng": 9.140763,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.553424,9.140763"
  },
  {
    "name": "Azienda Speciale Buccinasco - F.cia comunale 1",
    "address": "Via Marzabotto, 1, Buccinasco MI 20090, ITALIA",
    "lat": 45.421798,
    "lng": 9.121212,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.421798,9.121212"
  },
  {
    "name": "F.cia Daniotti sas",
    "address": "Via Panagulis, 1/3, Casarile MI 20059, ITALIA",
    "lat": 44.959527,
    "lng": 10.683063,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.959527,10.683063"
  },
  {
    "name": "F.cia Cassina De Pecchi snc",
    "address": "Via Papa Giovanni XXIII 5, Cassina De’ Pecchi MI 20051, ITALIA",
    "lat": 45.553672,
    "lng": 9.384378,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.553672,9.384378"
  },
  {
    "name": "F.cia San Bartolomeo sas",
    "address": "Via S.Bartolomeo 15 - Cantalupo, Cerro Maggiore MI 20023, ITALIA",
    "lat": 45.579986,
    "lng": 8.978513,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.579986,8.978513"
  },
  {
    "name": "F.cia Bignami Eredi Dott. Calò Giorgio Bianchini Annamaria",
    "address": "Via Libertà 71, Cinisello Balsamo MI 20092, ITALIA",
    "lat": 45.554595,
    "lng": 9.216019,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.554595,9.216019"
  },
  {
    "name": "F.cia Bignami sas",
    "address": "Via Libertà 71, Cinisello Balsamo MI 20092, ITALIA",
    "lat": 45.554595,
    "lng": 9.216019,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.554595,9.216019"
  },
  {
    "name": "F.cia Colucci di Norina Colucci",
    "address": "Via G.Pascoli, 9, Cologno Monzese MI 20093, ITALIA",
    "lat": 45.528649,
    "lng": 9.289231,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.528649,9.289231"
  },
  {
    "name": "F.cia Rivolta Dr. G. Meroni Rivolta",
    "address": "Via Caduti Libertà, 10, Cormano MI 20032, ITALIA",
    "lat": 45.542647,
    "lng": 9.172679,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.542647,9.172679"
  },
  {
    "name": "F.cia Sorrentino srl",
    "address": "Via Gramsci, 44, Cormano MI 20032, ITALIA",
    "lat": 40.43095,
    "lng": 18.041921,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.43095,18.041921"
  },
  {
    "name": "F.cia Comunale 2 Cornaredo",
    "address": "P.tta Europa, 11, Cornaredo MI 20007, ITALIA",
    "lat": 45.50154,
    "lng": 9.024812,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.50154,9.024812"
  },
  {
    "name": "F.Cia Corneliani srl",
    "address": "Via Vittorio Emanuele 22, Corsico MI 20094, ITALIA",
    "lat": 45.432963,
    "lng": 9.108184,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.432963,9.108184"
  },
  {
    "name": "F.cia Paltrinieri Dott.ssa Pirotta Elena",
    "address": "V.le Cooperazione, 20, Cusano Milanino MI 20095, ITALIA",
    "lat": 45.551607,
    "lng": 9.188022,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.551607,9.188022"
  },
  {
    "name": "F.Cia Perino Dr.Ssa Giulia",
    "address": "Via E.Toti 1/a, Dairago MI 20036, ITALIA",
    "lat": 45.547438,
    "lng": 8.888392,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.547438,8.888392"
  },
  {
    "name": "F.Cia Donati Snc D.Ssa Donati Giuseppina & C.",
    "address": "Via Italia 18, Gorgonzola MI 20064, ITALIA",
    "lat": 45.530921,
    "lng": 9.406027,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.530921,9.406027"
  },
  {
    "name": "F.cia Rizzi srl",
    "address": "Via Marchesi, 30, Inzago MI 20065, ITALIA",
    "lat": 45.538677,
    "lng": 9.487474,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.538677,9.487474"
  },
  {
    "name": "F.cia Fiammenghi sas del Dott. Roberto Bignami",
    "address": "C.so Matteotti, 60, Lacchiarella MI 20084, ITALIA",
    "lat": 45.319954,
    "lng": 9.138093,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.319954,9.138093"
  },
  {
    "name": "Az.Speciale Farmaceutica di Lainate",
    "address": "Via Re Umberto 1/3, Lainate MI 20045, ITALIA",
    "lat": 45.572101,
    "lng": 9.027782,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.572101,9.027782"
  },
  {
    "name": "F.cia Grancia Dott.Gritti C.Angelo & C. sas",
    "address": "Via Grancia 40/n, Lainate MI 20045, ITALIA",
    "lat": 45.555999,
    "lng": 9.019473,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.555999,9.019473"
  },
  {
    "name": "F.cia Comunale 2 Lainate- Az.Speciale Farmaceutica di Lainate",
    "address": "Via La Marmora, 7, Lainate MI 20045, ITALIA",
    "lat": 45.577455,
    "lng": 9.025254,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.577455,9.025254"
  },
  {
    "name": "F.cia Sant’Anna di Carrara Dott.ssa Patrizia Margherita",
    "address": "Via Carro Maggiore, Mediglia MI 20076, ITALIA",
    "lat": 45.433384,
    "lng": 9.34408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.433384,9.34408"
  },
  {
    "name": "F.cia Borsa sas della Dr.ssa Silvia Borsa",
    "address": "Via De Amicis, 3, Melzo MI 20066, ITALIA",
    "lat": 45.504189,
    "lng": 9.423974,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.504189,9.423974"
  },
  {
    "name": "F.Cia Cavalli A.",
    "address": "Via Giuseppe Candiani, 122, Milano MI 20158, ITALIA",
    "lat": 45.503209,
    "lng": 9.16252,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.503209,9.16252"
  },
  {
    "name": "F.cia Olmi snc del Dr. Alberto Alessio",
    "address": "Via Delle Betulle 10, Milano MI 20152, ITALIA",
    "lat": 45.453234,
    "lng": 9.083668,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.453234,9.083668"
  },
  {
    "name": "F.Cia Laghi Dr.Ssa A. Gattei",
    "address": "Viale Certosa, 282, Milano MI 20156, ITALIA",
    "lat": 45.502082,
    "lng": 9.125546,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.502082,9.125546"
  },
  {
    "name": "F.Cia Metalla & C. S.N.C. Di Dr.Celeste Metalla",
    "address": "Viale Umbria 19, Milano MI 20135, ITALIA",
    "lat": 45.449605,
    "lng": 9.211669,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.449605,9.211669"
  },
  {
    "name": "F.cia Plebisciti sas del dottor Danesi Pietro & C.",
    "address": "Corso Plebisciti 7, Milano MI 20129, ITALIA",
    "lat": 45.468175,
    "lng": 9.21871,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.468175,9.21871"
  },
  {
    "name": "F.cia San Paolo srl",
    "address": "Via Pordenone 1, Milano MI 20132, ITALIA",
    "lat": 45.490076,
    "lng": 9.234157,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.490076,9.234157"
  },
  {
    "name": "F.Cia Sociale Dr. Berra Carlo",
    "address": "Viale Monza, 126, Milano MI 20127, ITALIA",
    "lat": 45.501543,
    "lng": 9.221639,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.501543,9.221639"
  },
  {
    "name": "F.Cia Rombon Dr.Racca",
    "address": "Via Rombon 29, Milano MI 20134, ITALIA",
    "lat": 45.4864,
    "lng": 9.24076,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.4864,9.24076"
  },
  {
    "name": "F.cia Sacchi snc",
    "address": "Via A. Anfossi, 9, Milano MI 20135, ITALIA",
    "lat": 43.865271,
    "lng": 7.868427,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.865271,7.868427"
  },
  {
    "name": "F.cia Antica Diana dr. Damioli S.",
    "address": "Piazza Oberdan, 4, Milano MI 20129, ITALIA",
    "lat": 45.474172,
    "lng": 9.206725,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.474172,9.206725"
  },
  {
    "name": "F.cia Nuova Inganni Snc",
    "address": "Via Inganni, 70, Milano MI 20147, ITALIA",
    "lat": 45.454885,
    "lng": 9.123982,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.454885,9.123982"
  },
  {
    "name": "F.cia S.Giovanni sas della Dr.ssa Antonella Costa",
    "address": "Via Pola, 13, Milano MI 20124, ITALIA",
    "lat": 45.488763,
    "lng": 9.194013,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.488763,9.194013"
  },
  {
    "name": "F.cia Niguarda srl",
    "address": "Via Monterotondo, 1, Milano MI 20121, ITALIA",
    "lat": 45.515219,
    "lng": 9.194098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.515219,9.194098"
  },
  {
    "name": "F.cia Sempione di Gheza e C. snc",
    "address": "C.so Sempione, 5, Milano MI 20145, ITALIA",
    "lat": 45.476742,
    "lng": 9.17061,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.476742,9.17061"
  },
  {
    "name": "F.cia Porpora sas di Macchi Annalisa & C.",
    "address": "Via Porpora, 148, Milano MI 20131, ITALIA",
    "lat": 45.560127,
    "lng": 8.93772,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.560127,8.93772"
  },
  {
    "name": "F.cia Ovidio CLUB SALUTE",
    "address": "Via Toscolano, 1, Milano MI 20138, ITALIA",
    "lat": 45.458753,
    "lng": 9.241811,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.458753,9.241811"
  },
  {
    "name": "F.cia Modiano Clara sas",
    "address": "Piazza Stuparich 4, Milano MI 20148, ITALIA",
    "lat": 45.482512,
    "lng": 9.143662,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.482512,9.143662"
  },
  {
    "name": "F.cia Santa Chiara snc",
    "address": "Via Crescenzago, 36, Milano MI 20134, ITALIA",
    "lat": 45.489308,
    "lng": 9.241847,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.489308,9.241847"
  },
  {
    "name": "Farma Bonola srl",
    "address": "Via Quarenghi, 23, Milano MI 20151, ITALIA",
    "lat": 45.495838,
    "lng": 9.114798,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.495838,9.114798"
  },
  {
    "name": "F.Cia Cenisio srl",
    "address": "Via S.Galdino 11, Milano MI 20154, ITALIA",
    "lat": 45.487077,
    "lng": 9.166642,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.487077,9.166642"
  },
  {
    "name": "F.cia Bandi srl",
    "address": "Via Rovereto, 14 (ang. v.le Monza), Milano MI 20127, ITALIA",
    "lat": 45.494979,
    "lng": 9.219718,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.494979,9.219718"
  },
  {
    "name": "F.cia della Torretta Milano sas Dr.ssa M.Rocchi e C.",
    "address": "Via Largo Promessi Sposi 4, Milano MI 20142, ITALIA",
    "lat": 45.435787,
    "lng": 9.173182,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.435787,9.173182"
  },
  {
    "name": "F.cia San Luca snc",
    "address": "Via Carnevali 70, Milano MI 20158, ITALIA",
    "lat": 45.503049,
    "lng": 9.170532,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.503049,9.170532"
  },
  {
    "name": "F.cia Falqui Milano srl",
    "address": "V.le Zara, 145, Milano MI 20159, ITALIA",
    "lat": 45.500842,
    "lng": 9.197072,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.500842,9.197072"
  },
  {
    "name": "F.cia Canonica snc",
    "address": "Via Canonica, 32, Milano MI 20154, ITALIA",
    "lat": 45.478959,
    "lng": 9.174507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.478959,9.174507"
  },
  {
    "name": "F.cia Concordia Dr. Papa srl",
    "address": "C.so Concordia, 16, Milano MI 20129, ITALIA",
    "lat": 45.46771,
    "lng": 9.209839,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.46771,9.209839"
  },
  {
    "name": "Farmacia San Michele Srl",
    "address": "Viale Coni Zugna, 12, Milano MI 20144, ITALIA",
    "lat": 45.459796,
    "lng": 9.165145,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.459796,9.165145"
  },
  {
    "name": "F.Cia Cavalli di Cozzi Dr. Paolo",
    "address": "Via Giuseppe Candiani, 122, Milano MI 20158, ITALIA",
    "lat": 45.503209,
    "lng": 9.16252,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.503209,9.16252"
  },
  {
    "name": "Parafarmacia D.ssa Muzzio Anna",
    "address": "Via Soriani,1, Motta Visconti MI 20086, ITALIA",
    "lat": 45.287241,
    "lng": 8.992702,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.287241,8.992702"
  },
  {
    "name": "F.Cia Preti Dr.Preti & C. S.N.C.",
    "address": "Via Milano, 6/A, Nerviano MI 20014, ITALIA",
    "lat": 45.556507,
    "lng": 8.979326,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.556507,8.979326"
  },
  {
    "name": "F.cia Marzagalli di A. Marzagalli e c. snc",
    "address": "Piazza Della Vittoria 17, Nerviano MI 20014, ITALIA",
    "lat": 45.55532,
    "lng": 8.975026,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.55532,8.975026"
  },
  {
    "name": "F.cia Rocca snc",
    "address": "V.le J.F. Kennedy, 52/54, Nerviano MI 20014, ITALIA",
    "lat": 42.457604,
    "lng": 14.087281,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=42.457604,14.087281"
  },
  {
    "name": "F.cia Stelvio srl",
    "address": "Via Stelvio, 9, Novate Milanese MI 20026, ITALIA",
    "lat": 45.537962,
    "lng": 9.131732,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.537962,9.131732"
  },
  {
    "name": "F.cia Comunale Novate M.se n.1",
    "address": "Via Matteotti 5, Novate Milanese MI 20026, ITALIA",
    "lat": 45.478659,
    "lng": 10.038876,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.478659,10.038876"
  },
  {
    "name": "F.cia Lunghi Opera srl",
    "address": "Via Cadorna, 5/7, Opera MI 20073, ITALIA",
    "lat": 45.377017,
    "lng": 9.20972,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.377017,9.20972"
  },
  {
    "name": "F.cia S.Martino del dott. Asnaghi",
    "address": "Via Coti Zelati, 35, Paderno Dugnano MI 20037, ITALIA",
    "lat": 45.581961,
    "lng": 9.157738,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.581961,9.157738"
  },
  {
    "name": "F.cia Viani srl",
    "address": "Via Gramsci, 168, Paderno Dugnano MI 20037, ITALIA",
    "lat": 45.569344,
    "lng": 9.165672,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.569344,9.165672"
  },
  {
    "name": "F.Cia Rinaldi sas di Ferrari L. e C.",
    "address": "Via Risorgimento,41/a, Pantigliate MI 20048, ITALIA",
    "lat": 45.43384,
    "lng": 9.352092,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.43384,9.352092"
  },
  {
    "name": "F.cia Comunale Parabiago",
    "address": "Via B.Cavalieri, 11-c/o Coop, Parabiago MI 20015, ITALIA",
    "lat": 45.550151,
    "lng": 8.948252,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.550151,8.948252"
  },
  {
    "name": "F.Cia Borsa snc delle Dott.sse Vigo e Migliavacca",
    "address": "Via Milano 18, Paullo MI 20067, ITALIA",
    "lat": 45.417863,
    "lng": 9.389787,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.417863,9.389787"
  },
  {
    "name": "F.cia Comunale di Pero",
    "address": "Via C. Battisti, 6, Pero MI 20016, ITALIA",
    "lat": 40.199861,
    "lng": 18.298507,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.199861,18.298507"
  },
  {
    "name": "F.Cia Ghiozzi sas Dott. Ghiozzi Fernanda & C.",
    "address": "Corso Europa, 42, Pessano Con Bornago MI 20042, ITALIA",
    "lat": 45.547253,
    "lng": 9.384324,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.547253,9.384324"
  },
  {
    "name": "F.cia Dei Popoli di M.Moffa e P.Nigro snc",
    "address": "Viale San Francesco, 16, Pioltello MI 20096, ITALIA",
    "lat": 45.498677,
    "lng": 9.322408,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.498677,9.322408"
  },
  {
    "name": "F.cia Verderio srl",
    "address": "Via Matteotti 14, Rescaldina MI 20027, ITALIA",
    "lat": 40.175298,
    "lng": 18.163219,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.175298,18.163219"
  },
  {
    "name": "F.cia Mezzacappa snc Dott.ssa Mezzacappa A. e C.",
    "address": "Via A.Da Giussano, 2, Rescaldina MI 20027, ITALIA",
    "lat": 45.626871,
    "lng": 8.94433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.626871,8.94433"
  },
  {
    "name": "F.Cia Chiaudani Dr.Ferdinando",
    "address": "Via Fosse Ardeatine 2, Rho MI 20017, ITALIA",
    "lat": 45.535538,
    "lng": 9.040716,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.535538,9.040716"
  },
  {
    "name": "F.cia Lucernate snc",
    "address": "Via G. Cesare, 15, Rho MI 20017, ITALIA",
    "lat": 45.515856,
    "lng": 9.035033,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.515856,9.035033"
  },
  {
    "name": "F.cia Benessere srl",
    "address": "Via per Casterno, 20, Robecco sul Naviglio MI 20087, ITALIA",
    "lat": 45.429823,
    "lng": 8.870941,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.429823,8.870941"
  },
  {
    "name": "Parafarmacia Dr.a Ferrario",
    "address": "Via Roma,32, Rosate MI 20088, ITALIA",
    "lat": 45.351152,
    "lng": 9.018562,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.351152,9.018562"
  },
  {
    "name": "F.cia Quinto Stampi snc",
    "address": "Via Isonzo, 24, Rozzano MI 20089, ITALIA",
    "lat": 45.389805,
    "lng": 9.170764,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.389805,9.170764"
  },
  {
    "name": "F.cia Rinascita snc di Martinoli R. & C.",
    "address": "V.le Lombardia, 40, Rozzano MI 20089, ITALIA",
    "lat": 45.385979,
    "lng": 9.148708,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.385979,9.148708"
  },
  {
    "name": "F.cia Colombo di Colombo Luisa e C. snc",
    "address": "Via Roma 57, S.Giorgio Su Legnano MI 20034, ITALIA",
    "lat": 45.576942,
    "lng": 8.912093,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.576942,8.912093"
  },
  {
    "name": "F.Cia Verri Dr.Luigi",
    "address": "Via Dante Alighieri 9, S.Zenone Al Lambro MI 20070, ITALIA",
    "lat": 44.720582,
    "lng": 8.286072,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.720582,8.286072"
  },
  {
    "name": "F.cia Santa Barbara srl",
    "address": "Via Alfonsine, 22, San Donato Milanese MI 20097, ITALIA",
    "lat": 45.423658,
    "lng": 9.265405,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.423658,9.265405"
  },
  {
    "name": "F.Cia Zucca sas di Zucca Sara & C.",
    "address": "Via Roma, 8, Segrate MI 20054, ITALIA",
    "lat": 45.490513,
    "lng": 9.295207,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.490513,9.295207"
  },
  {
    "name": "F.Cia Centrale Dr.ssa Amato Lucia Giuseppina",
    "address": "Via Garibaldi, 3, Senago MI 20030, ITALIA",
    "lat": 40.033153,
    "lng": 18.392795,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.033153,18.392795"
  },
  {
    "name": "F.Cia Centrale Amato snc",
    "address": "Via Garibaldi, 3, Senago MI 20030, ITALIA",
    "lat": 40.033153,
    "lng": 18.392795,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.033153,18.392795"
  },
  {
    "name": "F.cia Rovani di Salvo Maria E. & C. Sas",
    "address": "Via Rovani, 84, Sesto S.Giovanni MI 20099, ITALIA",
    "lat": 45.536052,
    "lng": 9.228118,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.536052,9.228118"
  },
  {
    "name": "F.cia De Carli",
    "address": "P.zza Trento Trieste, 11, Sesto S.Giovanni MI 20099, ITALIA",
    "lat": 45.532686,
    "lng": 9.227508,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.532686,9.227508"
  },
  {
    "name": "F.cia Sanitas snc",
    "address": "Via Gorizia, 15- Ang.Via Marelli, Sesto San Giovanni MI 20099, ITALIA",
    "lat": 45.526507,
    "lng": 9.228222,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.526507,9.228222"
  },
  {
    "name": "F.cia Culzoni snc",
    "address": "Via Bianchi, 18/A, Settimo Milanese MI 20019, ITALIA",
    "lat": 45.487443,
    "lng": 9.053204,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.487443,9.053204"
  },
  {
    "name": "F.cia di Concesa della Dott.ssa C. Pirola & C. snc",
    "address": "P.zza Cereda, 6, Trezzo Sull’Adda MI 20056, ITALIA",
    "lat": 45.602161,
    "lng": 9.526352,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.602161,9.526352"
  },
  {
    "name": "F.cia Pirazzini srl",
    "address": "Via Ferrazzi, 2, Villa Cortese MI 20020, ITALIA",
    "lat": 45.566038,
    "lng": 8.887103,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.566038,8.887103"
  },
  {
    "name": "F.cia San Remigio sas D.ssa Cristiana Terzi & C.",
    "address": "Via XI Febbraio 3, Vimodrone MI 20055, ITALIA",
    "lat": 45.51349,
    "lng": 9.285098,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.51349,9.285098"
  },
  {
    "name": "F.cia Santa Croce srl",
    "address": "Via Nino Bixio, 7, Vittuone MI 20009, ITALIA",
    "lat": 45.490044,
    "lng": 8.948999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.490044,8.948999"
  },
  {
    "name": "Far.com srl - F.cia comunale Vizzolo Predabissi",
    "address": "Via Verdi, 9, Vizzolo Predabissi MI 20070, ITALIA",
    "lat": 45.36024,
    "lng": 9.346151,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.36024,9.346151"
  },
  {
    "name": "F.cia Borgoforte srl",
    "address": "P.zza Matteotti, 18, Borgoforte MN 46034, ITALIA",
    "lat": 45.048995,
    "lng": 10.750179,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.048995,10.750179"
  },
  {
    "name": "F.cia Essenza srl",
    "address": "Via Madrid cm, Castel Goffredo MN 46042, ITALIA",
    "lat": 45.28604,
    "lng": 10.461777,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.28604,10.461777"
  },
  {
    "name": "F.cia Orlandi D.ssa Orlandi Giulia sas",
    "address": "Piazza I Maggio, 9, Castellucchio MN 46014, ITALIA",
    "lat": 45.728697,
    "lng": 11.676642,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.728697,11.676642"
  },
  {
    "name": "F.Cia Giovannoli srl",
    "address": "Via Mazzini,65, Castiglione Delle Stiviere MN 46043, ITALIA",
    "lat": 45.455894,
    "lng": 10.385584,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.455894,10.385584"
  },
  {
    "name": "F.Cia Tarana sas",
    "address": "Via Provinciale Nord, 52/B, Dosolo MN 46030, ITALIA",
    "lat": 44.953571,
    "lng": 10.632569,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.953571,10.632569"
  },
  {
    "name": "F.cia Azzali Dr.Lino",
    "address": "Via Dante Alighieri, 13, Goito MN 46044, ITALIA",
    "lat": 45.255103,
    "lng": 10.672411,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.255103,10.672411"
  },
  {
    "name": "F.cia Bondeno di Ferrari-Schiavo & C. sas",
    "address": "Via Arduini, 2/E - Bondeno, Gonzaga MN 46020, ITALIA",
    "lat": 43.145964,
    "lng": 10.974385,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=43.145964,10.974385"
  },
  {
    "name": "F.cia Grusi Dott.ssa Marzia & C. sas",
    "address": "Via Levata, 67, Levata di Curtatone MN 46010, ITALIA",
    "lat": 45.122544,
    "lng": 10.766043,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.122544,10.766043"
  },
  {
    "name": "F.Cia Al Te Dr.Marcello Schena",
    "address": "Piazza Porta Ceresa, 3, Mantova MN 46100, ITALIA",
    "lat": 45.158448,
    "lng": 10.794218,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.158448,10.794218"
  },
  {
    "name": "F.cia Degli Angeli di Mattioli Dott.ssa Luisa",
    "address": "Via Dell’Aldriga, 3, Mantova MN 46100, ITALIA",
    "lat": 45.155205,
    "lng": 10.752197,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.155205,10.752197"
  },
  {
    "name": "F.cia Maria Assunta D.ssa Martinelli Erika",
    "address": "Via Matteotti, 62, Mariana Mantovana MN 46010, ITALIA",
    "lat": 45.192276,
    "lng": 10.486213,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.192276,10.486213"
  },
  {
    "name": "F.cia Medole srl",
    "address": "Via Matteotti, 12/B, Medole MN 46046, ITALIA",
    "lat": 45.326484,
    "lng": 10.519053,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.326484,10.519053"
  },
  {
    "name": "F.Cia Breviglieri Dr.ssa Lucia",
    "address": "Via Rovigo, 118 - Corregioli, Ostiglia MN 46035, ITALIA",
    "lat": 45.166876,
    "lng": 11.322152,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.166876,11.322152"
  },
  {
    "name": "F.cia Paternieri di Paternieri F. e C. snc",
    "address": "Via Francesca Ovest 4, Rodigo MN 46040, ITALIA",
    "lat": 45.200473,
    "lng": 10.62194,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.200473,10.62194"
  },
  {
    "name": "Antica Farmacia Ghidini Anna",
    "address": "Via E. Ferri n. 42, San Benedetto PO MN 46027, ITALIA",
    "lat": 45.042531,
    "lng": 10.92766,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.042531,10.92766"
  },
  {
    "name": "F.cie Vittoria srl",
    "address": "Via E. Ferri, 6, San Benedetto Po MN 46027, ITALIA",
    "lat": 45.042531,
    "lng": 10.92766,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.042531,10.92766"
  },
  {
    "name": "F.cia S.Giorgio Servizi srl",
    "address": "P.zza Madre Teresa di Calcutta, 6, San Giorgio di Bigarello MN 46051, ITALIA",
    "lat": 45.165545,
    "lng": 10.841141,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.165545,10.841141"
  },
  {
    "name": "F.Cia Centrale di Breviglieri P. e I. sas",
    "address": "Piazza Garibaldi 1/B, Suzzara MN 46029, ITALIA",
    "lat": 44.990965,
    "lng": 10.744201,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.990965,10.744201"
  },
  {
    "name": "F.cia 2M di Morselli e Mantovani snc",
    "address": "Via Solferino, 6/D, Suzzara MN 46029, ITALIA",
    "lat": 44.991968,
    "lng": 10.754177,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.991968,10.754177"
  },
  {
    "name": "F.cia Greco di Maurizio Giammanco e C. snc",
    "address": "Via D. D’Amico, 32, Bagheria PA 90011, ITALIA",
    "lat": 38.079297,
    "lng": 13.516436,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.079297,13.516436"
  },
  {
    "name": "F.cia San Giuseppe srl",
    "address": "Via Ing. G.Bagnera, 18 int.4, Bagheria PA 90011, ITALIA",
    "lat": 38.078942,
    "lng": 13.507318,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.078942,13.507318"
  },
  {
    "name": "Parafarmacia Le 3G",
    "address": "C.so Butera, 464, Bagheria PA 90011, ITALIA",
    "lat": 38.079282,
    "lng": 13.506862,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.079282,13.506862"
  },
  {
    "name": "F.cia Cefalà Diana srl",
    "address": "P.zza Umberto I, 20, Cefalà Diana PA 90030, ITALIA",
    "lat": 37.91547,
    "lng": 13.463174,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.91547,13.463174"
  },
  {
    "name": "F.cia Santa Barbara snc",
    "address": "Via Vitaliano Brancati 2, Cefalù PA 90015, ITALIA",
    "lat": 38.032548,
    "lng": 14.02575,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.032548,14.02575"
  },
  {
    "name": "F.cia Vacanti snc",
    "address": "Via Cannizzaro, 3, Cefalù PA 90015, ITALIA",
    "lat": 38.033712,
    "lng": 14.015876,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.033712,14.015876"
  },
  {
    "name": "F.cia Moschitta Pietro di A. e L. Moschitta snc",
    "address": "C.so V. Emanuele, 331, Misilmeri PA 90036, ITALIA",
    "lat": 39.307854,
    "lng": 16.911941,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.307854,16.911941"
  },
  {
    "name": "F.cia Tornabene della Dott.ssa Patrizia Tornabene",
    "address": "Via Luigi Sturzo, 76, Misilmeri PA 90036, ITALIA",
    "lat": 38.037603,
    "lng": 13.45842,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.037603,13.45842"
  },
  {
    "name": "F.cia Gierre snc Dott.sse Piraino e Greco",
    "address": "Via Roma, 344/B, Misilmeri PA 90036, ITALIA",
    "lat": 38.031762,
    "lng": 13.443023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.031762,13.443023"
  },
  {
    "name": "Farmacia Liggio Dr.a Rossella",
    "address": "Via Leonardo da Vinci, 319, Palermo PA 90135, ITALIA",
    "lat": 38.127259,
    "lng": 13.323734,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.127259,13.323734"
  },
  {
    "name": "F.cia Borsellino Dott. Riccardo Listro",
    "address": "Piazza Chiesa S.Alfonso dei Liguori, 31, Palermo PA 90145, ITALIA",
    "lat": 38.12916,
    "lng": 13.337878,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.12916,13.337878"
  },
  {
    "name": "Farmacia Menni Dr Giovanni",
    "address": "Via Archimede, 182, Palermo PA 90132, ITALIA",
    "lat": 38.128512,
    "lng": 13.35425,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.128512,13.35425"
  },
  {
    "name": "F.cia Mercadante Ignazio Della Dott.ssa Giordano",
    "address": "Via Carbone, 44, Palermo PA 90151, ITALIA",
    "lat": 38.197756,
    "lng": 13.315716,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.197756,13.315716"
  },
  {
    "name": "F.cia Laura di Figlia",
    "address": "Via Messina Marina, 795, Palermo PA 90121, ITALIA",
    "lat": 38.096474,
    "lng": 13.428451,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.096474,13.428451"
  },
  {
    "name": "F.cia Marchese di Villabianca snc",
    "address": "Via Marchese di Villabianca, 26, Palermo PA 90143, ITALIA",
    "lat": 38.135344,
    "lng": 13.351644,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.135344,13.351644"
  },
  {
    "name": "F.cia Dr.ssa Saladino Olivia",
    "address": "Via Principe di Belmonte, 112, Palermo PA 90139, ITALIA",
    "lat": 38.123577,
    "lng": 13.356602,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.123577,13.356602"
  },
  {
    "name": "F.cia Dei Leoni sas",
    "address": "P.zza Leoni, 83, Palermo PA 90143, ITALIA",
    "lat": 38.146851,
    "lng": 13.343327,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.146851,13.343327"
  },
  {
    "name": "Parafarmacia Servizi e Salute sas del Dott. Listro Orazio",
    "address": "Via Orsa Minore, 272/274, Palermo PA 90124, ITALIA",
    "lat": 38.094774,
    "lng": 13.367974,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.094774,13.367974"
  },
  {
    "name": "F.cia Dott. Listro Orazio srl",
    "address": "Via S.Filippo, 8, Palermo PA 90125, ITALIA",
    "lat": 38.089965,
    "lng": 13.35673,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.089965,13.35673"
  },
  {
    "name": "F.cia Dei Dott. Randazzo snc",
    "address": "C.so dei Mille, 262, Partinico PA 90047, ITALIA",
    "lat": 38.0451,
    "lng": 13.115964,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.0451,13.115964"
  },
  {
    "name": "F.cia Giovanna di Salvo & C. snc",
    "address": "Via Della Chiesa, 79 - Porticello, Santa Flavia PA 90017, ITALIA",
    "lat": 38.088701,
    "lng": 13.537667,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.088701,13.537667"
  },
  {
    "name": "F.cia Dr. Gioia srl",
    "address": "Via Trento, 74, Trappeto PA 90040, ITALIA",
    "lat": 38.067637,
    "lng": 13.038896,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.067637,13.038896"
  },
  {
    "name": "Parafarmacia Rosselli di Rosselli Anna Maria",
    "address": "Via Gen. Armendo Diaz, 44, Vicari PA 90020, ITALIA",
    "lat": 37.822746,
    "lng": 13.568696,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.822746,13.568696"
  },
  {
    "name": "Parafarmacia Villafrati di F.cia Cefalà Diana srl",
    "address": "Via V. Emanuele, 80, Villafrati PA 90030, ITALIA",
    "lat": 37.680909,
    "lng": 13.379435,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.680909,13.379435"
  },
  {
    "name": "F.cia Garavani di Garafarma snc di Garavani & C",
    "address": "Corso Matteotti, 76, Castel San Giovanni PC 29015, ITALIA",
    "lat": 45.058978,
    "lng": 9.434773,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.058978,9.434773"
  },
  {
    "name": "F.cia Riccardi di Riccardi Anna Maria",
    "address": "Via Roma, 5, Barbianello PV 27041, ITALIA",
    "lat": 45.074426,
    "lng": 9.207373,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.074426,9.207373"
  },
  {
    "name": "F.Cia Fraschini snc Dr.Lorenza e Romana Fraschini",
    "address": "Via Lungargine, 57, Bastida Pancarana PV 27050, ITALIA",
    "lat": 45.084839,
    "lng": 9.080654,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.084839,9.080654"
  },
  {
    "name": "F.cia Borgo San Siro Dr.ssa Comelli Margherita",
    "address": "Via Roma, 34, Borgo S.Siro PV 27020, ITALIA",
    "lat": 45.234426,
    "lng": 8.913091,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.234426,8.913091"
  },
  {
    "name": "F.cia Borgo San Siro srl",
    "address": "Via Roma, 34, Borgo S.Siro PV 27020, ITALIA",
    "lat": 45.234426,
    "lng": 8.913091,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.234426,8.913091"
  },
  {
    "name": "F.cia Croce di Dott.ssa Passotti Margherita",
    "address": "Via Vallone, 2, Castelletto di Branduzzo PV 27040, ITALIA",
    "lat": 45.071057,
    "lng": 9.101313,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.071057,9.101313"
  },
  {
    "name": "F.cia di Castello d’Agogna snc",
    "address": "Via Milano 47, Castello d’Agogna PV 27030, ITALIA",
    "lat": 45.234971,
    "lng": 8.691175,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.234971,8.691175"
  },
  {
    "name": "F.cia Di Ceranova snc",
    "address": "P.zza del Municipio, Ceranova PV 27010, ITALIA",
    "lat": 45.259028,
    "lng": 9.23848,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.259028,9.23848"
  },
  {
    "name": "F.cia Capitelli Chignolo",
    "address": "Via XXV Aprile 93, Chignolo Po PV 27013, ITALIA",
    "lat": 45.148805,
    "lng": 9.483779,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.148805,9.483779"
  },
  {
    "name": "F.cia Comunale Casa Serena",
    "address": "Via Pizzarelli, 20, Cilavegna PV 27024, ITALIA",
    "lat": 45.309406,
    "lng": 8.745046,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.309406,8.745046"
  },
  {
    "name": "F.cia Delucchi Dr.Franco",
    "address": "Via Roma,105, Codevilla PV 27050, ITALIA",
    "lat": 44.966861,
    "lng": 9.06027,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.966861,9.06027"
  },
  {
    "name": "F.cia Barisonzi srl",
    "address": "Via De Gasperi, 1, Cura Carpignano PV 27010, ITALIA",
    "lat": 45.239409,
    "lng": 9.177667,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.239409,9.177667"
  },
  {
    "name": "F.Cia Bozzani Alessandro di Bozzani A. & P. s.n.c.",
    "address": "Via Cavour 127, Garlasco PV 27026, ITALIA",
    "lat": 40.379677,
    "lng": 17.358201,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.379677,17.358201"
  },
  {
    "name": "F.cia Arnerio snc di Portalupi G. e C.",
    "address": "P.zza Garibaldi, 17, Garlasco PV 27026, ITALIA",
    "lat": 45.197176,
    "lng": 8.923768,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.197176,8.923768"
  },
  {
    "name": "La Parafarmacia di Paola Strigazzi e C. sas",
    "address": "P.zza Garibaldi, 20, Garlasco PV 27026, ITALIA",
    "lat": 45.197176,
    "lng": 8.923768,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.197176,8.923768"
  },
  {
    "name": "Parafarmacia Paochi",
    "address": "Via Marconi, 9, Giussago PV 27010, ITALIA",
    "lat": 45.285592,
    "lng": 9.141188,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.285592,9.141188"
  },
  {
    "name": "F.cia Marro sas dei D.ri Marro, Carrera e C.",
    "address": "Piazza I Novembre 1872, 2, Marzano PV 27010, ITALIA",
    "lat": 46.078683,
    "lng": 12.030029,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.078683,12.030029"
  },
  {
    "name": "F.cia San Michele di Giraldelli B. e C. snc",
    "address": "Piazza Garibaldi 11, Montù Beccaria PV 27040, ITALIA",
    "lat": 45.035353,
    "lng": 9.314746,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.035353,9.314746"
  },
  {
    "name": "Farmacia Piselli di Spanò Dr Antonio",
    "address": "Piazza Martiri Libertà, 14, Mortara PV 27036, ITALIA",
    "lat": 45.252006,
    "lng": 8.737645,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.252006,8.737645"
  },
  {
    "name": "F.cia Basiglio Dr.ssa Paola Margherita",
    "address": "Via S.Siro 1, Parona Lomellina PV 27020, ITALIA",
    "lat": 45.28324,
    "lng": 8.751514,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.28324,8.751514"
  },
  {
    "name": "Paraf. Parafapa di Marco Branca snc c/o Clinica Maugeri",
    "address": "Via Maugeri, 10-c/o Clinica Maugeri, Pavia PV 27100, ITALIA",
    "lat": 45.185567,
    "lng": 9.154295,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.185567,9.154295"
  },
  {
    "name": "F.cia San Patrizio della Dr.ssa Comelli Barbara",
    "address": "Corso Manzoni 1, Pavia PV 27100, ITALIA",
    "lat": 45.187272,
    "lng": 9.146377,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.187272,9.146377"
  },
  {
    "name": "F.cia Gatti Di Mascherpa Dott.ssa Ilaria",
    "address": "Via Roma, 60, Pieve del Cairo PV 27037, ITALIA",
    "lat": 45.049614,
    "lng": 8.802843,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.049614,8.802843"
  },
  {
    "name": "F.cia Baiardi di Baiardi Dr.Vittorio & C.SNC",
    "address": "Piazza Cornaggia, 54, Rivanazzano PV 27055, ITALIA",
    "lat": 44.93069,
    "lng": 9.015722,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.93069,9.015722"
  },
  {
    "name": "F.cia Gipponi snc",
    "address": "C.so Bellotti, 6/8, Robbio PV 27038, ITALIA",
    "lat": 45.289325,
    "lng": 8.592755,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.289325,8.592755"
  },
  {
    "name": "F.cia S.Giovanni di Vitali Dott.ssa Silvia",
    "address": "Via Gravellone, 1, S.Martino Siccomario PV 27028, ITALIA",
    "lat": 45.165271,
    "lng": 9.14001,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.165271,9.14001"
  },
  {
    "name": "F.cia Centrale Riccardi snc di Stringa Dr.Stefano",
    "address": "Via Mazzini, 48, Sannazzaro de’ Burgondi PV 27039, ITALIA",
    "lat": 45.103308,
    "lng": 8.90663,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.103308,8.90663"
  },
  {
    "name": "F.cia Lodola Dott. F. e G. srl",
    "address": "Via Roma, 59, Siziano PV 27010, ITALIA",
    "lat": 45.319358,
    "lng": 9.200265,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.319358,9.200265"
  },
  {
    "name": "La Nuova Farmacia Di Miavaldi E. e Ubezio L. snc",
    "address": "C.so Pavia, 73, Vigevano PV 27029, ITALIA",
    "lat": 45.306986,
    "lng": 8.869149,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.306986,8.869149"
  },
  {
    "name": "F.cia Montegrappa snc di Caccoa e Mainardi",
    "address": "V.le Montegrappa, 6, Vigevano PV 27029, ITALIA",
    "lat": 45.326385,
    "lng": 8.855261,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.326385,8.855261"
  },
  {
    "name": "F.cia Brughiera di Dott.ssa Scevola M. & C. snc",
    "address": "Via San Giovanni, 79, Vigevano PV 27029, ITALIA",
    "lat": 45.323397,
    "lng": 8.883175,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.323397,8.883175"
  },
  {
    "name": "F.cia Garafarma snc di Garavani & C",
    "address": "Via Matteotti, 40, Voghera PV 27058, ITALIA",
    "lat": 45.004274,
    "lng": 8.924255,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.004274,8.924255"
  },
  {
    "name": "F.cia Marzani srl",
    "address": "Via Vittorio Emanuele, 15, Zavattarello PV 27059, ITALIA",
    "lat": 44.867942,
    "lng": 9.265023,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=44.867942,9.265023"
  },
  {
    "name": "F.cia Agape della Dr.ssa Rosamaria Macrì",
    "address": "Via Ternicola, snc, Bovalino RC 89034, ITALIA",
    "lat": 38.148587,
    "lng": 16.178,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.148587,16.178"
  },
  {
    "name": "F.cia Calderone",
    "address": "P.zza Zaleuco, 9, Marina di Gioiosa Ionica RC 89046, ITALIA",
    "lat": 38.299949,
    "lng": 16.328686,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.299949,16.328686"
  },
  {
    "name": "F.cia Pellicanò Dott.ssa Luciana",
    "address": "V.le Calabria, 78, Reggio Calabria RC 89133, ITALIA",
    "lat": 38.09625,
    "lng": 15.64008,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.09625,15.64008"
  },
  {
    "name": "F.cia Laganà sas del Dott. A. Laganà e C.",
    "address": "C.so Garibaldi, 573, Reggio Calabria RC 89127, ITALIA",
    "lat": 38.103361,
    "lng": 15.638038,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.103361,15.638038"
  },
  {
    "name": "F.cia Athena srl",
    "address": "Str.Stat.18 III tratto, 244-Gallico, Reggio Calabria RC 89135, ITALIA",
    "lat": 38.003777,
    "lng": 15.639828,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.003777,15.639828"
  },
  {
    "name": "Parafarmacia Falletti sas di F.M. Falletti & C.",
    "address": "C.so della Repubblica, 96, Siderno Marina RC 89048, ITALIA",
    "lat": 38.266107,
    "lng": 16.295061,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.266107,16.295061"
  },
  {
    "name": "F.cia Dello Stretto sas",
    "address": "Via Ammiraglio Curzon, 11, Villa S.Giovanni RC 89018, ITALIA",
    "lat": 38.219949,
    "lng": 15.636723,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.219949,15.636723"
  },
  {
    "name": "F.cia Aprica di Giudicatti R. e Bariggi C. snc",
    "address": "C.so Roma, 191, Aprica SO 23031, ITALIA",
    "lat": 46.154889,
    "lng": 10.156211,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.154889,10.156211"
  },
  {
    "name": "F.cia Margolfo Frosio srl",
    "address": "Via Libertà, 6, Ardenno SO 23011, ITALIA",
    "lat": 46.169444,
    "lng": 9.650454,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.169444,9.650454"
  },
  {
    "name": "F.cia Castello dell’Acqua di Rossi Cecilia",
    "address": "Via Cavallari, 31, Castello dell’Acqua SO 23030, ITALIA",
    "lat": 46.155199,
    "lng": 10.031525,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.155199,10.031525"
  },
  {
    "name": "F.cia di Regoledo sas di Margolfo A. & c.",
    "address": "Via Statale 219, Cosio Valtellino SO 23013, ITALIA",
    "lat": 46.133671,
    "lng": 9.550942,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.133671,9.550942"
  },
  {
    "name": "Ferri F.cie sas (Delebio)",
    "address": "Via IV Novembre, 5/A, Delebio SO 23014, ITALIA",
    "lat": 46.13811,
    "lng": 9.464103,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.13811,9.464103"
  },
  {
    "name": "F.cia Pighetti Dott.Silvia",
    "address": "Via Spluga, 48 -Nuova Olonio, Dubino SO 23015, ITALIA",
    "lat": 46.169269,
    "lng": 9.429431,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.169269,9.429431"
  },
  {
    "name": "F.Cia Vairetti Dr.Annamaria",
    "address": "Via Roma, 29, Lovero SO 23030, ITALIA",
    "lat": 46.233872,
    "lng": 10.230851,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.233872,10.230851"
  },
  {
    "name": "F.cia Quadrio srl",
    "address": "Piazzetta Rusconi 5, Sondrio SO 23100, ITALIA",
    "lat": 46.170822,
    "lng": 9.870538,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=46.170822,9.870538"
  },
  {
    "name": "F.cia San Martino srl",
    "address": "Largo Risorgimento, 18, Tirano SO 23037, ITALIA",
    "lat": 40.725625,
    "lng": 17.574703,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=40.725625,17.574703"
  },
  {
    "name": "F.cia Cicirata srl",
    "address": "Via Lavaggi, 100, Augusta SR 96011, ITALIA",
    "lat": 37.24039,
    "lng": 15.220433,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.24039,15.220433"
  },
  {
    "name": "F.cia Star bene della Dott.ssa Giliberto Santina",
    "address": "Via Enzo Giudice, 2/A, Floridia SR 96014, ITALIA",
    "lat": 37.08635,
    "lng": 15.14561,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.08635,15.14561"
  },
  {
    "name": "F.cia Tafuri della Dott.ssa Campo Corrada snc",
    "address": "P.zza V. Emanuele, 26, Pachino SR 96018, ITALIA",
    "lat": 36.743417,
    "lng": 15.117089,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=36.743417,15.117089"
  },
  {
    "name": "F.cia Favata srl",
    "address": "Via Misterbianco. 11, Siracusa SR 96100, ITALIA",
    "lat": 37.095428,
    "lng": 15.272136,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.095428,15.272136"
  },
  {
    "name": "F.cia Favara T. & C. sas",
    "address": "V.le Scala Greca, 399/C, Siracusa SR 96100, ITALIA",
    "lat": 37.09899,
    "lng": 15.266933,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.09899,15.266933"
  },
  {
    "name": "F.cia Bambina snc",
    "address": "Corso VI Aprile, 411, Alcamo TP 91011, ITALIA",
    "lat": 37.980155,
    "lng": 12.956095,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=37.980155,12.956095"
  },
  {
    "name": "F.cia Messana Dr.a Miriam",
    "address": "Viale Umberto I, 22, Castellammare del Golfo TP 91014, ITALIA",
    "lat": 38.017532,
    "lng": 12.885772,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.017532,12.885772"
  },
  {
    "name": "Parafarmacia del Viale Dott. Roberto Zichichi",
    "address": "V.le Regione Siciliana, 43, Trapani TP 91100, ITALIA",
    "lat": 38.017357,
    "lng": 12.53796,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=38.017357,12.53796"
  },
  {
    "name": "F.cia Binda srl",
    "address": "Via Cavour 2/A, Brebbia VA 21020, ITALIA",
    "lat": 45.829586,
    "lng": 8.652999,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.829586,8.652999"
  },
  {
    "name": "Agesp Spa - F.cia comunale Busto A. n.2",
    "address": "Via Padre REg.Giuliani, 10, Busto Arsizio VA 21052, ITALIA",
    "lat": 45.611343,
    "lng": 8.85081,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.611343,8.85081"
  },
  {
    "name": "F.cia Comunale Busto Arsizio n.2 di Agesp Attività Strumentali srl-Settore F.cie",
    "address": "Via Padre Reg.Giuliani, 10, Busto Arsizio VA 21052, ITALIA",
    "lat": 45.611343,
    "lng": 8.85081,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.611343,8.85081"
  },
  {
    "name": "F.cia Comunale Busto Arsizio n.3 di Agesp Attività Strumentali srl-Settore F.cie",
    "address": "L.go Giardini, 3, Busto Arsizio VA 21052, ITALIA",
    "lat": 45.617912,
    "lng": 8.85444,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.617912,8.85444"
  },
  {
    "name": "F.cia Comunale Busto Arsizio n.4 di Agesp Attività Strumentali srl-Settore F.cie",
    "address": "V.le Boccaccio, 83, Busto Arsizio VA 21052, ITALIA",
    "lat": 45.593836,
    "lng": 8.859668,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.593836,8.859668"
  },
  {
    "name": "F.cia Cogliati Dr.ssa Angela",
    "address": "Via Corridoni, 5, Cairate VA 21050, ITALIA",
    "lat": 45.689944,
    "lng": 8.8694,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.689944,8.8694"
  },
  {
    "name": "F.cia di Caravate Dott.sse Fantoni e Ossola snc",
    "address": "P.Zza Garibaldi 8, Caravate VA 21032, ITALIA",
    "lat": 45.877352,
    "lng": 8.65219,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.877352,8.65219"
  },
  {
    "name": "Azienda Speciale Serv.Pubblici - Farmacia Comunale",
    "address": "Piazza Mazzini, 13, Cardano Al Campo VA 21010, ITALIA",
    "lat": 45.644757,
    "lng": 8.772307,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.644757,8.772307"
  },
  {
    "name": "F.cia Dr. Peroni di Antonio E. Peroni & C. sas",
    "address": "Via Castiglioni 6, Carnago VA 21040, ITALIA",
    "lat": 45.72182,
    "lng": 8.836016,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.72182,8.836016"
  },
  {
    "name": "La Farmacia dei D.ri Morelli R. ed E. & C. sas",
    "address": "Via S.Camillo, 1/2, Castellanza VA 21053, ITALIA",
    "lat": 45.61318,
    "lng": 8.908605,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.61318,8.908605"
  },
  {
    "name": "F.cia Dott. Daniela Lodoletti e C. sas",
    "address": "Via Cavour, 29, Castronno VA 21040, ITALIA",
    "lat": 45.74523,
    "lng": 8.811981,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.74523,8.811981"
  },
  {
    "name": "F.cia Volta Dott. Frigerio & C. sas",
    "address": "via Cesare Battisti n. 1511, Cislago VA 21040, ITALIA",
    "lat": 45.656762,
    "lng": 8.981191,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.656762,8.981191"
  },
  {
    "name": "F.cie Leali Mirabile della Dott.ssa Carmen Mirabile & C. sas(Comerio)",
    "address": "Via Piave, 10/A, Comerio VA 21025, ITALIA",
    "lat": 45.841665,
    "lng": 8.748325,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.841665,8.748325"
  },
  {
    "name": "F.Cia S.Serafino Dr.Chiesa Giampiero",
    "address": "Via Battaglia di S.Martino,108, Cuveglio VA 21030, ITALIA",
    "lat": 45.90501,
    "lng": 8.74038,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.90501,8.74038"
  },
  {
    "name": "GE.A.S.C - F.cia comunale Fagnano Olona",
    "address": "Via Montello 2E, Fagnano Olona VA 21054, ITALIA",
    "lat": 45.667519,
    "lng": 8.867211,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.667519,8.867211"
  },
  {
    "name": "F.cia Raimondi di Raimondi Dott. Virginio e C. sas",
    "address": "V.le Europa, 34, Gorla Maggiore VA 21050, ITALIA",
    "lat": 45.66417,
    "lng": 8.896962,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.66417,8.896962"
  },
  {
    "name": "F.cia Vidussi di Vidussi Dr. Alessandro",
    "address": "Via Indipendenza, 32, Jerago con Orago VA 21040, ITALIA",
    "lat": 45.70765,
    "lng": 8.790667,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.70765,8.790667"
  },
  {
    "name": "Paraf. Pharmasì Dott.ssa Manaa Nadia",
    "address": "Via Varesina, 44, Jerago con Orago VA 21040, ITALIA",
    "lat": 45.711199,
    "lng": 8.802823,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.711199,8.802823"
  },
  {
    "name": "F.cia Pauli dei D.ri S. e G. Pauli & C. snc",
    "address": "Via Gioberti 10/A, Leggiuno VA 21038, ITALIA",
    "lat": 45.875666,
    "lng": 8.621183,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.875666,8.621183"
  },
  {
    "name": "F.cia Ticino snc D.ri M. Pavan e C. Lapidari",
    "address": "P.zza Cesare Battisti, 1, Lonate Pozzolo VA 21015, ITALIA",
    "lat": 45.597137,
    "lng": 8.75147,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.597137,8.75147"
  },
  {
    "name": "F.cia Castelletti del Dott. Castelletti & C. sas",
    "address": "Via Isonzo, 2 - S.Antonino Ticino, Lonate Pozzolo VA 21015, ITALIA",
    "lat": 45.586821,
    "lng": 8.757713,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.586821,8.757713"
  },
  {
    "name": "F.cia S.Maria di Dot. Roberta Leoncini & C. sas",
    "address": "Via Stoppani, 2, Saronno VA 21047, ITALIA",
    "lat": 45.609206,
    "lng": 9.142064,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.609206,9.142064"
  },
  {
    "name": "F.cia Comunale Pastrengo",
    "address": "Via Pastrengo, 1, Somma Lombardo VA 21019, ITALIA",
    "lat": 45.67578,
    "lng": 8.704686,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.67578,8.704686"
  },
  {
    "name": "Farmacia Pianori di Cecilia Nodari",
    "address": "Corso Bernacchi, 50, Tradate VA 21049, ITALIA",
    "lat": 45.712828,
    "lng": 8.905716,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.712828,8.905716"
  },
  {
    "name": "F.Cia Corti Dr.Alberto",
    "address": "Via Trieste 6/1, Travedona Monate VA 21028, ITALIA",
    "lat": 45.803767,
    "lng": 8.674485,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.803767,8.674485"
  },
  {
    "name": "F.Cia Corti Dott.sse A. e C. Corti e C. snc",
    "address": "Via Trieste 6/1, Travedona Monate VA 21028, ITALIA",
    "lat": 45.803767,
    "lng": 8.674485,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.803767,8.674485"
  },
  {
    "name": "F.cia Ponti Sessa Dr.ssa Mara Francesca Maria",
    "address": "V.le V.Veneto, 2, Varano Borghi VA 21020, ITALIA",
    "lat": 45.774879,
    "lng": 8.703867,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.774879,8.703867"
  },
  {
    "name": "F.Cia Agostinini Dr.Marco",
    "address": "Piazza S.Giorgio 10, Venegono Superiore VA 21040, ITALIA",
    "lat": 45.755359,
    "lng": 8.899195,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=45.755359,8.899195"
  },
  {
    "name": "F.cia Mobrici di Mobrici L. & Figli sas",
    "address": "Via Provinciale, 141 S.Domenica, Ricadi VV 89855, ITALIA",
    "lat": 39.985424,
    "lng": 18.380312,
    "directions": "https://www.google.com/maps/dir/?api=1&destination=39.985424,18.380312"
  }
];